[
    {
        "icon": "0",
        "label": "0",
        "search": [
            "Digit Zero",
            "nada",
            "none",
            "zero",
            "zilch"
        ]
    },
    {
        "icon": "1",
        "label": "1",
        "search": [
            "Digit One",
            "one"
        ]
    },
    {
        "icon": "2",
        "label": "2",
        "search": [
            "Digit Two",
            "two"
        ]
    },
    {
        "icon": "3",
        "label": "3",
        "search": [
            "Digit Three",
            "three"
        ]
    },
    {
        "icon": "4",
        "label": "4",
        "search": [
            "Digit Four",
            "four"
        ]
    },
    {
        "icon": "5",
        "label": "5",
        "search": [
            "Digit Five",
            "five"
        ]
    },
    {
        "icon": "6",
        "label": "6",
        "search": [
            "Digit Six",
            "six"
        ]
    },
    {
        "icon": "7",
        "label": "7",
        "search": [
            "Digit Seven",
            "seven"
        ]
    },
    {
        "icon": "8",
        "label": "8",
        "search": [
            "Digit Eight",
            "eight"
        ]
    },
    {
        "icon": "9",
        "label": "9",
        "search": [
            "Digit Nine",
            "nine"
        ]
    },
    {
        "icon": "chess-pawn-piece",
        "label": "Chess Pawn Piece",
        "search": [
            "board",
            "checkmate",
            "game",
            "strategy"
        ]
    },
    {
        "icon": "dollar-sign",
        "label": "Dollar Sign",
        "search": [
            "Dollar Sign",
            "coupon",
            "currency",
            "dollar",
            "heavy dollar sign",
            "investment",
            "money",
            "premium",
            "revenue",
            "salary"
        ]
    },
    {
        "icon": "layer-plus",
        "label": "Layer Plus",
        "search": [
            "add",
            "arrange",
            "create",
            "layers",
            "new",
            "platform",
            "positive",
            "stack"
        ]
    },
    {
        "icon": "grid-4",
        "label": "Grid 4",
        "search": [
            "app",
            "collection",
            "compact",
            "filter",
            "grid",
            "sort"
        ]
    },
    {
        "icon": "dog",
        "label": "Dog",
        "search": [
            "animal",
            "canine",
            "dog",
            "fauna",
            "mammal",
            "pet",
            "pooch",
            "puppy",
            "woof"
        ]
    },
    {
        "icon": "truck-moving",
        "label": "Truck Moving",
        "search": [
            "cargo",
            "inventory",
            "rental",
            "vehicle"
        ]
    },
    {
        "icon": "rotate",
        "label": "Rotate",
        "search": [
            "arrow",
            "clockwise",
            "exchange",
            "modify",
            "refresh",
            "reload",
            "renew",
            "retry",
            "rotate",
            "swap",
            "withershins"
        ]
    },
    {
        "icon": "keyboard-brightness",
        "label": "Keyboard Brightness",
        "search": [
            "glow",
            "keyboard",
            "keycap",
            "light"
        ]
    },
    {
        "icon": "tent-double-peak",
        "label": "Tent Double Peak",
        "search": [
            "big top",
            "bivouac",
            "camp",
            "campground",
            "campsite",
            "carnival",
            "circus",
            "refugee",
            "shelter",
            "tent"
        ]
    },
    {
        "icon": "square-minus",
        "label": "Square Minus",
        "search": [
            "collapse",
            "delete",
            "hide",
            "minify",
            "negative",
            "remove",
            "shape",
            "trash"
        ]
    },
    {
        "icon": "square-github",
        "label": "Square Github",
        "search": [
            "octocat"
        ]
    },
    {
        "icon": "water-arrow-up",
        "label": "Water Arrow Up",
        "search": [
            "flood",
            "lake",
            "liquid",
            "ocean",
            "sea",
            "swim",
            "upgrade",
            "wet"
        ]
    },
    {
        "icon": "xmark-to-slot",
        "label": "Xmark To Slot",
        "search": [
            "cast",
            "election",
            "negative",
            "no",
            "politics",
            "reject",
            "uncheck",
            "voting"
        ]
    },
    {
        "icon": "sensor-cloud",
        "label": "Sensor Cloud",
        "search": [
            "alarm",
            "alert",
            "carbon monoxide",
            "detector",
            "fire",
            "smoke"
        ]
    },
    {
        "icon": "align-justify",
        "label": "Align Justify",
        "search": [
            "format",
            "paragraph",
            "text"
        ]
    },
    {
        "icon": "sunglasses",
        "label": "Sunglasses",
        "search": [
            "bright",
            "cool",
            "dark",
            "eye",
            "eyewear",
            "glasses",
            "mib",
            "shades",
            "sunglasses"
        ]
    },
    {
        "icon": "cloud-check",
        "label": "Cloud Check",
        "search": [
            "enable",
            "success",
            "upload",
            "validate",
            "verify",
            "working"
        ]
    },
    {
        "icon": "message-minus",
        "label": "Message Minus",
        "search": [
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "delete",
            "feedback",
            "message",
            "negative",
            "note",
            "notification",
            "remove",
            "sms",
            "speech",
            "texting"
        ]
    },
    {
        "icon": "face-clouds",
        "label": "Face Clouds",
        "search": [
            "bliss",
            "brain fog",
            "calm",
            "confusion",
            "foggy",
            "forget",
            "haze",
            "smoke"
        ]
    },
    {
        "icon": "left-long-to-line",
        "label": "Left Long To Line",
        "search": [
            "back",
            "delete",
            "left"
        ]
    },
    {
        "icon": "calendar-check",
        "label": "Calendar Check",
        "search": [
            "accept",
            "agree",
            "appointment",
            "confirm",
            "correct",
            "date",
            "day",
            "done",
            "enable",
            "event",
            "month",
            "ok",
            "schedule",
            "select",
            "success",
            "tick",
            "time",
            "todo",
            "validate",
            "warranty",
            "when",
            "working",
            "year"
        ]
    },
    {
        "icon": "square-ring",
        "label": "Square Ring",
        "search": [
            "pipe",
            "service"
        ]
    },
    {
        "icon": "face-kiss",
        "label": "Face Kiss",
        "search": [
            "beso",
            "emoticon",
            "face",
            "kiss",
            "kissing face",
            "love",
            "smooch"
        ]
    },
    {
        "icon": "circle-video",
        "label": "Circle Video",
        "search": [
            "camera",
            "film"
        ]
    },
    {
        "icon": "think-peaks",
        "label": "Think Peaks",
        "search": []
    },
    {
        "icon": "cart-shopping-fast",
        "label": "Cart Shopping Fast",
        "search": [
            "fast",
            "food",
            "grocery",
            "market",
            "quick"
        ]
    },
    {
        "icon": "google-drive",
        "label": "Google Drive",
        "search": []
    },
    {
        "icon": "desktop-arrow-down",
        "label": "Desktop Arrow Down",
        "search": [
            "computer",
            "desktop",
            "download",
            "insert"
        ]
    },
    {
        "icon": "banjo",
        "label": "Banjo",
        "search": [
            "banjo",
            "bluegrass",
            "folk",
            "guitar",
            "instrument",
            "jazz",
            "music",
            "stringed"
        ]
    },
    {
        "icon": "cloud-hail-mixed",
        "label": "Cloud Hail Mixed",
        "search": [
            "freezing",
            "ice",
            "precipitation",
            "rain",
            "sleet",
            "snow",
            "storm"
        ]
    },
    {
        "icon": "autoprefixer",
        "label": "Autoprefixer",
        "search": []
    },
    {
        "icon": "kitchen-set",
        "label": "Kitchen Set",
        "search": [
            "chef",
            "cook",
            "cup",
            "kitchen",
            "pan",
            "pot",
            "skillet"
        ]
    },
    {
        "icon": "dna",
        "label": "Dna",
        "search": [
            "biologist",
            "dna",
            "double helix",
            "evolution",
            "gene",
            "genetic",
            "genetics",
            "helix",
            "life",
            "molecule",
            "protein"
        ]
    },
    {
        "icon": "box-circle-check",
        "label": "Box Circle Check",
        "search": [
            "confirm",
            "enable",
            "inventory",
            "not affected",
            "ok",
            "okay",
            "package",
            "validate",
            "working"
        ]
    },
    {
        "icon": "trillium",
        "label": "Trillium",
        "search": [
            "blossom",
            "flower",
            "leaves",
            "nature",
            "spring",
            "summer"
        ]
    },
    {
        "icon": "delete-right",
        "label": "Delete Right",
        "search": [
            "Erase to the Right",
            "remove",
            "trash"
        ]
    },
    {
        "icon": "child-reaching",
        "label": "Child Reaching",
        "search": [
            "boy",
            "girl",
            "kid",
            "toddler",
            "uer",
            "young",
            "youth"
        ]
    },
    {
        "icon": "face-confounded",
        "label": "Face Confounded",
        "search": [
            "confounded",
            "confounded face",
            "face",
            "grimace",
            "quiver",
            "scrunched",
            "squiggle"
        ]
    },
    {
        "icon": "sidebar",
        "label": "Sidebar",
        "search": [
            "browser",
            "ui",
            "window"
        ]
    },
    {
        "icon": "paste",
        "label": "Paste",
        "search": [
            "clipboard",
            "copy",
            "document",
            "paper"
        ]
    },
    {
        "icon": "inhaler",
        "label": "Inhaler",
        "search": [
            "asthma",
            "cough",
            "lungs",
            "nebulizer",
            "vaporizer"
        ]
    },
    {
        "icon": "meteor",
        "label": "Meteor",
        "search": [
            "armageddon",
            "asteroid",
            "comet",
            "shooting star",
            "space"
        ]
    },
    {
        "icon": "honey-pot",
        "label": "Honey Pot",
        "search": [
            "Winnie the pooh",
            "drip",
            "honey",
            "jar",
            "sweet"
        ]
    },
    {
        "icon": "laptop-slash",
        "label": "Laptop Slash",
        "search": [
            "computer",
            "disabled",
            "disconnect"
        ]
    },
    {
        "icon": "gears",
        "label": "Gears",
        "search": [
            "configuration",
            "gears",
            "mechanical",
            "modify",
            "settings",
            "sprocket",
            "wheel"
        ]
    },
    {
        "icon": "wave-sine",
        "label": "Wave Sine",
        "search": [
            "Sine Wave",
            "frequency",
            "pulse",
            "signal"
        ]
    },
    {
        "icon": "arrow-turn-left-up",
        "label": "Arrow Turn Left Up",
        "search": [
            "direction",
            "forward",
            "north",
            "right",
            "turn"
        ]
    },
    {
        "icon": "garage",
        "label": "Garage",
        "search": [
            "auto",
            "car",
            "door",
            "storage",
            "structure",
            "warehouse"
        ]
    },
    {
        "icon": "flatbread-stuffed",
        "label": "Flatbread Stuffed",
        "search": [
            "chickpea",
            "falafel",
            "garbanzo",
            "gyro",
            "kebab",
            "pita",
            "sandwich"
        ]
    },
    {
        "icon": "eyes",
        "label": "Eyes",
        "search": [
            "eye",
            "idea",
            "look",
            "see"
        ]
    },
    {
        "icon": "dash",
        "label": "Dash",
        "search": [
            "Em Dash",
            "Minus Sign",
            "collapse",
            "delete",
            "hide",
            "horizontal rule",
            "hyphen",
            "line",
            "math",
            "minify",
            "minus",
            "negative",
            "remove",
            "sign",
            "trash",
            "−"
        ]
    },
    {
        "icon": "photo-film-music",
        "label": "Photo Film Music",
        "search": [
            "img",
            "media"
        ]
    },
    {
        "icon": "circle-m",
        "label": "Circle M",
        "search": [
            "Circled Latin Capital Letter M",
            "letter"
        ]
    },
    {
        "icon": "arrow-up-to-dotted-line",
        "label": "Arrow Up To Dotted Line",
        "search": [
            "import",
            "transfer",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "file-circle-plus",
        "label": "File Circle Plus",
        "search": [
            "add",
            "document",
            "file",
            "new",
            "page",
            "paper",
            "pdf"
        ]
    },
    {
        "icon": "mustache",
        "label": "Mustache",
        "search": [
            "beard",
            "face",
            "hair",
            "lumberjack",
            "shave",
            "walrus",
            "whiskers"
        ]
    },
    {
        "icon": "window-frame",
        "label": "Window Frame",
        "search": [
            "door",
            "frame",
            "fresh air",
            "glass",
            "opening",
            "pane",
            "transparent",
            "view",
            "window"
        ]
    },
    {
        "icon": "house-night",
        "label": "House Night",
        "search": [
            "abode",
            "building",
            "family",
            "home",
            "moon",
            "residence",
            "stars"
        ]
    },
    {
        "icon": "reel",
        "label": "Reel",
        "search": [
            "needle",
            "sewing",
            "spool",
            "string",
            "thread",
            "wire"
        ]
    },
    {
        "icon": "icicles",
        "label": "Icicles",
        "search": [
            "cold",
            "frozen",
            "hanging",
            "ice",
            "seasonal",
            "sharp"
        ]
    },
    {
        "icon": "binary-slash",
        "label": "Binary Slash",
        "search": [
            "binary",
            "data",
            "disabled",
            "error",
            "programming"
        ]
    },
    {
        "icon": "square-sliders-vertical",
        "label": "Square Sliders Vertical",
        "search": [
            "adjust",
            "configuration",
            "modify",
            "settings",
            "sliders",
            "toggle"
        ]
    },
    {
        "icon": "arrow-trend-up",
        "label": "Arrow Trend Up",
        "search": [
            "line",
            "stocks",
            "trend"
        ]
    },
    {
        "icon": "timeline-arrow",
        "label": "Timeline Arrow",
        "search": [
            "chronological",
            "deadline",
            "history",
            "linear"
        ]
    },
    {
        "icon": "fort",
        "label": "Fort",
        "search": [
            "castle",
            "fort",
            "fortress",
            "garrison",
            "palace",
            "turret"
        ]
    },
    {
        "icon": "circle-v",
        "label": "Circle V",
        "search": [
            "Circled Latin Capital Letter V",
            "letter"
        ]
    },
    {
        "icon": "hexagon-nodes-bolt",
        "label": "Hexagon Nodes Bolt",
        "search": [
            "LLM",
            "action",
            "ai",
            "artificial intelligence",
            "cluster",
            "graph",
            "language",
            "llm",
            "model",
            "network",
            "neuronal"
        ]
    },
    {
        "icon": "light-emergency-on",
        "label": "Light Emergency On",
        "search": [
            "alarm",
            "ambulance",
            "light",
            "siren",
            "warning"
        ]
    },
    {
        "icon": "question",
        "label": "Question",
        "search": [
            "?",
            "Question Mark",
            "faq",
            "help",
            "information",
            "mark",
            "outlined",
            "punctuation",
            "question",
            "red question mark",
            "request",
            "support",
            "unknown",
            "white question mark"
        ]
    },
    {
        "icon": "square-dashed-circle-plus",
        "label": "Square Dashed Circle Plus",
        "search": [
            "add",
            "copy",
            "dotted",
            "modifier",
            "new",
            "select",
            "selection"
        ]
    },
    {
        "icon": "square-viadeo",
        "label": "Square Viadeo",
        "search": []
    },
    {
        "icon": "chair-office",
        "label": "Chair Office",
        "search": [
            "ergonomic",
            "furniture",
            "seat"
        ]
    },
    {
        "icon": "user-magnifying-glass",
        "label": "User Magnifying Glass",
        "search": [
            "bust",
            "find",
            "person",
            "review",
            "search",
            "silhouette",
            "user"
        ]
    },
    {
        "icon": "container-storage",
        "label": "Container Storage",
        "search": [
            "archive",
            "box",
            "crate",
            "intermodal",
            "inventory",
            "shipping",
            "warehouse"
        ]
    },
    {
        "icon": "arrow-left-to-bracket",
        "label": "Arrow Left To Bracket",
        "search": [
            "enter",
            "exit",
            "login"
        ]
    },
    {
        "icon": "sparkle",
        "label": "Sparkle",
        "search": [
            "glitter",
            "magic",
            "new",
            "shine",
            "sparkle",
            "special",
            "star",
            "twinkle"
        ]
    },
    {
        "icon": "campfire",
        "label": "Campfire",
        "search": [
            "Dungeons & Dragons",
            "caliente",
            "campaign",
            "camping",
            "d&d",
            "dnd",
            "fall",
            "fire",
            "flame",
            "gathering",
            "heat",
            "hot",
            "meeting",
            "outdoors",
            "seasonal",
            "tent",
            "wilderness"
        ]
    },
    {
        "icon": "hands-bound",
        "label": "Hands Bound",
        "search": [
            "abduction",
            "bound",
            "handcuff",
            "wrist"
        ]
    },
    {
        "icon": "cpanel",
        "label": "cPanel",
        "search": []
    },
    {
        "icon": "panel-fire",
        "label": "Panel Fire",
        "search": [
            "burn",
            "emergency",
            "flame",
            "indicator",
            "intercom"
        ]
    },
    {
        "icon": "clock-seven-thirty",
        "label": "Clock Seven Thirty",
        "search": [
            "7",
            "7:30",
            "clock",
            "hour",
            "minute",
            "o'clock",
            "pending",
            "seven",
            "seven-thirty",
            "thirty",
            "ticking",
            "time"
        ]
    },
    {
        "icon": "mendeley",
        "label": "Mendeley",
        "search": []
    },
    {
        "icon": "tugrik-sign",
        "label": "Tugrik Sign",
        "search": [
            "Tugrik Sign",
            "currency"
        ]
    },
    {
        "icon": "draft2digital",
        "label": "Draft2digital",
        "search": []
    },
    {
        "icon": "audio-description-slash",
        "label": "Audio Description Slash",
        "search": [
            "audio",
            "disabled",
            "narration",
            "video",
            "visual"
        ]
    },
    {
        "icon": "face-thermometer",
        "label": "Face Thermometer",
        "search": [
            "cold",
            "coronavirus",
            "covid",
            "covid-19",
            "face",
            "face with thermometer",
            "fever",
            "flu",
            "ill",
            "sick",
            "thermometer"
        ]
    },
    {
        "icon": "lightbulb-cfl-on",
        "label": "Lightbulb Cfl On",
        "search": [
            "bulb",
            "comic",
            "compact",
            "electric",
            "energy",
            "fluorescent",
            "idea",
            "inspiration",
            "light",
            "light bulb"
        ]
    },
    {
        "icon": "clock-three",
        "label": "Clock Three",
        "search": [
            "00",
            "3",
            "3:00",
            "clock",
            "hour",
            "minute",
            "o'clock",
            "o’clock",
            "pending",
            "three",
            "three o’clock",
            "ticking",
            "time",
            "witching hour"
        ]
    },
    {
        "icon": "person-walking-luggage",
        "label": "Person Walking Luggage",
        "search": [
            "bag",
            "baggage",
            "briefcase",
            "carry-on",
            "deployment",
            "follow",
            "rolling",
            "uer"
        ]
    },
    {
        "icon": "replyd",
        "label": "replyd",
        "search": []
    },
    {
        "icon": "file-arrow-down",
        "label": "File Arrow Down",
        "search": [
            "archive",
            "document",
            "export",
            "insert",
            "save"
        ]
    },
    {
        "icon": "person-booth",
        "label": "Person Booth",
        "search": [
            "changing room",
            "curtain",
            "uer",
            "vote",
            "voting"
        ]
    },
    {
        "icon": "locust",
        "label": "Locust",
        "search": [
            "horde",
            "infestation",
            "locust",
            "plague",
            "swarm"
        ]
    },
    {
        "icon": "window",
        "label": "Window",
        "search": [
            "browser",
            "computer",
            "development"
        ]
    },
    {
        "icon": "right-long",
        "label": "Right Long",
        "search": [
            "forward",
            "long-arrow-right",
            "next"
        ]
    },
    {
        "icon": "truck-droplet",
        "label": "Truck Droplet",
        "search": [
            "blood",
            "thirst",
            "truck",
            "water",
            "water supply"
        ]
    },
    {
        "icon": "hand-holding-medical",
        "label": "Hand Holding Medical",
        "search": [
            "care",
            "covid-19",
            "donate",
            "help"
        ]
    },
    {
        "icon": "hand-point-left",
        "label": "Hand Point Left",
        "search": [
            "back",
            "finger",
            "hand-o-left",
            "left",
            "point",
            "previous"
        ]
    },
    {
        "icon": "calculator",
        "label": "Calculator",
        "search": [
            "Pocket Calculator",
            "abacus",
            "addition",
            "arithmetic",
            "counting",
            "math",
            "multiplication",
            "subtraction"
        ]
    },
    {
        "icon": "oil-temperature",
        "label": "Oil Temperature",
        "search": [
            "auto",
            "crude",
            "gasoline",
            "grease",
            "lubricate",
            "overheat",
            "petroleum",
            "temperature"
        ]
    },
    {
        "icon": "empire",
        "label": "Galactic Empire",
        "search": []
    },
    {
        "icon": "minus",
        "label": "Minus",
        "search": [
            "En Dash",
            "Minus Sign",
            "collapse",
            "delete",
            "hide",
            "math",
            "minify",
            "minus",
            "negative",
            "remove",
            "sign",
            "trash",
            "−"
        ]
    },
    {
        "icon": "message-arrow-down",
        "label": "Message Arrow Down",
        "search": [
            "answer",
            "chat",
            "contact",
            "download",
            "insert"
        ]
    },
    {
        "icon": "game-board-simple",
        "label": "Game Board Simple",
        "search": [
            "checkers",
            "chess",
            "gaming",
            "grid",
            "tabletop"
        ]
    },
    {
        "icon": "arrow-turn-left",
        "label": "Arrow Turn Left",
        "search": [
            "back",
            "direction",
            "left",
            "return",
            "turn",
            "west"
        ]
    },
    {
        "icon": "accessible-icon",
        "label": "Accessible Icon",
        "search": [
            "accessibility",
            "disabled",
            "handicap",
            "person",
            "uer",
            "wheelchair",
            "wheelchair-alt"
        ]
    },
    {
        "icon": "circle-4",
        "label": "Circle 4",
        "search": [
            "Circled Digit Four",
            "Dingbat Circled Sans-Serif Digit Four",
            "Dingbat Negative Circled Digit Four",
            "Dingbat Negative Circled Sans-Serif Digit Four",
            "four"
        ]
    },
    {
        "icon": "hammer-war",
        "label": "Hammer War",
        "search": [
            "Dungeons & Dragons",
            "cleric",
            "d&d",
            "dnd",
            "dwarf",
            "fantasy",
            "melee attack",
            "weapon"
        ]
    },
    {
        "icon": "light-emergency",
        "label": "Light Emergency",
        "search": [
            "alarm",
            "ambulance",
            "light",
            "siren",
            "warning"
        ]
    },
    {
        "icon": "quora",
        "label": "Quora",
        "search": []
    },
    {
        "icon": "arrow-up-z-a",
        "label": "Arrow Up Z A",
        "search": [
            "alphabetical",
            "arrange",
            "filter",
            "order",
            "sort-alpha-desc"
        ]
    },
    {
        "icon": "microphone-slash",
        "label": "Microphone Slash",
        "search": [
            "audio",
            "disable",
            "disabled",
            "mute",
            "podcast",
            "record",
            "sing",
            "sound",
            "voice"
        ]
    },
    {
        "icon": "square-pen",
        "label": "Square Pen",
        "search": [
            "edit",
            "modify",
            "pencil-square",
            "update",
            "write"
        ]
    },
    {
        "icon": "bell-plus",
        "label": "Bell Plus",
        "search": [
            "alarm",
            "alert",
            "chime",
            "notification",
            "reminder",
            "request"
        ]
    },
    {
        "icon": "hand-fist",
        "label": "Hand Fist",
        "search": [
            "Dungeons & Dragons",
            "clenched",
            "d&d",
            "dnd",
            "fantasy",
            "fist",
            "hand",
            "ki",
            "monk",
            "punch",
            "raised fist",
            "resist",
            "strength",
            "unarmed combat"
        ]
    },
    {
        "icon": "comment-sms",
        "label": "Comment Sms",
        "search": [
            "answer",
            "chat",
            "conversation",
            "message",
            "mobile",
            "notification",
            "phone",
            "sms",
            "texting"
        ]
    },
    {
        "icon": "head-side-gear",
        "label": "Head Side Gear",
        "search": [
            "ai",
            "android",
            "artificial intelligence",
            "augmented",
            "bald",
            "cybernetics",
            "face",
            "gear",
            "learning",
            "machine",
            "profile",
            "robot",
            "settings",
            "thinking",
            "thought",
            "user"
        ]
    },
    {
        "icon": "transporter-1",
        "label": "Transporter 1",
        "search": [
            "move",
            "teleport",
            "transfer",
            "translocate",
            "travel"
        ]
    },
    {
        "icon": "scanner-touchscreen",
        "label": "Scanner Touchscreen",
        "search": [
            "barcode",
            "checkout",
            "gun",
            "inventory",
            "price",
            "upc",
            "warehouse"
        ]
    },
    {
        "icon": "cc-jcb",
        "label": "JCB Credit Card",
        "search": []
    },
    {
        "icon": "flask-round-potion",
        "label": "Flask Round Potion",
        "search": [
            "Dungeons & Dragons",
            "alert",
            "beaker",
            "beaker",
            "beverage",
            "chemicals",
            "container",
            "d&d",
            "danger",
            "dangerous",
            "deadly",
            "death",
            "dnd",
            "drink",
            "experiment",
            "experimental",
            "fantasy",
            "halloween",
            "heal",
            "health",
            "holiday",
            "knowledge",
            "labs",
            "liquid",
            "magic",
            "mana",
            "potion",
            "science",
            "science",
            "vial"
        ]
    },
    {
        "icon": "car-bolt",
        "label": "Car Bolt",
        "search": [
            "auto",
            "automobile",
            "electric",
            "ev",
            "sedan",
            "tesla",
            "transportation",
            "travel",
            "vehicle"
        ]
    },
    {
        "icon": "table-rows",
        "label": "Table Rows",
        "search": [
            "cell",
            "spreadsheet",
            "table"
        ]
    },
    {
        "icon": "cloud-slash",
        "label": "Cloud Slash",
        "search": [
            "connection",
            "disabled",
            "internet"
        ]
    },
    {
        "icon": "face-hand-yawn",
        "label": "Face Hand Yawn",
        "search": [
            "bored",
            "tired",
            "yawn",
            "yawning face"
        ]
    },
    {
        "icon": "tickets",
        "label": "Tickets",
        "search": [
            "admission",
            "admission tickets",
            "coupon",
            "movie",
            "pass",
            "support",
            "ticket",
            "voucher"
        ]
    },
    {
        "icon": "sim-card",
        "label": "Sim Card",
        "search": [
            "hard drive",
            "hardware",
            "portable",
            "storage",
            "technology",
            "tiny"
        ]
    },
    {
        "icon": "fedora",
        "label": "Fedora",
        "search": [
            "linux",
            "operating system",
            "os"
        ]
    },
    {
        "icon": "shield-quartered",
        "label": "Shield Quartered",
        "search": [
            "achievement",
            "armor",
            "award",
            "block",
            "cleric",
            "defend",
            "defense",
            "holy",
            "paladin",
            "security",
            "shield",
            "weapon",
            "winner"
        ]
    },
    {
        "icon": "square-ellipsis-vertical",
        "label": "Square Ellipsis Vertical",
        "search": [
            "dots",
            "menu",
            "three dots"
        ]
    },
    {
        "icon": "oven",
        "label": "Oven",
        "search": [
            "bake",
            "broiler",
            "convection",
            "cook",
            "kitchen",
            "stove"
        ]
    },
    {
        "icon": "scale-balanced",
        "label": "Scale Balanced",
        "search": [
            "Libra",
            "balance",
            "balance scale",
            "balanced",
            "justice",
            "law",
            "legal",
            "measure",
            "rule",
            "scale",
            "weight",
            "zodiac"
        ]
    },
    {
        "icon": "car",
        "label": "Car",
        "search": [
            "auto",
            "automobile",
            "car",
            "oncoming",
            "oncoming automobile",
            "sedan",
            "transportation",
            "travel",
            "vehicle"
        ]
    },
    {
        "icon": "badger-honey",
        "label": "Badger Honey",
        "search": [
            "animal",
            "badger",
            "care",
            "dont",
            "ewww",
            "fauna",
            "honey badger",
            "mammal",
            "nasty",
            "pester"
        ]
    },
    {
        "icon": "crop-simple",
        "label": "Crop Simple",
        "search": [
            "design",
            "frame",
            "mask",
            "modify",
            "resize",
            "shrink"
        ]
    },
    {
        "icon": "timer",
        "label": "Timer",
        "search": [
            "clock",
            "countdown",
            "pending",
            "stopwatch",
            "timer",
            "timer clock",
            "waiting"
        ]
    },
    {
        "icon": "square-dollar",
        "label": "Square Dollar",
        "search": [
            "$",
            "coupon",
            "dollar-sign",
            "money",
            "premium",
            "price",
            "salary",
            "usd"
        ]
    },
    {
        "icon": "medal",
        "label": "Medal",
        "search": [
            "award",
            "guarantee",
            "medal",
            "quality",
            "ribbon",
            "sports medal",
            "star",
            "trophy",
            "warranty"
        ]
    },
    {
        "icon": "scroll",
        "label": "Scroll",
        "search": [
            "Dungeons & Dragons",
            "announcement",
            "d&d",
            "dnd",
            "fantasy",
            "paper",
            "scholar",
            "script",
            "scroll"
        ]
    },
    {
        "icon": "calendars",
        "label": "Calendars",
        "search": [
            "date",
            "day",
            "month",
            "reminder",
            "year"
        ]
    },
    {
        "icon": "apple-core",
        "label": "Apple Core",
        "search": [
            "compost",
            "eaten",
            "fall",
            "fruit",
            "fuji",
            "macintosh",
            "orchard",
            "seasonal",
            "vegan"
        ]
    },
    {
        "icon": "file-excel",
        "label": "File Excel",
        "search": [
            "csv",
            "document",
            "numbers",
            "spreadsheets",
            "table"
        ]
    },
    {
        "icon": "diamond-half",
        "label": "Diamond Half",
        "search": [
            "diamond",
            "gem",
            "half",
            "rating"
        ]
    },
    {
        "icon": "firstdraft",
        "label": "firstdraft",
        "search": []
    },
    {
        "icon": "freebsd",
        "label": "FreeBSD",
        "search": []
    },
    {
        "icon": "baguette",
        "label": "Baguette",
        "search": [
            "baguette",
            "bread",
            "french",
            "loaf",
            "sourdough"
        ]
    },
    {
        "icon": "h5",
        "label": "H5",
        "search": [
            "format",
            "header",
            "text",
            "title"
        ]
    },
    {
        "icon": "person-ski-lift",
        "label": "Person Ski Lift",
        "search": [
            "mountain",
            "skiing",
            "uer",
            "winter"
        ]
    },
    {
        "icon": "filter",
        "label": "Filter",
        "search": [
            "funnel",
            "options",
            "separate",
            "sort"
        ]
    },
    {
        "icon": "calculator-simple",
        "label": "Calculator Simple",
        "search": [
            "abacus",
            "addition",
            "arithmetic",
            "counting",
            "math",
            "multiplication",
            "subtraction"
        ]
    },
    {
        "icon": "coin-blank",
        "label": "Coin Blank",
        "search": [
            "coin",
            "dime",
            "gold",
            "metal",
            "money",
            "nickel",
            "penny",
            "premium",
            "quarter",
            "silver",
            "treasure"
        ]
    },
    {
        "icon": "intersection",
        "label": "Intersection",
        "search": [
            "N-Ary Intersection",
            "calculus",
            "equation",
            "function",
            "math"
        ]
    },
    {
        "icon": "drum",
        "label": "Drum",
        "search": [
            "drum",
            "drumsticks",
            "instrument",
            "music",
            "percussion",
            "snare",
            "sound"
        ]
    },
    {
        "icon": "map-pin",
        "label": "Map Pin",
        "search": [
            "address",
            "agree",
            "coordinates",
            "destination",
            "gps",
            "localize",
            "location",
            "map",
            "marker",
            "navigation",
            "pin",
            "place",
            "position",
            "pushpin",
            "round pushpin",
            "travel"
        ]
    },
    {
        "icon": "table-pivot",
        "label": "Table Pivot",
        "search": [
            "cell",
            "flip",
            "layout",
            "rotate",
            "row",
            "table"
        ]
    },
    {
        "icon": "bridge-suspension",
        "label": "Bridge Suspension",
        "search": [
            "bridge",
            "connect",
            "cross",
            "golden gate",
            "join",
            "overpass",
            "road",
            "span",
            "suspension"
        ]
    },
    {
        "icon": "scale-unbalanced-flip",
        "label": "Scale Unbalanced Flip",
        "search": [
            "justice",
            "legal",
            "measure",
            "unbalanced",
            "weight"
        ]
    },
    {
        "icon": "light-switch",
        "label": "Light Switch",
        "search": [
            "light",
            "off",
            "on"
        ]
    },
    {
        "icon": "arrows-to-circle",
        "label": "Arrows To Circle",
        "search": [
            "center",
            "concentrate",
            "coordinate",
            "coordination",
            "focal point",
            "focus",
            "insert"
        ]
    },
    {
        "icon": "ampersand",
        "label": "Ampersand",
        "search": [
            "Ampersand",
            "and"
        ]
    },
    {
        "icon": "chess-clock",
        "label": "Chess Clock",
        "search": [
            "board",
            "checkmate",
            "game",
            "strategy",
            "timer",
            "tournament"
        ]
    },
    {
        "icon": "envelope",
        "label": "Envelope",
        "search": [
            "Back of Envelope",
            "e-mail",
            "email",
            "envelope",
            "letter",
            "mail",
            "message",
            "newsletter",
            "notification",
            "offer",
            "support"
        ]
    },
    {
        "icon": "baby",
        "label": "Baby",
        "search": [
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "odysee",
        "label": "Odysee",
        "search": []
    },
    {
        "icon": "nfc-lock",
        "label": "Nfc Lock",
        "search": [
            "connect",
            "data",
            "near field communication",
            "nfc",
            "padlock",
            "privacy",
            "scan",
            "signal",
            "transfer",
            "wireless"
        ]
    },
    {
        "icon": "gg-circle",
        "label": "GG Currency Circle",
        "search": []
    },
    {
        "icon": "cloudflare",
        "label": "Cloudflare",
        "search": []
    },
    {
        "icon": "square-caret-down",
        "label": "Square Caret Down",
        "search": [
            "arrow",
            "caret-square-o-down",
            "dropdown",
            "expand",
            "insert",
            "menu",
            "more",
            "triangle"
        ]
    },
    {
        "icon": "hyphen",
        "label": "Hyphen",
        "search": [
            "Hyphen-Minus",
            "dash",
            "horizontal rule",
            "line",
            "minus"
        ]
    },
    {
        "icon": "plane-prop",
        "label": "Plane Prop",
        "search": [
            "aeroplane",
            "airplane",
            "airport",
            "fly",
            "sky",
            "small airplane"
        ]
    },
    {
        "icon": "tent",
        "label": "Tent",
        "search": [
            "bivouac",
            "campground",
            "campsite",
            "refugee",
            "shelter",
            "tent"
        ]
    },
    {
        "icon": "chimney",
        "label": "Chimney",
        "search": [
            "brick",
            "exhaust",
            "fireplace",
            "house",
            "roof",
            "vent"
        ]
    },
    {
        "icon": "a",
        "label": "A",
        "search": [
            "Latin Capital Letter A",
            "Latin Small Letter A",
            "letter"
        ]
    },
    {
        "icon": "circle-small",
        "label": "Circle Small",
        "search": [
            "dot",
            "period"
        ]
    },
    {
        "icon": "parachute-box",
        "label": "Parachute Box",
        "search": [
            "aid",
            "assistance",
            "goods",
            "relief",
            "rescue",
            "supplies"
        ]
    },
    {
        "icon": "cart-flatbed-boxes",
        "label": "Cart Flatbed Boxes",
        "search": [
            "carry",
            "inventory",
            "shipping",
            "transport"
        ]
    },
    {
        "icon": "hackerrank",
        "label": "Hackerrank",
        "search": []
    },
    {
        "icon": "cart-arrow-down",
        "label": "Cart Arrow Down",
        "search": [
            "download",
            "insert",
            "save",
            "shopping"
        ]
    },
    {
        "icon": "circle-7",
        "label": "Circle 7",
        "search": [
            "Circled Digit Seven",
            "Dingbat Circled Sans-Serif Digit Seven",
            "Dingbat Negative Circled Digit Seven",
            "Dingbat Negative Circled Sans-Serif Digit Seven",
            "seven"
        ]
    },
    {
        "icon": "lock-hashtag",
        "label": "Lock Hashtag",
        "search": [
            "number lock",
            "numeric lock",
            "numlock",
            "padlock",
            "privacy"
        ]
    },
    {
        "icon": "circle-sterling",
        "label": "Circle Sterling",
        "search": [
            "coin",
            "currency",
            "pound sign"
        ]
    },
    {
        "icon": "bridge-circle-exclamation",
        "label": "Bridge Circle Exclamation",
        "search": [
            "affected",
            "bridge",
            "failed",
            "road"
        ]
    },
    {
        "icon": "cloud-arrow-up",
        "label": "Cloud Arrow Up",
        "search": [
            "import",
            "save",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "at",
        "label": "At",
        "search": [
            "Commercial At",
            "address",
            "author",
            "e-mail",
            "email",
            "fluctuate",
            "handle"
        ]
    },
    {
        "icon": "indian-rupee-sign",
        "label": "Indian Rupee Sign",
        "search": [
            "Indian Rupee Sign",
            "currency"
        ]
    },
    {
        "icon": "truck",
        "label": "Truck",
        "search": [
            "Black Truck",
            "cargo",
            "delivery",
            "delivery truck",
            "shipping",
            "truck",
            "vehicle"
        ]
    },
    {
        "icon": "game-console-handheld-crank",
        "label": "Game Console Handheld Crank",
        "search": [
            "panic",
            "playdate",
            "video games"
        ]
    },
    {
        "icon": "skyatlas",
        "label": "skyatlas",
        "search": []
    },
    {
        "icon": "chalkboard-user",
        "label": "Chalkboard User",
        "search": [
            "blackboard",
            "instructor",
            "learning",
            "professor",
            "school",
            "uer",
            "whiteboard",
            "writing"
        ]
    },
    {
        "icon": "user-check",
        "label": "User Check",
        "search": [
            "employee",
            "enable",
            "uer",
            "users-people",
            "validate",
            "working"
        ]
    },
    {
        "icon": "chart-pie-simple-circle-currency",
        "label": "Chart Pie Simple Circle Currency",
        "search": [
            "analytics",
            "chart",
            "currency",
            "diagram",
            "graph",
            "margin",
            "money",
            "pie"
        ]
    },
    {
        "icon": "face-fearful",
        "label": "Face Fearful",
        "search": [
            "face",
            "fear",
            "fearful",
            "fearful face",
            "scared",
            "surprise"
        ]
    },
    {
        "icon": "user-ninja",
        "label": "User Ninja",
        "search": [
            "assassin",
            "avatar",
            "dangerous",
            "deadly",
            "fighter",
            "hidden",
            "ninja",
            "sneaky",
            "stealth",
            "uer"
        ]
    },
    {
        "icon": "frame",
        "label": "Frame",
        "search": [
            "artboard",
            "crop",
            "grid",
            "group",
            "viewbox"
        ]
    },
    {
        "icon": "plant-wilt",
        "label": "Plant Wilt",
        "search": [
            "drought",
            "planting",
            "vegetation",
            "wilt"
        ]
    },
    {
        "icon": "weight-scale",
        "label": "Weight Scale",
        "search": [
            "health",
            "measurement",
            "scale",
            "weight"
        ]
    },
    {
        "icon": "farm",
        "label": "Farm",
        "search": [
            "agriculture",
            "barn",
            "dairy",
            "farming",
            "ranch",
            "silo"
        ]
    },
    {
        "icon": "caret-right",
        "label": "Caret Right",
        "search": [
            "arrow",
            "forward",
            "next",
            "triangle"
        ]
    },
    {
        "icon": "hexagon-divide",
        "label": "Hexagon Divide",
        "search": [
            "algebra",
            "arithmetic",
            "division"
        ]
    },
    {
        "icon": "florin-sign",
        "label": "Florin Sign",
        "search": [
            "currency"
        ]
    },
    {
        "icon": "lightbulb-exclamation-on",
        "label": "Lightbulb Exclamation On",
        "search": [
            "bright",
            "failed",
            "idea",
            "thought"
        ]
    },
    {
        "icon": "bell",
        "label": "Bell",
        "search": [
            "alarm",
            "alert",
            "bel",
            "bell",
            "chime",
            "notification",
            "reminder",
            "request"
        ]
    },
    {
        "icon": "hand-back-point-left",
        "label": "Hand Back Point Left",
        "search": [
            "backhand",
            "backhand index pointing left",
            "direction",
            "finger",
            "hand",
            "index",
            "point"
        ]
    },
    {
        "icon": "lari-sign",
        "label": "Lari Sign",
        "search": [
            "Lari Sign",
            "currency"
        ]
    },
    {
        "icon": "cucumber",
        "label": "Cucumber",
        "search": [
            "cuke",
            "pickle",
            "zucchini"
        ]
    },
    {
        "icon": "deskpro",
        "label": "Deskpro",
        "search": []
    },
    {
        "icon": "resolving",
        "label": "Resolving",
        "search": []
    },
    {
        "icon": "seal",
        "label": "Seal",
        "search": [
            "badge",
            "certificate",
            "confirm",
            "guarantee"
        ]
    },
    {
        "icon": "circle-caret-down",
        "label": "Circle Caret Down",
        "search": [
            "arrow",
            "dropdown",
            "expand",
            "insert",
            "menu",
            "more",
            "triangle"
        ]
    },
    {
        "icon": "mill-sign",
        "label": "Mill Sign",
        "search": [
            "Mill Sign",
            "currency"
        ]
    },
    {
        "icon": "mug-tea-saucer",
        "label": "Mug Tea Saucer",
        "search": [
            "afternoon",
            "cuppa",
            "saucer"
        ]
    },
    {
        "icon": "cart-circle-check",
        "label": "Cart Circle Check",
        "search": [
            "cart",
            "enable",
            "grocery",
            "market",
            "shopping",
            "validate",
            "working"
        ]
    },
    {
        "icon": "blackberry",
        "label": "BlackBerry",
        "search": []
    },
    {
        "icon": "album",
        "label": "Album",
        "search": [
            "computer",
            "computer disk",
            "disk",
            "library",
            "minidisk",
            "music",
            "optical",
            "record",
            "song",
            "vinyl"
        ]
    },
    {
        "icon": "left-to-line",
        "label": "Left To Line",
        "search": [
            "back",
            "previous"
        ]
    },
    {
        "icon": "person-snowboarding",
        "label": "Person Snowboarding",
        "search": [
            "olympics",
            "ski",
            "snow",
            "snowboard",
            "snowboarder",
            "uer",
            "winter"
        ]
    },
    {
        "icon": "tty",
        "label": "Tty",
        "search": [
            "communication",
            "deaf",
            "telephone",
            "teletypewriter",
            "text"
        ]
    },
    {
        "icon": "users-rectangle",
        "label": "Users Rectangle",
        "search": [
            "crowd",
            "employee",
            "focus",
            "group",
            "people",
            "reached",
            "uer"
        ]
    },
    {
        "icon": "mobile",
        "label": "Mobile",
        "search": [
            "android",
            "call",
            "cell",
            "cell phone",
            "device",
            "mobile",
            "mobile phone",
            "number",
            "phone",
            "screen",
            "telephone",
            "text"
        ]
    },
    {
        "icon": "arrows-turn-to-dots",
        "label": "Arrows Turn To Dots",
        "search": [
            "destination",
            "insert",
            "nexus"
        ]
    },
    {
        "icon": "exclamation",
        "label": "Exclamation",
        "search": [
            "!",
            "Exclamation Mark",
            "alert",
            "attention",
            "danger",
            "error",
            "exclamation",
            "failed",
            "important",
            "mark",
            "notice",
            "notification",
            "notify",
            "outlined",
            "problem",
            "punctuation",
            "red exclamation mark",
            "required",
            "warning",
            "white exclamation mark"
        ]
    },
    {
        "icon": "location-xmark",
        "label": "Location Xmark",
        "search": [
            "agree",
            "archive",
            "coordinates",
            "delete",
            "destination",
            "location",
            "map",
            "navigation",
            "pin",
            "place",
            "remove",
            "uncheck",
            "x"
        ]
    },
    {
        "icon": "stripe-s",
        "label": "Stripe S",
        "search": []
    },
    {
        "icon": "church",
        "label": "Church",
        "search": [
            "Christian",
            "building",
            "cathedral",
            "chapel",
            "church",
            "community",
            "cross",
            "religion"
        ]
    },
    {
        "icon": "toggle-off",
        "label": "Toggle Off",
        "search": [
            "button",
            "off",
            "on",
            "switch"
        ]
    },
    {
        "icon": "face-nauseated",
        "label": "Face Nauseated",
        "search": [
            "digust",
            "face",
            "flu",
            "green",
            "mr yuck",
            "nauseated",
            "nauseated face",
            "sickness",
            "vomit"
        ]
    },
    {
        "icon": "deer",
        "label": "Deer",
        "search": [
            "animal",
            "antlers",
            "blitzen",
            "comet",
            "cupid",
            "dancer",
            "dasher",
            "dee",
            "deer",
            "donner",
            "fauna",
            "mammal",
            "prancer",
            "reindeer",
            "vixen"
        ]
    },
    {
        "icon": "box-open-full",
        "label": "Box Open Full",
        "search": [
            "attic",
            "package",
            "packed",
            "storage"
        ]
    },
    {
        "icon": "cherries",
        "label": "Cherries",
        "search": [
            "berries",
            "cherries",
            "cherry",
            "fruit",
            "pacman",
            "red",
            "stem"
        ]
    },
    {
        "icon": "vacuum-robot",
        "label": "Vacuum Robot",
        "search": [
            "cleaning",
            "floor",
            "roomba",
            "suck",
            "suction"
        ]
    },
    {
        "icon": "square-behance",
        "label": "Square Behance",
        "search": []
    },
    {
        "icon": "shoe-prints",
        "label": "Shoe Prints",
        "search": [
            "feet",
            "footprints",
            "steps",
            "walk"
        ]
    },
    {
        "icon": "squirrel",
        "label": "Squirrel",
        "search": [
            "animal",
            "chipmunk",
            "mammal",
            "marmot",
            "rat",
            "rodent",
            "tree"
        ]
    },
    {
        "icon": "file-circle-exclamation",
        "label": "File Circle Exclamation",
        "search": [
            "document",
            "failed",
            "file",
            "paper"
        ]
    },
    {
        "icon": "wallet",
        "label": "Wallet",
        "search": [
            "billfold",
            "cash",
            "currency",
            "money",
            "salary"
        ]
    },
    {
        "icon": "servicestack",
        "label": "Servicestack",
        "search": []
    },
    {
        "icon": "rocketchat",
        "label": "Rocket.Chat",
        "search": []
    },
    {
        "icon": "rebel",
        "label": "Rebel Alliance",
        "search": []
    },
    {
        "icon": "message",
        "label": "Message",
        "search": [
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "conversation",
            "discussion",
            "feedback",
            "message",
            "note",
            "notification",
            "sms",
            "speech",
            "talk",
            "talking",
            "texting"
        ]
    },
    {
        "icon": "trophy",
        "label": "Trophy",
        "search": [
            "achievement",
            "award",
            "cup",
            "game",
            "prize",
            "trophy",
            "winner"
        ]
    },
    {
        "icon": "face-dizzy",
        "label": "Face Dizzy",
        "search": [
            "dazed",
            "dead",
            "disapprove",
            "emoticon",
            "face"
        ]
    },
    {
        "icon": "square-web-awesome",
        "label": "Square Web Awesome",
        "search": [
            "awesome",
            "coding",
            "components",
            "crown",
            "web"
        ]
    },
    {
        "icon": "bacteria",
        "label": "Bacteria",
        "search": [
            "antibiotic",
            "antibody",
            "covid-19",
            "health",
            "organism",
            "sick"
        ]
    },
    {
        "icon": "toggle-large-on",
        "label": "Toggle Large On",
        "search": [
            "button",
            "off",
            "on",
            "switch"
        ]
    },
    {
        "icon": "ear-deaf",
        "label": "Ear Deaf",
        "search": [
            "ear",
            "hearing",
            "sign language"
        ]
    },
    {
        "icon": "people-arrows",
        "label": "People Arrows",
        "search": [
            "conversation",
            "discussion",
            "distance",
            "insert",
            "isolation",
            "separate",
            "social distancing",
            "talk",
            "talking",
            "together",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "treasure-chest",
        "label": "Treasure Chest",
        "search": [
            "Dungeons & Dragons",
            "booty",
            "d&d",
            "dnd",
            "fantasy",
            "gold",
            "hidden",
            "loot",
            "premium",
            "reward",
            "trap"
        ]
    },
    {
        "icon": "simplybuilt",
        "label": "SimplyBuilt",
        "search": []
    },
    {
        "icon": "hands-clapping",
        "label": "Hands Clapping",
        "search": [
            "applause",
            "clap",
            "clapping hands",
            "hand"
        ]
    },
    {
        "icon": "circle-ampersand",
        "label": "Circle Ampersand",
        "search": [
            "and"
        ]
    },
    {
        "icon": "virus-covid-slash",
        "label": "Virus Covid Slash",
        "search": [
            "bug",
            "covid-19",
            "disabled",
            "flu",
            "health",
            "infection",
            "pandemic",
            "vaccine",
            "viral",
            "virus"
        ]
    },
    {
        "icon": "chart-simple-horizontal",
        "label": "Chart Simple Horizontal",
        "search": [
            "analytics",
            "bar",
            "chart",
            "column",
            "graph",
            "performance",
            "row",
            "statistics",
            "trend"
        ]
    },
    {
        "icon": "down-from-dotted-line",
        "label": "Down From Dotted Line",
        "search": [
            "download",
            "export",
            "insert",
            "transfer"
        ]
    },
    {
        "icon": "calendar-days",
        "label": "Calendar Days",
        "search": [
            "calendar",
            "date",
            "day",
            "event",
            "month",
            "schedule",
            "time",
            "when",
            "year"
        ]
    },
    {
        "icon": "lighthouse",
        "label": "Lighthouse",
        "search": [
            "alert",
            "beacon",
            "breakwater",
            "cove",
            "ship",
            "tower",
            "warning"
        ]
    },
    {
        "icon": "diamond-turn-right",
        "label": "Diamond Turn Right",
        "search": [
            "map",
            "navigation",
            "sign",
            "turn"
        ]
    },
    {
        "icon": "stubber",
        "label": "Stubber",
        "search": []
    },
    {
        "icon": "apper",
        "label": "Apper Systems AB",
        "search": []
    },
    {
        "icon": "drone",
        "label": "Drone",
        "search": [
            "aerial",
            "big brother",
            "surveillance",
            "uav",
            "unmanned",
            "vehicle"
        ]
    },
    {
        "icon": "google-scholar",
        "label": "Google Scholar",
        "search": []
    },
    {
        "icon": "text",
        "label": "Text",
        "search": [
            "font",
            "format",
            "letter",
            "style",
            "typography"
        ]
    },
    {
        "icon": "toilet-paper-under-slash",
        "label": "Toilet Paper Under Slash",
        "search": [
            "bathroom",
            "disabled",
            "lavatory",
            "privy",
            "restroom",
            "roll",
            "toilet",
            "wipe"
        ]
    },
    {
        "icon": "hand-point-up",
        "label": "Hand Point Up",
        "search": [
            "finger",
            "hand",
            "hand-o-up",
            "index",
            "index pointing up",
            "point",
            "request",
            "up",
            "upgrade"
        ]
    },
    {
        "icon": "pen-slash",
        "label": "Pen Slash",
        "search": [
            "disabled",
            "modify",
            "remove",
            "style"
        ]
    },
    {
        "icon": "comment-plus",
        "label": "Comment Plus",
        "search": [
            "add",
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "create",
            "feedback",
            "message",
            "new",
            "note",
            "notification",
            "positive",
            "sms",
            "speech",
            "texting"
        ]
    },
    {
        "icon": "bezier-curve",
        "label": "Bezier Curve",
        "search": [
            "curves",
            "illustrator",
            "lines",
            "path",
            "vector"
        ]
    },
    {
        "icon": "clipboard-list-check",
        "label": "Clipboard List Check",
        "search": [
            "cheatsheet",
            "checklist",
            "completed",
            "done",
            "election",
            "enable",
            "finished",
            "intinerary",
            "ol",
            "schedule",
            "summary",
            "survey",
            "tick",
            "todo",
            "ul",
            "validate",
            "vote",
            "voting",
            "working"
        ]
    },
    {
        "icon": "lamp-desk",
        "label": "Lamp Desk",
        "search": [
            "bright",
            "furniture",
            "light"
        ]
    },
    {
        "icon": "person-half-dress",
        "label": "Person Half Dress",
        "search": [
            "gender",
            "man",
            "restroom",
            "transgender",
            "uer",
            "woman"
        ]
    },
    {
        "icon": "peanut",
        "label": "Peanut",
        "search": [
            "goober",
            "legume",
            "nut",
            "shell"
        ]
    },
    {
        "icon": "message-plus",
        "label": "Message Plus",
        "search": [
            "add",
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "create",
            "feedback",
            "message",
            "new",
            "note",
            "notification",
            "positive",
            "sms",
            "speech",
            "texting"
        ]
    },
    {
        "icon": "bracket-curly",
        "label": "Bracket Curly",
        "search": [
            "Left Curly Bracket",
            "braces",
            "code"
        ]
    },
    {
        "icon": "square-poll-horizontal",
        "label": "Square Poll Horizontal",
        "search": [
            "chart",
            "graph",
            "results",
            "statistics",
            "survey",
            "trend",
            "vote",
            "voting"
        ]
    },
    {
        "icon": "nfc-signal",
        "label": "Nfc Signal",
        "search": [
            "connect",
            "data",
            "near field communication",
            "nfc",
            "scan",
            "signal",
            "transfer",
            "wireless"
        ]
    },
    {
        "icon": "yarn",
        "label": "Yarn",
        "search": []
    },
    {
        "icon": "school-circle-xmark",
        "label": "School Circle Xmark",
        "search": [
            "destroy",
            "schoolhouse",
            "uncheck"
        ]
    },
    {
        "icon": "stack-overflow",
        "label": "Stack Overflow",
        "search": []
    },
    {
        "icon": "grapes",
        "label": "Grapes",
        "search": [
            "fruit",
            "grape",
            "grapes",
            "raisin",
            "vine",
            "vineyard",
            "wine"
        ]
    },
    {
        "icon": "hand-lizard",
        "label": "Hand Lizard",
        "search": [
            "game",
            "roshambo"
        ]
    },
    {
        "icon": "camera-slash",
        "label": "Camera Slash",
        "search": [
            "camera",
            "disabled",
            "img",
            "photo"
        ]
    },
    {
        "icon": "chalkboard",
        "label": "Chalkboard",
        "search": [
            "blackboard",
            "learning",
            "school",
            "teaching",
            "whiteboard",
            "writing"
        ]
    },
    {
        "icon": "memo-pad",
        "label": "Memo Pad",
        "search": [
            "cv",
            "file",
            "idea",
            "note",
            "notepad",
            "paper"
        ]
    },
    {
        "icon": "bluetooth",
        "label": "Bluetooth",
        "search": [
            "signal"
        ]
    },
    {
        "icon": "objects-align-center-horizontal",
        "label": "Objects Align Center Horizontal",
        "search": [
            "align",
            "distribute",
            "line",
            "rectangles"
        ]
    },
    {
        "icon": "distribute-spacing-vertical",
        "label": "Distribute Spacing Vertical",
        "search": [
            "align",
            "line",
            "padding",
            "rectangle",
            "spacing"
        ]
    },
    {
        "icon": "up-right-from-square",
        "label": "Up Right From Square",
        "search": [
            "external-link",
            "new",
            "open",
            "share",
            "upgrade"
        ]
    },
    {
        "icon": "rotate-exclamation",
        "label": "Rotate Exclamation",
        "search": [
            "attention",
            "failed",
            "redo",
            "sync",
            "warning"
        ]
    },
    {
        "icon": "right-from-line",
        "label": "Right From Line",
        "search": [
            "back",
            "previous"
        ]
    },
    {
        "icon": "circle-q",
        "label": "Circle Q",
        "search": [
            "Circled Latin Capital Letter Q",
            "letter"
        ]
    },
    {
        "icon": "moon-over-sun",
        "label": "Moon Over Sun",
        "search": [
            "lunar",
            "moon",
            "shadow",
            "solar",
            "sun"
        ]
    },
    {
        "icon": "360-degrees",
        "label": "360 Degrees",
        "search": [
            "3D",
            "panorama",
            "revolve",
            "rotate"
        ]
    },
    {
        "icon": "bracket-round-right",
        "label": "Bracket Round Right",
        "search": [
            "Right Parenthesis",
            "parentheses"
        ]
    },
    {
        "icon": "square-full",
        "label": "Square Full",
        "search": [
            "black large square",
            "block",
            "blue",
            "blue square",
            "box",
            "brown",
            "brown square",
            "geometric",
            "green",
            "green square",
            "orange",
            "orange square",
            "purple",
            "purple square",
            "red",
            "red square",
            "shape",
            "square",
            "white large square",
            "yellow",
            "yellow square"
        ]
    },
    {
        "icon": "star-sharp",
        "label": "Star Sharp",
        "search": [
            "Black Small Star",
            "critic",
            "quality",
            "ratings",
            "review",
            "sky",
            "vip"
        ]
    },
    {
        "icon": "list-radio",
        "label": "List Radio",
        "search": [
            "cheatsheet",
            "list",
            "order",
            "selection",
            "summary"
        ]
    },
    {
        "icon": "creative-commons-nc-jp",
        "label": "Creative Commons Noncommercial (Yen Sign)",
        "search": []
    },
    {
        "icon": "head-side-medical",
        "label": "Head Side Medical",
        "search": [
            "diagnosis",
            "face",
            "mental health",
            "profile",
            "psychiatric",
            "psychiatry",
            "uer"
        ]
    },
    {
        "icon": "tombstone",
        "label": "Tombstone",
        "search": [
            "cemetery",
            "cross",
            "dead",
            "death",
            "delete",
            "grave",
            "halloween",
            "holiday",
            "remove"
        ]
    },
    {
        "icon": "square-a-lock",
        "label": "Square A Lock",
        "search": [
            "capital",
            "capslock",
            "letter",
            "padlock",
            "privacy"
        ]
    },
    {
        "icon": "clover",
        "label": "Clover",
        "search": [
            "4",
            "charm",
            "clover",
            "four",
            "four leaf clover",
            "four-leaf clover",
            "leaf",
            "leprechaun",
            "luck",
            "lucky"
        ]
    },
    {
        "icon": "signal-bars-fair",
        "label": "Signal Bars Fair",
        "search": [
            "bars",
            "graph",
            "online",
            "reception",
            "status"
        ]
    },
    {
        "icon": "folder-heart",
        "label": "Folder Heart",
        "search": [
            "favorite",
            "file",
            "wishlist"
        ]
    },
    {
        "icon": "cloud-word",
        "label": "Cloud Word",
        "search": [
            "captions",
            "ideas",
            "subtitle",
            "subtitling"
        ]
    },
    {
        "icon": "screen-users",
        "label": "Screen Users",
        "search": [
            "chalkboard",
            "crowd",
            "employee",
            "group",
            "presentation",
            "students",
            "teachers",
            "team",
            "uer"
        ]
    },
    {
        "icon": "teeth-open",
        "label": "Teeth Open",
        "search": [
            "dental",
            "dentist",
            "gums bite",
            "mouth",
            "smile",
            "tooth"
        ]
    },
    {
        "icon": "circle-u",
        "label": "Circle U",
        "search": [
            "Circled Latin Capital Letter U",
            "letter"
        ]
    },
    {
        "icon": "calendar-heart",
        "label": "Calendar Heart",
        "search": [
            "date",
            "day",
            "favorite",
            "month",
            "rsvp",
            "valentine",
            "wishlist",
            "year"
        ]
    },
    {
        "icon": "narwhal",
        "label": "Narwhal",
        "search": [
            "animal",
            "fauna",
            "holiday",
            "ivory",
            "mammal",
            "tusk",
            "unicorn",
            "whale"
        ]
    },
    {
        "icon": "bars-staggered",
        "label": "Bars Staggered",
        "search": [
            "flow",
            "list",
            "timeline"
        ]
    },
    {
        "icon": "warehouse",
        "label": "Warehouse",
        "search": [
            "building",
            "capacity",
            "garage",
            "inventory",
            "storage"
        ]
    },
    {
        "icon": "swatchbook",
        "label": "Swatchbook",
        "search": [
            "Pantone",
            "color",
            "design",
            "hue",
            "palette"
        ]
    },
    {
        "icon": "circle-three-quarters",
        "label": "Circle Three Quarters",
        "search": [
            "chart",
            "fill",
            "pacman",
            "pie chart",
            "progress",
            "revenue"
        ]
    },
    {
        "icon": "campground",
        "label": "Campground",
        "search": [
            "camping",
            "fall",
            "outdoors",
            "teepee",
            "tent",
            "tipi"
        ]
    },
    {
        "icon": "person-walking-arrow-right",
        "label": "Person Walking Arrow Right",
        "search": [
            "exit",
            "follow",
            "internally displaced",
            "leave",
            "refugee",
            "uer"
        ]
    },
    {
        "icon": "spider-black-widow",
        "label": "Spider Black Widow",
        "search": [
            "alert",
            "arachnid",
            "bug",
            "charlotte",
            "crawl",
            "danger",
            "dangerous",
            "deadly",
            "eight",
            "error",
            "halloween"
        ]
    },
    {
        "icon": "glasses",
        "label": "Glasses",
        "search": [
            "hipster",
            "nerd",
            "reading",
            "sight",
            "spectacles",
            "vision"
        ]
    },
    {
        "icon": "circle-pause",
        "label": "Circle Pause",
        "search": [
            "hold",
            "wait"
        ]
    },
    {
        "icon": "memory",
        "label": "Memory",
        "search": [
            "DIMM",
            "RAM",
            "hardware",
            "storage",
            "technology"
        ]
    },
    {
        "icon": "gift",
        "label": "Gift",
        "search": [
            "box",
            "celebration",
            "christmas",
            "generosity",
            "gift",
            "giving",
            "holiday",
            "party",
            "present",
            "wrapped",
            "wrapped gift",
            "xmas"
        ]
    },
    {
        "icon": "sprinkler-ceiling",
        "label": "Sprinkler Ceiling",
        "search": [
            "emergency",
            "fire",
            "water"
        ]
    },
    {
        "icon": "square-phone-hangup",
        "label": "Square Phone Hangup",
        "search": [
            "call",
            "end",
            "handset"
        ]
    },
    {
        "icon": "money-bill-wheat",
        "label": "Money Bill Wheat",
        "search": [
            "agribusiness",
            "agriculture",
            "farming",
            "food",
            "investment",
            "livelihood",
            "subsidy"
        ]
    },
    {
        "icon": "dungeon",
        "label": "Dungeon",
        "search": [
            "Dungeons & Dragons",
            "building",
            "d&d",
            "dnd",
            "door",
            "entrance",
            "fantasy",
            "gate"
        ]
    },
    {
        "icon": "comet",
        "label": "Comet",
        "search": [
            "asteroid",
            "dust",
            "ice",
            "meteor",
            "orbit",
            "rock",
            "shooting star",
            "solar system",
            "space"
        ]
    },
    {
        "icon": "face-holding-back-tears",
        "label": "Face Holding Back Tears",
        "search": [
            "anger",
            "cry",
            "emotion",
            "sad",
            "upset"
        ]
    },
    {
        "icon": "card-heart",
        "label": "Card Heart",
        "search": [
            "ace",
            "card",
            "gamble",
            "playing card",
            "poker",
            "suit",
            "wishlist"
        ]
    },
    {
        "icon": "car-mirrors",
        "label": "Car Mirrors",
        "search": [
            "auto",
            "automobile",
            "sedan",
            "side-view",
            "transportation",
            "travel",
            "vehicle"
        ]
    },
    {
        "icon": "suitcase-medical",
        "label": "Suitcase Medical",
        "search": [
            "first aid",
            "firstaid",
            "health",
            "help",
            "medical",
            "supply",
            "support"
        ]
    },
    {
        "icon": "block-quote",
        "label": "Block Quote",
        "search": [
            "callout",
            "indent",
            "inset",
            "quote"
        ]
    },
    {
        "icon": "hands-holding-heart",
        "label": "Hands Holding Heart",
        "search": [
            "carry",
            "gift",
            "help",
            "hold",
            "lift",
            "wishlist"
        ]
    },
    {
        "icon": "arrow-up-small-big",
        "label": "Arrow Up Small Big",
        "search": [
            "arrange",
            "filter",
            "order",
            "rectangle"
        ]
    },
    {
        "icon": "sliders-simple",
        "label": "Sliders Simple",
        "search": [
            "adjust",
            "configuration",
            "modify",
            "off",
            "on",
            "settings",
            "toggles"
        ]
    },
    {
        "icon": "person-cane",
        "label": "Person Cane",
        "search": [
            "aging",
            "cane",
            "elderly",
            "old",
            "staff",
            "uer"
        ]
    },
    {
        "icon": "reddit",
        "label": "Reddit",
        "search": []
    },
    {
        "icon": "message-music",
        "label": "Message Music",
        "search": [
            "answer",
            "chat",
            "commenting",
            "conversation",
            "create",
            "message",
            "music",
            "note",
            "notification",
            "sing",
            "sms",
            "song",
            "texting"
        ]
    },
    {
        "icon": "gauge-low",
        "label": "Gauge Low",
        "search": [
            "dashboard",
            "fast",
            "odometer",
            "speed",
            "speedometer"
        ]
    },
    {
        "icon": "connectdevelop",
        "label": "Connect Develop",
        "search": []
    },
    {
        "icon": "vscode",
        "label": "vscode"
    },
    {
        "icon": "gauge",
        "label": "Gauge",
        "search": [
            "dashboard",
            "fast",
            "odometer",
            "speed",
            "speedometer"
        ]
    },
    {
        "icon": "envelope-open-text",
        "label": "Envelope Open Text",
        "search": [
            "e-mail",
            "email",
            "letter",
            "mail",
            "message",
            "newsletter",
            "notification",
            "offer",
            "support"
        ]
    },
    {
        "icon": "toolbox",
        "label": "Toolbox",
        "search": [
            "admin",
            "chest",
            "configuration",
            "container",
            "equipment",
            "fix",
            "maintenance",
            "mechanic",
            "modify",
            "repair",
            "settings",
            "tool",
            "toolbox",
            "tools"
        ]
    },
    {
        "icon": "wheat-slash",
        "label": "Wheat Slash",
        "search": [
            "disabled",
            "gluten",
            "gluten free",
            "wheat"
        ]
    },
    {
        "icon": "power-off",
        "label": "Power Off",
        "search": [
            "Power Symbol",
            "cancel",
            "computer",
            "on",
            "reboot",
            "restart"
        ]
    },
    {
        "icon": "researchgate",
        "label": "Researchgate",
        "search": []
    },
    {
        "icon": "signal",
        "label": "Signal",
        "search": [
            "antenna",
            "antenna bars",
            "bar",
            "bars",
            "cell",
            "graph",
            "mobile",
            "online",
            "phone",
            "reception",
            "status"
        ]
    },
    {
        "icon": "arrows-spin",
        "label": "Arrows Spin",
        "search": [
            "cycle",
            "rotate",
            "spin",
            "whirl"
        ]
    },
    {
        "icon": "joint",
        "label": "Joint",
        "search": [
            "blunt",
            "cannabis",
            "doobie",
            "drugs",
            "marijuana",
            "roach",
            "smoke",
            "smoking",
            "spliff"
        ]
    },
    {
        "icon": "down-from-line",
        "label": "Down From Line",
        "search": [
            "download",
            "export",
            "insert",
            "transfer"
        ]
    },
    {
        "icon": "tablet-rugged",
        "label": "Tablet Rugged",
        "search": [
            "device",
            "durable",
            "protection",
            "screen",
            "tough"
        ]
    },
    {
        "icon": "braille",
        "label": "Braille",
        "search": [
            "alphabet",
            "blind",
            "dots",
            "raised",
            "vision"
        ]
    },
    {
        "icon": "signal-messenger",
        "label": "Signal Messenger",
        "search": []
    },
    {
        "icon": "basket-shopping",
        "label": "Basket Shopping",
        "search": [
            "buy",
            "checkout",
            "grocery",
            "payment",
            "purchase"
        ]
    },
    {
        "icon": "xing",
        "label": "Xing",
        "search": []
    },
    {
        "icon": "party-bell",
        "label": "Party Bell",
        "search": [
            "ball",
            "celebrate",
            "celebration",
            "confetti",
            "confetti ball",
            "party",
            "tada"
        ]
    },
    {
        "icon": "car-wash",
        "label": "Car Wash",
        "search": [
            "auto",
            "automobile",
            "clean",
            "sedan",
            "transportation",
            "vehicle"
        ]
    },
    {
        "icon": "face-sunglasses",
        "label": "Face Sunglasses",
        "search": [
            "bright",
            "cool",
            "face",
            "friend",
            "shades",
            "smiling face with sunglasses",
            "sun",
            "sunglasses"
        ]
    },
    {
        "icon": "bridge",
        "label": "Bridge",
        "search": [
            "bridge",
            "road"
        ]
    },
    {
        "icon": "arrows-from-line",
        "label": "Arrows From Line",
        "search": [
            "expand",
            "grow"
        ]
    },
    {
        "icon": "up-to-line",
        "label": "Up To Line",
        "search": [
            "import",
            "transfer",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "plane-arrival",
        "label": "Plane Arrival",
        "search": [
            "aeroplane",
            "airplane",
            "airplane arrival",
            "airport",
            "arrivals",
            "arriving",
            "destination",
            "fly",
            "land",
            "landing",
            "location",
            "mode",
            "travel",
            "trip"
        ]
    },
    {
        "icon": "pot-food",
        "label": "Pot Food",
        "search": [
            "food",
            "pot",
            "soup",
            "stew"
        ]
    },
    {
        "icon": "cash-register",
        "label": "Cash Register",
        "search": [
            "buy",
            "cha-ching",
            "change",
            "checkout",
            "commerce",
            "leaerboard",
            "machine",
            "pay",
            "payment",
            "purchase",
            "store"
        ]
    },
    {
        "icon": "ring",
        "label": "Ring",
        "search": [
            "Dungeons & Dragons",
            "Gollum",
            "band",
            "binding",
            "d&d",
            "dnd",
            "engagement",
            "fantasy",
            "gold",
            "jewelry",
            "marriage",
            "precious",
            "premium"
        ]
    },
    {
        "icon": "message-xmark",
        "label": "Message Xmark",
        "search": [
            "answer",
            "archive",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "delete",
            "feedback",
            "message",
            "note",
            "notification",
            "remove",
            "sms",
            "speech",
            "texting",
            "uncheck",
            "x"
        ]
    },
    {
        "icon": "square-js",
        "label": "Square Js",
        "search": []
    },
    {
        "icon": "fonticons",
        "label": "Fonticons",
        "search": []
    },
    {
        "icon": "share-nodes",
        "label": "Share Nodes",
        "search": [
            "forward",
            "save",
            "send",
            "social"
        ]
    },
    {
        "icon": "octagon-divide",
        "label": "Octagon Divide",
        "search": [
            "algebra",
            "arithmetic",
            "division"
        ]
    },
    {
        "icon": "folder-arrow-up",
        "label": "Folder Arrow Up",
        "search": [
            "archive",
            "directory",
            "document",
            "file",
            "save",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "arrows-minimize",
        "label": "Arrows Minimize",
        "search": [
            "collapse",
            "minimize",
            "shrink"
        ]
    },
    {
        "icon": "ups",
        "label": "UPS",
        "search": [
            "United Parcel Service",
            "package",
            "shipping"
        ]
    },
    {
        "icon": "person-circle-exclamation",
        "label": "Person Circle Exclamation",
        "search": [
            "affected",
            "alert",
            "failed",
            "lost",
            "missing",
            "uer"
        ]
    },
    {
        "icon": "amazon-pay",
        "label": "Amazon Pay",
        "search": []
    },
    {
        "icon": "binoculars",
        "label": "Binoculars",
        "search": [
            "glasses",
            "inspection",
            "magnifier",
            "magnify",
            "scenic",
            "spyglass",
            "view"
        ]
    },
    {
        "icon": "grid-round-5",
        "label": "Grid Round 5",
        "search": [
            "app",
            "collection",
            "filter",
            "grid",
            "sort"
        ]
    },
    {
        "icon": "kip-sign",
        "label": "Kip Sign",
        "search": [
            "Kip Sign",
            "currency"
        ]
    },
    {
        "icon": "hard-drive",
        "label": "Hard Drive",
        "search": [
            "Hard Disk",
            "cpu",
            "hard drive",
            "harddrive",
            "machine",
            "save",
            "storage"
        ]
    },
    {
        "icon": "ranking-star",
        "label": "Ranking Star",
        "search": [
            "chart",
            "first place",
            "podium",
            "quality",
            "rank",
            "revenue",
            "win"
        ]
    },
    {
        "icon": "user-tie",
        "label": "User Tie",
        "search": [
            "administrator",
            "avatar",
            "business",
            "clothing",
            "employee",
            "formal",
            "offer",
            "portfolio",
            "professional",
            "suit",
            "uer"
        ]
    },
    {
        "icon": "ellipsis",
        "label": "Ellipsis",
        "search": [
            "dots",
            "drag",
            "kebab",
            "list",
            "menu",
            "nav",
            "navigation",
            "ol",
            "pacman",
            "reorder",
            "settings",
            "three dots",
            "ul"
        ]
    },
    {
        "icon": "arrow-turn-down-left",
        "label": "Arrow Turn Down Left",
        "search": [
            "enter",
            "keyboard",
            "return"
        ]
    },
    {
        "icon": "octagon-check",
        "label": "Octagon Check",
        "search": [
            "accept",
            "agree",
            "box",
            "button",
            "check",
            "checkmark",
            "confirm",
            "correct",
            "done",
            "enable",
            "mark",
            "ok",
            "select",
            "success",
            "tick",
            "todo",
            "validate",
            "working",
            "yes",
            "✓"
        ]
    },
    {
        "icon": "openid",
        "label": "OpenID",
        "search": []
    },
    {
        "icon": "store-slash",
        "label": "Store Slash",
        "search": [
            "building",
            "buy",
            "closed",
            "covid-19",
            "disabled",
            "purchase",
            "shopping"
        ]
    },
    {
        "icon": "percent",
        "label": "Percent",
        "search": [
            "Percent Sign",
            "discount",
            "fraction",
            "proportion",
            "rate",
            "ratio"
        ]
    },
    {
        "icon": "circle-n",
        "label": "Circle N",
        "search": [
            "Circled Latin Capital Letter N",
            "letter",
            "nay",
            "no"
        ]
    },
    {
        "icon": "file-zipper",
        "label": "File Zipper",
        "search": [
            ".zip",
            "bundle",
            "compress",
            "compression",
            "download",
            "zip"
        ]
    },
    {
        "icon": "trash-can-xmark",
        "label": "Trash Can Xmark",
        "search": [
            "cancel",
            "delete",
            "garbage",
            "hide",
            "remove",
            "uncheck"
        ]
    },
    {
        "icon": "display",
        "label": "Display",
        "search": [
            "Screen",
            "computer",
            "desktop",
            "imac"
        ]
    },
    {
        "icon": "ellipsis-stroke",
        "label": "Ellipsis Stroke",
        "search": [
            "dots",
            "drag",
            "kebab",
            "list",
            "menu",
            "nav",
            "navigation",
            "ol",
            "reorder",
            "settings",
            "three dots",
            "ul"
        ]
    },
    {
        "icon": "air-conditioner",
        "label": "Air Conditioner",
        "search": [
            "ac",
            "cool",
            "heat",
            "heat pump",
            "hvac",
            "mini-split",
            "temperature",
            "unit"
        ]
    },
    {
        "icon": "file-xls",
        "label": "File Xls",
        "search": [
            "csv",
            "document",
            "excel",
            "file",
            "numbers",
            "spreadsheets",
            "table"
        ]
    },
    {
        "icon": "pinata",
        "label": "Pinata",
        "search": [
            "celebration",
            "party",
            "piñata"
        ]
    },
    {
        "icon": "chart-fft",
        "label": "Chart Fft",
        "search": [
            "fast fourier transform",
            "frequency",
            "graph",
            "line",
            "vibration"
        ]
    },
    {
        "icon": "phone-intercom",
        "label": "Phone Intercom",
        "search": [
            "call",
            "phone",
            "warning"
        ]
    },
    {
        "icon": "turn-left-up",
        "label": "Turn Left Up",
        "search": [
            "direction",
            "forward",
            "north",
            "right",
            "turn"
        ]
    },
    {
        "icon": "scarf",
        "label": "Scarf",
        "search": [
            "clothing",
            "knitted",
            "neck",
            "scarf",
            "seasonal",
            "warmth"
        ]
    },
    {
        "icon": "message-pen",
        "label": "Message Pen",
        "search": [
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "edit",
            "feedback",
            "message",
            "modify",
            "note",
            "notification",
            "pen",
            "pencil",
            "sms",
            "speech",
            "texting",
            "update",
            "write"
        ]
    },
    {
        "icon": "icons",
        "label": "Icons",
        "search": [
            "bolt",
            "category",
            "emoji",
            "heart",
            "image",
            "music",
            "photo",
            "symbols"
        ]
    },
    {
        "icon": "file-xml",
        "label": "File Xml",
        "search": [
            "data",
            "document",
            "extensible",
            "file",
            "language",
            "markup"
        ]
    },
    {
        "icon": "ubuntu",
        "label": "Ubuntu",
        "search": [
            "linux",
            "operating system",
            "os"
        ]
    },
    {
        "icon": "ruler-vertical",
        "label": "Ruler Vertical",
        "search": [
            "design",
            "draft",
            "length",
            "measure",
            "planning"
        ]
    },
    {
        "icon": "viacoin",
        "label": "Viacoin",
        "search": []
    },
    {
        "icon": "map-location-dot",
        "label": "Map Location Dot",
        "search": [
            "address",
            "coordinates",
            "destination",
            "gps",
            "localize",
            "location",
            "map",
            "navigation",
            "paper",
            "pin",
            "place",
            "point of interest",
            "position",
            "route",
            "travel"
        ]
    },
    {
        "icon": "watermelon-slice",
        "label": "Watermelon Slice",
        "search": [
            "fruit",
            "seed",
            "watermelon",
            "wedge"
        ]
    },
    {
        "icon": "jack-o-lantern",
        "label": "Jack O Lantern",
        "search": [
            "carve",
            "celebration",
            "face",
            "halloween",
            "jack",
            "jack-o-lantern",
            "lantern",
            "pumpkin",
            "smile"
        ]
    },
    {
        "icon": "candy",
        "label": "Candy",
        "search": [
            "candy",
            "sugar",
            "sweet",
            "wrapper"
        ]
    },
    {
        "icon": "heart-crack",
        "label": "Heart Crack",
        "search": [
            "break",
            "breakup",
            "broken",
            "broken heart",
            "crushed",
            "dislike",
            "dumped",
            "grief",
            "love",
            "lovesick",
            "relationship",
            "sad"
        ]
    },
    {
        "icon": "cow",
        "label": "Cow",
        "search": [
            "agriculture",
            "animal",
            "beef",
            "bovine",
            "co",
            "cow",
            "farm",
            "fauna",
            "livestock",
            "mammal",
            "milk",
            "moo"
        ]
    },
    {
        "icon": "rss",
        "label": "Rss",
        "search": [
            "blog",
            "feed",
            "journal",
            "news",
            "writing"
        ]
    },
    {
        "icon": "magnifying-glass",
        "label": "Magnifying Glass",
        "search": [
            "bigger",
            "enlarge",
            "equipment",
            "find",
            "glass",
            "inspection",
            "magnifier",
            "magnify",
            "magnifying",
            "magnifying glass tilted left",
            "preview",
            "search",
            "tool",
            "zoom"
        ]
    },
    {
        "icon": "objects-align-left",
        "label": "Objects Align Left",
        "search": [
            "align",
            "distribute",
            "line",
            "rectangles"
        ]
    },
    {
        "icon": "cloud-moon",
        "label": "Cloud Moon",
        "search": [
            "crescent",
            "evening",
            "lunar",
            "night",
            "partly cloudy",
            "sky"
        ]
    },
    {
        "icon": "abacus",
        "label": "Abacus",
        "search": [
            "abacus",
            "addition",
            "ancient",
            "arithmetic",
            "calculation",
            "calculator",
            "counting",
            "hexadecimal",
            "math",
            "subtraction"
        ]
    },
    {
        "icon": "boxes-stacked",
        "label": "Boxes Stacked",
        "search": [
            "archives",
            "inventory",
            "storage",
            "warehouse"
        ]
    },
    {
        "icon": "code-branch",
        "label": "Code Branch",
        "search": [
            "branch",
            "git",
            "github",
            "mysql",
            "rebase",
            "sql",
            "svn",
            "vcs",
            "version"
        ]
    },
    {
        "icon": "zhihu",
        "label": "Zhihu",
        "search": []
    },
    {
        "icon": "ban",
        "label": "Ban",
        "search": [
            "404",
            "abort",
            "ban",
            "block",
            "cancel",
            "delete",
            "deny",
            "disabled",
            "entry",
            "failed",
            "forbidden",
            "hide",
            "no",
            "not",
            "not found",
            "prohibit",
            "prohibited",
            "remove",
            "stop",
            "trash"
        ]
    },
    {
        "icon": "person-carry-box",
        "label": "Person Carry Box",
        "search": [
            "deliver",
            "lift",
            "uer"
        ]
    },
    {
        "icon": "jug-detergent",
        "label": "Jug Detergent",
        "search": [
            "detergent",
            "laundry",
            "soap",
            "wash"
        ]
    },
    {
        "icon": "floppy-disk-pen",
        "label": "Floppy Disk Pen",
        "search": [
            "edit",
            "modify",
            "save",
            "save as"
        ]
    },
    {
        "icon": "lips",
        "label": "Lips",
        "search": [
            "Lips",
            "fashion",
            "kiss",
            "lips",
            "lipstick",
            "mouth",
            "smile"
        ]
    },
    {
        "icon": "outlet",
        "label": "Outlet",
        "search": [
            "electricity",
            "energy",
            "plug",
            "power"
        ]
    },
    {
        "icon": "reply",
        "label": "Reply",
        "search": [
            "mail",
            "message",
            "respond"
        ]
    },
    {
        "icon": "sun-plant-wilt",
        "label": "Sun Plant Wilt",
        "search": [
            "arid",
            "droop",
            "drought"
        ]
    },
    {
        "icon": "face-mask",
        "label": "Face Mask",
        "search": [
            "cold",
            "coronavirus",
            "covid",
            "covid-19",
            "doctor",
            "face",
            "face with medical mask",
            "mask",
            "medical",
            "sick",
            "surgical"
        ]
    },
    {
        "icon": "falafel",
        "label": "Falafel",
        "search": [
            "chickpea",
            "falafel",
            "garbanzo",
            "meatball"
        ]
    },
    {
        "icon": "tombstone-blank",
        "label": "Tombstone Blank",
        "search": [
            "cemetery",
            "cross",
            "dead",
            "death",
            "delete",
            "grave",
            "graveyard",
            "halloween",
            "headstone",
            "holiday",
            "remove",
            "tombstone"
        ]
    },
    {
        "icon": "circle-caret-up",
        "label": "Circle Caret Up",
        "search": [
            "arrow",
            "collapse",
            "triangle",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "lamp-street",
        "label": "Lamp Street",
        "search": [
            "light",
            "lighting",
            "utilities"
        ]
    },
    {
        "icon": "circle-b",
        "label": "Circle B",
        "search": [
            "Circled Latin Capital Letter B",
            "letter"
        ]
    },
    {
        "icon": "yandex",
        "label": "Yandex",
        "search": []
    },
    {
        "icon": "pixiv",
        "label": "Pixiv",
        "search": []
    },
    {
        "icon": "bacterium",
        "label": "Bacterium",
        "search": [
            "antibiotic",
            "antibody",
            "covid-19",
            "germ",
            "health",
            "organism",
            "sick"
        ]
    },
    {
        "icon": "square-7",
        "label": "Square 7",
        "search": [
            "seven"
        ]
    },
    {
        "icon": "magnifying-glass-arrows-rotate",
        "label": "Magnifying Glass Arrows Rotate",
        "search": [
            "clockwise",
            "exchange",
            "find",
            "glass",
            "inspection",
            "magnifier",
            "magnify",
            "magnifying",
            "magnifying glass tilted left",
            "modify",
            "preview",
            "refresh",
            "reload",
            "renew",
            "retry",
            "rotate",
            "search",
            "similar",
            "swap",
            "tool",
            "zoom"
        ]
    },
    {
        "icon": "square-i",
        "label": "Square I",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "sith",
        "label": "Sith",
        "search": []
    },
    {
        "icon": "standard-definition",
        "label": "Standard Definition",
        "search": [
            "low resolution"
        ]
    },
    {
        "icon": "alien-8bit",
        "label": "Alien 8bit",
        "search": [
            "ET",
            "alien",
            "alien monster",
            "creature",
            "extraterrestrial",
            "face",
            "humanoid",
            "monster",
            "space",
            "space invader",
            "strange",
            "ufo",
            "video game"
        ]
    },
    {
        "icon": "vacuum",
        "label": "Vacuum",
        "search": [
            "cleaning",
            "dyson",
            "floor",
            "suck",
            "suction"
        ]
    },
    {
        "icon": "bowl-chopsticks-noodles",
        "label": "Bowl Chopsticks Noodles",
        "search": [
            "bowl",
            "chopsticks",
            "noodle",
            "noodles",
            "ramen",
            "steaming",
            "steaming bowl"
        ]
    },
    {
        "icon": "nfc-directional",
        "label": "NFC Directional",
        "search": [
            "connect",
            "data",
            "near field communication",
            "nfc",
            "scan",
            "signal",
            "transfer",
            "wireless"
        ]
    },
    {
        "icon": "record-vinyl",
        "label": "Record Vinyl",
        "search": [
            "LP",
            "album",
            "analog",
            "music",
            "phonograph",
            "sound"
        ]
    },
    {
        "icon": "floppy-disk",
        "label": "Floppy Disk",
        "search": [
            "Black Hard Shell Floppy Disk",
            "computer",
            "disk",
            "download",
            "floppy",
            "floppy disk",
            "floppy-o"
        ]
    },
    {
        "icon": "down-left",
        "label": "Down Left",
        "search": [
            "South West Black Arrow",
            "diagonal",
            "direction",
            "southwest"
        ]
    },
    {
        "icon": "toilets-portable",
        "label": "Toilets Portable",
        "search": [
            "outhouse",
            "toilet"
        ]
    },
    {
        "icon": "o",
        "label": "O",
        "search": [
            "Latin Capital Letter O",
            "Latin Small Letter O",
            "letter"
        ]
    },
    {
        "icon": "palette",
        "label": "Palette",
        "search": [
            "acrylic",
            "art",
            "artist palette",
            "brush",
            "color",
            "fill",
            "museum",
            "paint",
            "painting",
            "palette",
            "pigment",
            "watercolor"
        ]
    },
    {
        "icon": "blueberries",
        "label": "Blueberries",
        "search": [
            "berry",
            "bilberry",
            "blue",
            "blueberries",
            "blueberry",
            "juice"
        ]
    },
    {
        "icon": "fish-bones",
        "label": "Fish Bones",
        "search": [
            "dead",
            "fish",
            "skeleton"
        ]
    },
    {
        "icon": "unlock",
        "label": "Unlock",
        "search": [
            "admin",
            "lock",
            "open",
            "padlock",
            "password",
            "privacy",
            "private",
            "protect",
            "unlock",
            "unlocked"
        ]
    },
    {
        "icon": "fan-table",
        "label": "Fan Table",
        "search": [
            "ac",
            "air conditioning",
            "blade",
            "blower",
            "cool",
            "hot",
            "oscillate"
        ]
    },
    {
        "icon": "ear-listen",
        "label": "Ear Listen",
        "search": [
            "amplify",
            "audio",
            "deaf",
            "ear",
            "headset",
            "hearing",
            "sound"
        ]
    },
    {
        "icon": "code-pull-request",
        "label": "Code Pull Request",
        "search": [
            "git",
            "github",
            "pr",
            "svn",
            "version"
        ]
    },
    {
        "icon": "key",
        "label": "Key",
        "search": [
            "key",
            "lock",
            "password",
            "private",
            "secret",
            "unlock"
        ]
    },
    {
        "icon": "snake",
        "label": "Snake",
        "search": [
            "Ophiuchus",
            "bearer",
            "cobra",
            "fauna",
            "reptile",
            "serpent",
            "slither",
            "snake",
            "zodiac"
        ]
    },
    {
        "icon": "circle-waveform-lines",
        "label": "Circle Waveform Lines",
        "search": [
            "signal"
        ]
    },
    {
        "icon": "empty-set",
        "label": "Empty Set",
        "search": [
            "Empty Set",
            "Latin Capital Letter O with Stroke",
            "math",
            "theory"
        ]
    },
    {
        "icon": "monkey",
        "label": "Monkey",
        "search": [
            "animal",
            "banana",
            "fauna",
            "mammal",
            "monke",
            "monkey",
            "tail"
        ]
    },
    {
        "icon": "forklift",
        "label": "Forklift",
        "search": [
            "archive",
            "inventory",
            "lorry",
            "maintenance",
            "pallet",
            "shipping",
            "tractor",
            "warehouse"
        ]
    },
    {
        "icon": "skull",
        "label": "Skull",
        "search": [
            "bones",
            "death",
            "face",
            "fairy tale",
            "monster",
            "skeleton",
            "skull",
            "uer",
            "x-ray",
            "yorick"
        ]
    },
    {
        "icon": "gamepad-modern",
        "label": "Gamepad Modern",
        "search": [
            "arcade",
            "controller",
            "d-pad",
            "game",
            "joystick",
            "playstore",
            "video",
            "video game"
        ]
    },
    {
        "icon": "square-k",
        "label": "Square K",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "comment-text",
        "label": "Comment Text",
        "search": [
            "answer",
            "chat",
            "font",
            "type"
        ]
    },
    {
        "icon": "mars-stroke-up",
        "label": "Mars Stroke Up",
        "search": [
            "Vertical Male with Stroke Sign",
            "gender"
        ]
    },
    {
        "icon": "creative-commons-by",
        "label": "Creative Commons Attribution",
        "search": []
    },
    {
        "icon": "cowbell",
        "label": "Cowbell",
        "search": [
            "Blue Öyster Cult",
            "Christopher Walken",
            "SNL",
            "The Bruce Dickinson",
            "Will Ferrell",
            "follow",
            "music"
        ]
    },
    {
        "icon": "fire-flame-simple",
        "label": "Fire Flame Simple",
        "search": [
            "caliente",
            "energy",
            "fire",
            "flame",
            "gas",
            "heat",
            "hot"
        ]
    },
    {
        "icon": "tree",
        "label": "Tree",
        "search": [
            "bark",
            "evergreen tree",
            "fall",
            "flora",
            "forest",
            "investment",
            "nature",
            "plant",
            "seasonal",
            "tree"
        ]
    },
    {
        "icon": "gauge-simple-min",
        "label": "Gauge Simple Min",
        "search": [
            "dashboard",
            "fast",
            "odometer",
            "speed",
            "speedometer"
        ]
    },
    {
        "icon": "comments-question-check",
        "label": "Comments Question Check",
        "search": [
            "answer",
            "chat",
            "enable",
            "faq",
            "help",
            "question",
            "request",
            "support",
            "validate",
            "working"
        ]
    },
    {
        "icon": "smog",
        "label": "Smog",
        "search": [
            "dragon",
            "fog",
            "haze",
            "pollution",
            "smoke",
            "weather"
        ]
    },
    {
        "icon": "s",
        "label": "S",
        "search": [
            "Latin Capital Letter S",
            "Latin Small Letter S",
            "letter"
        ]
    },
    {
        "icon": "phone-arrow-up-right",
        "label": "Phone Arrow Up Right",
        "search": [
            "call",
            "outgoing",
            "send",
            "upgrade"
        ]
    },
    {
        "icon": "teddy-bear",
        "label": "Teddy Bear",
        "search": [
            "plaything",
            "plush",
            "stuffed",
            "teddy bear",
            "toy"
        ]
    },
    {
        "icon": "umbraco",
        "label": "Umbraco",
        "search": []
    },
    {
        "icon": "slot-machine",
        "label": "Slot Machine",
        "search": [
            "gamble",
            "gambling",
            "game",
            "lucky",
            "slot",
            "slot machine",
            "vegas"
        ]
    },
    {
        "icon": "hooli",
        "label": "Hooli",
        "search": []
    },
    {
        "icon": "face-sleeping",
        "label": "Face Sleeping",
        "search": [
            "face",
            "sleep",
            "sleeping face",
            "snooze",
            "snoring",
            "zzz"
        ]
    },
    {
        "icon": "jedi",
        "label": "Jedi",
        "search": [
            "crest",
            "force",
            "sith",
            "skywalker",
            "star wars",
            "yoda"
        ]
    },
    {
        "icon": "police-box",
        "label": "Police Box",
        "search": [
            "doctor who",
            "tardis",
            "time and relative dimension in space",
            "time machine",
            "time travel"
        ]
    },
    {
        "icon": "dog-leashed",
        "label": "Dog Leashed",
        "search": [
            "accessibility",
            "animal",
            "blind",
            "canine",
            "fauna",
            "guide",
            "guide dog",
            "mammal",
            "pet",
            "pooch",
            "puppy",
            "walk",
            "woof"
        ]
    },
    {
        "icon": "person-hiking",
        "label": "Person Hiking",
        "search": [
            "autumn",
            "fall",
            "follow",
            "hike",
            "mountain",
            "outdoors",
            "summer",
            "uer",
            "walk"
        ]
    },
    {
        "icon": "arrows-up-to-line",
        "label": "Arrows Up To Line",
        "search": [
            "rise",
            "scale up",
            "upgrade"
        ]
    },
    {
        "icon": "pen-line",
        "label": "Pen Line",
        "search": [
            "draw",
            "modify",
            "write"
        ]
    },
    {
        "icon": "badge-percent",
        "label": "Badge Percent",
        "search": [
            "coupon",
            "deal",
            "discount",
            "guarantee",
            "investment",
            "money",
            "salary",
            "save",
            "usd"
        ]
    },
    {
        "icon": "square-git",
        "label": "Square Git",
        "search": []
    },
    {
        "icon": "mars-double",
        "label": "Mars Double",
        "search": [
            "Doubled Male Sign",
            "gay",
            "gender",
            "male",
            "men"
        ]
    },
    {
        "icon": "thermometer",
        "label": "Thermometer",
        "search": [
            "covid-19",
            "mercury",
            "status",
            "temperature"
        ]
    },
    {
        "icon": "paintbrush",
        "label": "Paintbrush",
        "search": [
            "acrylic",
            "art",
            "brush",
            "color",
            "fill",
            "modify",
            "paint",
            "paintbrush",
            "painting",
            "pigment",
            "watercolor"
        ]
    },
    {
        "icon": "signal-stream",
        "label": "Signal Stream",
        "search": [
            "podcast",
            "radio",
            "sisngal",
            "streaming",
            "wave",
            "wifi",
            "wireless",
            "www"
        ]
    },
    {
        "icon": "square-p",
        "label": "Square P",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "bee",
        "label": "Bee",
        "search": [
            "bee",
            "hive",
            "honey",
            "honeybee",
            "insect"
        ]
    },
    {
        "icon": "music-slash",
        "label": "Music Slash",
        "search": [
            "cancel",
            "disabled",
            "lyrics",
            "melody",
            "mute",
            "note",
            "off",
            "sing",
            "sound"
        ]
    },
    {
        "icon": "person-simple",
        "label": "Person Simple",
        "search": [
            "lavatory",
            "man",
            "men’s room",
            "restroom",
            "uer",
            "wc",
            "woman"
        ]
    },
    {
        "icon": "album-collection-circle-user",
        "label": "Album Collection Circle User",
        "search": [
            "artist",
            "catalog",
            "collection",
            "library",
            "music",
            "record",
            "shared",
            "song",
            "uer",
            "vinyl"
        ]
    },
    {
        "icon": "whale",
        "label": "Whale",
        "search": [
            "fauna",
            "mammal",
            "swimming",
            "whal",
            "whale"
        ]
    },
    {
        "icon": "arrow-up-triangle-square",
        "label": "Arrow Up Triangle Square",
        "search": [
            "arrange",
            "filter",
            "order",
            "shapes",
            "square",
            "triangle",
            "upgrade"
        ]
    },
    {
        "icon": "neuter",
        "label": "Neuter",
        "search": [
            "Neuter",
            "gender"
        ]
    },
    {
        "icon": "square-phone-flip",
        "label": "Square Phone Flip",
        "search": [
            "call",
            "earphone",
            "number",
            "support",
            "telephone",
            "voice"
        ]
    },
    {
        "icon": "odnoklassniki",
        "label": "Odnoklassniki",
        "search": []
    },
    {
        "icon": "circle-g",
        "label": "Circle G",
        "search": [
            "Circled Latin Capital Letter G",
            "letter"
        ]
    },
    {
        "icon": "circle-down-right",
        "label": "Circle Down Right",
        "search": [
            "diagonal",
            "southeast"
        ]
    },
    {
        "icon": "people-dress",
        "label": "People Dress",
        "search": [
            "couple",
            "hand",
            "holding hands",
            "together",
            "uer",
            "users-people",
            "women",
            "women holding hands"
        ]
    },
    {
        "icon": "circle-half",
        "label": "Circle Half",
        "search": [
            "Left Half Black Circle",
            "chart",
            "fill",
            "pie chart",
            "progress",
            "revenue"
        ]
    },
    {
        "icon": "face-grin-tongue-squint",
        "label": "Face Grin Tongue Squint",
        "search": [
            "LOL",
            "emoticon",
            "eye",
            "face",
            "horrible",
            "squinting face with tongue",
            "taste",
            "tongue"
        ]
    },
    {
        "icon": "pickaxe",
        "label": "Pickaxe",
        "search": [
            "axe",
            "climb",
            "ice",
            "mine",
            "mining",
            "mountaineering",
            "rock"
        ]
    },
    {
        "icon": "comment-dollar",
        "label": "Comment Dollar",
        "search": [
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "feedback",
            "message",
            "money",
            "note",
            "notification",
            "pay",
            "salary",
            "sms",
            "speech",
            "spend",
            "texting",
            "transfer"
        ]
    },
    {
        "icon": "list-timeline",
        "label": "List Timeline",
        "search": [
            "cheatsheet",
            "chronological",
            "deadline",
            "history",
            "linear",
            "summary"
        ]
    },
    {
        "icon": "swords-laser",
        "label": "Swords Laser",
        "search": [
            "clash",
            "darth vader",
            "duel",
            "fight",
            "jedi",
            "lightsaber",
            "luke skywalker",
            "rebel",
            "sith",
            "star wars"
        ]
    },
    {
        "icon": "hippo",
        "label": "Hippo",
        "search": [
            "animal",
            "fauna",
            "hippo",
            "hippopotamus",
            "hungry",
            "mammal"
        ]
    },
    {
        "icon": "sword-laser-alt",
        "label": "Sword Laser Alt",
        "search": [
            "darth vader",
            "empire",
            "lightsaber",
            "sith",
            "star wars"
        ]
    },
    {
        "icon": "flower",
        "label": "Flower",
        "search": [
            "Black Florette",
            "blossom",
            "daffodil",
            "flower",
            "nature",
            "spring",
            "summer"
        ]
    },
    {
        "icon": "bowl-food",
        "label": "Bowl Food",
        "search": [
            "catfood",
            "dogfood",
            "food",
            "rice"
        ]
    },
    {
        "icon": "drupal",
        "label": "Drupal Logo",
        "search": []
    },
    {
        "icon": "blogger-b",
        "label": "Blogger B",
        "search": []
    },
    {
        "icon": "globe-pointer",
        "label": "Globe Pointer",
        "search": [
            "World Wide Web",
            "cyberspace",
            "find",
            "globe",
            "internet",
            "link",
            "net",
            "search",
            "website",
            "www"
        ]
    },
    {
        "icon": "eggplant",
        "label": "Eggplant",
        "search": [
            "adventure island",
            "aubergine",
            "brinjal",
            "eggplant",
            "purple",
            "vegetable"
        ]
    },
    {
        "icon": "battery-slash",
        "label": "Battery Slash",
        "search": [
            "charge",
            "dead",
            "disabled",
            "power",
            "status"
        ]
    },
    {
        "icon": "film-slash",
        "label": "Film Slash",
        "search": [
            "cinema",
            "disabled",
            "movie",
            "strip",
            "video"
        ]
    },
    {
        "icon": "invision",
        "label": "InVision",
        "search": [
            "app",
            "design",
            "interface"
        ]
    },
    {
        "icon": "square-virus",
        "label": "Square Virus",
        "search": [
            "coronavirus",
            "covid-19",
            "disease",
            "flu",
            "infection",
            "pandemic"
        ]
    },
    {
        "icon": "tricycle-adult",
        "label": "Tricycle Adult",
        "search": [
            "adaptive",
            "bicycle",
            "bike",
            "peddle",
            "seat",
            "trike"
        ]
    },
    {
        "icon": "circle-phone-flip",
        "label": "Circle Phone Flip",
        "search": [
            "answer",
            "call",
            "handset",
            "telephone"
        ]
    },
    {
        "icon": "cloud-sun-rain",
        "label": "Cloud Sun Rain",
        "search": [
            "cloud",
            "day",
            "overcast",
            "precipitation",
            "rain",
            "storm",
            "summer",
            "sun",
            "sun behind rain cloud",
            "sunshower"
        ]
    },
    {
        "icon": "h4",
        "label": "H4",
        "search": [
            "format",
            "header",
            "text",
            "title"
        ]
    },
    {
        "icon": "circle-caret-right",
        "label": "Circle Caret Right",
        "search": [
            "arrow",
            "forward",
            "next",
            "triangle"
        ]
    },
    {
        "icon": "keyboard-brightness-low",
        "label": "Keyboard Brightness Low",
        "search": [
            "glow",
            "keyboard",
            "keycap",
            "light"
        ]
    },
    {
        "icon": "arrow-right-long",
        "label": "Arrow Right Long",
        "search": [
            "forward",
            "long-arrow-right",
            "next"
        ]
    },
    {
        "icon": "font-case",
        "label": "Font Case",
        "search": [
            "alphabet",
            "glyph",
            "lowercase",
            "text",
            "type",
            "typeface",
            "uppercase"
        ]
    },
    {
        "icon": "building-un",
        "label": "Building Un",
        "search": [
            "building",
            "city",
            "office",
            "united nations"
        ]
    },
    {
        "icon": "toilet-paper-xmark",
        "label": "Toilet Paper Xmark",
        "search": [
            "bathroom",
            "incorrect",
            "lavatory",
            "privy",
            "restroom",
            "roll",
            "toilet",
            "uncheck",
            "unsanitary",
            "wipe"
        ]
    },
    {
        "icon": "temperature-low",
        "label": "Temperature Low",
        "search": [
            "cold",
            "cool",
            "covid-19",
            "mercury",
            "thermometer",
            "winter"
        ]
    },
    {
        "icon": "h2",
        "label": "H2",
        "search": [
            "format",
            "header",
            "text",
            "title"
        ]
    },
    {
        "icon": "face-smile-halo",
        "label": "Face Smile Halo",
        "search": [
            "angel",
            "face",
            "fantasy",
            "halo",
            "happy",
            "innocent",
            "smiling face with halo"
        ]
    },
    {
        "icon": "facebook-f",
        "label": "Facebook F",
        "search": [
            "fabook",
            "facebook",
            "fb"
        ]
    },
    {
        "icon": "door-open",
        "label": "Door Open",
        "search": [
            "enter",
            "exit",
            "welcome"
        ]
    },
    {
        "icon": "align-left",
        "label": "Align Left",
        "search": [
            "format",
            "paragraph",
            "text"
        ]
    },
    {
        "icon": "centos",
        "label": "Centos",
        "search": [
            "linux",
            "operating system",
            "os"
        ]
    },
    {
        "icon": "pencil-slash",
        "label": "Pencil Slash",
        "search": [
            "disabled",
            "modify",
            "remove",
            "style"
        ]
    },
    {
        "icon": "cc-amazon-pay",
        "label": "Amazon Pay Credit Card",
        "search": []
    },
    {
        "icon": "camera",
        "label": "Camera",
        "search": [
            "image",
            "img",
            "lens",
            "photo",
            "picture",
            "record",
            "shutter",
            "video"
        ]
    },
    {
        "icon": "hat-winter",
        "label": "Hat Winter",
        "search": [
            "accessory",
            "clothing",
            "cold",
            "head",
            "knitted",
            "seasonal"
        ]
    },
    {
        "icon": "house-person-return",
        "label": "House Person Return",
        "search": [
            "home",
            "remote",
            "uer"
        ]
    },
    {
        "icon": "knife",
        "label": "Knife",
        "search": [
            "cut",
            "cutlery",
            "dining",
            "equipment",
            "silverware",
            "tool"
        ]
    },
    {
        "icon": "message-exclamation",
        "label": "Message Exclamation",
        "search": [
            "alert",
            "answer",
            "attention",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "error",
            "exclaim",
            "failed",
            "feedback",
            "important",
            "message",
            "note",
            "notification",
            "request",
            "required",
            "sms",
            "speech",
            "surprise",
            "texting",
            "warning"
        ]
    },
    {
        "icon": "right-to-line",
        "label": "Right To Line",
        "search": [
            "forward",
            "next"
        ]
    },
    {
        "icon": "mailbox",
        "label": "Mailbox",
        "search": [
            "archive",
            "closed",
            "closed mailbox with lowered flag",
            "envelope",
            "letter",
            "lowered",
            "mail",
            "mailbox",
            "newsletter",
            "offer",
            "post office",
            "postal",
            "postbox",
            "postcard",
            "send",
            "stamp",
            "usps"
        ]
    },
    {
        "icon": "message-heart",
        "label": "Message Heart",
        "search": [
            "bubble",
            "comment",
            "favorite",
            "happy",
            "love"
        ]
    },
    {
        "icon": "message-middle-top",
        "label": "Message Middle Top",
        "search": [
            "answer",
            "contact",
            "conversation",
            "conversation",
            "discussion",
            "sms",
            "talk",
            "talking"
        ]
    },
    {
        "icon": "users-rays",
        "label": "Users Rays",
        "search": [
            "affected",
            "crowd",
            "employee",
            "focused",
            "group",
            "people",
            "uer"
        ]
    },
    {
        "icon": "circles-overlap",
        "label": "Circles Overlap",
        "search": [
            "chart",
            "combine",
            "intersection",
            "logic",
            "overlap",
            "partnership",
            "venn"
        ]
    },
    {
        "icon": "rainbow",
        "label": "Rainbow",
        "search": [
            "gold",
            "leprechaun",
            "prism",
            "rain",
            "rainbow",
            "sky"
        ]
    },
    {
        "icon": "sitemap",
        "label": "Sitemap",
        "search": [
            "directory",
            "hierarchy",
            "ia",
            "information architecture",
            "organization"
        ]
    },
    {
        "icon": "caravan-simple",
        "label": "Caravan Simple",
        "search": [
            "camper",
            "motor home",
            "rv",
            "trailer",
            "travel"
        ]
    },
    {
        "icon": "face-grin-stars",
        "label": "Face Grin Stars",
        "search": [
            "emoticon",
            "eyes",
            "face",
            "grinning",
            "quality",
            "star",
            "star-struck",
            "starry-eyed",
            "vip"
        ]
    },
    {
        "icon": "message-sms",
        "label": "Message Sms",
        "search": [
            "chat"
        ]
    },
    {
        "icon": "comments-question",
        "label": "Comments Question",
        "search": [
            "answer",
            "chat",
            "faq",
            "help",
            "question",
            "request",
            "support"
        ]
    },
    {
        "icon": "sort-up",
        "label": "Sort Up",
        "search": [
            "arrow",
            "ascending",
            "filter",
            "order",
            "sort-asc",
            "upgrade"
        ]
    },
    {
        "icon": "billboard",
        "label": "Billboard",
        "search": [
            "advertising",
            "promotion",
            "sign",
            "signboard",
            "slogan poster"
        ]
    },
    {
        "icon": "eye",
        "label": "Eye",
        "search": [
            "body",
            "eye",
            "look",
            "optic",
            "see",
            "seen",
            "show",
            "sight",
            "views",
            "visible"
        ]
    },
    {
        "icon": "arrow-down-small-big",
        "label": "Arrow Down Small Big",
        "search": [
            "arrange",
            "filter",
            "order",
            "rectangle"
        ]
    },
    {
        "icon": "axe",
        "label": "Axe",
        "search": [
            "axe",
            "blade",
            "chop",
            "cut",
            "equipment",
            "fall",
            "hatchet",
            "lumberjack",
            "outdoors",
            "sharp",
            "split",
            "swing",
            "tool",
            "weapon",
            "wood"
        ]
    },
    {
        "icon": "caret-left",
        "label": "Caret Left",
        "search": [
            "arrow",
            "back",
            "previous",
            "triangle"
        ]
    },
    {
        "icon": "apple-whole",
        "label": "Apple Whole",
        "search": [
            "apple",
            "fall",
            "fruit",
            "fuji",
            "green",
            "green apple",
            "macintosh",
            "orchard",
            "red",
            "red apple",
            "seasonal",
            "vegan"
        ]
    },
    {
        "icon": "ebay",
        "label": "eBay",
        "search": []
    },
    {
        "icon": "scroll-torah",
        "label": "Scroll Torah",
        "search": [
            "book",
            "jewish",
            "judaism",
            "religion",
            "scroll"
        ]
    },
    {
        "icon": "house-lock",
        "label": "House Lock",
        "search": [
            "closed",
            "home",
            "house",
            "lockdown",
            "padlock",
            "privacy",
            "quarantine"
        ]
    },
    {
        "icon": "arrows-left-right-to-line",
        "label": "Arrows Left Right To Line",
        "search": [
            "analysis",
            "expand",
            "gap"
        ]
    },
    {
        "icon": "trash",
        "label": "Trash",
        "search": [
            "delete",
            "garbage",
            "hide",
            "remove"
        ]
    },
    {
        "icon": "face-sad-tear",
        "label": "Face Sad Tear",
        "search": [
            "cry",
            "crying face",
            "emoticon",
            "face",
            "sad",
            "tear",
            "tears"
        ]
    },
    {
        "icon": "tire-flat",
        "label": "Tire Flat",
        "search": [
            "auto",
            "car",
            "rim",
            "rubber",
            "wheel"
        ]
    },
    {
        "icon": "melon",
        "label": "Melon",
        "search": [
            "cantaloupe",
            "fruit",
            "honeydew",
            "melon",
            "muskmelon",
            "watermelon"
        ]
    },
    {
        "icon": "fax",
        "label": "Fax",
        "search": [
            "Fax Icon",
            "business",
            "communicate",
            "copy",
            "facsimile",
            "fax",
            "fax machine",
            "send"
        ]
    },
    {
        "icon": "gitbook",
        "label": "gitbook"
    },
    {
        "icon": "arrow-left-long-to-line",
        "label": "Arrow Left Long To Line",
        "search": [
            "back",
            "delete",
            "insert",
            "left"
        ]
    },
    {
        "icon": "user-music",
        "label": "User Music",
        "search": [
            "artist",
            "music",
            "musician",
            "singer",
            "uer"
        ]
    },
    {
        "icon": "person-circle-plus",
        "label": "Person Circle Plus",
        "search": [
            "add",
            "follow",
            "found",
            "uer"
        ]
    },
    {
        "icon": "hamsa",
        "label": "Hamsa",
        "search": [
            "amulet",
            "christianity",
            "islam",
            "jewish",
            "judaism",
            "muslim",
            "protection"
        ]
    },
    {
        "icon": "house-building",
        "label": "House Building",
        "search": [
            "abode",
            "apartment",
            "building",
            "city",
            "home",
            "residence",
            "suburbs",
            "urban"
        ]
    },
    {
        "icon": "contao",
        "label": "Contao",
        "search": []
    },
    {
        "icon": "ello",
        "label": "Ello",
        "search": []
    },
    {
        "icon": "sistrix",
        "label": "SISTRIX",
        "search": []
    },
    {
        "icon": "person-circle-question",
        "label": "Person Circle Question",
        "search": [
            "faq",
            "lost",
            "missing",
            "request",
            "uer"
        ]
    },
    {
        "icon": "crate-empty",
        "label": "Crate Empty",
        "search": [
            "box",
            "crate"
        ]
    },
    {
        "icon": "sun-haze",
        "label": "Sun Haze",
        "search": [
            "fog",
            "heat",
            "hot",
            "sweltering"
        ]
    },
    {
        "icon": "circle-3",
        "label": "Circle 3",
        "search": [
            "Circled Digit Three",
            "Dingbat Circled Sans-Serif Digit Three",
            "Dingbat Negative Circled Digit Three",
            "Dingbat Negative Circled Sans-Serif Digit Three",
            "three"
        ]
    },
    {
        "icon": "clipboard-check",
        "label": "Clipboard Check",
        "search": [
            "accept",
            "agree",
            "confirm",
            "coupon",
            "done",
            "enable",
            "ok",
            "select",
            "success",
            "tick",
            "todo",
            "validate",
            "working",
            "yes"
        ]
    },
    {
        "icon": "periscope",
        "label": "Periscope",
        "search": []
    },
    {
        "icon": "share-from-square",
        "label": "Share From Square",
        "search": [
            "forward",
            "save",
            "send",
            "social"
        ]
    },
    {
        "icon": "fork-knife",
        "label": "Fork Knife",
        "search": [
            "cutlery",
            "dining",
            "dinner",
            "eat",
            "food",
            "fork",
            "knife",
            "restaurant"
        ]
    },
    {
        "icon": "receipt",
        "label": "Receipt",
        "search": [
            "accounting",
            "bookkeeping",
            "check",
            "coupon",
            "evidence",
            "invoice",
            "money",
            "pay",
            "proof",
            "receipt",
            "table"
        ]
    },
    {
        "icon": "equals",
        "label": "Equals",
        "search": [
            "Equals Sign",
            "arithmetic",
            "even",
            "match",
            "math"
        ]
    },
    {
        "icon": "diagram-lean-canvas",
        "label": "Diagram Lean Canvas",
        "search": [
            "columns",
            "grid",
            "rows"
        ]
    },
    {
        "icon": "chevron-up",
        "label": "Chevron Up",
        "search": [
            "arrow",
            "collapse",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "virus-slash",
        "label": "Virus Slash",
        "search": [
            "bug",
            "coronavirus",
            "covid-19",
            "cure",
            "disabled",
            "eliminate",
            "flu",
            "health",
            "infection",
            "pandemic",
            "sick",
            "vaccine",
            "viral"
        ]
    },
    {
        "icon": "globe-stand",
        "label": "Globe Stand",
        "search": [
            "earth",
            "geography",
            "global",
            "localize",
            "location",
            "map",
            "travel",
            "world",
            "www"
        ]
    },
    {
        "icon": "ring-diamond",
        "label": "Ring Diamond",
        "search": [
            "diamond",
            "engagement",
            "gold",
            "ice",
            "marriage",
            "matrimony",
            "platinum",
            "premium",
            "proposal",
            "rock",
            "sparkle"
        ]
    },
    {
        "icon": "phone-rotary",
        "label": "Phone Rotary",
        "search": [
            "call",
            "earphone",
            "number",
            "phone",
            "retro",
            "support",
            "telephone",
            "vintage",
            "voice"
        ]
    },
    {
        "icon": "slash",
        "label": "Slash",
        "search": [
            "cancel",
            "close",
            "mute",
            "off",
            "stop",
            "x"
        ]
    },
    {
        "icon": "arrow-down-to-dotted-line",
        "label": "Arrow Down To Dotted Line",
        "search": [
            "download",
            "export",
            "insert",
            "transfer"
        ]
    },
    {
        "icon": "saxophone-fire",
        "label": "Saxophone Fire",
        "search": [
            "brass",
            "fire",
            "flame",
            "instrument",
            "jazz",
            "music",
            "saxophone",
            "woodwind"
        ]
    },
    {
        "icon": "window-frame-open",
        "label": "Window Frame Open",
        "search": [
            "door",
            "glass",
            "pane",
            "view",
            "window"
        ]
    },
    {
        "icon": "circle-d",
        "label": "Circle D",
        "search": [
            "Circled Latin Capital Letter D",
            "letter"
        ]
    },
    {
        "icon": "expand",
        "label": "Expand",
        "search": [
            "arrows",
            "bigger",
            "enlarge",
            "expand",
            "fullscreen",
            "maximize",
            "resize",
            "resize",
            "scale",
            "size",
            "viewfinder"
        ]
    },
    {
        "icon": "file-mp4",
        "label": "File Mp4",
        "search": [
            "document",
            "film",
            "movie",
            "mp4",
            "mpeg",
            "video"
        ]
    },
    {
        "icon": "note-sticky",
        "label": "Note Sticky",
        "search": [
            "message",
            "note",
            "paper",
            "reminder",
            "sticker"
        ]
    },
    {
        "icon": "dolphin",
        "label": "Dolphin",
        "search": [
            "aquarium",
            "dolphin",
            "fish",
            "flipper",
            "mammal",
            "marine",
            "maritime",
            "porpoise"
        ]
    },
    {
        "icon": "border-bottom",
        "label": "Border Bottom",
        "search": [
            "cell",
            "grid",
            "outline",
            "stroke",
            "table"
        ]
    },
    {
        "icon": "signal-weak",
        "label": "Signal Weak",
        "search": [
            "bars",
            "graph",
            "online",
            "reception",
            "status"
        ]
    },
    {
        "icon": "table-columns",
        "label": "Table Columns",
        "search": [
            "browser",
            "category",
            "dashboard",
            "organize",
            "panes",
            "split"
        ]
    },
    {
        "icon": "person-shelter",
        "label": "Person Shelter",
        "search": [
            "house",
            "inside",
            "roof",
            "safe",
            "safety",
            "shelter",
            "uer"
        ]
    },
    {
        "icon": "camera-security",
        "label": "Camera Security",
        "search": [
            "chat",
            "conference call",
            "facetime",
            "podcast",
            "security",
            "video",
            "videoconferencing",
            "youtube"
        ]
    },
    {
        "icon": "circle-notch",
        "label": "Circle Notch",
        "search": [
            "circle-o-notch",
            "diameter",
            "dot",
            "ellipse",
            "round",
            "spinner"
        ]
    },
    {
        "icon": "water",
        "label": "Water",
        "search": [
            "lake",
            "liquid",
            "ocean",
            "sea",
            "swim",
            "wet"
        ]
    },
    {
        "icon": "delete-left",
        "label": "Delete Left",
        "search": [
            "Erase to the Left",
            "command",
            "delete",
            "erase",
            "keyboard",
            "undo"
        ]
    },
    {
        "icon": "expeditedssl",
        "label": "ExpeditedSSL",
        "search": []
    },
    {
        "icon": "arrow-down-to-square",
        "label": "Arrow Down To Square",
        "search": [
            "download",
            "insert",
            "share",
            "transfer"
        ]
    },
    {
        "icon": "square-b",
        "label": "Square B",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "napster",
        "label": "Napster",
        "search": []
    },
    {
        "icon": "broom-ball",
        "label": "Broom Ball",
        "search": [
            "ball",
            "bludger",
            "broom",
            "golden snitch",
            "harry potter",
            "hogwarts",
            "quaffle",
            "sport",
            "wizard"
        ]
    },
    {
        "icon": "delicious",
        "label": "Delicious",
        "search": []
    },
    {
        "icon": "h6",
        "label": "H6",
        "search": [
            "format",
            "header",
            "text",
            "title"
        ]
    },
    {
        "icon": "j",
        "label": "J",
        "search": [
            "Latin Capital Letter J",
            "Latin Small Letter J",
            "letter"
        ]
    },
    {
        "icon": "guilded",
        "label": "Guilded",
        "search": []
    },
    {
        "icon": "shuttle-space",
        "label": "Shuttle Space",
        "search": [
            "astronaut",
            "machine",
            "nasa",
            "rocket",
            "space",
            "transportation"
        ]
    },
    {
        "icon": "yin-yang",
        "label": "Yin Yang",
        "search": [
            "daoism",
            "opposites",
            "religion",
            "tao",
            "taoism",
            "taoist",
            "yang",
            "yin",
            "yin yang"
        ]
    },
    {
        "icon": "signal-good",
        "label": "Signal Good",
        "search": [
            "bars",
            "graph",
            "online",
            "reception",
            "status"
        ]
    },
    {
        "icon": "stop",
        "label": "Stop",
        "search": [
            "block",
            "box",
            "square",
            "stop",
            "stop button"
        ]
    },
    {
        "icon": "trowel",
        "label": "Trowel",
        "search": [
            "build",
            "construction",
            "equipment",
            "maintenance",
            "tool"
        ]
    },
    {
        "icon": "circle-2",
        "label": "Circle 2",
        "search": [
            "Circled Digit Two",
            "Dingbat Circled Sans-Serif Digit Two",
            "Dingbat Negative Circled Digit Two",
            "Dingbat Negative Circled Sans-Serif Digit Two",
            "two"
        ]
    },
    {
        "icon": "drumstick",
        "label": "Drumstick",
        "search": [
            "bone",
            "chicken",
            "drumstick",
            "leg",
            "meat",
            "poultry",
            "poultry leg",
            "turkey"
        ]
    },
    {
        "icon": "square-x",
        "label": "Square X",
        "search": [
            "letter",
            "uncheck"
        ]
    },
    {
        "icon": "peapod",
        "label": "Peapod",
        "search": [
            "pea",
            "seed"
        ]
    },
    {
        "icon": "xbox",
        "label": "Xbox",
        "search": []
    },
    {
        "icon": "message-text",
        "label": "Message Text",
        "search": [
            "answer",
            "contact",
            "font",
            "text",
            "type"
        ]
    },
    {
        "icon": "hand-back-fist",
        "label": "Hand Back Fist",
        "search": [
            "fist",
            "game",
            "roshambo"
        ]
    },
    {
        "icon": "untappd",
        "label": "Untappd",
        "search": []
    },
    {
        "icon": "snowman-head",
        "label": "Snowman Head",
        "search": [
            "carrot",
            "hat",
            "snowman",
            "winter"
        ]
    },
    {
        "icon": "blanket",
        "label": "Blanket",
        "search": [
            "bed",
            "cover",
            "cozy",
            "sleep",
            "warm"
        ]
    },
    {
        "icon": "comment-xmark",
        "label": "Comment Xmark",
        "search": [
            "answer",
            "archive",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "delete",
            "feedback",
            "message",
            "note",
            "notification",
            "remove",
            "sms",
            "speech",
            "texting",
            "uncheck",
            "x"
        ]
    },
    {
        "icon": "google-plus-g",
        "label": "Google Plus G",
        "search": [
            "google-plus",
            "social network"
        ]
    },
    {
        "icon": "person-dolly-empty",
        "label": "Person Dolly Empty",
        "search": [
            "carry",
            "deliver",
            "transport",
            "uer"
        ]
    },
    {
        "icon": "signal-slash",
        "label": "Signal Slash",
        "search": [
            "bars",
            "disabled",
            "disconnect",
            "graph",
            "online",
            "reception",
            "status"
        ]
    },
    {
        "icon": "hexagon-plus",
        "label": "Hexagon Plus",
        "search": [
            "add",
            "create",
            "expand",
            "new",
            "positive",
            "shape"
        ]
    },
    {
        "icon": "temperature-high",
        "label": "Temperature High",
        "search": [
            "cook",
            "covid-19",
            "mercury",
            "summer",
            "thermometer",
            "warm"
        ]
    },
    {
        "icon": "greater-than",
        "label": "Greater Than",
        "search": [
            "Greater-Than Sign",
            "arithmetic",
            "compare",
            "math"
        ]
    },
    {
        "icon": "toothbrush",
        "label": "Toothbrush",
        "search": [
            "bathroom",
            "bicuspid",
            "brush",
            "clean",
            "dental",
            "dentist",
            "hygiene",
            "molar",
            "mouth",
            "teeth",
            "toothbrush"
        ]
    },
    {
        "icon": "flute",
        "label": "Flute",
        "search": [
            "aerophone",
            "instrument",
            "music",
            "pied piper",
            "woodwind"
        ]
    },
    {
        "icon": "lobster",
        "label": "Lobster",
        "search": [
            "bisque",
            "claes",
            "crustacean",
            "lobster",
            "seafood",
            "shellfish"
        ]
    },
    {
        "icon": "calendar-circle-exclamation",
        "label": "Calendar Circle Exclamation",
        "search": [
            "alert",
            "calendar",
            "date",
            "day",
            "error",
            "event",
            "failed",
            "important",
            "month",
            "schedule",
            "time",
            "when",
            "year"
        ]
    },
    {
        "icon": "github-alt",
        "label": "Alternate GitHub",
        "search": [
            "octocat"
        ]
    },
    {
        "icon": "crutch",
        "label": "Crutch",
        "search": [
            "cane",
            "injury",
            "mobility",
            "wheelchair"
        ]
    },
    {
        "icon": "command",
        "label": "Command",
        "search": [
            "Place of Interest Sign",
            "apple key",
            "loop"
        ]
    },
    {
        "icon": "tv-retro",
        "label": "Tv Retro",
        "search": [
            "computer",
            "display",
            "monitor",
            "television",
            "tv",
            "video"
        ]
    },
    {
        "icon": "get-pocket",
        "label": "Get Pocket",
        "search": []
    },
    {
        "icon": "paw-claws",
        "label": "Paw Claws",
        "search": [
            "Dungeons & Dragons",
            "animal",
            "beast",
            "d&d",
            "dnd",
            "fantasy",
            "lion",
            "pet",
            "print"
        ]
    },
    {
        "icon": "face-smile-upside-down",
        "label": "Face Smile Upside Down",
        "search": [
            "awkward",
            "face",
            "humor",
            "irony",
            "sarcasm",
            "silly",
            "upside-down",
            "upside-down face"
        ]
    },
    {
        "icon": "glass-empty",
        "label": "Glass Empty",
        "search": [
            "drink",
            "water"
        ]
    },
    {
        "icon": "ear",
        "label": "Ear",
        "search": [
            "body",
            "ear",
            "head",
            "hearing",
            "listen",
            "lobe"
        ]
    },
    {
        "icon": "street-view",
        "label": "Street View",
        "search": [
            "directions",
            "location",
            "map",
            "navigation",
            "uer"
        ]
    },
    {
        "icon": "speakers",
        "label": "Speakers",
        "search": [
            "audio",
            "device",
            "group",
            "music",
            "sound",
            "subwoofer",
            "transducer",
            "tweeter"
        ]
    },
    {
        "icon": "wave-square",
        "label": "Wave Square",
        "search": [
            "frequency",
            "pulse",
            "signal"
        ]
    },
    {
        "icon": "angle-left",
        "label": "Angle Left",
        "search": [
            "Single Left-Pointing Angle Quotation Mark",
            "arrow",
            "back",
            "caret",
            "less",
            "previous"
        ]
    },
    {
        "icon": "glide",
        "label": "Glide",
        "search": []
    },
    {
        "icon": "bity",
        "label": "Bity",
        "search": []
    },
    {
        "icon": "turtle",
        "label": "Turtle",
        "search": [
            "cowabunga",
            "donatello",
            "fauna",
            "leonardo",
            "michaelangelo",
            "raphael",
            "reptile",
            "shell",
            "slow",
            "terrapin",
            "tortoise",
            "turtle"
        ]
    },
    {
        "icon": "arrow-right-to-line",
        "label": "Arrow Right To Line",
        "search": [
            "Rightwards Arrow to Bar",
            "forward",
            "insert",
            "next"
        ]
    },
    {
        "icon": "screwdriver",
        "label": "Screwdriver",
        "search": [
            "admin",
            "configuration",
            "equipment",
            "fix",
            "maintenance",
            "mechanic",
            "modify",
            "repair",
            "screw",
            "screwdriver",
            "settings",
            "tool"
        ]
    },
    {
        "icon": "traffic-light-stop",
        "label": "Traffic Light Stop",
        "search": [
            "direction",
            "red",
            "road",
            "signal",
            "stop",
            "travel"
        ]
    },
    {
        "icon": "tractor",
        "label": "Tractor",
        "search": [
            "agriculture",
            "farm",
            "tractor",
            "vehicle"
        ]
    },
    {
        "icon": "bridge-circle-xmark",
        "label": "Bridge Circle Xmark",
        "search": [
            "bridge",
            "destroy",
            "road",
            "uncheck"
        ]
    },
    {
        "icon": "vials",
        "label": "Vials",
        "search": [
            "ampule",
            "experiment",
            "knowledge",
            "lab",
            "sample",
            "science",
            "test",
            "test tube"
        ]
    },
    {
        "icon": "starfighter-twin-ion-engine-advanced",
        "label": "Starfighter Twin Ion Engine Advanced",
        "search": [
            "empire",
            "tie fighter"
        ]
    },
    {
        "icon": "stethoscope",
        "label": "Stethoscope",
        "search": [
            "covid-19",
            "diagnosis",
            "doctor",
            "general practitioner",
            "heart",
            "hospital",
            "infirmary",
            "medicine",
            "office",
            "outpatient",
            "stethoscope"
        ]
    },
    {
        "icon": "wpexplorer",
        "label": "WPExplorer",
        "search": []
    },
    {
        "icon": "podcast",
        "label": "Podcast",
        "search": [
            "audio",
            "broadcast",
            "music",
            "sound"
        ]
    },
    {
        "icon": "arrow-up-right-dots",
        "label": "Arrow Up Right Dots",
        "search": [
            "growth",
            "increase",
            "population",
            "upgrade"
        ]
    },
    {
        "icon": "chess-queen",
        "label": "Chess Queen",
        "search": [
            "Black Chess Queen",
            "board",
            "checkmate",
            "game",
            "strategy"
        ]
    },
    {
        "icon": "anchor-circle-exclamation",
        "label": "Anchor Circle Exclamation",
        "search": [
            "affected",
            "failed",
            "marina",
            "port"
        ]
    },
    {
        "icon": "megaport",
        "label": "Megaport",
        "search": []
    },
    {
        "icon": "ellipsis-vertical",
        "label": "Ellipsis Vertical",
        "search": [
            "bullet",
            "dots",
            "drag",
            "kebab",
            "list",
            "menu",
            "nav",
            "navigation",
            "ol",
            "reorder",
            "settings",
            "three dots",
            "ul"
        ]
    },
    {
        "icon": "acorn",
        "label": "Acorn",
        "search": [
            "fall",
            "nature",
            "nut",
            "oak",
            "seasonal",
            "seed",
            "squirrel",
            "tree"
        ]
    },
    {
        "icon": "ban-parking",
        "label": "Ban Parking",
        "search": [
            "auto",
            "car",
            "deny",
            "disabled",
            "garage",
            "meter"
        ]
    },
    {
        "icon": "list-dropdown",
        "label": "List Dropdown",
        "search": [
            "cheatsheet",
            "menu",
            "summary",
            "wishlist"
        ]
    },
    {
        "icon": "family-dress",
        "label": "Family Dress",
        "search": [
            "adults",
            "child",
            "family",
            "folk",
            "kid",
            "parent",
            "together",
            "uer"
        ]
    },
    {
        "icon": "podium",
        "label": "Podium",
        "search": [
            "debate",
            "election",
            "keynote",
            "lecture",
            "panel",
            "politics",
            "seminar",
            "speak",
            "speaker",
            "speech",
            "talk"
        ]
    },
    {
        "icon": "robot-astromech",
        "label": "Robot Astromech",
        "search": [
            "artoo",
            "beep",
            "droid",
            "gps",
            "mechanic",
            "r2d2",
            "star wars"
        ]
    },
    {
        "icon": "heart-circle-exclamation",
        "label": "Heart Circle Exclamation",
        "search": [
            "failed",
            "favorite",
            "heart",
            "love"
        ]
    },
    {
        "icon": "building-circle-exclamation",
        "label": "Building Circle Exclamation",
        "search": [
            "affected",
            "building",
            "city",
            "failed",
            "office"
        ]
    },
    {
        "icon": "mdb",
        "label": "Material Design for Bootstrap",
        "search": []
    },
    {
        "icon": "page4",
        "label": "page4 Corporation",
        "search": []
    },
    {
        "icon": "person-arrow-up-from-line",
        "label": "Person Arrow Up From Line",
        "search": [
            "population",
            "rise",
            "uer",
            "upgrade"
        ]
    },
    {
        "icon": "circle-arrow-down-left",
        "label": "Circle Arrow Down Left",
        "search": [
            "diagonal",
            "southwest"
        ]
    },
    {
        "icon": "the-red-yeti",
        "label": "The Red Yeti",
        "search": []
    },
    {
        "icon": "not-equal",
        "label": "Not Equal",
        "search": [
            "arithmetic",
            "compare",
            "math"
        ]
    },
    {
        "icon": "binary-circle-check",
        "label": "Binary Circle Check",
        "search": [
            "accept",
            "binary",
            "check",
            "crc",
            "data",
            "enable",
            "encrypt",
            "hash",
            "not affected",
            "ok",
            "okay",
            "programming",
            "validate",
            "working"
        ]
    },
    {
        "icon": "train-tram",
        "label": "Train Tram",
        "search": [
            "crossing",
            "machine",
            "mountains",
            "seasonal",
            "tram",
            "transportation",
            "trolleybus"
        ]
    },
    {
        "icon": "plane-departure",
        "label": "Plane Departure",
        "search": [
            "aeroplane",
            "airplane",
            "airplane departure",
            "airport",
            "check-in",
            "departing",
            "departure",
            "departures",
            "destination",
            "fly",
            "location",
            "mode",
            "take off",
            "taking off",
            "travel",
            "trip"
        ]
    },
    {
        "icon": "microphone-stand",
        "label": "Microphone Stand",
        "search": [
            "audio",
            "karaoke",
            "mic",
            "microphone",
            "podcast",
            "record",
            "sing",
            "sound",
            "talking",
            "voice"
        ]
    },
    {
        "icon": "jira",
        "label": "Jira",
        "search": [
            "atlassian"
        ]
    },
    {
        "icon": "brightness",
        "label": "Brightness",
        "search": [
            "bright",
            "bright button",
            "brightness",
            "display",
            "light",
            "sun"
        ]
    },
    {
        "icon": "right-to-bracket",
        "label": "Right To Bracket",
        "search": [
            "arrow",
            "enter",
            "join",
            "log in",
            "login",
            "sign in",
            "sign up",
            "sign-in",
            "signin",
            "signup"
        ]
    },
    {
        "icon": "sd-card",
        "label": "Sd Card",
        "search": [
            "image",
            "img",
            "memory",
            "photo",
            "save"
        ]
    },
    {
        "icon": "house-circle-exclamation",
        "label": "House Circle Exclamation",
        "search": [
            "abode",
            "affected",
            "failed",
            "home",
            "house"
        ]
    },
    {
        "icon": "shekel-sign",
        "label": "Shekel Sign",
        "search": [
            "New Sheqel Sign",
            "currency",
            "ils",
            "money"
        ]
    },
    {
        "icon": "square-u",
        "label": "Square U",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "truck-container-empty",
        "label": "Truck Container Empty",
        "search": [
            "container",
            "flatbed",
            "shipping"
        ]
    },
    {
        "icon": "user-pilot-tie",
        "label": "User Pilot Tie",
        "search": [
            "airplane",
            "airport",
            "flight",
            "fly",
            "navigate",
            "pilot",
            "uer"
        ]
    },
    {
        "icon": "radio",
        "label": "Radio",
        "search": [
            "am",
            "broadcast",
            "fm",
            "frequency",
            "music",
            "news",
            "radio",
            "receiver",
            "transmitter",
            "tuner",
            "video"
        ]
    },
    {
        "icon": "hand-dots",
        "label": "Hand Dots",
        "search": [
            "allergy",
            "freckles",
            "hand",
            "hives",
            "palm",
            "pox",
            "skin",
            "spots"
        ]
    },
    {
        "icon": "flask-gear",
        "label": "Flask Gear",
        "search": [
            "beaker",
            "chemicals",
            "experiment",
            "experimental",
            "gear",
            "labs",
            "liquid",
            "potion",
            "science",
            "settings",
            "vial"
        ]
    },
    {
        "icon": "book-skull",
        "label": "Book Skull",
        "search": [
            "Dungeons & Dragons",
            "crossbones",
            "d&d",
            "dark arts",
            "death",
            "dnd",
            "documentation",
            "evil",
            "fantasy",
            "halloween",
            "holiday",
            "library",
            "necronomicon",
            "read",
            "research",
            "skull",
            "spell"
        ]
    },
    {
        "icon": "unlock-keyhole",
        "label": "Unlock Keyhole",
        "search": [
            "admin",
            "lock",
            "padlock",
            "password",
            "privacy",
            "private",
            "protect"
        ]
    },
    {
        "icon": "fedex",
        "label": "FedEx",
        "search": [
            "Federal Express",
            "package",
            "shipping"
        ]
    },
    {
        "icon": "truck-ramp",
        "label": "Truck Ramp",
        "search": [
            "box",
            "cargo",
            "delivery",
            "inventory",
            "moving",
            "rental",
            "vehicle"
        ]
    },
    {
        "icon": "envelope-dot",
        "label": "Envelope Dot",
        "search": [
            "email"
        ]
    },
    {
        "icon": "house-heart",
        "label": "House Heart",
        "search": [
            "abode",
            "building",
            "charity",
            "house",
            "main",
            "wishlist"
        ]
    },
    {
        "icon": "file-arrow-up",
        "label": "File Arrow Up",
        "search": [
            "document",
            "import",
            "page",
            "save",
            "upgrade"
        ]
    },
    {
        "icon": "game-console-handheld",
        "label": "Game Console Handheld",
        "search": [
            "cartridge",
            "gameboy",
            "nintendo",
            "retro",
            "video games",
            "vintage"
        ]
    },
    {
        "icon": "face-grin-tears",
        "label": "Face Grin Tears",
        "search": [
            "LOL",
            "emoticon",
            "face",
            "face with tears of joy",
            "joy",
            "laugh",
            "tear"
        ]
    },
    {
        "icon": "pen-to-square",
        "label": "Pen To Square",
        "search": [
            "edit",
            "modify",
            "pen",
            "pencil",
            "update",
            "write"
        ]
    },
    {
        "icon": "evernote",
        "label": "Evernote",
        "search": []
    },
    {
        "icon": "earth-europe",
        "label": "Earth Europe",
        "search": [
            "all",
            "country",
            "earth",
            "europe",
            "global",
            "globe",
            "gps",
            "language",
            "localize",
            "location",
            "map",
            "online",
            "place",
            "planet",
            "translate",
            "travel",
            "world"
        ]
    },
    {
        "icon": "table-picnic",
        "label": "Table Picnic",
        "search": [
            "bench",
            "outdoor",
            "picnic",
            "sit"
        ]
    },
    {
        "icon": "face-grin-beam-sweat",
        "label": "Face Grin Beam Sweat",
        "search": [
            "cold",
            "embarass",
            "emoticon",
            "face",
            "grinning face with sweat",
            "open",
            "smile",
            "sweat"
        ]
    },
    {
        "icon": "circle-half-stroke",
        "label": "Circle Half Stroke",
        "search": [
            "Circle with Left Half Black",
            "adjust",
            "chart",
            "contrast",
            "dark",
            "fill",
            "light",
            "pie",
            "progress",
            "saturation"
        ]
    },
    {
        "icon": "usb",
        "label": "USB",
        "search": []
    },
    {
        "icon": "ruler-triangle",
        "label": "Ruler Triangle",
        "search": [
            "design",
            "draft",
            "length",
            "measure",
            "planning",
            "ruler",
            "set",
            "triangle",
            "triangular ruler"
        ]
    },
    {
        "icon": "octagon-plus",
        "label": "Octagon Plus",
        "search": [
            "add",
            "create",
            "expand",
            "new",
            "positive",
            "shape"
        ]
    },
    {
        "icon": "user-cowboy",
        "label": "User Cowboy",
        "search": [
            "buckaroo",
            "cowgirl",
            "horse",
            "jackeroo",
            "jessie",
            "old west",
            "pardner",
            "ranch",
            "rancher",
            "rodeo",
            "the lone ranger",
            "uer",
            "western",
            "woody",
            "wrangler"
        ]
    },
    {
        "icon": "person-military-to-person",
        "label": "Person Military To Person",
        "search": [
            "civilian",
            "coordination",
            "military",
            "uer"
        ]
    },
    {
        "icon": "angrycreative",
        "label": "Angry Creative",
        "search": []
    },
    {
        "icon": "person-pinball",
        "label": "Person Pinball",
        "search": [
            "arcade",
            "fun",
            "game",
            "pinball",
            "uer"
        ]
    },
    {
        "icon": "mouse-field",
        "label": "Mouse Field",
        "search": [
            "cheese",
            "mickey",
            "minnie",
            "rat",
            "rodent",
            "squeak"
        ]
    },
    {
        "icon": "table-cells-column-lock",
        "label": "Table Cells Column Lock",
        "search": [
            "blocks",
            "boxes",
            "category",
            "column",
            "excel",
            "grid",
            "lock",
            "spreadsheet",
            "squares"
        ]
    },
    {
        "icon": "truck-field-un",
        "label": "Truck Field Un",
        "search": [
            "supplies",
            "truck",
            "united nations"
        ]
    },
    {
        "icon": "clock",
        "label": "Clock",
        "search": [
            "00",
            "4",
            "4:00",
            "clock",
            "date",
            "four",
            "four o’clock",
            "hour",
            "late",
            "minute",
            "o'clock",
            "o’clock",
            "pending",
            "schedule",
            "ticking",
            "time",
            "timer",
            "timestamp",
            "watch"
        ]
    },
    {
        "icon": "mizuni",
        "label": "Mizuni",
        "search": []
    },
    {
        "icon": "layer-minus",
        "label": "Layer Minus",
        "search": [
            "arrange",
            "delete",
            "layers",
            "negative",
            "platform",
            "remove",
            "stack"
        ]
    },
    {
        "icon": "itch-io",
        "label": "itch.io",
        "search": []
    },
    {
        "icon": "circle-euro",
        "label": "Circle Euro",
        "search": [
            "coin",
            "currency",
            "euro sign"
        ]
    },
    {
        "icon": "book",
        "label": "Book",
        "search": [
            "book",
            "cover",
            "decorated",
            "diary",
            "documentation",
            "journal",
            "knowledge",
            "library",
            "notebook",
            "notebook with decorative cover",
            "read",
            "research",
            "scholar"
        ]
    },
    {
        "icon": "face-laugh-wink",
        "label": "Face Laugh Wink",
        "search": [
            "LOL",
            "emoticon",
            "face",
            "happy",
            "smile"
        ]
    },
    {
        "icon": "user-doctor-hair-long",
        "label": "User Doctor Hair Long",
        "search": [
            "covid-19",
            "job",
            "medical",
            "nurse",
            "occupation",
            "physician",
            "profile",
            "surgeon",
            "uer"
        ]
    },
    {
        "icon": "cloud-meatball",
        "label": "Cloud Meatball",
        "search": [
            "FLDSMDFR",
            "food",
            "spaghetti",
            "storm"
        ]
    },
    {
        "icon": "cloud-xmark",
        "label": "Cloud Xmark",
        "search": [
            "cancel",
            "remove",
            "uncheck"
        ]
    },
    {
        "icon": "chart-area",
        "label": "Chart Area",
        "search": [
            "analytics",
            "area",
            "chart",
            "graph",
            "performance",
            "revenue",
            "statistics"
        ]
    },
    {
        "icon": "utility-pole-double",
        "label": "Utility Pole Double",
        "search": [
            "phone",
            "power",
            "transmission"
        ]
    },
    {
        "icon": "rupiah-sign",
        "label": "Rupiah Sign",
        "search": [
            "currency"
        ]
    },
    {
        "icon": "windows",
        "label": "Windows",
        "search": [
            "microsoft",
            "operating system",
            "os"
        ]
    },
    {
        "icon": "diagram-nested",
        "label": "Diagram Nested",
        "search": [
            "cells",
            "chart",
            "directory",
            "gantt",
            "next",
            "table",
            "tree"
        ]
    },
    {
        "icon": "square-quarters",
        "label": "Square Quarters",
        "search": [
            "damper",
            "fire",
            "vent"
        ]
    },
    {
        "icon": "print-slash",
        "label": "Print Slash",
        "search": [
            "business",
            "copy",
            "disabled",
            "document",
            "office",
            "offline",
            "paper"
        ]
    },
    {
        "icon": "shield-keyhole",
        "label": "Shield Keyhole",
        "search": [
            "lock",
            "privacy",
            "protect",
            "safety"
        ]
    },
    {
        "icon": "square-left",
        "label": "Square Left",
        "search": [
            "arrow",
            "back",
            "cardinal",
            "direction",
            "left arrow",
            "previous",
            "west"
        ]
    },
    {
        "icon": "text-width",
        "label": "Text Width",
        "search": [
            "edit",
            "font",
            "format",
            "modify",
            "text",
            "type"
        ]
    },
    {
        "icon": "signature-lock",
        "label": "Signature Lock",
        "search": [
            "key signature",
            "lock",
            "padlock",
            "privacy",
            "private",
            "signature",
            "username",
            "verified"
        ]
    },
    {
        "icon": "satellite",
        "label": "Satellite",
        "search": [
            "communications",
            "hardware",
            "orbit",
            "satellite",
            "space"
        ]
    },
    {
        "icon": "stumbleupon",
        "label": "StumbleUpon Logo",
        "search": []
    },
    {
        "icon": "google",
        "label": "Google Logo",
        "search": []
    },
    {
        "icon": "ball-pile",
        "label": "Ball Pile",
        "search": [
            "balance",
            "cannon",
            "group",
            "pyramid",
            "snowball"
        ]
    },
    {
        "icon": "file-eps",
        "label": "File Eps",
        "search": [
            "Document with Picture",
            "document",
            "eps",
            "image",
            "img",
            "vector"
        ]
    },
    {
        "icon": "magnifying-glass-minus",
        "label": "Magnifying Glass Minus",
        "search": [
            "magnifier",
            "minify",
            "negative",
            "smaller",
            "zoom",
            "zoom out"
        ]
    },
    {
        "icon": "vent-damper",
        "label": "Vent Damper",
        "search": [
            "air",
            "fire",
            "hvac",
            "ventilate"
        ]
    },
    {
        "icon": "people-group",
        "label": "People Group",
        "search": [
            "crowd",
            "family",
            "group",
            "team",
            "together",
            "uer"
        ]
    },
    {
        "icon": "square-quote",
        "label": "Square Quote",
        "search": [
            "mention",
            "note",
            "text",
            "type"
        ]
    },
    {
        "icon": "square-binary",
        "label": "Square Binary",
        "search": [
            "ai",
            "data",
            "language",
            "llm",
            "model",
            "programming",
            "token"
        ]
    },
    {
        "icon": "masks-theater",
        "label": "Masks Theater",
        "search": [
            "art",
            "comedy",
            "mask",
            "perform",
            "performing",
            "performing arts",
            "theater",
            "theatre",
            "tragedy"
        ]
    },
    {
        "icon": "house-turret",
        "label": "House Turret",
        "search": [
            "castle",
            "fortress",
            "hideout",
            "palace"
        ]
    },
    {
        "icon": "discord",
        "label": "Discord",
        "search": []
    },
    {
        "icon": "cart-plus",
        "label": "Cart Plus",
        "search": [
            "add",
            "create",
            "new",
            "positive",
            "shopping"
        ]
    },
    {
        "icon": "hands-asl-interpreting",
        "label": "Hands Asl Interpreting",
        "search": [
            "asl",
            "deaf",
            "finger",
            "hand",
            "interpret",
            "speak"
        ]
    },
    {
        "icon": "hacker-news",
        "label": "Hacker News",
        "search": []
    },
    {
        "icon": "face-anxious-sweat",
        "label": "Face Anxious Sweat",
        "search": [
            "anxiety",
            "anxious face with sweat",
            "blue",
            "cold",
            "concern",
            "face",
            "nervous",
            "rushed",
            "sad",
            "sweat"
        ]
    },
    {
        "icon": "message-smile",
        "label": "Message Smile",
        "search": [
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "emoji",
            "feedback",
            "happy",
            "message",
            "note",
            "notification",
            "sms",
            "speech",
            "texting"
        ]
    },
    {
        "icon": "location-exclamation",
        "label": "Location Exclamation",
        "search": [
            "agree",
            "alert",
            "attention",
            "coordinates",
            "destination",
            "failed",
            "important",
            "location",
            "map",
            "navigation",
            "pin",
            "place"
        ]
    },
    {
        "icon": "table-cells-row-unlock",
        "label": "Table Cells Row Unlock",
        "search": [
            "blocks",
            "boxes",
            "category",
            "column",
            "column",
            "excel",
            "grid",
            "lock",
            "lock",
            "spreadsheet",
            "squares",
            "unlock"
        ]
    },
    {
        "icon": "diamonds-4",
        "label": "Diamonds 4",
        "search": [
            "Figma",
            "component",
            "design",
            "diamond",
            "grid",
            "instance",
            "linked",
            "main",
            "sketch",
            "symbol",
            "tool"
        ]
    },
    {
        "icon": "rocket",
        "label": "Rocket",
        "search": [
            "aircraft",
            "app",
            "jet",
            "launch",
            "nasa",
            "space"
        ]
    },
    {
        "icon": "file-circle-info",
        "label": "File Circle Info",
        "search": [
            "details",
            "document",
            "info",
            "new",
            "page",
            "pdf"
        ]
    },
    {
        "icon": "cloud-fog",
        "label": "Cloud Fog",
        "search": [
            "cloud",
            "fog",
            "haze",
            "karl",
            "mist",
            "opaque",
            "san francisco",
            "visibility",
            "weather"
        ]
    },
    {
        "icon": "option",
        "label": "Option",
        "search": [
            "alt",
            "alternate"
        ]
    },
    {
        "icon": "utility-pole",
        "label": "Utility Pole",
        "search": [
            "phone",
            "power",
            "transmission"
        ]
    },
    {
        "icon": "shrimp",
        "label": "Shrimp",
        "search": [
            "allergy",
            "crustacean",
            "prawn",
            "seafood",
            "shellfish",
            "shrimp",
            "tail"
        ]
    },
    {
        "icon": "alien",
        "label": "Alien",
        "search": [
            "ET",
            "alien",
            "creature",
            "extraterrestrial",
            "face",
            "fantasy",
            "humanoid",
            "monster",
            "space",
            "strange",
            "ufo"
        ]
    },
    {
        "icon": "skeleton",
        "label": "Skeleton",
        "search": [
            "bones",
            "skeletal",
            "vertebrate",
            "x-ray"
        ]
    },
    {
        "icon": "tire-pressure-warning",
        "label": "Tire Pressure Warning",
        "search": [
            "alert",
            "auto",
            "car",
            "flat",
            "rim",
            "rubber",
            "wheel"
        ]
    },
    {
        "icon": "nose",
        "label": "Nose",
        "search": [
            "face",
            "nasal",
            "nostril",
            "smell",
            "sniff",
            "snout"
        ]
    },
    {
        "icon": "sign-posts-wrench",
        "label": "Sign Posts Wrench",
        "search": [
            "directions",
            "directory",
            "install",
            "map",
            "permit",
            "signage",
            "wayfinding"
        ]
    },
    {
        "icon": "tenge-sign",
        "label": "Tenge Sign",
        "search": [
            "Tenge Sign",
            "currency"
        ]
    },
    {
        "icon": "face-scream",
        "label": "Face Scream",
        "search": [
            "face",
            "face screaming in fear",
            "fear",
            "home alone",
            "munch",
            "scared",
            "scream"
        ]
    },
    {
        "icon": "house-chimney-medical",
        "label": "House Chimney Medical",
        "search": [
            "covid-19",
            "doctor",
            "general practitioner",
            "hospital",
            "infirmary",
            "medicine",
            "office",
            "outpatient"
        ]
    },
    {
        "icon": "square-arrow-left",
        "label": "Square Arrow Left",
        "search": [
            "back",
            "previous"
        ]
    },
    {
        "icon": "circle-location-arrow",
        "label": "Circle Location Arrow",
        "search": [
            "address",
            "compass",
            "coordinate",
            "direction",
            "gps",
            "map",
            "navigation",
            "place"
        ]
    },
    {
        "icon": "users-slash",
        "label": "Users Slash",
        "search": [
            "disabled",
            "disconnect",
            "employee",
            "together",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "traffic-cone",
        "label": "Traffic Cone",
        "search": [
            "alert",
            "construction",
            "maintenance",
            "road"
        ]
    },
    {
        "icon": "star-sharp-half-stroke",
        "label": "Star Sharp Half Stroke",
        "search": [
            "critic",
            "ratings",
            "review",
            "sky"
        ]
    },
    {
        "icon": "h1",
        "label": "H1",
        "search": [
            "format",
            "header",
            "text",
            "title"
        ]
    },
    {
        "icon": "tamale",
        "label": "Tamale",
        "search": [
            "mexican",
            "tamale",
            "wrapped"
        ]
    },
    {
        "icon": "teamspeak",
        "label": "Teamspeak",
        "search": []
    },
    {
        "icon": "route-highway",
        "label": "Route Highway",
        "search": [
            "directions",
            "highway",
            "interstate",
            "navigation",
            "sign",
            "travel"
        ]
    },
    {
        "icon": "paper-plane",
        "label": "Paper Plane",
        "search": [
            "air",
            "float",
            "fold",
            "mail",
            "paper",
            "send"
        ]
    },
    {
        "icon": "supple",
        "label": "Supple",
        "search": []
    },
    {
        "icon": "object-intersect",
        "label": "Object Intersect",
        "search": [
            "boolean",
            "combine",
            "group",
            "join",
            "pathfinder"
        ]
    },
    {
        "icon": "book-atlas",
        "label": "Book Atlas",
        "search": [
            "book",
            "directions",
            "geography",
            "globe",
            "knowledge",
            "library",
            "map",
            "research",
            "travel",
            "wayfinding"
        ]
    },
    {
        "icon": "table",
        "label": "Table",
        "search": [
            "category",
            "data",
            "excel",
            "spreadsheet"
        ]
    },
    {
        "icon": "square-twitter",
        "label": "Square Twitter",
        "search": [
            "social network",
            "tweet"
        ]
    },
    {
        "icon": "circle-sort",
        "label": "Circle Sort",
        "search": [
            "down",
            "elevator",
            "lower",
            "raise",
            "temperature",
            "thermostat",
            "up"
        ]
    },
    {
        "icon": "heart",
        "label": "Heart",
        "search": [
            "ace",
            "black",
            "black heart",
            "blue",
            "blue heart",
            "brown",
            "brown heart",
            "card",
            "evil",
            "favorite",
            "game",
            "green",
            "green heart",
            "heart",
            "heart suit",
            "like",
            "love",
            "orange",
            "orange heart",
            "purple",
            "purple heart",
            "red heart",
            "relationship",
            "valentine",
            "white",
            "white heart",
            "wicked",
            "wishlist",
            "yellow",
            "yellow heart"
        ]
    },
    {
        "icon": "scythe",
        "label": "Scythe",
        "search": [
            "Dungeons & Dragons",
            "blade",
            "d&d",
            "death",
            "dnd",
            "fantasy",
            "grim reaper",
            "weapon"
        ]
    },
    {
        "icon": "circle-chevron-up",
        "label": "Circle Chevron Up",
        "search": [
            "arrow",
            "collapse",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "apostrophe",
        "label": "Apostrophe",
        "search": [
            "Apostrophe",
            "comma",
            "contraction",
            "quote"
        ]
    },
    {
        "icon": "battery-half",
        "label": "Battery Half",
        "search": [
            "charge",
            "power",
            "status"
        ]
    },
    {
        "icon": "font-awesome",
        "label": "Font Awesome",
        "search": [
            "awesome",
            "flag",
            "font",
            "icons",
            "typeface"
        ]
    },
    {
        "icon": "handcuffs",
        "label": "Handcuffs",
        "search": [
            "arrest",
            "criminal",
            "handcuffs",
            "jail",
            "lock",
            "police",
            "wrist"
        ]
    },
    {
        "icon": "hat-cowboy-side",
        "label": "Hat Cowboy Side",
        "search": [
            "buckaroo",
            "horse",
            "jackeroo",
            "john b.",
            "old west",
            "pardner",
            "ranch",
            "rancher",
            "rodeo",
            "western",
            "wrangler"
        ]
    },
    {
        "icon": "sausage",
        "label": "Sausage",
        "search": [
            "bratwurst",
            "breakfast",
            "chorizo",
            "frankfurt",
            "frankfurter",
            "hot dog",
            "hotdog",
            "kielbasa",
            "kosher",
            "pepperoni",
            "polish",
            "vienna",
            "weiner"
        ]
    },
    {
        "icon": "chevrons-down",
        "label": "Chevrons Down",
        "search": [
            "arrow",
            "download",
            "expand"
        ]
    },
    {
        "icon": "industry",
        "label": "Industry",
        "search": [
            "building",
            "factory",
            "industrial",
            "manufacturing",
            "mill",
            "warehouse"
        ]
    },
    {
        "icon": "people-dress-simple",
        "label": "People Dress Simple",
        "search": [
            "together",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "lines-leaning",
        "label": "Lines Leaning",
        "search": [
            "canted",
            "domino",
            "falling",
            "resilience",
            "resilient",
            "tipped"
        ]
    },
    {
        "icon": "passport",
        "label": "Passport",
        "search": [
            "document",
            "id",
            "identification",
            "issued",
            "travel"
        ]
    },
    {
        "icon": "infinity",
        "label": "Infinity",
        "search": [
            "Infinity",
            "eternity",
            "forever",
            "infinity",
            "math",
            "unbounded",
            "universal"
        ]
    },
    {
        "icon": "hand-heart",
        "label": "Hand Heart",
        "search": [
            "care",
            "charity",
            "donate",
            "help",
            "palm",
            "wishlist"
        ]
    },
    {
        "icon": "clone",
        "label": "Clone",
        "search": [
            "arrange",
            "copy",
            "duplicate",
            "paste"
        ]
    },
    {
        "icon": "forward",
        "label": "Forward",
        "search": [
            "arrow",
            "double",
            "fast",
            "fast-forward button",
            "forward",
            "next",
            "skip"
        ]
    },
    {
        "icon": "square-r",
        "label": "Square R",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "period",
        "label": "Period",
        "search": [
            "Full Stop",
            "circle",
            "dot",
            "end",
            "stop"
        ]
    },
    {
        "icon": "m",
        "label": "M",
        "search": [
            "Latin Capital Letter M",
            "Latin Small Letter M",
            "letter"
        ]
    },
    {
        "icon": "money-check-pen",
        "label": "Money Check Pen",
        "search": [
            "bank check",
            "buy",
            "checkout",
            "cheque",
            "modify",
            "money",
            "payment",
            "pen",
            "price",
            "purchase",
            "salary"
        ]
    },
    {
        "icon": "wirsindhandwerk",
        "label": "wirsindhandwerk",
        "search": []
    },
    {
        "icon": "road-spikes",
        "label": "Road Spikes",
        "search": [
            "barrier",
            "roadblock",
            "spikes"
        ]
    },
    {
        "icon": "fish-cooked",
        "label": "Fish Cooked",
        "search": [
            "grilled",
            "health",
            "salmon",
            "seafood",
            "tuna"
        ]
    },
    {
        "icon": "person-seat-reclined",
        "label": "Person Seat Reclined",
        "search": [
            "airplane",
            "chair",
            "recline",
            "seat",
            "travel",
            "uer"
        ]
    },
    {
        "icon": "mountain",
        "label": "Mountain",
        "search": [
            "cold",
            "glacier",
            "hiking",
            "hill",
            "landscape",
            "mountain",
            "snow",
            "snow-capped mountain",
            "travel",
            "view"
        ]
    },
    {
        "icon": "circle-w",
        "label": "Circle W",
        "search": [
            "Circled Latin Capital Letter W",
            "letter"
        ]
    },
    {
        "icon": "chess",
        "label": "Chess",
        "search": [
            "board",
            "castle",
            "checkmate",
            "game",
            "king",
            "rook",
            "strategy",
            "tournament"
        ]
    },
    {
        "icon": "temperature-three-quarters",
        "label": "Temperature Three Quarters",
        "search": [
            "mercury",
            "status",
            "temperature"
        ]
    },
    {
        "icon": "b",
        "label": "B",
        "search": [
            "Latin Capital Letter B",
            "Latin Small Letter B",
            "letter"
        ]
    },
    {
        "icon": "shield-virus",
        "label": "Shield Virus",
        "search": [
            "antibodies",
            "barrier",
            "coronavirus",
            "covid-19",
            "flu",
            "health",
            "infection",
            "pandemic",
            "protect",
            "safety",
            "vaccine"
        ]
    },
    {
        "icon": "triangle",
        "label": "Triangle",
        "search": [
            "Black Up-Pointing Triangle",
            "pyramid",
            "shape"
        ]
    },
    {
        "icon": "litecoin-sign",
        "label": "Litecoin Sign",
        "search": [
            "currency"
        ]
    },
    {
        "icon": "dice-d6",
        "label": "Dice D6",
        "search": [
            "Dungeons & Dragons",
            "chance",
            "d&d",
            "dnd",
            "fantasy",
            "gambling",
            "game",
            "roll"
        ]
    },
    {
        "icon": "grip-lines-vertical",
        "label": "Grip Lines Vertical",
        "search": [
            "affordance",
            "drag",
            "drop",
            "grab",
            "handle"
        ]
    },
    {
        "icon": "toggle-large-off",
        "label": "Toggle Large Off",
        "search": [
            "button",
            "off",
            "on",
            "switch"
        ]
    },
    {
        "icon": "golf-ball-tee",
        "label": "Golf Ball Tee",
        "search": [
            "caddy",
            "eagle",
            "putt",
            "tee"
        ]
    },
    {
        "icon": "hexagon",
        "label": "Hexagon",
        "search": [
            "Horizontal Black Hexagon",
            "geometry",
            "honeycomb",
            "polygon",
            "shape"
        ]
    },
    {
        "icon": "kite",
        "label": "Kite",
        "search": [
            "air",
            "benjamin",
            "fall",
            "fly",
            "flying",
            "franklin",
            "kite",
            "outdoors",
            "seasonal",
            "sky",
            "soar",
            "wind"
        ]
    },
    {
        "icon": "share-all",
        "label": "Share All",
        "search": [
            "forward",
            "save",
            "send",
            "social"
        ]
    },
    {
        "icon": "confluence",
        "label": "Confluence",
        "search": [
            "atlassian"
        ]
    },
    {
        "icon": "folder-open",
        "label": "Folder Open",
        "search": [
            "Open Folder",
            "archive",
            "directory",
            "document",
            "empty",
            "file",
            "folder",
            "new",
            "open",
            "open file folder"
        ]
    },
    {
        "icon": "tick",
        "label": "Tick",
        "search": [
            "apostrophe",
            "foot"
        ]
    },
    {
        "icon": "digg",
        "label": "Digg Logo",
        "search": []
    },
    {
        "icon": "face-drooling",
        "label": "Face Drooling",
        "search": [
            "drool",
            "drooling",
            "drooling face",
            "face",
            "sleep",
            "spit"
        ]
    },
    {
        "icon": "bullseye-arrow",
        "label": "Bullseye Arrow",
        "search": [
            "archery",
            "arrow",
            "bullseye",
            "dart",
            "direct hit",
            "game",
            "goal",
            "hit",
            "objective",
            "robin hood",
            "strategy",
            "target"
        ]
    },
    {
        "icon": "threads",
        "label": "Threads",
        "search": [
            "social network"
        ]
    },
    {
        "icon": "kaaba",
        "label": "Kaaba",
        "search": [
            "Muslim",
            "building",
            "cube",
            "islam",
            "kaaba",
            "muslim",
            "religion"
        ]
    },
    {
        "icon": "hand-back-point-right",
        "label": "Hand Back Point Right",
        "search": [
            "backhand",
            "backhand index pointing right",
            "direction",
            "finger",
            "hand",
            "index",
            "point"
        ]
    },
    {
        "icon": "starfighter-twin-ion-engine",
        "label": "Starfighter Twin Ion Engine",
        "search": [
            "darth vader",
            "empire",
            "spaceship",
            "star wars",
            "tie fighter"
        ]
    },
    {
        "icon": "hand-holding",
        "label": "Hand Holding",
        "search": [
            "carry",
            "lift"
        ]
    },
    {
        "icon": "badge-sheriff",
        "label": "Badge Sheriff",
        "search": [
            "cowboy",
            "justice",
            "law",
            "old west",
            "western"
        ]
    },
    {
        "icon": "comment-lines",
        "label": "Comment Lines",
        "search": [
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "feedback",
            "message",
            "note",
            "notification",
            "sms",
            "speech",
            "texting"
        ]
    },
    {
        "icon": "wpressr",
        "label": "wpressr",
        "search": [
            "rendact"
        ]
    },
    {
        "icon": "bottle-droplet",
        "label": "Bottle Droplet",
        "search": [
            "alcohol",
            "drink",
            "oil",
            "olive oil",
            "wine"
        ]
    },
    {
        "icon": "yoast",
        "label": "Yoast",
        "search": []
    },
    {
        "icon": "face-explode",
        "label": "Face Explode",
        "search": [
            "exploding head",
            "mind blown",
            "omg",
            "shocked",
            "wow"
        ]
    },
    {
        "icon": "window-minimize",
        "label": "Window Minimize",
        "search": [
            "Minimize",
            "browser",
            "collapse",
            "computer",
            "development"
        ]
    },
    {
        "icon": "megaphone",
        "label": "Megaphone",
        "search": [
            "announcement",
            "broadcast",
            "bullhorn",
            "cheering",
            "louder",
            "megaphone",
            "share"
        ]
    },
    {
        "icon": "burger-glass",
        "label": "Burger Glass",
        "search": [
            "beer",
            "fast food",
            "junk food",
            "sandwich",
            "soda",
            "takeout"
        ]
    },
    {
        "icon": "pen-paintbrush",
        "label": "Pen Paintbrush",
        "search": [
            "art",
            "design",
            "modify",
            "paint",
            "pencil",
            "write"
        ]
    },
    {
        "icon": "lightbulb-slash",
        "label": "Lightbulb Slash",
        "search": [
            "dark",
            "disabled",
            "light",
            "off"
        ]
    },
    {
        "icon": "nimblr",
        "label": "Nimblr",
        "search": []
    },
    {
        "icon": "person-to-door",
        "label": "Person To Door",
        "search": [
            "door",
            "exit",
            "leave",
            "uer"
        ]
    },
    {
        "icon": "face-viewfinder",
        "label": "Face Viewfinder",
        "search": [
            "face id",
            "facial",
            "identity",
            "recognition",
            "scan",
            "smile"
        ]
    },
    {
        "icon": "yahoo",
        "label": "Yahoo Logo",
        "search": []
    },
    {
        "icon": "tennis-ball",
        "label": "Tennis Ball",
        "search": [
            "ball",
            "racket",
            "racquet",
            "sport",
            "tennis",
            "us open"
        ]
    },
    {
        "icon": "chevron-right",
        "label": "Chevron Right",
        "search": [
            "Right-Pointing Angle Bracket",
            "arrow",
            "bracket",
            "forward",
            "next"
        ]
    },
    {
        "icon": "egg",
        "label": "Egg",
        "search": [
            "breakfast",
            "chicken",
            "easter",
            "egg",
            "food",
            "shell",
            "yolk"
        ]
    },
    {
        "icon": "conveyor-belt-arm",
        "label": "Conveyor Belt Arm",
        "search": [
            "carousel",
            "inventory",
            "manufacture",
            "packaging",
            "produce",
            "production",
            "shipping"
        ]
    },
    {
        "icon": "landmark-dome",
        "label": "Landmark Dome",
        "search": [
            "building",
            "historic",
            "memorable",
            "monument",
            "politics"
        ]
    },
    {
        "icon": "grate",
        "label": "Grate",
        "search": [
            "drain",
            "manhole"
        ]
    },
    {
        "icon": "worm",
        "label": "Worm",
        "search": [
            "dirt",
            "garden",
            "worm",
            "wriggle"
        ]
    },
    {
        "icon": "sack",
        "label": "Sack",
        "search": [
            "bag",
            "burlap",
            "money",
            "salary",
            "santa"
        ]
    },
    {
        "icon": "user-injured",
        "label": "User Injured",
        "search": [
            "employee",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "bluesky",
        "label": "Bluesky",
        "search": [
            "social network"
        ]
    },
    {
        "icon": "scribd",
        "label": "Scribd",
        "search": []
    },
    {
        "icon": "strikethrough",
        "label": "Strikethrough",
        "search": [
            "cancel",
            "edit",
            "font",
            "format",
            "modify",
            "text",
            "type"
        ]
    },
    {
        "icon": "creative-commons-pd",
        "label": "Creative Commons Public Domain",
        "search": []
    },
    {
        "icon": "calendar-circle-minus",
        "label": "Calendar Circle Minus",
        "search": [
            "calendar",
            "date",
            "day",
            "delete",
            "event",
            "month",
            "negative",
            "remove",
            "schedule",
            "time",
            "when",
            "year"
        ]
    },
    {
        "icon": "blog",
        "label": "Blog",
        "search": [
            "journal",
            "log",
            "online",
            "personal",
            "post",
            "web 2.0",
            "wordpress",
            "writing"
        ]
    },
    {
        "icon": "stopwatch-20",
        "label": "Stopwatch 20",
        "search": [
            "ABCs",
            "countdown",
            "covid-19",
            "happy birthday",
            "i will survive",
            "reminder",
            "seconds",
            "time",
            "timer"
        ]
    },
    {
        "icon": "binary",
        "label": "Binary",
        "search": [
            "binary",
            "data",
            "programming"
        ]
    },
    {
        "icon": "shield-check",
        "label": "Shield Check",
        "search": [
            "achievement",
            "award",
            "block",
            "defend",
            "enable",
            "protect",
            "safety",
            "security",
            "select",
            "success",
            "tick",
            "todo",
            "validate",
            "warranty",
            "winner",
            "working"
        ]
    },
    {
        "icon": "truck-pickup",
        "label": "Truck Pickup",
        "search": [
            "cargo",
            "maintenance",
            "pick-up",
            "pickup",
            "pickup truck",
            "truck",
            "vehicle"
        ]
    },
    {
        "icon": "seedling",
        "label": "Seedling",
        "search": [
            "environment",
            "flora",
            "grow",
            "investment",
            "plant",
            "sapling",
            "seedling",
            "vegan",
            "young"
        ]
    },
    {
        "icon": "circle-divide",
        "label": "Circle Divide",
        "search": [
            "algebra",
            "arithmetic",
            "division"
        ]
    },
    {
        "icon": "transgender",
        "label": "Transgender",
        "search": [
            "female",
            "gender",
            "intersex",
            "male",
            "transgender",
            "transgender symbol"
        ]
    },
    {
        "icon": "arrow-down-to-bracket",
        "label": "Arrow Down To Bracket",
        "search": [
            "download",
            "insert",
            "share",
            "transfer"
        ]
    },
    {
        "icon": "unicorn",
        "label": "Unicorn",
        "search": [
            "face",
            "fantasy",
            "fauna",
            "horn",
            "horse",
            "unicorn"
        ]
    },
    {
        "icon": "earlybirds",
        "label": "Earlybirds",
        "search": []
    },
    {
        "icon": "left-from-bracket",
        "label": "Left From Bracket",
        "search": [
            "exit",
            "leave",
            "logout",
            "send"
        ]
    },
    {
        "icon": "ramp-loading",
        "label": "Ramp Loading",
        "search": [
            "inventory",
            "moving",
            "shipping",
            "storage",
            "warehouse"
        ]
    },
    {
        "icon": "hand-holding-box",
        "label": "Hand Holding Box",
        "search": [
            "carry",
            "gift",
            "handling",
            "lift",
            "package"
        ]
    },
    {
        "icon": "star-half",
        "label": "Star Half",
        "search": [
            "achievement",
            "award",
            "rating",
            "score",
            "star-half-empty",
            "star-half-full"
        ]
    },
    {
        "icon": "arrow-down-to-line",
        "label": "Arrow Down To Line",
        "search": [
            "download",
            "export",
            "insert",
            "transfer"
        ]
    },
    {
        "icon": "photo-film",
        "label": "Photo Film",
        "search": [
            "av",
            "film",
            "image",
            "library",
            "media"
        ]
    },
    {
        "icon": "pi",
        "label": "Pi",
        "search": [
            "alphabet",
            "circumference",
            "diameter",
            "greek",
            "math",
            "mathematics"
        ]
    },
    {
        "icon": "table-cells-lock",
        "label": "Table Cells Lock",
        "search": [
            "blocks",
            "boxes",
            "category",
            "column",
            "excel",
            "grid",
            "lock",
            "spreadsheet",
            "squares"
        ]
    },
    {
        "icon": "pump-medical",
        "label": "Pump Medical",
        "search": [
            "anti-bacterial",
            "clean",
            "covid-19",
            "disinfect",
            "hygiene",
            "medical grade",
            "sanitizer",
            "soap"
        ]
    },
    {
        "icon": "fire",
        "label": "Fire",
        "search": [
            "burn",
            "caliente",
            "fire",
            "flame",
            "heat",
            "hot",
            "popular",
            "tool"
        ]
    },
    {
        "icon": "face-smile-plus",
        "label": "Face Smile Plus",
        "search": [
            "add",
            "emoticon",
            "face",
            "follow",
            "happy",
            "new"
        ]
    },
    {
        "icon": "magnifying-glass-plus",
        "label": "Magnifying Glass Plus",
        "search": [
            "bigger",
            "enlarge",
            "magnifier",
            "magnify",
            "positive",
            "zoom",
            "zoom in"
        ]
    },
    {
        "icon": "swap",
        "label": "Swap",
        "search": [
            "arrows",
            "change",
            "merge",
            "move",
            "route",
            "transfer"
        ]
    },
    {
        "icon": "comment-heart",
        "label": "Comment Heart",
        "search": [
            "bubble",
            "favorite",
            "happy",
            "love",
            "message"
        ]
    },
    {
        "icon": "face-smile-tear",
        "label": "Face Smile Tear",
        "search": [
            "cry",
            "grateful",
            "proud",
            "relieved",
            "smiling",
            "smiling face with tear",
            "tear",
            "touched"
        ]
    },
    {
        "icon": "wheat",
        "label": "Wheat",
        "search": [
            "agriculture",
            "autumn",
            "fall",
            "farming",
            "grain",
            "seasonal"
        ]
    },
    {
        "icon": "barcode-scan",
        "label": "Barcode Scan",
        "search": [
            "info",
            "laser",
            "price",
            "scan",
            "upc"
        ]
    },
    {
        "icon": "galaxy",
        "label": "Galaxy",
        "search": [
            "black hole",
            "cosmic",
            "nebula",
            "solar system",
            "space",
            "spiral",
            "universe"
        ]
    },
    {
        "icon": "flask",
        "label": "Flask",
        "search": [
            "beaker",
            "chemicals",
            "experiment",
            "experimental",
            "knowledge",
            "labs",
            "liquid",
            "potion",
            "science",
            "vial"
        ]
    },
    {
        "icon": "fireplace",
        "label": "Fireplace",
        "search": [
            "caliente",
            "flame",
            "hearth",
            "heat",
            "holiday",
            "mantle",
            "toasty",
            "warmth"
        ]
    },
    {
        "icon": "square-odnoklassniki",
        "label": "Square Odnoklassniki",
        "search": []
    },
    {
        "icon": "markdown",
        "label": "Markdown",
        "search": []
    },
    {
        "icon": "flower-tulip",
        "label": "Flower Tulip",
        "search": [
            "flower",
            "nature",
            "spring",
            "summer",
            "tulip"
        ]
    },
    {
        "icon": "inboxes",
        "label": "Inboxes",
        "search": [
            "communication",
            "dropbox",
            "email",
            "incoming",
            "organize",
            "outgoing",
            "send"
        ]
    },
    {
        "icon": "rectangle-vertical",
        "label": "Rectangle Vertical",
        "search": [
            "geometry",
            "shape"
        ]
    },
    {
        "icon": "align-right",
        "label": "Align Right",
        "search": [
            "format",
            "paragraph",
            "text"
        ]
    },
    {
        "icon": "typo3",
        "label": "Typo3",
        "search": []
    },
    {
        "icon": "transporter-6",
        "label": "Transporter 6",
        "search": [
            "move",
            "teleport",
            "transfer",
            "translocate",
            "travel"
        ]
    },
    {
        "icon": "cable-car",
        "label": "Cable Car",
        "search": [
            "aerial tramway",
            "cable",
            "gondola",
            "lift",
            "mountain",
            "mountain cableway",
            "tram",
            "tramway",
            "trolley"
        ]
    },
    {
        "icon": "kit-medical",
        "label": "Kit Medical",
        "search": [
            "emergency",
            "emt",
            "health",
            "medical",
            "rescue"
        ]
    },
    {
        "icon": "grip-lines",
        "label": "Grip Lines",
        "search": [
            "affordance",
            "drag",
            "drop",
            "grab",
            "handle"
        ]
    },
    {
        "icon": "burger",
        "label": "Burger",
        "search": [
            "bacon",
            "beef",
            "burger",
            "burger king",
            "cheeseburger",
            "fast food",
            "grill",
            "ground beef",
            "mcdonalds",
            "sandwich"
        ]
    },
    {
        "icon": "raindrops",
        "label": "Raindrops",
        "search": [
            "precipitation",
            "rain",
            "sprinkle",
            "storm"
        ]
    },
    {
        "icon": "snowman",
        "label": "Snowman",
        "search": [
            "cold",
            "decoration",
            "frost",
            "frosty",
            "holiday",
            "snow",
            "snowman",
            "snowman without snow"
        ]
    },
    {
        "icon": "hotel",
        "label": "Hotel",
        "search": [
            "building",
            "hotel",
            "inn",
            "lodging",
            "motel",
            "resort",
            "travel"
        ]
    },
    {
        "icon": "print",
        "label": "Print",
        "search": [
            "Print Screen Symbol",
            "Printer Icon",
            "business",
            "computer",
            "copy",
            "document",
            "office",
            "paper",
            "printer"
        ]
    },
    {
        "icon": "dial-min",
        "label": "Dial Min",
        "search": [
            "dial",
            "level"
        ]
    },
    {
        "icon": "family",
        "label": "Family",
        "search": [
            "adults",
            "child",
            "famil",
            "family",
            "folk",
            "kid",
            "parent",
            "together",
            "uer"
        ]
    },
    {
        "icon": "starfighter",
        "label": "Starfighter",
        "search": [
            "luke skywalker",
            "rebel",
            "spaceship",
            "star wars",
            "x-wing"
        ]
    },
    {
        "icon": "cart-circle-arrow-down",
        "label": "Cart Circle Arrow Down",
        "search": [
            "cart",
            "grocery",
            "market",
            "shopping"
        ]
    },
    {
        "icon": "message-medical",
        "label": "Message Medical",
        "search": [
            "advice",
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "diagnose",
            "feedback",
            "message",
            "note",
            "notification",
            "prescription",
            "sms",
            "speech",
            "texting"
        ]
    },
    {
        "icon": "circle-arrow-down-right",
        "label": "Circle Arrow Down Right",
        "search": [
            "diagonal",
            "southeast"
        ]
    },
    {
        "icon": "volleyball",
        "label": "Volleyball",
        "search": [
            "ball",
            "beach",
            "game",
            "olympics",
            "sport",
            "volleyball"
        ]
    },
    {
        "icon": "arrow-turn-down-right",
        "label": "Arrow Turn Down Right",
        "search": [
            "forward",
            "move"
        ]
    },
    {
        "icon": "traffic-light",
        "label": "Traffic Light",
        "search": [
            "direction",
            "go",
            "light",
            "road",
            "signal",
            "slow",
            "stop",
            "traffic",
            "travel",
            "vertical traffic light"
        ]
    },
    {
        "icon": "plane-circle-check",
        "label": "Plane Circle Check",
        "search": [
            "airplane",
            "airport",
            "enable",
            "flight",
            "fly",
            "not affected",
            "ok",
            "okay",
            "travel",
            "validate",
            "working"
        ]
    },
    {
        "icon": "house-water",
        "label": "House Water",
        "search": [
            "building",
            "devastation",
            "disaster",
            "flood",
            "home",
            "insurance",
            "water"
        ]
    },
    {
        "icon": "users",
        "label": "Users",
        "search": [
            "employee",
            "together",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "certificate",
        "label": "Certificate",
        "search": [
            "badge",
            "guarantee",
            "star",
            "verified"
        ]
    },
    {
        "icon": "alarm-clock",
        "label": "Alarm Clock",
        "search": [
            "alarm",
            "alarm clock",
            "clock",
            "date",
            "late",
            "pending",
            "reminder",
            "sleep",
            "snooze",
            "timer",
            "timestamp",
            "watch"
        ]
    },
    {
        "icon": "helicopter-symbol",
        "label": "Helicopter Symbol",
        "search": [
            "chopper",
            "helicopter",
            "landing pad",
            "whirlybird"
        ]
    },
    {
        "icon": "house-chimney-crack",
        "label": "House Chimney Crack",
        "search": [
            "building",
            "devastation",
            "disaster",
            "earthquake",
            "home",
            "insurance"
        ]
    },
    {
        "icon": "dryer-heat",
        "label": "Dryer Heat",
        "search": [
            "clean",
            "clothes",
            "laundromat",
            "laundry",
            "washing machine"
        ]
    },
    {
        "icon": "bring-forward",
        "label": "Bring Forward",
        "search": [
            "arrange",
            "front",
            "layer",
            "order",
            "stack"
        ]
    },
    {
        "icon": "dial-low",
        "label": "Dial Low",
        "search": [
            "dial",
            "level"
        ]
    },
    {
        "icon": "circle-wifi-circle-wifi",
        "label": "Circle Wifi Circle Wifi",
        "search": [
            "connection",
            "group",
            "hotspot",
            "internet",
            "network",
            "pair",
            "signal",
            "wireless",
            "www"
        ]
    },
    {
        "icon": "display-medical",
        "label": "Display Medical",
        "search": [
            "computer",
            "desktop",
            "records"
        ]
    },
    {
        "icon": "person-military-pointing",
        "label": "Person Military Pointing",
        "search": [
            "army",
            "customs",
            "guard",
            "uer"
        ]
    },
    {
        "icon": "database",
        "label": "Database",
        "search": [
            "computer",
            "development",
            "directory",
            "memory",
            "mysql",
            "sql",
            "storage"
        ]
    },
    {
        "icon": "newspaper",
        "label": "Newspaper",
        "search": [
            "article",
            "editorial",
            "headline",
            "journal",
            "journalism",
            "news",
            "newsletter",
            "newspaper",
            "paper",
            "press"
        ]
    },
    {
        "icon": "cloud-rain",
        "label": "Cloud Rain",
        "search": [
            "Rain",
            "cloud",
            "cloud with rain",
            "precipitation",
            "rain",
            "sky",
            "storm"
        ]
    },
    {
        "icon": "signal-strong",
        "label": "Signal Strong",
        "search": [
            "bars",
            "graph",
            "online",
            "reception",
            "status"
        ]
    },
    {
        "icon": "maximize",
        "label": "Maximize",
        "search": [
            "arrows",
            "bigger",
            "enlarge",
            "expand",
            "fullscreen",
            "maximize",
            "resize",
            "resize",
            "scale",
            "size"
        ]
    },
    {
        "icon": "joomla",
        "label": "Joomla Logo",
        "search": []
    },
    {
        "icon": "location-arrow",
        "label": "Location Arrow",
        "search": [
            "address",
            "compass",
            "coordinate",
            "direction",
            "gps",
            "map",
            "navigation",
            "place"
        ]
    },
    {
        "icon": "city",
        "label": "City",
        "search": [
            "buildings",
            "busy",
            "city",
            "cityscape",
            "skyscrapers",
            "urban",
            "windows"
        ]
    },
    {
        "icon": "rectangle-code",
        "label": "Rectangle Code",
        "search": [
            "code",
            "coding",
            "command",
            "console",
            "development",
            "prompt",
            "terminal"
        ]
    },
    {
        "icon": "weixin",
        "label": "Weixin (WeChat)",
        "search": []
    },
    {
        "icon": "toilet-paper-check",
        "label": "Toilet Paper Check",
        "search": [
            "bathroom",
            "correct",
            "enable",
            "lavatory",
            "privy",
            "restroom",
            "roll",
            "sanitary",
            "toilet",
            "validate",
            "wipe",
            "working"
        ]
    },
    {
        "icon": "seal-question",
        "label": "Seal Question",
        "search": [
            "badge",
            "faq",
            "idea",
            "question"
        ]
    },
    {
        "icon": "x-ray",
        "label": "X Ray",
        "search": [
            "health",
            "medical",
            "radiological images",
            "radiology",
            "skeleton"
        ]
    },
    {
        "icon": "umbrella-beach",
        "label": "Umbrella Beach",
        "search": [
            "beach",
            "beach with umbrella",
            "protection",
            "recreation",
            "sand",
            "shade",
            "summer",
            "sun",
            "umbrella"
        ]
    },
    {
        "icon": "arrow-right-to-bracket",
        "label": "Arrow Right To Bracket",
        "search": [
            "arrow",
            "enter",
            "insert",
            "join",
            "log in",
            "login",
            "sign in",
            "sign up",
            "sign-in",
            "signin",
            "signup"
        ]
    },
    {
        "icon": "grunt",
        "label": "Grunt",
        "search": []
    },
    {
        "icon": "headset",
        "label": "Headset",
        "search": [
            "audio",
            "gamer",
            "gaming",
            "listen",
            "live chat",
            "microphone",
            "shot caller",
            "sound",
            "support",
            "telemarketer"
        ]
    },
    {
        "icon": "camera-polaroid",
        "label": "Camera Polaroid",
        "search": [
            "capture",
            "film",
            "instant camera",
            "lens",
            "photo",
            "photography",
            "retro",
            "snapshot",
            "vintage"
        ]
    },
    {
        "icon": "face-saluting",
        "label": "Face Saluting",
        "search": [
            "honor",
            "respect",
            "salute"
        ]
    },
    {
        "icon": "hand-horns",
        "label": "Hand Horns",
        "search": [
            "devil horns",
            "finger",
            "hand",
            "horns",
            "rock",
            "rock-on",
            "sign of the horns"
        ]
    },
    {
        "icon": "file-exclamation",
        "label": "File Exclamation",
        "search": [
            "alert",
            "document",
            "failed",
            "important",
            "page"
        ]
    },
    {
        "icon": "pipe-circle-check",
        "label": "Pipe Circle Check",
        "search": [
            "drain",
            "enable",
            "plumbing",
            "supply",
            "validate",
            "vesda",
            "water",
            "working"
        ]
    },
    {
        "icon": "splotch",
        "label": "Splotch",
        "search": [
            "Ink",
            "blob",
            "blotch",
            "glob",
            "stain"
        ]
    },
    {
        "icon": "up-long",
        "label": "Up Long",
        "search": [
            "long-arrow-up",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "face-unamused",
        "label": "Face Unamused",
        "search": [
            "dissatisfied",
            "face",
            "frown",
            "grumpy",
            "irritated",
            "meh",
            "skeptical",
            "unamused",
            "unamused face",
            "unhappy",
            "unimpressed"
        ]
    },
    {
        "icon": "spinner-scale",
        "label": "Spinner Scale",
        "search": [
            "circle",
            "loading",
            "pending",
            "progress"
        ]
    },
    {
        "icon": "hexagon-nodes",
        "label": "Hexagon Nodes",
        "search": [
            "action",
            "ai",
            "artificial intelligence",
            "cluster",
            "graph",
            "language",
            "llm",
            "model",
            "network",
            "neuronal"
        ]
    },
    {
        "icon": "hospital",
        "label": "Hospital",
        "search": [
            "building",
            "covid-19",
            "doctor",
            "emergency room",
            "hospital",
            "medical center",
            "medicine"
        ]
    },
    {
        "icon": "face-relieved",
        "label": "Face Relieved",
        "search": [
            "content",
            "face",
            "happy",
            "pleased",
            "relieved",
            "relieved face"
        ]
    },
    {
        "icon": "comment-smile",
        "label": "Comment Smile",
        "search": [
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "emoji",
            "feedback",
            "happy",
            "message",
            "note",
            "notification",
            "sms",
            "speech",
            "texting"
        ]
    },
    {
        "icon": "folder-check",
        "label": "Folder Check",
        "search": [
            "Black Folder",
            "archive",
            "directory",
            "document",
            "file",
            "file folder",
            "folder"
        ]
    },
    {
        "icon": "chart-user",
        "label": "Chart User",
        "search": [
            "employee",
            "performance",
            "revenue",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "person-harassing",
        "label": "Person Harassing",
        "search": [
            "abuse",
            "scream",
            "shame",
            "shout",
            "uer",
            "yell"
        ]
    },
    {
        "icon": "flatbread",
        "label": "Flatbread",
        "search": [
            "arepa",
            "flatbread",
            "lavash",
            "naan",
            "pita"
        ]
    },
    {
        "icon": "circle-microphone-lines",
        "label": "Circle Microphone Lines",
        "search": [
            "listen",
            "podcast",
            "record",
            "talking"
        ]
    },
    {
        "icon": "money-bill-trend-up",
        "label": "Money Bill Trend Up",
        "search": [
            "bank",
            "bonds",
            "inflation",
            "investment",
            "market",
            "revenue",
            "salary",
            "stocks",
            "trade"
        ]
    },
    {
        "icon": "pen-ruler",
        "label": "Pen Ruler",
        "search": [
            "design",
            "draft",
            "draw",
            "maintenance",
            "modify",
            "pencil"
        ]
    },
    {
        "icon": "brackets-square",
        "label": "Brackets Square",
        "search": [
            "code",
            "developer",
            "development",
            "parentheses"
        ]
    },
    {
        "icon": "person-dress-simple",
        "label": "Person Dress Simple",
        "search": [
            "lavatory",
            "man",
            "restroom",
            "skirt",
            "uer",
            "wc",
            "woman",
            "women’s room"
        ]
    },
    {
        "icon": "train-subway-tunnel",
        "label": "Train Subway Tunnel",
        "search": [
            "metro",
            "rail",
            "railroad",
            "railway",
            "subway",
            "train",
            "tunnel"
        ]
    },
    {
        "icon": "rockrms",
        "label": "Rockrms",
        "search": []
    },
    {
        "icon": "repeat",
        "label": "Repeat",
        "search": [
            "arrow",
            "clockwise",
            "flip",
            "reload",
            "renew",
            "repeat",
            "repeat button",
            "retry",
            "rewind",
            "switch"
        ]
    },
    {
        "icon": "bottle-baby",
        "label": "Bottle Baby",
        "search": [
            "baby",
            "bottle",
            "formula",
            "infant",
            "nurse",
            "nursing"
        ]
    },
    {
        "icon": "unsplash",
        "label": "Unsplash",
        "search": []
    },
    {
        "icon": "bone",
        "label": "Bone",
        "search": [
            "bone",
            "calcium",
            "dog",
            "skeletal",
            "skeleton",
            "tibia"
        ]
    },
    {
        "icon": "square-instagram",
        "label": "Square Instagram",
        "search": []
    },
    {
        "icon": "right-left-large",
        "label": "Right Left Large",
        "search": [
            "demand",
            "direction",
            "left",
            "pull",
            "push",
            "right",
            "share",
            "supply",
            "transfer"
        ]
    },
    {
        "icon": "strawberry",
        "label": "Strawberry",
        "search": [
            "berry",
            "fruit",
            "juice",
            "seed",
            "strawberry",
            "summer"
        ]
    },
    {
        "icon": "first-order-alt",
        "label": "Alternate First Order",
        "search": []
    },
    {
        "icon": "square-bolt",
        "label": "Square Bolt",
        "search": [
            "energy",
            "flash",
            "lightning"
        ]
    },
    {
        "icon": "fire-flame-curved",
        "label": "Fire Flame Curved",
        "search": [
            "burn",
            "caliente",
            "flame",
            "heat",
            "hot",
            "popular"
        ]
    },
    {
        "icon": "signature-slash",
        "label": "Signature Slash",
        "search": [
            "disabled",
            "signature",
            "unverified",
            "username"
        ]
    },
    {
        "icon": "fulcrum",
        "label": "Fulcrum",
        "search": []
    },
    {
        "icon": "bus-simple",
        "label": "Bus Simple",
        "search": [
            "mta",
            "public transportation",
            "transportation",
            "travel",
            "vehicle"
        ]
    },
    {
        "icon": "tank-water",
        "label": "Tank Water",
        "search": [
            "hydration",
            "storage",
            "water"
        ]
    },
    {
        "icon": "user-shakespeare",
        "label": "User Shakespeare",
        "search": [
            "bard",
            "playwright",
            "theater",
            "theatre",
            "uer"
        ]
    },
    {
        "icon": "venus-mars",
        "label": "Venus Mars",
        "search": [
            "Interlocked Female and Male Sign",
            "female",
            "gender",
            "heterosexual",
            "male"
        ]
    },
    {
        "icon": "kazoo",
        "label": "Kazoo",
        "search": [
            "buzz",
            "instrument",
            "membranophone",
            "mirliton",
            "music"
        ]
    },
    {
        "icon": "diagram-subtask",
        "label": "Diagram Subtask",
        "search": [
            "cells",
            "chart",
            "gantt",
            "next",
            "row",
            "subtask",
            "successor",
            "table",
            "tree"
        ]
    },
    {
        "icon": "arrows-from-dotted-line",
        "label": "Arrows From Dotted Line",
        "search": [
            "expand",
            "grow"
        ]
    },
    {
        "icon": "grip-dots",
        "label": "Grip Dots",
        "search": [
            "circles",
            "drag",
            "drop",
            "ellipsis",
            "grab",
            "grid",
            "handle",
            "move"
        ]
    },
    {
        "icon": "blender",
        "label": "Blender",
        "search": [
            "cocktail",
            "milkshake",
            "mixer",
            "puree",
            "smoothie"
        ]
    },
    {
        "icon": "u",
        "label": "U",
        "search": [
            "Latin Capital Letter U",
            "Latin Small Letter U",
            "letter"
        ]
    },
    {
        "icon": "box-heart",
        "label": "Box Heart",
        "search": [
            "care",
            "donation",
            "package",
            "storage",
            "wishlist"
        ]
    },
    {
        "icon": "lightbulb-cfl",
        "label": "Lightbulb Cfl",
        "search": [
            "bulb",
            "comic",
            "compact",
            "electric",
            "energy",
            "fluorescent",
            "idea",
            "inspiration",
            "light",
            "light bulb"
        ]
    },
    {
        "icon": "share",
        "label": "Share",
        "search": [
            "forward",
            "save",
            "send",
            "social"
        ]
    },
    {
        "icon": "cassette-vhs",
        "label": "Cassette Vhs",
        "search": [
            "betamax",
            "cassette",
            "rental",
            "retro",
            "tape",
            "vhs",
            "video",
            "videocassette",
            "vintage"
        ]
    },
    {
        "icon": "phone-flip",
        "label": "Phone Flip",
        "search": [
            "Right Hand Telephone Receiver",
            "call",
            "earphone",
            "number",
            "support",
            "telephone",
            "voice"
        ]
    },
    {
        "icon": "face-swear",
        "label": "Face Swear",
        "search": [
            "anger",
            "curse",
            "cursing",
            "cussing",
            "face with symbols on mouth",
            "grawlix",
            "swearing",
            "symbols"
        ]
    },
    {
        "icon": "toilet-portable",
        "label": "Toilet Portable",
        "search": [
            "outhouse",
            "toilet"
        ]
    },
    {
        "icon": "table-cells-column-unlock",
        "label": "Table Cells Column Unlock",
        "search": [
            "blocks",
            "boxes",
            "category",
            "column",
            "excel",
            "grid",
            "lock",
            "spreadsheet",
            "squares",
            "unlock"
        ]
    },
    {
        "icon": "person-pregnant",
        "label": "Person Pregnant",
        "search": [
            "baby",
            "birth",
            "child",
            "parent",
            "pregnant",
            "pregnant woman",
            "uer",
            "woman"
        ]
    },
    {
        "icon": "less-than",
        "label": "Less Than",
        "search": [
            "Less-Than Sign",
            "arithmetic",
            "compare",
            "math"
        ]
    },
    {
        "icon": "square-fragile",
        "label": "Square Fragile",
        "search": [
            "broken",
            "careful",
            "glass",
            "package"
        ]
    },
    {
        "icon": "inbox-full",
        "label": "Inbox Full",
        "search": [
            "communication",
            "dropbox",
            "email",
            "incoming",
            "organize",
            "outgoing",
            "send"
        ]
    },
    {
        "icon": "film-canister",
        "label": "Film Canister",
        "search": [
            "110",
            "35mm",
            "darkroom",
            "develop",
            "image",
            "photo",
            "photography",
            "retro",
            "vintage"
        ]
    },
    {
        "icon": "hammer-brush",
        "label": "Hammer Brush",
        "search": [
            "admin",
            "art",
            "bristles",
            "configuration",
            "equipment",
            "fix",
            "hammer",
            "maintenance",
            "modify",
            "paint",
            "recovery",
            "remodel",
            "repair",
            "settings",
            "tool"
        ]
    },
    {
        "icon": "superscript",
        "label": "Superscript",
        "search": [
            "edit",
            "exponential",
            "font",
            "format",
            "text",
            "type"
        ]
    },
    {
        "icon": "uniform-martial-arts",
        "label": "Uniform Martial Arts",
        "search": [
            "aikido",
            "belt",
            "jiu jitsu",
            "judo",
            "karate",
            "martial arts",
            "martial arts uniform",
            "taekwondo",
            "uniform"
        ]
    },
    {
        "icon": "circle-stop",
        "label": "Circle Stop",
        "search": [
            "block",
            "box",
            "circle",
            "square"
        ]
    },
    {
        "icon": "arrows-up-down",
        "label": "Arrows Up Down",
        "search": [
            "expand",
            "portrait",
            "resize",
            "tall",
            "vertical"
        ]
    },
    {
        "icon": "meter-droplet",
        "label": "Meter Droplet",
        "search": [
            "electricity",
            "transmission",
            "utilities"
        ]
    },
    {
        "icon": "ornament",
        "label": "Ornament",
        "search": [
            "christmas",
            "decoration",
            "holiday",
            "xmas"
        ]
    },
    {
        "icon": "display-slash",
        "label": "Display Slash",
        "search": [
            "computer",
            "desktop",
            "disabled",
            "disconnect"
        ]
    },
    {
        "icon": "page-caret-up",
        "label": "Page Caret Up",
        "search": [
            "document",
            "empty",
            "file",
            "new",
            "page up",
            "pdf",
            "resume",
            "upgrade"
        ]
    },
    {
        "icon": "poo-storm",
        "label": "Poo Storm",
        "search": [
            "bolt",
            "cloud",
            "euphemism",
            "lightning",
            "mess",
            "poop",
            "shit",
            "turd"
        ]
    },
    {
        "icon": "brave-reverse",
        "label": "Brave Reverse",
        "search": []
    },
    {
        "icon": "video-slash",
        "label": "Video Slash",
        "search": [
            "add",
            "create",
            "disabled",
            "disconnect",
            "film",
            "new",
            "positive",
            "record",
            "video"
        ]
    },
    {
        "icon": "square-xmark",
        "label": "Square Xmark",
        "search": [
            "close",
            "cross",
            "cross mark button",
            "incorrect",
            "mark",
            "notice",
            "notification",
            "notify",
            "problem",
            "square",
            "uncheck",
            "window",
            "wrong",
            "x",
            "×"
        ]
    },
    {
        "icon": "message-dots",
        "label": "Message Dots",
        "search": [
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "feedback",
            "message",
            "more",
            "note",
            "notification",
            "reply",
            "request",
            "sms",
            "speech",
            "texting"
        ]
    },
    {
        "icon": "droplet-degree",
        "label": "Droplet Degree",
        "search": [
            "air",
            "fog",
            "humidity",
            "temperature",
            "water"
        ]
    },
    {
        "icon": "tower-control",
        "label": "Tower Control",
        "search": [
            "air traffic control",
            "airplane",
            "airport"
        ]
    },
    {
        "icon": "burger-cheese",
        "label": "Burger Cheese",
        "search": [
            "bacon",
            "beef",
            "burger",
            "burger king",
            "fast food",
            "grill",
            "ground beef",
            "hamburger",
            "mcdonalds",
            "sandwich",
            "slider",
            "wendys",
            "white castle"
        ]
    },
    {
        "icon": "hand-holding-droplet",
        "label": "Hand Holding Droplet",
        "search": [
            "blood",
            "carry",
            "covid-19",
            "drought",
            "grow",
            "lift",
            "sanitation"
        ]
    },
    {
        "icon": "won-sign",
        "label": "Won Sign",
        "search": [
            "Won Sign",
            "currency"
        ]
    },
    {
        "icon": "object-ungroup",
        "label": "Object Ungroup",
        "search": [
            "copy",
            "design",
            "merge",
            "select",
            "separate"
        ]
    },
    {
        "icon": "chart-waterfall",
        "label": "Chart Waterfall",
        "search": [
            "chart",
            "graph",
            "performance",
            "revenue",
            "statistics",
            "track",
            "trend"
        ]
    },
    {
        "icon": "comment",
        "label": "Comment",
        "search": [
            "Right Speech Bubble",
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "conversation",
            "discussion",
            "feedback",
            "message",
            "note",
            "notification",
            "sms",
            "speech",
            "talk",
            "talking",
            "texting"
        ]
    },
    {
        "icon": "space-station-moon",
        "label": "Space Station Moon",
        "search": [
            "death star",
            "empire",
            "galen erso",
            "kyber crystal",
            "laser",
            "not a moon",
            "secret weapon",
            "star wars"
        ]
    },
    {
        "icon": "up-from-bracket",
        "label": "Up From Bracket",
        "search": [
            "import",
            "share",
            "transfer",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "calendar-circle-plus",
        "label": "Calendar Circle Plus",
        "search": [
            "add",
            "calendar",
            "create",
            "date",
            "day",
            "event",
            "month",
            "new",
            "positive",
            "schedule",
            "time",
            "when",
            "year"
        ]
    },
    {
        "icon": "tablet-screen",
        "label": "Tablet Screen",
        "search": [
            "device",
            "kindle",
            "screen"
        ]
    },
    {
        "icon": "avianex",
        "label": "avianex",
        "search": []
    },
    {
        "icon": "salt-shaker",
        "label": "Salt Shaker",
        "search": [
            "condiment",
            "pepper",
            "salt"
        ]
    },
    {
        "icon": "file-check",
        "label": "File Check",
        "search": [
            "accept",
            "agree",
            "confirm",
            "document",
            "done",
            "enable",
            "ok",
            "select",
            "success",
            "synced",
            "tick",
            "todo",
            "validate",
            "working"
        ]
    },
    {
        "icon": "hill-avalanche",
        "label": "Hill Avalanche",
        "search": [
            "mudslide",
            "snow",
            "winter"
        ]
    },
    {
        "icon": "arrows-to-eye",
        "label": "Arrows To Eye",
        "search": [
            "center",
            "coordinated assessment",
            "focus"
        ]
    },
    {
        "icon": "snowplow",
        "label": "Snowplow",
        "search": [
            "clean up",
            "cold",
            "road",
            "storm",
            "winter"
        ]
    },
    {
        "icon": "shield-exclamation",
        "label": "Shield Exclamation",
        "search": [
            "attention",
            "danger",
            "failed",
            "protect",
            "required",
            "safety"
        ]
    },
    {
        "icon": "ns8",
        "label": "NS8",
        "search": []
    },
    {
        "icon": "square-w",
        "label": "Square W",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "chart-gantt",
        "label": "Chart Gantt",
        "search": [
            "chart",
            "graph",
            "performance",
            "statistics",
            "track",
            "trend"
        ]
    },
    {
        "icon": "credit-card-blank",
        "label": "Credit Card Blank",
        "search": [
            "buy",
            "checkout",
            "debit",
            "money",
            "payment",
            "purchase"
        ]
    },
    {
        "icon": "hands-holding-dollar",
        "label": "Hands Holding Dollar",
        "search": [
            "$",
            "carry",
            "coupon",
            "dollar sign",
            "donation",
            "giving",
            "hold",
            "investment",
            "money",
            "premium",
            "price",
            "revenue",
            "salary",
            "usd"
        ]
    },
    {
        "icon": "square-pinterest",
        "label": "Square Pinterest",
        "search": []
    },
    {
        "icon": "building-magnifying-glass",
        "label": "Building Magnifying Glass",
        "search": [
            "apartment",
            "building",
            "business",
            "city",
            "company",
            "find",
            "inspect",
            "inspection",
            "office",
            "office building",
            "permit",
            "search",
            "urban",
            "work",
            "zoning"
        ]
    },
    {
        "icon": "headphones-simple",
        "label": "Headphones Simple",
        "search": [
            "audio",
            "listen",
            "music",
            "sound",
            "speaker"
        ]
    },
    {
        "icon": "square-a",
        "label": "Square A",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "video",
        "label": "Video",
        "search": [
            "camera",
            "film",
            "movie",
            "record",
            "video-camera"
        ]
    },
    {
        "icon": "bluetooth-b",
        "label": "Bluetooth",
        "search": []
    },
    {
        "icon": "face-pouting",
        "label": "Face Pouting",
        "search": [
            "angry",
            "face",
            "mad",
            "pouting",
            "pouting face",
            "rage",
            "red"
        ]
    },
    {
        "icon": "chess-pawn",
        "label": "Chess Pawn",
        "search": [
            "board",
            "checkmate",
            "chess",
            "chess pawn",
            "dupe",
            "expendable",
            "game",
            "strategy"
        ]
    },
    {
        "icon": "user-headset",
        "label": "User Headset",
        "search": [
            "employee",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "synagogue",
        "label": "Synagogue",
        "search": [
            "Jew",
            "Jewish",
            "building",
            "jewish",
            "judaism",
            "religion",
            "star of david",
            "synagogue",
            "temple"
        ]
    },
    {
        "icon": "mug",
        "label": "Mug",
        "search": [
            "coffee",
            "cup",
            "drink",
            "hot chocolate",
            "tea"
        ]
    },
    {
        "icon": "building-circle-check",
        "label": "Building Circle Check",
        "search": [
            "building",
            "city",
            "enable",
            "not affected",
            "office",
            "ok",
            "okay",
            "validate",
            "working"
        ]
    },
    {
        "icon": "calendar-plus",
        "label": "Calendar Plus",
        "search": [
            "add",
            "calendar",
            "create",
            "date",
            "day",
            "event",
            "month",
            "new",
            "positive",
            "schedule",
            "time",
            "when",
            "year"
        ]
    },
    {
        "icon": "wheelchair-move",
        "label": "Wheelchair Move",
        "search": [
            "access",
            "disabled",
            "handicap",
            "impairment",
            "physical",
            "uer",
            "wheelchair symbol"
        ]
    },
    {
        "icon": "user-shield",
        "label": "User Shield",
        "search": [
            "employee",
            "protect",
            "safety",
            "uer"
        ]
    },
    {
        "icon": "tally-4",
        "label": "Tally 4",
        "search": [
            "calculate",
            "count",
            "hash",
            "number"
        ]
    },
    {
        "icon": "bread-loaf",
        "label": "Bread Loaf",
        "search": [
            "bake",
            "bakery",
            "baking",
            "bread",
            "dough",
            "flour",
            "gluten",
            "grain",
            "loaf",
            "sandwich",
            "sourdough",
            "toast",
            "wheat",
            "yeast"
        ]
    },
    {
        "icon": "gripfire",
        "label": "Gripfire, Inc.",
        "search": []
    },
    {
        "icon": "circle-0",
        "label": "Circle 0",
        "search": [
            "Circled Digit Zero",
            "Negative Circled Digit Zero",
            "nada",
            "none",
            "zero",
            "zilch"
        ]
    },
    {
        "icon": "bold",
        "label": "Bold",
        "search": [
            "emphasis",
            "format",
            "text"
        ]
    },
    {
        "icon": "heart-pulse",
        "label": "Heart Pulse",
        "search": [
            "ekg",
            "electrocardiogram",
            "health",
            "lifeline",
            "vital signs"
        ]
    },
    {
        "icon": "square-root-variable",
        "label": "Square Root Variable",
        "search": [
            "arithmetic",
            "calculus",
            "division",
            "math"
        ]
    },
    {
        "icon": "message-check",
        "label": "Message Check",
        "search": [
            "accept",
            "agree",
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "enable",
            "feedback",
            "message",
            "note",
            "notification",
            "select",
            "sms",
            "speech",
            "success",
            "synced",
            "texting",
            "tick",
            "todo",
            "validate",
            "working"
        ]
    },
    {
        "icon": "hands-bubbles",
        "label": "Hands Bubbles",
        "search": [
            "covid-19",
            "hygiene",
            "soap",
            "wash"
        ]
    },
    {
        "icon": "guitars",
        "label": "Guitars",
        "search": [
            "acoustic",
            "axes",
            "electric",
            "instrument",
            "music",
            "rock",
            "rock and roll",
            "song",
            "strings"
        ]
    },
    {
        "icon": "marker",
        "label": "Marker",
        "search": [
            "design",
            "edit",
            "modify",
            "sharpie",
            "update",
            "write"
        ]
    },
    {
        "icon": "user-hair-long",
        "label": "User Hair Long",
        "search": [
            "bust",
            "bust in silhouette",
            "person",
            "profile",
            "silhouette",
            "uer"
        ]
    },
    {
        "icon": "square-google-plus",
        "label": "Square Google Plus",
        "search": [
            "social network"
        ]
    },
    {
        "icon": "traffic-light-go",
        "label": "Traffic Light Go",
        "search": [
            "begin",
            "direction",
            "go",
            "green",
            "road",
            "signal",
            "start",
            "travel"
        ]
    },
    {
        "icon": "house-person-leave",
        "label": "House Person Leave",
        "search": [
            "away",
            "home",
            "uer"
        ]
    },
    {
        "icon": "clipboard",
        "label": "Clipboard",
        "search": [
            "clipboar",
            "clipboard",
            "copy",
            "notepad",
            "notes",
            "paste",
            "record"
        ]
    },
    {
        "icon": "place-of-worship",
        "label": "Place Of Worship",
        "search": [
            "building",
            "church",
            "holy",
            "mosque",
            "synagogue"
        ]
    },
    {
        "icon": "cannabis",
        "label": "Cannabis",
        "search": [
            "bud",
            "chronic",
            "drugs",
            "endica",
            "endo",
            "ganja",
            "marijuana",
            "mary jane",
            "pot",
            "reefer",
            "sativa",
            "spliff",
            "weed",
            "whacky-tabacky"
        ]
    },
    {
        "icon": "face-zipper",
        "label": "Face Zipper",
        "search": [
            "face",
            "lips",
            "mouth",
            "quiet",
            "sealed",
            "secret",
            "zipper",
            "zipper-mouth face"
        ]
    },
    {
        "icon": "people-roof",
        "label": "People Roof",
        "search": [
            "crowd",
            "family",
            "group",
            "manage",
            "people",
            "safe",
            "shelter",
            "together",
            "uer"
        ]
    },
    {
        "icon": "pump",
        "label": "Pump",
        "search": [
            "drain",
            "flood",
            "pump",
            "sump",
            "water"
        ]
    },
    {
        "icon": "square-ampersand",
        "label": "Square Ampersand",
        "search": [
            "and"
        ]
    },
    {
        "icon": "disease",
        "label": "Disease",
        "search": [
            "bacteria",
            "cancer",
            "coronavirus",
            "covid-19",
            "flu",
            "illness",
            "infection",
            "pandemic",
            "sickness",
            "virus"
        ]
    },
    {
        "icon": "book-bible",
        "label": "Book Bible",
        "search": [
            "book",
            "catholicism",
            "christianity",
            "god",
            "holy"
        ]
    },
    {
        "icon": "chess-board",
        "label": "Chess Board",
        "search": [
            "board",
            "checkmate",
            "game",
            "strategy"
        ]
    },
    {
        "icon": "sprinkler",
        "label": "Sprinkler",
        "search": [
            "grass",
            "lawn",
            "shower",
            "spray",
            "water"
        ]
    },
    {
        "icon": "gun-squirt",
        "label": "Gun Squirt",
        "search": [
            "firearm",
            "gun",
            "handgun",
            "pistol",
            "revolver",
            "super soaker",
            "tool",
            "water",
            "water pistol",
            "weapon"
        ]
    },
    {
        "icon": "app-store",
        "label": "App Store",
        "search": []
    },
    {
        "icon": "mug-marshmallows",
        "label": "Mug Marshmallows",
        "search": [
            "cocoa",
            "coffee",
            "cup",
            "drink",
            "hot chocolate",
            "seasonal",
            "sweet",
            "warmth"
        ]
    },
    {
        "icon": "circle-heart",
        "label": "Circle Heart",
        "search": [
            "favorite",
            "like",
            "love",
            "wishlist"
        ]
    },
    {
        "icon": "diagram-sankey",
        "label": "Diagram Sankey",
        "search": [
            "chart",
            "timeline"
        ]
    },
    {
        "icon": "sunset",
        "label": "Sunset",
        "search": [
            "dusk",
            "night",
            "nighttime",
            "sun",
            "sun down",
            "sunset"
        ]
    },
    {
        "icon": "wix",
        "label": "Wix",
        "search": []
    },
    {
        "icon": "intercom",
        "label": "Intercom",
        "search": [
            "app",
            "customer",
            "messenger"
        ]
    },
    {
        "icon": "mars",
        "label": "Mars",
        "search": [
            "gender",
            "male",
            "male sign",
            "man"
        ]
    },
    {
        "icon": "laptop",
        "label": "Laptop",
        "search": [
            "computer",
            "cpu",
            "dell",
            "demo",
            "device",
            "fabook",
            "fb",
            "laptop",
            "mac",
            "macbook",
            "machine",
            "pc",
            "personal"
        ]
    },
    {
        "icon": "user-xmark",
        "label": "User Xmark",
        "search": [
            "archive",
            "delete",
            "employee",
            "remove",
            "uer",
            "uncheck",
            "x"
        ]
    },
    {
        "icon": "flag-usa",
        "label": "Flag Usa",
        "search": [
            "betsy ross",
            "country",
            "fla",
            "flag: United States",
            "old glory",
            "stars",
            "stripes",
            "symbol"
        ]
    },
    {
        "icon": "hand-middle-finger",
        "label": "Hand Middle Finger",
        "search": [
            "finger",
            "flip the bird",
            "gesture",
            "hand",
            "hate",
            "middle finger",
            "rude"
        ]
    },
    {
        "icon": "alt",
        "label": "Alt",
        "search": [
            "alternate",
            "option"
        ]
    },
    {
        "icon": "mortar-pestle",
        "label": "Mortar Pestle",
        "search": [
            "crush",
            "culinary",
            "grind",
            "medical",
            "mix",
            "pharmacy",
            "prescription",
            "spices"
        ]
    },
    {
        "icon": "banana",
        "label": "Banana",
        "search": [
            "banana",
            "fruit",
            "peel",
            "plantain",
            "potassium"
        ]
    },
    {
        "icon": "umbrella-simple",
        "label": "Umbrella Simple",
        "search": [
            "clothing",
            "rain",
            "spring",
            "umbrella"
        ]
    },
    {
        "icon": "joystick",
        "label": "Joystick",
        "search": [
            "arcade",
            "atari",
            "controller",
            "game",
            "joystick",
            "playstore",
            "retro",
            "video game",
            "vintage"
        ]
    },
    {
        "icon": "head-side-cough",
        "label": "Head Side Cough",
        "search": [
            "cough",
            "covid-19",
            "germs",
            "lungs",
            "respiratory",
            "sick",
            "uer"
        ]
    },
    {
        "icon": "plane-lock",
        "label": "Plane Lock",
        "search": [
            "airplane",
            "airport",
            "closed",
            "flight",
            "fly",
            "lockdown",
            "padlock",
            "privacy",
            "quarantine",
            "travel"
        ]
    },
    {
        "icon": "battery-three-quarters",
        "label": "Battery Three Quarters",
        "search": [
            "charge",
            "power",
            "status"
        ]
    },
    {
        "icon": "franc-sign",
        "label": "Franc Sign",
        "search": [
            "French Franc Sign",
            "currency"
        ]
    },
    {
        "icon": "filter-circle-dollar",
        "label": "Filter Circle Dollar",
        "search": [
            "filter",
            "money",
            "options",
            "premium",
            "separate",
            "sort"
        ]
    },
    {
        "icon": "cheese",
        "label": "Cheese",
        "search": [
            "cheddar",
            "curd",
            "gouda",
            "melt",
            "parmesan",
            "sandwich",
            "swiss",
            "wedge"
        ]
    },
    {
        "icon": "circle-h",
        "label": "Circle H",
        "search": [
            "Circled Latin Capital Letter H",
            "clinic",
            "covid-19",
            "emergency",
            "letter",
            "map"
        ]
    },
    {
        "icon": "box-ballot",
        "label": "Box Ballot",
        "search": [
            "ballot",
            "ballot box with ballot",
            "box",
            "election",
            "politics",
            "survey",
            "vote",
            "voting"
        ]
    },
    {
        "icon": "reacteurope",
        "label": "ReactEurope",
        "search": []
    },
    {
        "icon": "location-check",
        "label": "Location Check",
        "search": [
            "agree",
            "coordinates",
            "destination",
            "enable",
            "location",
            "map",
            "navigation",
            "pin",
            "place",
            "select",
            "success",
            "tick",
            "todo",
            "validate",
            "working"
        ]
    },
    {
        "icon": "tilde",
        "label": "Tilde",
        "search": [
            "Tilde",
            "accent",
            "symbol",
            "text",
            "type"
        ]
    },
    {
        "icon": "comment-middle",
        "label": "Comment Middle",
        "search": [
            "answer",
            "chat",
            "conversation"
        ]
    },
    {
        "icon": "waze",
        "label": "Waze",
        "search": []
    },
    {
        "icon": "arrow-down-from-bracket",
        "label": "Arrow Down From Bracket",
        "search": [
            "download",
            "exit",
            "share",
            "transfer"
        ]
    },
    {
        "icon": "creative-commons-remix",
        "label": "Creative Commons Remix",
        "search": []
    },
    {
        "icon": "school",
        "label": "School",
        "search": [
            "building",
            "education",
            "learn",
            "school",
            "student",
            "teacher"
        ]
    },
    {
        "icon": "ear-muffs",
        "label": "Ear Muffs",
        "search": [
            "accessory",
            "clothing",
            "cold",
            "head",
            "puffy",
            "soft",
            "winter"
        ]
    },
    {
        "icon": "clock-seven",
        "label": "Clock Seven",
        "search": [
            "00",
            "7",
            "7:00",
            "clock",
            "hour",
            "minute",
            "o'clock",
            "o’clock",
            "pending",
            "seven",
            "seven o’clock",
            "ticking",
            "time"
        ]
    },
    {
        "icon": "dice-five",
        "label": "Dice Five",
        "search": [
            "Die Face-5",
            "chance",
            "gambling",
            "game",
            "roll"
        ]
    },
    {
        "icon": "tornado",
        "label": "Tornado",
        "search": [
            "cloud",
            "cyclone",
            "dorothy",
            "landspout",
            "tornado",
            "toto",
            "twister",
            "vortext",
            "waterspout",
            "weather",
            "whirlwind"
        ]
    },
    {
        "icon": "arrow-left-to-line",
        "label": "Arrow Left To Line",
        "search": [
            "Leftwards Arrow to Bar",
            "back",
            "insert",
            "previous"
        ]
    },
    {
        "icon": "jet-fighter",
        "label": "Jet Fighter",
        "search": [
            "airforce",
            "airplane",
            "airport",
            "fast",
            "fly",
            "goose",
            "marines",
            "maverick",
            "military",
            "plane",
            "quick",
            "top gun",
            "transportation",
            "travel"
        ]
    },
    {
        "icon": "person-biking-mountain",
        "label": "Person Biking Mountain",
        "search": [
            "bicycle",
            "bicyclist",
            "bike",
            "cyclist",
            "mountain",
            "offroad",
            "pedal",
            "person mountain biking",
            "summer",
            "uer",
            "wheel"
        ]
    },
    {
        "icon": "thumbs-down",
        "label": "Thumbs Down",
        "search": [
            "-1",
            "disagree",
            "disapprove",
            "dislike",
            "down",
            "hand",
            "social",
            "thumb",
            "thumbs down",
            "thumbs-o-down"
        ]
    },
    {
        "icon": "function",
        "label": "Function",
        "search": [
            "math",
            "mathematics"
        ]
    },
    {
        "icon": "broom",
        "label": "Broom",
        "search": [
            "broom",
            "clean",
            "cleaning",
            "firebolt",
            "fly",
            "halloween",
            "nimbus 2000",
            "quidditch",
            "sweep",
            "sweeping",
            "witch"
        ]
    },
    {
        "icon": "disc-drive",
        "label": "Disc Drive",
        "search": [
            "blu-ray",
            "cd",
            "cd-rom",
            "computer",
            "dvd",
            "load",
            "music",
            "optical drive",
            "peripheral",
            "tray",
            "video"
        ]
    },
    {
        "icon": "grill",
        "label": "Grill",
        "search": [
            "barbecue",
            "barbeque",
            "bbq",
            "burger",
            "charcoal",
            "cook",
            "cookout",
            "hot",
            "smoke"
        ]
    },
    {
        "icon": "file-import",
        "label": "File Import",
        "search": [
            "copy",
            "document",
            "insert",
            "send",
            "upload"
        ]
    },
    {
        "icon": "jug",
        "label": "Jug",
        "search": [
            "beverage",
            "bottle",
            "drink",
            "moonshine",
            "pitcher",
            "western"
        ]
    },
    {
        "icon": "utensils",
        "label": "Utensils",
        "search": [
            "cooking",
            "cutlery",
            "dining",
            "dinner",
            "eat",
            "food",
            "fork",
            "fork and knife",
            "knife",
            "restaurant"
        ]
    },
    {
        "icon": "id-badge",
        "label": "Id Badge",
        "search": [
            "address",
            "contact",
            "identification",
            "license",
            "profile",
            "uer",
            "username"
        ]
    },
    {
        "icon": "bandcamp",
        "label": "Bandcamp",
        "search": []
    },
    {
        "icon": "spider",
        "label": "Spider",
        "search": [
            "arachnid",
            "bug",
            "charlotte",
            "crawl",
            "eight",
            "halloween",
            "insect",
            "spider"
        ]
    },
    {
        "icon": "person-fairy",
        "label": "Person Fairy",
        "search": [
            "elf",
            "faerie",
            "faery",
            "fairy",
            "fantasy",
            "magic",
            "sprite",
            "wings"
        ]
    },
    {
        "icon": "square-web-awesome-stroke",
        "label": "Square Web Awesome Stroke",
        "search": [
            "awesome",
            "coding",
            "components",
            "crown",
            "web"
        ]
    },
    {
        "icon": "vimeo-v",
        "label": "Vimeo V",
        "search": [
            "vimeo"
        ]
    },
    {
        "icon": "mobile-retro",
        "label": "Mobile Retro",
        "search": [
            "cellphone",
            "cellular",
            "phone"
        ]
    },
    {
        "icon": "signs-post",
        "label": "Signs Post",
        "search": [
            "directions",
            "directory",
            "map",
            "signage",
            "wayfinding"
        ]
    },
    {
        "icon": "group-arrows-rotate",
        "label": "Group Arrows Rotate",
        "search": [
            "community",
            "engagement",
            "spin",
            "sync"
        ]
    },
    {
        "icon": "diagram-venn",
        "label": "Diagram Venn",
        "search": [
            "chart",
            "intersection",
            "logic",
            "overlap"
        ]
    },
    {
        "icon": "arrows-split-up-and-left",
        "label": "Arrows Split Up And Left",
        "search": [
            "agile",
            "split"
        ]
    },
    {
        "icon": "image-polaroid-user",
        "label": "Image Polaroid User",
        "search": [
            "img",
            "kodak",
            "portrait",
            "selfie",
            "uer"
        ]
    },
    {
        "icon": "arrow-up-left",
        "label": "Arrow Up Left",
        "search": [
            "diagonal",
            "northwest"
        ]
    },
    {
        "icon": "car-garage",
        "label": "Car Garage",
        "search": [
            "auto",
            "automobile",
            "mechanic",
            "sedan",
            "transportation",
            "vehicle"
        ]
    },
    {
        "icon": "person-from-portal",
        "label": "Person From Portal",
        "search": [
            "portal",
            "run",
            "transport",
            "travel",
            "uer"
        ]
    },
    {
        "icon": "fill-drip",
        "label": "Fill Drip",
        "search": [
            "bucket",
            "color",
            "drop",
            "paint",
            "paint bucket",
            "spill"
        ]
    },
    {
        "icon": "shield-heart",
        "label": "Shield Heart",
        "search": [
            "love",
            "protect",
            "safe",
            "safety",
            "shield",
            "wishlist"
        ]
    },
    {
        "icon": "trash-can-undo",
        "label": "Trash Can Undo",
        "search": [
            "back",
            "control z",
            "delete",
            "garbage",
            "hide",
            "oops",
            "remove",
            "restore",
            "undo"
        ]
    },
    {
        "icon": "champagne-glass",
        "label": "Champagne Glass",
        "search": [
            "alcohol",
            "bar",
            "beverage",
            "celebration",
            "champagne",
            "drink",
            "holiday",
            "party"
        ]
    },
    {
        "icon": "strava",
        "label": "Strava",
        "search": []
    },
    {
        "icon": "uniregistry",
        "label": "Uniregistry",
        "search": []
    },
    {
        "icon": "person-skiing-nordic",
        "label": "Person Skiing Nordic",
        "search": [
            "cross country",
            "olympics",
            "uer",
            "winter"
        ]
    },
    {
        "icon": "cc-diners-club",
        "label": "Diner's Club Credit Card",
        "search": []
    },
    {
        "icon": "diagram-cells",
        "label": "Diagram Cells",
        "search": [
            "cells",
            "chart",
            "gantt",
            "row",
            "subtask",
            "table"
        ]
    },
    {
        "icon": "square-6",
        "label": "Square 6",
        "search": [
            "six"
        ]
    },
    {
        "icon": "square-2",
        "label": "Square 2",
        "search": [
            "two"
        ]
    },
    {
        "icon": "arrows-to-dotted-line",
        "label": "Arrows To Dotted Line",
        "search": [
            "collapse",
            "shrink"
        ]
    },
    {
        "icon": "hat-beach",
        "label": "Hat Beach",
        "search": [
            "beach",
            "flower",
            "hat",
            "shade",
            "sun"
        ]
    },
    {
        "icon": "router",
        "label": "Router",
        "search": [
            "bandwidth",
            "connection",
            "dsl",
            "ethernet",
            "internet",
            "modem",
            "switch",
            "wifi",
            "wireless",
            "www"
        ]
    },
    {
        "icon": "sensor",
        "label": "Sensor",
        "search": [
            "alarm",
            "alert",
            "carbon monoxide",
            "detector",
            "fire",
            "smoke"
        ]
    },
    {
        "icon": "square-check",
        "label": "Square Check",
        "search": [
            "accept",
            "agree",
            "box",
            "button",
            "check",
            "check box with check",
            "check mark button",
            "checkmark",
            "confirm",
            "correct",
            "coupon",
            "done",
            "enable",
            "mark",
            "ok",
            "select",
            "success",
            "tick",
            "todo",
            "validate",
            "working",
            "yes",
            "✓"
        ]
    },
    {
        "icon": "paintbrush-fine",
        "label": "Paintbrush Fine",
        "search": [
            "acrylic",
            "art",
            "brush",
            "color",
            "fill",
            "modify",
            "paint",
            "pigment",
            "watercolor"
        ]
    },
    {
        "icon": "bath",
        "label": "Bath",
        "search": [
            "bath",
            "bathtub",
            "clean",
            "shower",
            "tub",
            "wash"
        ]
    },
    {
        "icon": "chess-bishop",
        "label": "Chess Bishop",
        "search": [
            "Black Chess Bishop",
            "board",
            "checkmate",
            "game",
            "strategy"
        ]
    },
    {
        "icon": "pinterest",
        "label": "Pinterest",
        "search": []
    },
    {
        "icon": "fence",
        "label": "Fence",
        "search": [
            "fencing",
            "picket",
            "planks",
            "wall",
            "wood"
        ]
    },
    {
        "icon": "microwave",
        "label": "Microwave",
        "search": [
            "chef",
            "cook",
            "kitchen",
            "nuke"
        ]
    },
    {
        "icon": "alarm-exclamation",
        "label": "Alarm Exclamation",
        "search": [
            "alert",
            "attention",
            "date",
            "failed",
            "late",
            "pending",
            "reminder",
            "sleep",
            "snooze",
            "timer",
            "timestamp",
            "watch"
        ]
    },
    {
        "icon": "algolia",
        "label": "Algolia",
        "search": []
    },
    {
        "icon": "tomato",
        "label": "Tomato",
        "search": [
            "blt",
            "fresh",
            "fruit",
            "garden",
            "salad",
            "summer",
            "tomato",
            "vegetable"
        ]
    },
    {
        "icon": "prescription-bottle-medical",
        "label": "Prescription Bottle Medical",
        "search": [
            "drugs",
            "medical",
            "medicine",
            "pharmacy",
            "rx"
        ]
    },
    {
        "icon": "watch-calculator",
        "label": "Watch Calculator",
        "search": [
            "casio",
            "digital",
            "math",
            "time"
        ]
    },
    {
        "icon": "draw-polygon",
        "label": "Draw Polygon",
        "search": [
            "anchors",
            "lines",
            "object",
            "render",
            "shape"
        ]
    },
    {
        "icon": "slider",
        "label": "Slider",
        "search": [
            "adjust",
            "configuration",
            "modify",
            "settings",
            "toggle"
        ]
    },
    {
        "icon": "i-cursor",
        "label": "I Cursor",
        "search": [
            "editing",
            "i-beam",
            "type",
            "writing"
        ]
    },
    {
        "icon": "cloud-rainbow",
        "label": "Cloud Rainbow",
        "search": [
            "gold",
            "leprechaun",
            "prism",
            "rain",
            "sky"
        ]
    },
    {
        "icon": "heart-circle-plus",
        "label": "Heart Circle Plus",
        "search": [
            "favorite",
            "heart",
            "love"
        ]
    },
    {
        "icon": "stackpath",
        "label": "Stackpath",
        "search": []
    },
    {
        "icon": "shield-dog",
        "label": "Shield Dog",
        "search": [
            "animal",
            "canine",
            "pet",
            "protect",
            "safety",
            "veterinary"
        ]
    },
    {
        "icon": "file-slash",
        "label": "File Slash",
        "search": [
            "cancel",
            "delete",
            "disabled",
            "paper",
            "remove"
        ]
    },
    {
        "icon": "chess-rook-piece",
        "label": "Chess Rook Piece",
        "search": [
            "board",
            "castle",
            "checkmate",
            "game",
            "strategy"
        ]
    },
    {
        "icon": "greater-than-equal",
        "label": "Greater Than Equal",
        "search": [
            "arithmetic",
            "compare",
            "math"
        ]
    },
    {
        "icon": "envelope-open",
        "label": "Envelope Open",
        "search": [
            "e-mail",
            "email",
            "letter",
            "mail",
            "message",
            "newsletter",
            "notification",
            "offer",
            "support"
        ]
    },
    {
        "icon": "mound",
        "label": "Mound",
        "search": [
            "barrier",
            "hill",
            "pitcher",
            "speedbump"
        ]
    },
    {
        "icon": "rings-wedding",
        "label": "Rings Wedding",
        "search": [
            "diamond",
            "engagement",
            "gold",
            "marriage",
            "matrimony",
            "platinum",
            "premium",
            "proposal"
        ]
    },
    {
        "icon": "grill-fire",
        "label": "Grill Fire",
        "search": [
            "barbecue",
            "barbeque",
            "bbq",
            "burger",
            "charcoal",
            "cook",
            "cookout",
            "hot",
            "smoke"
        ]
    },
    {
        "icon": "distribute-spacing-horizontal",
        "label": "Distribute Spacing Horizontal",
        "search": [
            "align",
            "line",
            "padding",
            "rectangle",
            "spacing"
        ]
    },
    {
        "icon": "bowl-soft-serve",
        "label": "Bowl Soft Serve",
        "search": [
            "cone",
            "creemee",
            "frozen yogurt",
            "ice cream",
            "icecream",
            "softserve"
        ]
    },
    {
        "icon": "voicemail",
        "label": "Voicemail",
        "search": [
            "answer",
            "inbox",
            "message",
            "phone"
        ]
    },
    {
        "icon": "vest",
        "label": "Vest",
        "search": [
            "biker",
            "fashion",
            "style"
        ]
    },
    {
        "icon": "octopus-deploy",
        "label": "Octopus Deploy",
        "search": []
    },
    {
        "icon": "audio-description",
        "label": "Audio Description",
        "search": [
            "blind",
            "narration",
            "video",
            "visual"
        ]
    },
    {
        "icon": "w",
        "label": "W",
        "search": [
            "Latin Capital Letter W",
            "Latin Small Letter W",
            "letter"
        ]
    },
    {
        "icon": "cart-circle-xmark",
        "label": "Cart Circle Xmark",
        "search": [
            "cart",
            "grocery",
            "market",
            "shopping",
            "uncheck"
        ]
    },
    {
        "icon": "clouds-sun",
        "label": "Clouds Sun",
        "search": [
            "cloudy",
            "day",
            "moonlight",
            "overcast",
            "sky",
            "summer"
        ]
    },
    {
        "icon": "eye-dropper",
        "label": "Eye Dropper",
        "search": [
            "beaker",
            "clone",
            "color",
            "copy",
            "eyedropper",
            "pipette"
        ]
    },
    {
        "icon": "circle-xmark",
        "label": "Circle Xmark",
        "search": [
            "close",
            "cross",
            "destroy",
            "exit",
            "incorrect",
            "notice",
            "notification",
            "notify",
            "problem",
            "uncheck",
            "wrong",
            "x"
        ]
    },
    {
        "icon": "trailer",
        "label": "Trailer",
        "search": [
            "carry",
            "haul",
            "moving",
            "travel"
        ]
    },
    {
        "icon": "turkish-lira-sign",
        "label": "Turkish Lira Sign",
        "search": [
            "Turkish Lira Sign",
            "currency"
        ]
    },
    {
        "icon": "gauge-circle-minus",
        "label": "Gauge Circle Minus",
        "search": [
            "dashboard",
            "decrease",
            "fast",
            "odometer",
            "speed",
            "speedometer"
        ]
    },
    {
        "icon": "draw-square",
        "label": "Draw Square",
        "search": [
            "anchors",
            "lines",
            "object",
            "render",
            "shape"
        ]
    },
    {
        "icon": "mountains",
        "label": "Mountains",
        "search": [
            "glacier",
            "hiking",
            "hill",
            "landscape",
            "mountain",
            "travel",
            "view"
        ]
    },
    {
        "icon": "truck-tow",
        "label": "Truck Tow",
        "search": [
            "accident",
            "assistance",
            "help",
            "tow"
        ]
    },
    {
        "icon": "location-minus",
        "label": "Location Minus",
        "search": [
            "agree",
            "coordinates",
            "delete",
            "destination",
            "location",
            "map",
            "navigation",
            "negative",
            "pin",
            "place",
            "remove"
        ]
    },
    {
        "icon": "shield-xmark",
        "label": "Shield Xmark",
        "search": [
            "protect",
            "remove",
            "safety",
            "uncheck"
        ]
    },
    {
        "icon": "face-shush",
        "label": "Face Shush",
        "search": [
            "finger",
            "hush",
            "quiet",
            "shh",
            "shush",
            "shushing face"
        ]
    },
    {
        "icon": "yammer",
        "label": "Yammer",
        "search": []
    },
    {
        "icon": "house-day",
        "label": "House Day",
        "search": [
            "abode",
            "building",
            "family",
            "home",
            "residence",
            "solar",
            "sun"
        ]
    },
    {
        "icon": "volcano",
        "label": "Volcano",
        "search": [
            "caldera",
            "eruption",
            "lava",
            "magma",
            "mountain",
            "smoke",
            "volcano"
        ]
    },
    {
        "icon": "wand-sparkles",
        "label": "Wand Sparkles",
        "search": [
            "autocomplete",
            "automatic",
            "fantasy",
            "halloween",
            "holiday",
            "magic",
            "weapon",
            "witch",
            "wizard"
        ]
    },
    {
        "icon": "fire-flame",
        "label": "Fire Flame",
        "search": [
            "Dungeons & Dragons",
            "caliente",
            "d&d",
            "dnd",
            "fantasy",
            "heat",
            "hot"
        ]
    },
    {
        "icon": "bowling-ball-pin",
        "label": "Bowling Ball Pin",
        "search": [
            "ball",
            "bowling",
            "game",
            "league",
            "pin",
            "strike"
        ]
    },
    {
        "icon": "microphone",
        "label": "Microphone",
        "search": [
            "address",
            "audio",
            "information",
            "podcast",
            "public",
            "record",
            "sing",
            "sound",
            "talking",
            "voice"
        ]
    },
    {
        "icon": "crown",
        "label": "Crown",
        "search": [
            "award",
            "clothing",
            "crown",
            "favorite",
            "king",
            "queen",
            "royal",
            "tiara",
            "vip"
        ]
    },
    {
        "icon": "tent-arrow-turn-left",
        "label": "Tent Arrow Turn Left",
        "search": [
            "bivouac",
            "campground",
            "campsite",
            "refugee",
            "refugee",
            "shelter",
            "shelter",
            "temporary",
            "tent"
        ]
    },
    {
        "icon": "truck-fast",
        "label": "Truck Fast",
        "search": [
            "express",
            "fedex",
            "mail",
            "overnight",
            "package",
            "quick",
            "ups"
        ]
    },
    {
        "icon": "user-pen",
        "label": "User Pen",
        "search": [
            "employee",
            "modify",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "person-snowmobiling",
        "label": "Person Snowmobiling",
        "search": [
            "snowmobile",
            "uer",
            "winter"
        ]
    },
    {
        "icon": "burger-soda",
        "label": "Burger Soda",
        "search": [
            "bacon",
            "beef",
            "cheeseburger",
            "fast food",
            "grill",
            "ground beef",
            "hamburger",
            "junk food",
            "pop",
            "sandwich",
            "slider"
        ]
    },
    {
        "icon": "rabbit-running",
        "label": "Rabbit Running",
        "search": [
            "animal",
            "bunny",
            "fast",
            "fauna",
            "follow",
            "hare",
            "mammal",
            "quick",
            "running",
            "speed",
            "wabbit"
        ]
    },
    {
        "icon": "dial-max",
        "label": "Dial Max",
        "search": [
            "dial",
            "level"
        ]
    },
    {
        "icon": "face-hushed",
        "label": "Face Hushed",
        "search": [
            "face",
            "hushed",
            "hushed face",
            "stunned",
            "surprise",
            "surprised",
            "wow"
        ]
    },
    {
        "icon": "stocking",
        "label": "Stocking",
        "search": [
            "christmas",
            "clothing",
            "decoration",
            "gift",
            "holiday",
            "present",
            "sock",
            "tradition",
            "xmas"
        ]
    },
    {
        "icon": "user-clock",
        "label": "User Clock",
        "search": [
            "employee",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "face-downcast-sweat",
        "label": "Face Downcast Sweat",
        "search": [
            "cold",
            "downcast face with sweat",
            "face",
            "hard work",
            "sweat",
            "tired",
            "tough"
        ]
    },
    {
        "icon": "shield-plus",
        "label": "Shield Plus",
        "search": [
            "add",
            "protect",
            "safe",
            "safety"
        ]
    },
    {
        "icon": "modx",
        "label": "MODX",
        "search": []
    },
    {
        "icon": "square-threads",
        "label": "Square Threads",
        "search": [
            "social network"
        ]
    },
    {
        "icon": "accent-grave",
        "label": "Accent Grave",
        "search": [
            "Grave Accent",
            "apostrophe",
            "tick"
        ]
    },
    {
        "icon": "hood-cloak",
        "label": "Hood Cloak",
        "search": [
            "Dungeons & Dragons",
            "clothing",
            "d&d",
            "dnd",
            "fantasy",
            "hat",
            "rogue",
            "stealth"
        ]
    },
    {
        "icon": "square-arrow-up",
        "label": "Square Arrow Up",
        "search": [
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "clock-ten-thirty",
        "label": "Clock Ten Thirty",
        "search": [
            "10",
            "10:30",
            "clock",
            "hour",
            "minute",
            "o'clock",
            "pending",
            "ten",
            "ten-thirty",
            "thirty",
            "ticking",
            "time"
        ]
    },
    {
        "icon": "old-republic",
        "label": "Old Republic",
        "search": [
            "politics",
            "star wars"
        ]
    },
    {
        "icon": "suse",
        "label": "Suse",
        "search": [
            "linux",
            "operating system",
            "os"
        ]
    },
    {
        "icon": "square-4",
        "label": "Square 4",
        "search": [
            "four"
        ]
    },
    {
        "icon": "shower",
        "label": "Shower",
        "search": [
            "bath",
            "clean",
            "faucet",
            "shower",
            "water"
        ]
    },
    {
        "icon": "fishing-rod",
        "label": "Fishing Rod",
        "search": [
            "bait",
            "cast",
            "fish",
            "fishing pole",
            "pole"
        ]
    },
    {
        "icon": "square-caret-up",
        "label": "Square Caret Up",
        "search": [
            "arrow",
            "caret-square-o-up",
            "collapse",
            "triangle",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "circle-arrow-up-left",
        "label": "Circle Arrow Up Left",
        "search": [
            "diagonal",
            "northwest"
        ]
    },
    {
        "icon": "box-dollar",
        "label": "Box Dollar",
        "search": [
            "$",
            "dollar-sign",
            "donation",
            "money",
            "salary",
            "usd"
        ]
    },
    {
        "icon": "theta",
        "label": "Theta",
        "search": [
            "alphabet",
            "greek",
            "math"
        ]
    },
    {
        "icon": "face-smile-tongue",
        "label": "Face Smile Tongue",
        "search": [
            "delicious",
            "face",
            "face savoring food",
            "savoring",
            "savouring",
            "smile",
            "yum"
        ]
    },
    {
        "icon": "file-vector",
        "label": "File Vector",
        "search": [
            "document",
            "eps",
            "image",
            "svg",
            "vector"
        ]
    },
    {
        "icon": "video-arrow-up-right",
        "label": "Video Arrow Up Right",
        "search": [
            "export",
            "film",
            "movie",
            "send",
            "upgrade"
        ]
    },
    {
        "icon": "app-store-ios",
        "label": "iOS App Store",
        "search": []
    },
    {
        "icon": "map-location",
        "label": "Map Location",
        "search": [
            "address",
            "coordinates",
            "destination",
            "gps",
            "localize",
            "location",
            "map",
            "navigation",
            "paper",
            "pin",
            "place",
            "point of interest",
            "position",
            "route",
            "travel"
        ]
    },
    {
        "icon": "face-icicles",
        "label": "Face Icicles",
        "search": [
            "blue-faced",
            "chill",
            "cold",
            "cold face",
            "cool",
            "freezing",
            "frostbite",
            "frozen",
            "ice",
            "icicles"
        ]
    },
    {
        "icon": "pen-fancy",
        "label": "Pen Fancy",
        "search": [
            "black nib",
            "design",
            "edit",
            "fountain",
            "fountain pen",
            "modify",
            "nib",
            "pen",
            "update",
            "write"
        ]
    },
    {
        "icon": "square-dribbble",
        "label": "Square Dribbble",
        "search": []
    },
    {
        "icon": "user-chef",
        "label": "User Chef",
        "search": [
            "chef",
            "cook",
            "dining",
            "employee",
            "food",
            "kitchen",
            "restaurant",
            "uer"
        ]
    },
    {
        "icon": "uikit",
        "label": "UIkit",
        "search": []
    },
    {
        "icon": "euro-sign",
        "label": "Euro Sign",
        "search": [
            "Euro Sign",
            "currency"
        ]
    },
    {
        "icon": "house-circle-xmark",
        "label": "House Circle Xmark",
        "search": [
            "abode",
            "destroy",
            "home",
            "house",
            "uncheck"
        ]
    },
    {
        "icon": "lira-sign",
        "label": "Lira Sign",
        "search": [
            "Lira Sign",
            "currency"
        ]
    },
    {
        "icon": "yen-sign",
        "label": "Yen Sign",
        "search": [
            "Yen Sign",
            "currency"
        ]
    },
    {
        "icon": "box-open",
        "label": "Box Open",
        "search": [
            "archive",
            "container",
            "package",
            "storage",
            "unpack"
        ]
    },
    {
        "icon": "golf-flag-hole",
        "label": "Golf Flag Hole",
        "search": [
            "bogey",
            "eagle",
            "flag in hole",
            "golf",
            "hole",
            "putt"
        ]
    },
    {
        "icon": "superpowers",
        "label": "Superpowers",
        "search": []
    },
    {
        "icon": "truck-field",
        "label": "Truck Field",
        "search": [
            "supplies",
            "truck"
        ]
    },
    {
        "icon": "youtube",
        "label": "YouTube",
        "search": [
            "film",
            "video",
            "youtube-play",
            "youtube-square"
        ]
    },
    {
        "icon": "whistle",
        "label": "Whistle",
        "search": [
            "alert",
            "single",
            "sound",
            "toot"
        ]
    },
    {
        "icon": "kerning",
        "label": "Kerning",
        "search": [
            "adjust",
            "font",
            "spacing",
            "text",
            "tracking",
            "type",
            "typography"
        ]
    },
    {
        "icon": "location-pin-lock",
        "label": "Location Pin Lock",
        "search": [
            "closed",
            "lockdown",
            "map",
            "padlock",
            "privacy",
            "quarantine"
        ]
    },
    {
        "icon": "ember",
        "label": "Ember",
        "search": []
    },
    {
        "icon": "waves-sine",
        "label": "Waves Sine",
        "search": [
            "Sine Wave",
            "compare",
            "frequency",
            "pulse",
            "signal",
            "similar"
        ]
    },
    {
        "icon": "grid-horizontal",
        "label": "Grid Horizontal",
        "search": [
            "app",
            "collection",
            "dashboard",
            "grid",
            "launcher",
            "square"
        ]
    },
    {
        "icon": "person-praying",
        "label": "Person Praying",
        "search": [
            "kneel",
            "place of worship",
            "religion",
            "thank",
            "uer",
            "worship"
        ]
    },
    {
        "icon": "location-plus",
        "label": "Location Plus",
        "search": [
            "add",
            "agree",
            "coordinates",
            "create",
            "destination",
            "location",
            "map",
            "navigation",
            "new",
            "pin",
            "place",
            "positive"
        ]
    },
    {
        "icon": "diamond-half-stroke",
        "label": "Diamond Half Stroke",
        "search": [
            "contrast",
            "diamond",
            "gem",
            "half",
            "rating"
        ]
    },
    {
        "icon": "clipboard-list",
        "label": "Clipboard List",
        "search": [
            "cheatsheet",
            "checklist",
            "completed",
            "done",
            "finished",
            "intinerary",
            "ol",
            "schedule",
            "summary",
            "survey",
            "tick",
            "todo",
            "ul",
            "wishlist"
        ]
    },
    {
        "icon": "objects-align-center-vertical",
        "label": "Objects Align Center Vertical",
        "search": [
            "align",
            "distribute",
            "line",
            "rectangles"
        ]
    },
    {
        "icon": "candy-bar",
        "label": "Candy Bar",
        "search": [
            "candy",
            "chocolate",
            "hershey"
        ]
    },
    {
        "icon": "booth-curtain",
        "label": "Booth Curtain",
        "search": [
            "changing room",
            "election",
            "vote",
            "voting",
            "voting booth"
        ]
    },
    {
        "icon": "sack-dollar",
        "label": "Sack Dollar",
        "search": [
            "bag",
            "burlap",
            "cash",
            "dollar",
            "investment",
            "money",
            "money bag",
            "moneybag",
            "premium",
            "robber",
            "salary",
            "santa",
            "usd"
        ]
    },
    {
        "icon": "mountain-sun",
        "label": "Mountain Sun",
        "search": [
            "country",
            "hiking",
            "landscape",
            "rural",
            "travel",
            "view"
        ]
    },
    {
        "icon": "hockey-mask",
        "label": "Hockey Mask",
        "search": [
            "clothing",
            "friday",
            "halloween",
            "ice",
            "jason",
            "nhl",
            "protection",
            "sport",
            "thirteenth"
        ]
    },
    {
        "icon": "location-smile",
        "label": "Location Smile",
        "search": [
            "agree",
            "coordinates",
            "destination",
            "emoji",
            "happy",
            "location",
            "map",
            "navigation",
            "pin",
            "place",
            "success"
        ]
    },
    {
        "icon": "tally-3",
        "label": "Tally 3",
        "search": [
            "calculate",
            "count",
            "hash",
            "number"
        ]
    },
    {
        "icon": "bootstrap",
        "label": "Bootstrap",
        "search": []
    },
    {
        "icon": "arrow-down-from-line",
        "label": "Arrow Down From Line",
        "search": [
            "download",
            "export",
            "transfer"
        ]
    },
    {
        "icon": "chart-pyramid",
        "label": "Chart Pyramid",
        "search": [
            "chart",
            "food",
            "graph",
            "performance",
            "statistics"
        ]
    },
    {
        "icon": "goal-net",
        "label": "Goal Net",
        "search": [
            "goal",
            "goal net",
            "hockey",
            "lacrosse",
            "net",
            "penalty",
            "soccer"
        ]
    },
    {
        "icon": "link-horizontal-slash",
        "label": "Link Horizontal Slash",
        "search": [
            "attachment",
            "chain",
            "disabled",
            "disconnect",
            "hotspot"
        ]
    },
    {
        "icon": "carpool",
        "label": "Carpool",
        "search": [
            "auto",
            "automobile",
            "car",
            "caravan",
            "carpool",
            "oncoming",
            "oncoming automobile",
            "passengers",
            "rideshare",
            "sedan",
            "transportation",
            "travel",
            "vanpool",
            "vehicle"
        ]
    },
    {
        "icon": "arrow-up-wide-short",
        "label": "Arrow Up Wide Short",
        "search": [
            "arrange",
            "filter",
            "order",
            "sort-amount-desc",
            "upgrade"
        ]
    },
    {
        "icon": "itunes",
        "label": "iTunes",
        "search": []
    },
    {
        "icon": "arrow-up-from-dotted-line",
        "label": "Arrow Up From Dotted Line",
        "search": [
            "import",
            "transfer",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "square-xing",
        "label": "Square Xing",
        "search": []
    },
    {
        "icon": "hexagon-image",
        "label": "Hexagon Image",
        "search": [
            "blockchain",
            "crypto",
            "data",
            "image",
            "img",
            "nft",
            "non-fungible token",
            "photo"
        ]
    },
    {
        "icon": "css3-alt",
        "label": "Alternate CSS3 Logo",
        "search": []
    },
    {
        "icon": "users-line",
        "label": "Users Line",
        "search": [
            "crowd",
            "employee",
            "group",
            "need",
            "people",
            "together",
            "uer"
        ]
    },
    {
        "icon": "arrow-up-right-and-arrow-down-left-from-center",
        "label": "Arrow Up Right And Arrow Down Left From Center",
        "search": [
            "enlarge",
            "expand",
            "maximize",
            "resize",
            "scale",
            "size"
        ]
    },
    {
        "icon": "camera-viewfinder",
        "label": "Camera Viewfinder",
        "search": [
            "camera",
            "focus",
            "img",
            "screenshot",
            "video"
        ]
    },
    {
        "icon": "star-of-david",
        "label": "Star Of David",
        "search": [
            "David",
            "Jew",
            "Jewish",
            "jewish",
            "judaism",
            "religion",
            "star",
            "star of David"
        ]
    },
    {
        "icon": "notes-medical",
        "label": "Notes Medical",
        "search": [
            "clipboard",
            "doctor",
            "ehr",
            "health",
            "history",
            "records"
        ]
    },
    {
        "icon": "austral-sign",
        "label": "Austral Sign",
        "search": [
            "Austral Sign",
            "currency"
        ]
    },
    {
        "icon": "file-chart-pie",
        "label": "File Chart Pie",
        "search": [
            "analytics",
            "data",
            "document",
            "projection",
            "report",
            "revenue"
        ]
    },
    {
        "icon": "face-sad-sweat",
        "label": "Face Sad Sweat",
        "search": [
            "disappointed",
            "face",
            "relieved",
            "sad but relieved face",
            "whew"
        ]
    },
    {
        "icon": "clipboard-user",
        "label": "Clipboard User",
        "search": [
            "attendance",
            "employee",
            "record",
            "roster",
            "staff",
            "uer"
        ]
    },
    {
        "icon": "comment-arrow-down",
        "label": "Comment Arrow Down",
        "search": [
            "answer",
            "chat",
            "contact",
            "download",
            "insert"
        ]
    },
    {
        "icon": "file-image",
        "label": "File Image",
        "search": [
            "Document with Picture",
            "document",
            "image",
            "img",
            "jpg",
            "photo",
            "png"
        ]
    },
    {
        "icon": "file-mov",
        "label": "File Mov",
        "search": [
            "document",
            "film",
            "mov",
            "movie",
            "video"
        ]
    },
    {
        "icon": "pie",
        "label": "Pie",
        "search": [
            "apple",
            "bakery",
            "cake",
            "crust",
            "dessert",
            "filling",
            "fruit",
            "meat",
            "pastry",
            "pie",
            "pumpkin",
            "tart"
        ]
    },
    {
        "icon": "bagel",
        "label": "Bagel",
        "search": [
            "bagel",
            "bakery",
            "breakfast",
            "cream cheese",
            "schmear",
            "toast"
        ]
    },
    {
        "icon": "cart-xmark",
        "label": "Cart Xmark",
        "search": [
            "checkout",
            "food",
            "grocery",
            "uncheck"
        ]
    },
    {
        "icon": "square-caret-right",
        "label": "Square Caret Right",
        "search": [
            "arrow",
            "caret-square-o-right",
            "forward",
            "next",
            "triangle"
        ]
    },
    {
        "icon": "utensils-slash",
        "label": "Utensils Slash",
        "search": [
            "cooking",
            "cutlery",
            "dining",
            "dinner",
            "disabled",
            "eat",
            "food",
            "fork",
            "fork and knife",
            "knife",
            "restaurant"
        ]
    },
    {
        "icon": "vial",
        "label": "Vial",
        "search": [
            "ampule",
            "chemist",
            "chemistry",
            "experiment",
            "knowledge",
            "lab",
            "sample",
            "science",
            "test",
            "test tube"
        ]
    },
    {
        "icon": "helicopter",
        "label": "Helicopter",
        "search": [
            "airwolf",
            "apache",
            "chopper",
            "flight",
            "fly",
            "helicopter",
            "travel",
            "vehicle"
        ]
    },
    {
        "icon": "mitten",
        "label": "Mitten",
        "search": [
            "clothing",
            "cold",
            "glove",
            "hands",
            "knitted",
            "seasonal",
            "warmth"
        ]
    },
    {
        "icon": "file-music",
        "label": "File Music",
        "search": [
            "aac",
            "aif",
            "audio",
            "midi",
            "mp3",
            "ogg",
            "sheet music",
            "wav",
            "wma"
        ]
    },
    {
        "icon": "gas-pump",
        "label": "Gas Pump",
        "search": [
            "car",
            "diesel",
            "fuel",
            "fuel pump",
            "fuelpump",
            "gas",
            "gasoline",
            "petrol",
            "pump",
            "station"
        ]
    },
    {
        "icon": "squarespace",
        "label": "Squarespace",
        "search": []
    },
    {
        "icon": "helmet-battle",
        "label": "Helmet Battle",
        "search": [
            "Dungeons & Dragons",
            "armor",
            "clothing",
            "d&d",
            "dnd",
            "fantasy",
            "hat",
            "knight",
            "paladin"
        ]
    },
    {
        "icon": "meat",
        "label": "Meat",
        "search": [
            "beef",
            "bone",
            "ham",
            "meat",
            "meat on bone",
            "mutton",
            "pork",
            "veal"
        ]
    },
    {
        "icon": "trumpet",
        "label": "Trumpet",
        "search": [
            "brass",
            "bugle",
            "classical",
            "cornet",
            "instrument",
            "jazz",
            "music",
            "orchestra",
            "trumpet"
        ]
    },
    {
        "icon": "browsers",
        "label": "Browsers",
        "search": [
            "computer",
            "tabs",
            "ui",
            "window"
        ]
    },
    {
        "icon": "arrow-down-left",
        "label": "Arrow Down Left",
        "search": [
            "diagonal",
            "southwest"
        ]
    },
    {
        "icon": "square-1",
        "label": "Square 1",
        "search": [
            "one"
        ]
    },
    {
        "icon": "user-nurse-hair-long",
        "label": "User Nurse Hair Long",
        "search": [
            "doctor",
            "md",
            "midwife",
            "physician",
            "practitioner",
            "surgeon",
            "uer"
        ]
    },
    {
        "icon": "temperature-sun",
        "label": "Temperature Sun",
        "search": [
            "heat",
            "mercury",
            "summer",
            "thermometer"
        ]
    },
    {
        "icon": "gas-pump-slash",
        "label": "Gas Pump Slash",
        "search": [
            "car",
            "disabled",
            "empty",
            "fuel",
            "gasoline",
            "petrol"
        ]
    },
    {
        "icon": "mcp",
        "label": "mcp"
    },
    {
        "icon": "envelope-circle-check",
        "label": "Envelope Circle Check",
        "search": [
            "check",
            "email",
            "enable",
            "envelope",
            "mail",
            "not affected",
            "ok",
            "okay",
            "read",
            "sent",
            "validate",
            "working"
        ]
    },
    {
        "icon": "file-gif",
        "label": "File Gif",
        "search": [
            "animation",
            "document",
            "gif",
            "graphics interchange format",
            "image",
            "jif"
        ]
    },
    {
        "icon": "person-skating",
        "label": "Person Skating",
        "search": [
            "figure skating",
            "ice",
            "olympics",
            "rink",
            "skate",
            "uer",
            "winter"
        ]
    },
    {
        "icon": "trello",
        "label": "Trello",
        "search": [
            "atlassian"
        ]
    },
    {
        "icon": "face-angry-horns",
        "label": "Face Angry Horns",
        "search": [
            "angry face with horns",
            "demon",
            "devil",
            "face",
            "fantasy",
            "goblin",
            "imp"
        ]
    },
    {
        "icon": "sun",
        "label": "Sun",
        "search": [
            "bright",
            "brighten",
            "contrast",
            "day",
            "lighter",
            "rays",
            "sol",
            "solar",
            "star",
            "sun",
            "sunny",
            "weather"
        ]
    },
    {
        "icon": "diploma",
        "label": "Diploma",
        "search": [
            "award",
            "certificate",
            "college",
            "education",
            "graduate",
            "graduation",
            "scholar",
            "university"
        ]
    },
    {
        "icon": "baseball",
        "label": "Baseball",
        "search": [
            "ball",
            "baseball",
            "foul",
            "glove",
            "hardball",
            "league",
            "leather",
            "mlb",
            "softball",
            "sport",
            "underarm"
        ]
    },
    {
        "icon": "viadeo",
        "label": "Viadeo",
        "search": []
    },
    {
        "icon": "image",
        "label": "Image",
        "search": [
            "album",
            "img",
            "landscape",
            "photo",
            "picture"
        ]
    },
    {
        "icon": "boot",
        "label": "Boot",
        "search": [
            "backpacking",
            "boot",
            "camping",
            "clothing",
            "foot",
            "hiking",
            "hiking boot",
            "shoe",
            "sturdy"
        ]
    },
    {
        "icon": "car-bump",
        "label": "Car Bump",
        "search": [
            "auto",
            "automobile",
            "off-road",
            "sedan",
            "transportation",
            "vehicle"
        ]
    },
    {
        "icon": "money-bill-simple",
        "label": "Money Bill Simple",
        "search": [
            "atm",
            "cash",
            "investment",
            "money",
            "moolah",
            "premium",
            "salary"
        ]
    },
    {
        "icon": "square-arrow-down",
        "label": "Square Arrow Down",
        "search": [
            "download",
            "insert"
        ]
    },
    {
        "icon": "notdef",
        "label": "Notdef",
        "search": [
            "404",
            "close",
            "missing",
            "not found"
        ]
    },
    {
        "icon": "comment-question",
        "label": "Comment Question",
        "search": [
            "answer",
            "chat",
            "faq",
            "help",
            "question",
            "request",
            "support"
        ]
    },
    {
        "icon": "user-robot",
        "label": "User Robot",
        "search": [
            "android",
            "automate",
            "computer",
            "cyborg",
            "rosie",
            "uer"
        ]
    },
    {
        "icon": "searchengin",
        "label": "Searchengin",
        "search": []
    },
    {
        "icon": "basketball",
        "label": "Basketball",
        "search": [
            "ball",
            "basketball",
            "dribble",
            "dunk",
            "hoop",
            "nba"
        ]
    },
    {
        "icon": "pencil",
        "label": "Pencil",
        "search": [
            "Lower Left Pencil",
            "design",
            "draw",
            "edit",
            "lead",
            "maintenance",
            "modify",
            "pencil",
            "update",
            "write"
        ]
    },
    {
        "icon": "person-walking-arrow-loop-left",
        "label": "Person Walking Arrow Loop Left",
        "search": [
            "follow",
            "population return",
            "return",
            "uer"
        ]
    },
    {
        "icon": "paypal",
        "label": "Paypal",
        "search": []
    },
    {
        "icon": "boot-heeled",
        "label": "Boot Heeled",
        "search": [
            "boot",
            "clothing",
            "cowboy",
            "cowgirl",
            "knee high",
            "shoe",
            "woman",
            "woman’s boot"
        ]
    },
    {
        "icon": "dice-six",
        "label": "Dice Six",
        "search": [
            "Die Face-6",
            "chance",
            "gambling",
            "game",
            "roll"
        ]
    },
    {
        "icon": "circle-ellipsis",
        "label": "Circle Ellipsis",
        "search": [
            "menu",
            "more",
            "three dots"
        ]
    },
    {
        "icon": "arrow-up-square-triangle",
        "label": "Arrow Up Square Triangle",
        "search": [
            "arrange",
            "filter",
            "order",
            "shapes",
            "square",
            "triangle",
            "upgrade"
        ]
    },
    {
        "icon": "angles-down",
        "label": "Angles Down",
        "search": [
            "arrows",
            "caret",
            "download",
            "expand"
        ]
    },
    {
        "icon": "battery-low",
        "label": "Battery Low",
        "search": [
            "charge",
            "empty",
            "power"
        ]
    },
    {
        "icon": "lacrosse-stick-ball",
        "label": "Lacrosse Stick Ball",
        "search": [
            "ball",
            "goal",
            "lacrosse",
            "stick"
        ]
    },
    {
        "icon": "alarm-snooze",
        "label": "Alarm Snooze",
        "search": [
            "alert",
            "date",
            "late",
            "reminder",
            "sleep",
            "snooze",
            "timer",
            "timestamp",
            "watch"
        ]
    },
    {
        "icon": "syringe",
        "label": "Syringe",
        "search": [
            "covid-19",
            "doctor",
            "immunizations",
            "medical",
            "medicine",
            "needle",
            "shot",
            "sick",
            "syringe",
            "vaccinate",
            "vaccine"
        ]
    },
    {
        "icon": "shower-down",
        "label": "Shower Down",
        "search": [
            "bath",
            "drip",
            "hygiene",
            "water"
        ]
    },
    {
        "icon": "wheat-awn",
        "label": "Wheat Awn",
        "search": [
            "agriculture",
            "autumn",
            "fall",
            "farming",
            "grain"
        ]
    },
    {
        "icon": "plane-up",
        "label": "Plane Up",
        "search": [
            "airplane",
            "airport",
            "internet",
            "signal",
            "sky",
            "wifi",
            "wireless"
        ]
    },
    {
        "icon": "bat",
        "label": "Bat",
        "search": [
            "animal",
            "batman",
            "bruce wayne",
            "flying",
            "gotham",
            "halloween",
            "mammal",
            "vampire",
            "wings"
        ]
    },
    {
        "icon": "align-center",
        "label": "Align Center",
        "search": [
            "format",
            "middle",
            "paragraph",
            "text"
        ]
    },
    {
        "icon": "hockey-puck",
        "label": "Hockey Puck",
        "search": [
            "ice",
            "nhl",
            "sport"
        ]
    },
    {
        "icon": "circle-arrow-left",
        "label": "Circle Arrow Left",
        "search": [
            "back",
            "previous"
        ]
    },
    {
        "icon": "chart-radar",
        "label": "Chart Radar",
        "search": [
            "chart",
            "graph",
            "performance",
            "statistics",
            "track",
            "trend"
        ]
    },
    {
        "icon": "arrow-progress",
        "label": "Arrow Progress",
        "search": [
            "flow",
            "methodology",
            "process",
            "progress",
            "route",
            "steps"
        ]
    },
    {
        "icon": "warehouse-full",
        "label": "Warehouse Full",
        "search": [
            "building",
            "capacity",
            "garage",
            "inventory",
            "storage"
        ]
    },
    {
        "icon": "pen-swirl",
        "label": "Pen Swirl",
        "search": [
            "draw",
            "modify",
            "scribble",
            "stylus"
        ]
    },
    {
        "icon": "truck-ladder",
        "label": "Truck Ladder",
        "search": [
            "climb",
            "ladder",
            "pickup"
        ]
    },
    {
        "icon": "comment-image",
        "label": "Comment Image",
        "search": [
            "answer",
            "chat",
            "discussion",
            "photography",
            "photos"
        ]
    },
    {
        "icon": "plug-circle-bolt",
        "label": "Plug Circle Bolt",
        "search": [
            "electric",
            "electricity",
            "plug",
            "power"
        ]
    },
    {
        "icon": "grid-5",
        "label": "Grid 5",
        "search": [
            "app",
            "collection",
            "compact",
            "filter",
            "grid",
            "sort"
        ]
    },
    {
        "icon": "pipe-section",
        "label": "Pipe Section",
        "search": [
            "drain",
            "plumbing",
            "supply",
            "water"
        ]
    },
    {
        "icon": "restroom",
        "label": "Restroom",
        "search": [
            "bathroom",
            "toilet",
            "uer",
            "water closet",
            "wc"
        ]
    },
    {
        "icon": "reflect-both",
        "label": "Reflect Both",
        "search": [
            "edit",
            "exchange",
            "flip",
            "horizontal",
            "inverse",
            "invert",
            "mirror",
            "negative",
            "reflect",
            "swap",
            "target",
            "tool",
            "vertical"
        ]
    },
    {
        "icon": "gear-code",
        "label": "Gear Code",
        "search": [
            "code",
            "cog",
            "cogwheel",
            "develop",
            "digital",
            "gear",
            "mechanical",
            "settings",
            "sprocket",
            "tool",
            "wheel"
        ]
    },
    {
        "icon": "square-bluesky",
        "label": "Square Bluesky",
        "search": [
            "social network"
        ]
    },
    {
        "icon": "curling-stone",
        "label": "Curling Stone",
        "search": [
            "curling stone",
            "game",
            "ice",
            "olympics",
            "rock",
            "sport",
            "stone"
        ]
    },
    {
        "icon": "anchor-lock",
        "label": "Anchor Lock",
        "search": [
            "closed",
            "lockdown",
            "marina",
            "padlock",
            "port",
            "privacy",
            "quarantine"
        ]
    },
    {
        "icon": "d-and-d-beyond",
        "label": "D&D Beyond",
        "search": [
            "Dungeons & Dragons",
            "d&d",
            "dnd",
            "fantasy",
            "gaming",
            "tabletop"
        ]
    },
    {
        "icon": "timeline",
        "label": "Timeline",
        "search": [
            "chronological",
            "deadline",
            "history",
            "linear"
        ]
    },
    {
        "icon": "briefcase-blank",
        "label": "Briefcase Blank",
        "search": [
            "bag",
            "business",
            "luggage",
            "offer",
            "office",
            "portfolio",
            "work"
        ]
    },
    {
        "icon": "coin-front",
        "label": "Coin Front",
        "search": [
            "coin",
            "dime",
            "gold",
            "metal",
            "money",
            "nickel",
            "penny",
            "premium",
            "quarter",
            "silver",
            "super mario",
            "treasure"
        ]
    },
    {
        "icon": "calendar-star",
        "label": "Calendar Star",
        "search": [
            "calendar",
            "date",
            "day",
            "event",
            "favorite",
            "important",
            "month",
            "schedule",
            "time",
            "when",
            "year"
        ]
    },
    {
        "icon": "pen-circle",
        "label": "Pen Circle",
        "search": [
            "draw",
            "edit",
            "modify",
            "pencil",
            "write"
        ]
    },
    {
        "icon": "lightbulb",
        "label": "Lightbulb",
        "search": [
            "bulb",
            "bulb",
            "comic",
            "comic",
            "electric",
            "electric",
            "energy",
            "idea",
            "idea",
            "innovation",
            "inspiration",
            "inspiration",
            "light",
            "light bulb",
            "mechanical"
        ]
    },
    {
        "icon": "microsoft",
        "label": "Microsoft",
        "search": []
    },
    {
        "icon": "page-caret-down",
        "label": "Page Caret Down",
        "search": [
            "document",
            "empty",
            "file",
            "new",
            "page down",
            "pdf",
            "resume"
        ]
    },
    {
        "icon": "book-blank",
        "label": "Book Blank",
        "search": [
            "blue",
            "blue book",
            "book",
            "closed",
            "closed book",
            "diary",
            "documentation",
            "green",
            "green book",
            "journal",
            "knowledge",
            "library",
            "orange",
            "orange book",
            "read",
            "research"
        ]
    },
    {
        "icon": "trash-undo",
        "label": "Trash Undo",
        "search": [
            "back",
            "control z",
            "delete",
            "garbage",
            "hide",
            "oops",
            "remove",
            "restore",
            "undo"
        ]
    },
    {
        "icon": "subtitles",
        "label": "Subtitles",
        "search": [
            "caption",
            "closed captions",
            "description",
            "film",
            "language",
            "movie",
            "text",
            "translation"
        ]
    },
    {
        "icon": "fly",
        "label": "Fly",
        "search": []
    },
    {
        "icon": "cc-stripe",
        "label": "Stripe Credit Card",
        "search": []
    },
    {
        "icon": "wave-triangle",
        "label": "Wave Triangle",
        "search": [
            "frequency",
            "pulse",
            "signal"
        ]
    },
    {
        "icon": "gauge-circle-plus",
        "label": "Gauge Circle Plus",
        "search": [
            "dashboard",
            "fast",
            "increase",
            "odometer",
            "speed",
            "speedometer"
        ]
    },
    {
        "icon": "head-side",
        "label": "Head Side",
        "search": [
            "bald",
            "face",
            "profile",
            "uer",
            "user"
        ]
    },
    {
        "icon": "wordpress-simple",
        "label": "Wordpress Simple",
        "search": []
    },
    {
        "icon": "chevrons-left",
        "label": "Chevrons Left",
        "search": [
            "arrow",
            "back",
            "bracket",
            "previous"
        ]
    },
    {
        "icon": "circle-arrow-right",
        "label": "Circle Arrow Right",
        "search": [
            "forward",
            "next"
        ]
    },
    {
        "icon": "game-board",
        "label": "Game Board",
        "search": [
            "checkers",
            "chess",
            "gaming",
            "grid",
            "tabletop"
        ]
    },
    {
        "icon": "file-chart-column",
        "label": "File Chart Column",
        "search": [
            "analytics",
            "data",
            "document",
            "projection",
            "report",
            "revenue"
        ]
    },
    {
        "icon": "custard",
        "label": "Custard",
        "search": [
            "caramel",
            "custard",
            "dessert",
            "sweet"
        ]
    },
    {
        "icon": "block-question",
        "label": "Block Question",
        "search": [
            "block",
            "brick",
            "mystery",
            "prize",
            "question",
            "super mario"
        ]
    },
    {
        "icon": "mars-and-venus",
        "label": "Mars And Venus",
        "search": [
            "Male and Female Sign",
            "female",
            "gender",
            "intersex",
            "male",
            "transgender"
        ]
    },
    {
        "icon": "network-wired",
        "label": "Network Wired",
        "search": [
            "computer",
            "connect",
            "ethernet",
            "internet",
            "intranet"
        ]
    },
    {
        "icon": "face-confused",
        "label": "Face Confused",
        "search": [
            "confused",
            "confused face",
            "face",
            "meh",
            "nonplussed",
            "puzzled"
        ]
    },
    {
        "icon": "building-shield",
        "label": "Building Shield",
        "search": [
            "building",
            "city",
            "police",
            "protect",
            "safety"
        ]
    },
    {
        "icon": "bed-empty",
        "label": "Bed Empty",
        "search": [
            "bed",
            "hotel",
            "lodging",
            "mattress",
            "rest",
            "sleep",
            "travel"
        ]
    },
    {
        "icon": "grill-hot",
        "label": "Grill Hot",
        "search": [
            "barbecue",
            "barbeque",
            "bbq",
            "burger",
            "charcoal",
            "cook",
            "cookout",
            "hot",
            "smoke"
        ]
    },
    {
        "icon": "code",
        "label": "Code",
        "search": [
            "brackets",
            "code",
            "development",
            "html",
            "mysql",
            "sql"
        ]
    },
    {
        "icon": "feather-pointed",
        "label": "Feather Pointed",
        "search": [
            "bird",
            "light",
            "plucked",
            "quill",
            "write"
        ]
    },
    {
        "icon": "file-circle-question",
        "label": "File Circle Question",
        "search": [
            "document",
            "file",
            "paper"
        ]
    },
    {
        "icon": "face-nose-steam",
        "label": "Face Nose Steam",
        "search": [
            "angry",
            "face",
            "face with steam from nose",
            "frustrated",
            "mad",
            "steaming",
            "triumph",
            "upset",
            "won"
        ]
    },
    {
        "icon": "signature",
        "label": "Signature",
        "search": [
            "John Hancock",
            "cursive",
            "name",
            "username",
            "writing"
        ]
    },
    {
        "icon": "earth-americas",
        "label": "Earth Americas",
        "search": [
            "all",
            "america",
            "country",
            "earth",
            "global",
            "globe",
            "gps",
            "language",
            "localize",
            "location",
            "map",
            "online",
            "place",
            "planet",
            "translate",
            "travel",
            "world"
        ]
    },
    {
        "icon": "carrot",
        "label": "Carrot",
        "search": [
            "bugs bunny",
            "carrot",
            "food",
            "orange",
            "vegan",
            "vegetable"
        ]
    },
    {
        "icon": "sellsy",
        "label": "Sellsy",
        "search": []
    },
    {
        "icon": "sparkles",
        "label": "Sparkles",
        "search": [
            "*",
            "glitter",
            "magic",
            "new",
            "sparkle",
            "sparkles",
            "special",
            "star",
            "twinkle"
        ]
    },
    {
        "icon": "square-l",
        "label": "Square L",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "cauldron",
        "label": "Cauldron",
        "search": [
            "boil",
            "bubble",
            "cooking",
            "halloween",
            "holiday",
            "magic",
            "pot",
            "sorcery",
            "toil",
            "trouble",
            "witch",
            "wizard"
        ]
    },
    {
        "icon": "temperature-full",
        "label": "Temperature Full",
        "search": [
            "fever",
            "hot",
            "mercury",
            "status",
            "temperature"
        ]
    },
    {
        "icon": "table-cells-row-lock",
        "label": "Table Cells Row Lock",
        "search": [
            "blocks",
            "boxes",
            "category",
            "column",
            "column",
            "excel",
            "grid",
            "lock",
            "lock",
            "spreadsheet",
            "squares"
        ]
    },
    {
        "icon": "bolt-lightning",
        "label": "Bolt Lightning",
        "search": [
            "electricity",
            "flash",
            "lightning",
            "weather",
            "zap"
        ]
    },
    {
        "icon": "cloud-showers-water",
        "label": "Cloud Showers Water",
        "search": [
            "cloud",
            "deluge",
            "flood",
            "rain",
            "storm",
            "surge"
        ]
    },
    {
        "icon": "arrow-up-long",
        "label": "Arrow Up Long",
        "search": [
            "long-arrow-up",
            "upload"
        ]
    },
    {
        "icon": "flux-capacitor",
        "label": "Flux Capacitor",
        "search": [
            "1.21 gigawatts",
            "88 mph",
            "Emmett Brown",
            "Marty McFly",
            "Y",
            "back to the future",
            "delorean",
            "dmc",
            "time machine",
            "time travel"
        ]
    },
    {
        "icon": "address-card",
        "label": "Address Card",
        "search": [
            "about",
            "contact",
            "employee",
            "id",
            "identification",
            "portfolio",
            "postcard",
            "profile",
            "registration",
            "uer",
            "username"
        ]
    },
    {
        "icon": "staff",
        "label": "Staff",
        "search": [
            "Dungeons & Dragons",
            "d&d",
            "dnd",
            "fantasy",
            "mage",
            "stick",
            "weapon"
        ]
    },
    {
        "icon": "basket-shopping-minus",
        "label": "Basket Shopping Minus",
        "search": [
            "buy",
            "checkout",
            "grocery",
            "payment",
            "purchase",
            "remove"
        ]
    },
    {
        "icon": "angle-right",
        "label": "Angle Right",
        "search": [
            "Single Right-Pointing Angle Quotation Mark",
            "arrow",
            "care",
            "forward",
            "more",
            "next"
        ]
    },
    {
        "icon": "toilet-paper-under",
        "label": "Toilet Paper Under",
        "search": [
            "bathroom",
            "lavatory",
            "privy",
            "restroom",
            "roll",
            "toilet",
            "wipe"
        ]
    },
    {
        "icon": "stomach",
        "label": "Stomach",
        "search": [
            "abdomen",
            "belly",
            "food",
            "gut",
            "hungry",
            "intestine",
            "organ",
            "tummy"
        ]
    },
    {
        "icon": "face-cowboy-hat",
        "label": "Face Cowboy Hat",
        "search": [
            "cowboy",
            "cowboy hat face",
            "cowgirl",
            "face",
            "hat"
        ]
    },
    {
        "icon": "face-meh",
        "label": "Face Meh",
        "search": [
            "deadpan",
            "default",
            "emoticon",
            "face",
            "meh",
            "neutral",
            "neutral face",
            "rating",
            "uer"
        ]
    },
    {
        "icon": "dashcube",
        "label": "DashCube",
        "search": []
    },
    {
        "icon": "arrow-up-from-ground-water",
        "label": "Arrow Up From Ground Water",
        "search": [
            "groundwater",
            "spring",
            "upgrade",
            "water supply",
            "water table"
        ]
    },
    {
        "icon": "face-pleading",
        "label": "Face Pleading",
        "search": [
            "begging",
            "glossy",
            "mercy",
            "pleading face",
            "puppy eyes",
            "simp"
        ]
    },
    {
        "icon": "map",
        "label": "Map",
        "search": [
            "address",
            "coordinates",
            "destination",
            "gps",
            "localize",
            "location",
            "map",
            "navigation",
            "paper",
            "pin",
            "place",
            "point of interest",
            "position",
            "route",
            "travel",
            "world",
            "world map"
        ]
    },
    {
        "icon": "gitter",
        "label": "Gitter",
        "search": []
    },
    {
        "icon": "user-plus",
        "label": "User Plus",
        "search": [
            "add",
            "avatar",
            "employee",
            "follow",
            "positive",
            "sign up",
            "signup",
            "team",
            "uer"
        ]
    },
    {
        "icon": "wolf-pack-battalion",
        "label": "Wolf Pack Battalion",
        "search": []
    },
    {
        "icon": "turn-down-left",
        "label": "Turn Down Left",
        "search": [
            "Downwards Arrow with Corner Leftwards",
            "Return Left",
            "Return Symbol",
            "enter",
            "keyboard",
            "return"
        ]
    },
    {
        "icon": "plane-engines",
        "label": "Plane Engines",
        "search": [
            "aeroplane",
            "airplane",
            "airport",
            "destination",
            "fly",
            "location",
            "mode",
            "travel",
            "trip"
        ]
    },
    {
        "icon": "venus",
        "label": "Venus",
        "search": [
            "female",
            "female sign",
            "gender",
            "woman"
        ]
    },
    {
        "icon": "user-doctor-message",
        "label": "User Doctor Message",
        "search": [
            "advice",
            "answer",
            "comment",
            "diagnosis",
            "opinion",
            "prescription",
            "uer"
        ]
    },
    {
        "icon": "bars-sort",
        "label": "Bars Sort",
        "search": [
            "list",
            "menu",
            "sort"
        ]
    },
    {
        "icon": "high-definition",
        "label": "High Definition",
        "search": [
            "img",
            "resolution",
            "retina",
            "video"
        ]
    },
    {
        "icon": "ditto",
        "label": "Ditto",
        "search": [
            "Quotation Mark",
            "inch",
            "quotation",
            "quote"
        ]
    },
    {
        "icon": "lastfm",
        "label": "last.fm",
        "search": []
    },
    {
        "icon": "square-arrow-down-right",
        "label": "Square Arrow Down Right",
        "search": [
            "diagonal"
        ]
    },
    {
        "icon": "pipe-valve",
        "label": "Pipe Valve",
        "search": [
            "drain",
            "plumbing",
            "supply",
            "water"
        ]
    },
    {
        "icon": "square-s",
        "label": "Square S",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "diagram-successor",
        "label": "Diagram Successor",
        "search": [
            "cells",
            "chart",
            "gantt",
            "next",
            "row",
            "subtask",
            "successor",
            "table"
        ]
    },
    {
        "icon": "head-side-cough-slash",
        "label": "Head Side Cough Slash",
        "search": [
            "cough",
            "covid-19",
            "disabled",
            "germs",
            "lungs",
            "respiratory",
            "sick",
            "uer"
        ]
    },
    {
        "icon": "arrows-maximize",
        "label": "Arrows Maximize",
        "search": [
            "arrows",
            "bigger",
            "enlarge",
            "expand",
            "fullscreen",
            "maximize",
            "resize",
            "resize",
            "scale",
            "size"
        ]
    },
    {
        "icon": "shopware",
        "label": "Shopware",
        "search": []
    },
    {
        "icon": "plus-large",
        "label": "Plus Large",
        "search": [
            "+",
            "Plus Sign",
            "add",
            "create",
            "expand",
            "follow",
            "math",
            "modify",
            "new",
            "plus",
            "positive",
            "shape",
            "sign"
        ]
    },
    {
        "icon": "mug-tea",
        "label": "Mug Tea",
        "search": [
            "brew",
            "drink",
            "herbal",
            "oolong"
        ]
    },
    {
        "icon": "diagram-project",
        "label": "Diagram Project",
        "search": [
            "chart",
            "graph",
            "network",
            "pert",
            "statistics"
        ]
    },
    {
        "icon": "terminal",
        "label": "Terminal",
        "search": [
            "code",
            "coding",
            "command",
            "console",
            "development",
            "prompt",
            "terminal"
        ]
    },
    {
        "icon": "eclipse",
        "label": "Eclipse",
        "search": [
            "lunar",
            "moon",
            "shadow",
            "solar",
            "sun"
        ]
    },
    {
        "icon": "house-fire",
        "label": "House Fire",
        "search": [
            "burn",
            "emergency",
            "home"
        ]
    },
    {
        "icon": "mask",
        "label": "Mask",
        "search": [
            "carnivale",
            "costume",
            "disguise",
            "halloween",
            "secret",
            "super hero"
        ]
    },
    {
        "icon": "blogger",
        "label": "Blogger",
        "search": []
    },
    {
        "icon": "hurricane",
        "label": "Hurricane",
        "search": [
            "coriolis effect",
            "eye",
            "storm",
            "tropical cyclone",
            "typhoon"
        ]
    },
    {
        "icon": "earth-africa",
        "label": "Earth Africa",
        "search": [
            "africa",
            "all",
            "country",
            "earth",
            "europe",
            "global",
            "globe",
            "gps",
            "language",
            "localize",
            "location",
            "map",
            "online",
            "place",
            "planet",
            "translate",
            "travel",
            "world"
        ]
    },
    {
        "icon": "thumbtack",
        "label": "Thumbtack",
        "search": [
            "Black Pushpin",
            "coordinates",
            "location",
            "marker",
            "pin",
            "pushpin",
            "thumb-tack"
        ]
    },
    {
        "icon": "square-up",
        "label": "Square Up",
        "search": [
            "arrow",
            "cardinal",
            "direction",
            "north",
            "up arrow",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "face-tongue-money",
        "label": "Face Tongue Money",
        "search": [
            "coupon",
            "dollar",
            "face",
            "greed",
            "money",
            "money-mouth face",
            "mouth",
            "premium",
            "rich",
            "vip"
        ]
    },
    {
        "icon": "hand-point-down",
        "label": "Hand Point Down",
        "search": [
            "finger",
            "hand-o-down",
            "point"
        ]
    },
    {
        "icon": "face-meh-blank",
        "label": "Face Meh Blank",
        "search": [
            "emoticon",
            "face",
            "face without mouth",
            "mouth",
            "neutral",
            "quiet",
            "rating",
            "silent"
        ]
    },
    {
        "icon": "bowl-hot",
        "label": "Bowl Hot",
        "search": [
            "bisque",
            "bouillon",
            "bowl",
            "broth",
            "chicken",
            "chowder",
            "gazpacho",
            "ramen",
            "stew"
        ]
    },
    {
        "icon": "party-horn",
        "label": "Party Horn",
        "search": [
            "celebrate",
            "celebration",
            "confetti",
            "party",
            "party popper",
            "popper",
            "tada",
            "trumpet"
        ]
    },
    {
        "icon": "bells",
        "label": "Bells",
        "search": [
            "alert",
            "christmas",
            "holiday",
            "notification",
            "reminder",
            "request",
            "xmas"
        ]
    },
    {
        "icon": "temperature-empty",
        "label": "Temperature Empty",
        "search": [
            "cold",
            "mercury",
            "status",
            "temperature"
        ]
    },
    {
        "icon": "popcorn",
        "label": "Popcorn",
        "search": [
            "bucket",
            "butter",
            "corn",
            "junk food",
            "kernels",
            "movie",
            "popcor",
            "popcorn",
            "snack",
            "theater"
        ]
    },
    {
        "icon": "border-left",
        "label": "Border Left",
        "search": [
            "cell",
            "grid",
            "outline",
            "stroke",
            "table"
        ]
    },
    {
        "icon": "border-none",
        "label": "Border None",
        "search": [
            "cell",
            "grid",
            "outline",
            "stroke",
            "table"
        ]
    },
    {
        "icon": "highlighter",
        "label": "Highlighter",
        "search": [
            "edit",
            "marker",
            "modify",
            "sharpie",
            "update",
            "write"
        ]
    },
    {
        "icon": "pallet-box",
        "label": "Pallet Box",
        "search": [
            "inventory",
            "package",
            "shipping"
        ]
    },
    {
        "icon": "star-exclamation",
        "label": "Star Exclamation",
        "search": [
            "achievement",
            "alert",
            "attention",
            "award",
            "failed",
            "favorite",
            "night",
            "rating",
            "required",
            "score"
        ]
    },
    {
        "icon": "sickle",
        "label": "Sickle",
        "search": [
            "blade",
            "d&d",
            "dnd",
            "dungeons & dragons",
            "equipment",
            "fantasy",
            "weapon"
        ]
    },
    {
        "icon": "money-bill-wave",
        "label": "Money Bill Wave",
        "search": [
            "buy",
            "cash",
            "checkout",
            "money",
            "payment",
            "premium",
            "price",
            "purchase",
            "salary"
        ]
    },
    {
        "icon": "plane-tail",
        "label": "Plane Tail",
        "search": [
            "airplane",
            "airport",
            "fly",
            "sky"
        ]
    },
    {
        "icon": "toilet-paper-slash",
        "label": "Toilet Paper Slash",
        "search": [
            "bathroom",
            "covid-19",
            "disabled",
            "halloween",
            "holiday",
            "lavatory",
            "leaves",
            "prank",
            "privy",
            "restroom",
            "roll",
            "toilet",
            "trouble",
            "ut oh",
            "wipe"
        ]
    },
    {
        "icon": "siren-on",
        "label": "Siren On",
        "search": [
            "alarm",
            "alert",
            "ambulance",
            "loud",
            "police",
            "warning"
        ]
    },
    {
        "icon": "file-shield",
        "label": "File Shield",
        "search": [
            "antivirus",
            "data",
            "document",
            "protect",
            "safe",
            "safety",
            "secure"
        ]
    },
    {
        "icon": "edge",
        "label": "Edge Browser",
        "search": [
            "browser",
            "ie"
        ]
    },
    {
        "icon": "whiskey-glass-ice",
        "label": "Whiskey Glass Ice",
        "search": [
            "alcohol",
            "bar",
            "beverage",
            "bourbon",
            "drink",
            "ice",
            "liquor",
            "rye",
            "scotch",
            "whisky"
        ]
    },
    {
        "icon": "squid",
        "label": "Squid",
        "search": [
            "calamari",
            "ink",
            "marine",
            "ocean",
            "squid"
        ]
    },
    {
        "icon": "text-height",
        "label": "Text Height",
        "search": [
            "edit",
            "font",
            "format",
            "modify",
            "text",
            "type"
        ]
    },
    {
        "icon": "money-check-dollar-pen",
        "label": "Money Check Dollar Pen",
        "search": [
            "bank check",
            "buy",
            "checkout",
            "cheque",
            "modify",
            "money",
            "payment",
            "pen",
            "price",
            "purchase",
            "salary"
        ]
    },
    {
        "icon": "ioxhost",
        "label": "ioxhost",
        "search": []
    },
    {
        "icon": "schlix",
        "label": "SCHLIX",
        "search": []
    },
    {
        "icon": "hand-wave",
        "label": "Hand Wave",
        "search": [
            "hand",
            "hello",
            "palm",
            "request",
            "wave",
            "waving",
            "waving hand"
        ]
    },
    {
        "icon": "chart-candlestick",
        "label": "Chart Candlestick",
        "search": [
            "chart",
            "graph",
            "performance",
            "statistics",
            "track",
            "trend"
        ]
    },
    {
        "icon": "transporter-4",
        "label": "Transporter 4",
        "search": [
            "move",
            "teleport",
            "transfer",
            "translocate",
            "travel"
        ]
    },
    {
        "icon": "d-and-d",
        "label": "Dungeons & Dragons",
        "search": []
    },
    {
        "icon": "pan-food",
        "label": "Pan Food",
        "search": [
            "casserole",
            "paella",
            "pan",
            "shallow",
            "stew"
        ]
    },
    {
        "icon": "face-grin-tongue",
        "label": "Face Grin Tongue",
        "search": [
            "LOL",
            "emoticon",
            "face",
            "face with tongue",
            "tongue"
        ]
    },
    {
        "icon": "potato",
        "label": "Potato",
        "search": [
            "potato",
            "spud",
            "tater",
            "tuber"
        ]
    },
    {
        "icon": "file-signature",
        "label": "File Signature",
        "search": [
            "John Hancock",
            "contract",
            "document",
            "name",
            "username"
        ]
    },
    {
        "icon": "square-dashed",
        "label": "Square Dashed",
        "search": [
            "add",
            "copy",
            "dashed",
            "dotted",
            "marquee",
            "select",
            "selection"
        ]
    },
    {
        "icon": "steak",
        "label": "Steak",
        "search": [
            "beef",
            "chop",
            "cut of meat",
            "grill",
            "lambchop",
            "meat",
            "porkchop",
            "sirloin",
            "steak"
        ]
    },
    {
        "icon": "axe-battle",
        "label": "Axe Battle",
        "search": [
            "Dungeons & Dragons",
            "barbarian",
            "d&d",
            "dnd",
            "fantasy",
            "gimli",
            "lumberjack",
            "melee attack"
        ]
    },
    {
        "icon": "circle-quarter-stroke",
        "label": "Circle Quarter Stroke",
        "search": [
            "adjust",
            "chart",
            "fill",
            "pie",
            "progress"
        ]
    },
    {
        "icon": "phone-hangup",
        "label": "Phone Hangup",
        "search": [
            "end",
            "phone",
            "reject"
        ]
    },
    {
        "icon": "square-heart",
        "label": "Square Heart",
        "search": [
            "favorite",
            "heart",
            "heart decoration",
            "like",
            "love",
            "wishlist"
        ]
    },
    {
        "icon": "conveyor-belt",
        "label": "Conveyor Belt",
        "search": [
            "carousel",
            "inventory",
            "manufacture",
            "packaging",
            "shipping"
        ]
    },
    {
        "icon": "box-check",
        "label": "Box Check",
        "search": [
            "accept",
            "agree",
            "confirm",
            "correct",
            "done",
            "enable",
            "ok",
            "package",
            "select",
            "success",
            "tick",
            "todo",
            "validate",
            "working",
            "yes"
        ]
    },
    {
        "icon": "blanket-fire",
        "label": "Blanket Fire",
        "search": [
            "fire",
            "flammable",
            "safety"
        ]
    },
    {
        "icon": "vuejs",
        "label": "Vue.js",
        "search": []
    },
    {
        "icon": "square-9",
        "label": "Square 9",
        "search": [
            "nine"
        ]
    },
    {
        "icon": "building-wheat",
        "label": "Building Wheat",
        "search": [
            "agriculture",
            "building",
            "city",
            "usda"
        ]
    },
    {
        "icon": "plug-circle-minus",
        "label": "Plug Circle Minus",
        "search": [
            "disconnect",
            "electric",
            "electricity",
            "plug",
            "power"
        ]
    },
    {
        "icon": "hockey-sticks",
        "label": "Hockey Sticks",
        "search": [
            "ice",
            "nhl",
            "sport"
        ]
    },
    {
        "icon": "meta",
        "label": "Meta",
        "search": []
    },
    {
        "icon": "colon",
        "label": "Colon",
        "search": [
            "Colon",
            "clause",
            "dots"
        ]
    },
    {
        "icon": "creative-commons-share",
        "label": "Creative Commons Share",
        "search": []
    },
    {
        "icon": "futbol",
        "label": "Futbol",
        "search": [
            "ball",
            "football",
            "mls",
            "soccer",
            "soccer ball"
        ]
    },
    {
        "icon": "face-hand-over-mouth",
        "label": "Face Hand Over Mouth",
        "search": [
            "awe",
            "face with hand over mouth",
            "realization",
            "shock",
            "sudden",
            "sudden realization",
            "surprise",
            "whoops"
        ]
    },
    {
        "icon": "circle-plus",
        "label": "Circle Plus",
        "search": [
            "add",
            "create",
            "expand",
            "new",
            "positive",
            "shape"
        ]
    },
    {
        "icon": "coffee-pot",
        "label": "Coffee Pot",
        "search": [
            "beverage",
            "breakfast",
            "brew",
            "cafe",
            "carafe",
            "drink",
            "morning"
        ]
    },
    {
        "icon": "studiovinari",
        "label": "Studio Vinari",
        "search": []
    },
    {
        "icon": "square-question",
        "label": "Square Question",
        "search": [
            "faq",
            "help",
            "information",
            "support",
            "unknown"
        ]
    },
    {
        "icon": "list-tree",
        "label": "List Tree",
        "search": [
            "cheatsheet",
            "directory",
            "file",
            "summary",
            "tree"
        ]
    },
    {
        "icon": "brazilian-real-sign",
        "label": "Brazilian Real Sign",
        "search": [
            "brazilian real sign",
            "currency"
        ]
    },
    {
        "icon": "bitbucket",
        "label": "Bitbucket",
        "search": [
            "atlassian",
            "bitbucket-square",
            "git"
        ]
    },
    {
        "icon": "vk",
        "label": "VK",
        "search": []
    },
    {
        "icon": "ellipsis-stroke-vertical",
        "label": "Ellipsis Stroke Vertical",
        "search": [
            "bullet",
            "dots",
            "drag",
            "kebab",
            "list",
            "menu",
            "nav",
            "navigation",
            "ol",
            "reorder",
            "settings",
            "three dots",
            "ul"
        ]
    },
    {
        "icon": "github",
        "label": "GitHub",
        "search": [
            "octocat"
        ]
    },
    {
        "icon": "codiepie",
        "label": "Codie Pie",
        "search": []
    },
    {
        "icon": "star-and-crescent",
        "label": "Star And Crescent",
        "search": [
            "Muslim",
            "islam",
            "muslim",
            "religion",
            "star and crescent"
        ]
    },
    {
        "icon": "text-size",
        "label": "Text Size",
        "search": [
            "decrease",
            "edit",
            "font",
            "format",
            "increase",
            "modify",
            "text",
            "type"
        ]
    },
    {
        "icon": "face-surprise",
        "label": "Face Surprise",
        "search": [
            "emoticon",
            "face",
            "face with open mouth",
            "mouth",
            "open",
            "shocked",
            "sympathy"
        ]
    },
    {
        "icon": "hospital-user",
        "label": "Hospital User",
        "search": [
            "covid-19",
            "doctor",
            "network",
            "patient",
            "primary care",
            "uer"
        ]
    },
    {
        "icon": "arrow-down-up-lock",
        "label": "Arrow Down Up Lock",
        "search": [
            "border",
            "closed",
            "crossing",
            "lockdown",
            "padlock",
            "privacy",
            "quarantine",
            "transfer"
        ]
    },
    {
        "icon": "folder",
        "label": "Folder",
        "search": [
            "Black Folder",
            "archive",
            "directory",
            "document",
            "file",
            "file folder",
            "folder"
        ]
    },
    {
        "icon": "holly-berry",
        "label": "Holly Berry",
        "search": [
            "catwoman",
            "christmas",
            "decoration",
            "flora",
            "halle",
            "holiday",
            "ororo munroe",
            "plant",
            "storm",
            "xmas"
        ]
    },
    {
        "icon": "message-image",
        "label": "Message Image",
        "search": [
            "answer",
            "chat",
            "discussion",
            "img",
            "photography",
            "photos"
        ]
    },
    {
        "icon": "pied-piper",
        "label": "Pied Piper Logo",
        "search": []
    },
    {
        "icon": "comment-quote",
        "label": "Comment Quote",
        "search": [
            "answer",
            "chat",
            "quote"
        ]
    },
    {
        "icon": "venus-double",
        "label": "Venus Double",
        "search": [
            "Doubled Female Sign",
            "female",
            "gender",
            "lesbian"
        ]
    },
    {
        "icon": "elephant",
        "label": "Elephant",
        "search": [
            "animal",
            "dumbo",
            "elephan",
            "elephant",
            "fauna",
            "mammal",
            "pachyderm",
            "trunk"
        ]
    },
    {
        "icon": "clipboard-question",
        "label": "Clipboard Question",
        "search": [
            "assistance",
            "faq",
            "interview",
            "query",
            "question"
        ]
    },
    {
        "icon": "hotdog",
        "label": "Hotdog",
        "search": [
            "bun",
            "chili",
            "frankfurt",
            "frankfurter",
            "hot dog",
            "hotdog",
            "kosher",
            "polish",
            "sandwich",
            "sausage",
            "vienna",
            "weiner"
        ]
    },
    {
        "icon": "raspberry-pi",
        "label": "Raspberry Pi",
        "search": []
    },
    {
        "icon": "arrow-up-from-bracket",
        "label": "Arrow Up From Bracket",
        "search": [
            "share",
            "transfer",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "reply-clock",
        "label": "Reply Clock",
        "search": [
            "email",
            "remind",
            "reply",
            "send"
        ]
    },
    {
        "icon": "chart-line-up",
        "label": "Chart Line Up",
        "search": [
            "chart",
            "chart increasing",
            "graph",
            "growth",
            "performance",
            "revenue",
            "statistics",
            "track",
            "trend",
            "upward"
        ]
    },
    {
        "icon": "microscope",
        "label": "Microscope",
        "search": [
            "covid-19",
            "electron",
            "knowledge",
            "lens",
            "microscope",
            "optics",
            "science",
            "shrink",
            "testing",
            "tool"
        ]
    },
    {
        "icon": "css3",
        "label": "CSS 3 Logo",
        "search": [
            "code"
        ]
    },
    {
        "icon": "cat-space",
        "label": "Cat Space",
        "search": [
            "animal",
            "astronaut",
            "cosmonaut",
            "fauna",
            "meow",
            "space"
        ]
    },
    {
        "icon": "circle-exclamation-check",
        "label": "Circle Exclamation Check",
        "search": [
            "enable",
            "idea",
            "resolved",
            "validate",
            "working"
        ]
    },
    {
        "icon": "cards",
        "label": "Cards",
        "search": [
            "ace",
            "card",
            "gamble",
            "playing card",
            "poker",
            "suit"
        ]
    },
    {
        "icon": "hubspot",
        "label": "HubSpot",
        "search": []
    },
    {
        "icon": "cloud",
        "label": "Cloud",
        "search": [
            "atmosphere",
            "cloud",
            "fog",
            "overcast",
            "save",
            "upload",
            "weather"
        ]
    },
    {
        "icon": "album-circle-plus",
        "label": "Album Circle Plus",
        "search": [
            "computer",
            "disk",
            "library",
            "minidisk",
            "music",
            "new",
            "optical",
            "record",
            "song",
            "vinyl"
        ]
    },
    {
        "icon": "baseball-bat-ball",
        "label": "Baseball Bat Ball",
        "search": [
            "bat",
            "league",
            "mlb",
            "slugger",
            "softball",
            "sport"
        ]
    },
    {
        "icon": "car-rear",
        "label": "Car Rear",
        "search": [
            "auto",
            "automobile",
            "sedan",
            "transportation",
            "travel",
            "vehicle"
        ]
    },
    {
        "icon": "windsock",
        "label": "Windsock",
        "search": [
            "air",
            "blow",
            "breeze",
            "fall",
            "seasonal",
            "weather"
        ]
    },
    {
        "icon": "face-worried",
        "label": "Face Worried",
        "search": [
            "face",
            "sad",
            "sadface",
            "worried",
            "worried face"
        ]
    },
    {
        "icon": "message-lines",
        "label": "Message Lines",
        "search": [
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "feedback",
            "message",
            "note",
            "notification",
            "sms",
            "speech",
            "texting"
        ]
    },
    {
        "icon": "thumbtack-slash",
        "label": "Thumbtack Slash",
        "search": [
            "Black Pushpin",
            "coordinates",
            "location",
            "marker",
            "pin",
            "pushpin",
            "thumb-tack",
            "unpin"
        ]
    },
    {
        "icon": "cmplid",
        "label": "Cmplid",
        "search": []
    },
    {
        "icon": "plus-minus",
        "label": "Plus Minus",
        "search": [
            "Plus-Minus Sign",
            "add",
            "math",
            "subtract"
        ]
    },
    {
        "icon": "house-circle-check",
        "label": "House Circle Check",
        "search": [
            "abode",
            "enable",
            "home",
            "house",
            "not affected",
            "ok",
            "okay",
            "validate",
            "working"
        ]
    },
    {
        "icon": "face-woozy",
        "label": "Face Woozy",
        "search": [
            "disgust",
            "dizzy",
            "drunk",
            "exhaustion",
            "intoxicated",
            "tipsy",
            "uneven eyes",
            "wasckiness",
            "wavy mouth",
            "woozy face"
        ]
    },
    {
        "icon": "dyalog",
        "label": "Dyalog",
        "search": []
    },
    {
        "icon": "crate-apple",
        "label": "Crate Apple",
        "search": [
            "bushel",
            "container",
            "fall",
            "fruit",
            "fuji",
            "macintosh",
            "orchard",
            "peck",
            "seasonal"
        ]
    },
    {
        "icon": "calendar-day",
        "label": "Calendar Day",
        "search": [
            "date",
            "day",
            "detail",
            "event",
            "focus",
            "month",
            "schedule",
            "single day",
            "time",
            "today",
            "when",
            "year"
        ]
    },
    {
        "icon": "circle",
        "label": "Circle",
        "search": [
            "Black Circle",
            "Black Large Circle",
            "black circle",
            "blue",
            "blue circle",
            "brown",
            "brown circle",
            "chart",
            "circle",
            "circle-thin",
            "diameter",
            "dot",
            "ellipse",
            "fill",
            "geometric",
            "green",
            "green circle",
            "notification",
            "orange",
            "orange circle",
            "progress",
            "purple",
            "purple circle",
            "red",
            "red circle",
            "round",
            "white circle",
            "yellow",
            "yellow circle"
        ]
    },
    {
        "icon": "notebook",
        "label": "Notebook",
        "search": [
            "daybook",
            "diary",
            "journal",
            "noteboo",
            "notebook",
            "notepad",
            "sketch"
        ]
    },
    {
        "icon": "octagon-xmark",
        "label": "Octagon Xmark",
        "search": [
            "close",
            "cross",
            "exit",
            "incorrect",
            "notice",
            "notification",
            "notify",
            "problem",
            "uncheck",
            "wrong",
            "x"
        ]
    },
    {
        "icon": "elementor",
        "label": "Elementor",
        "search": []
    },
    {
        "icon": "racquet",
        "label": "Racquet",
        "search": [
            "badminton",
            "racket",
            "squash",
            "tennis"
        ]
    },
    {
        "icon": "first-order",
        "label": "First Order",
        "search": []
    },
    {
        "icon": "face-grin-squint",
        "label": "Face Grin Squint",
        "search": [
            "emoticon",
            "face",
            "grinning squinting face",
            "laugh",
            "mouth",
            "satisfied",
            "smile"
        ]
    },
    {
        "icon": "tree-deciduous",
        "label": "Tree Deciduous",
        "search": [
            "bark",
            "deciduous",
            "deciduous tree",
            "fall",
            "flora",
            "forest",
            "nature",
            "plant",
            "seasonal",
            "shedding",
            "tree"
        ]
    },
    {
        "icon": "users-between-lines",
        "label": "Users Between Lines",
        "search": [
            "covered",
            "crowd",
            "employee",
            "group",
            "people",
            "together",
            "uer"
        ]
    },
    {
        "icon": "dribbble",
        "label": "Dribbble",
        "search": []
    },
    {
        "icon": "linkedin",
        "label": "LinkedIn",
        "search": [
            "linkedin-square",
            "linkin"
        ]
    },
    {
        "icon": "mango",
        "label": "Mango",
        "search": [
            "fruit",
            "mango",
            "tropical"
        ]
    },
    {
        "icon": "crosshairs-simple",
        "label": "Crosshairs Simple",
        "search": [
            "aim",
            "bullseye",
            "gpd",
            "picker",
            "position",
            "screenshot",
            "target"
        ]
    },
    {
        "icon": "pipe-smoking",
        "label": "Pipe Smoking",
        "search": [
            "pipe",
            "smoke",
            "tobacco"
        ]
    },
    {
        "icon": "coconut",
        "label": "Coconut",
        "search": [
            "coconut",
            "palm",
            "piña colada",
            "tropical"
        ]
    },
    {
        "icon": "face-diagonal-mouth",
        "label": "Face Diagonal Mouth",
        "search": [
            "confusion",
            "frustration",
            "skepticism"
        ]
    },
    {
        "icon": "star-sharp-half",
        "label": "Star Sharp Half",
        "search": [
            "critic",
            "ratings",
            "review",
            "sky"
        ]
    },
    {
        "icon": "music-magnifying-glass",
        "label": "Music Magnifying Glass",
        "search": [
            "artist",
            "audio",
            "bigger",
            "enlarge",
            "equipment",
            "find",
            "genre",
            "glass",
            "hear",
            "inspection",
            "magnifier",
            "magnify",
            "magnifying",
            "magnifying glass tilted left",
            "music",
            "note",
            "notes",
            "search",
            "similar",
            "song",
            "sound",
            "tool",
            "zoom"
        ]
    },
    {
        "icon": "house-medical-circle-xmark",
        "label": "House Medical Circle Xmark",
        "search": [
            "clinic",
            "destroy",
            "hospital",
            "uncheck"
        ]
    },
    {
        "icon": "cc-paypal",
        "label": "Paypal Credit Card",
        "search": []
    },
    {
        "icon": "club",
        "label": "Club",
        "search": [
            "ace",
            "card",
            "club suit",
            "game",
            "poker",
            "suit"
        ]
    },
    {
        "icon": "fire-smoke",
        "label": "Fire Smoke",
        "search": [
            "burn",
            "caliente",
            "flame",
            "fog",
            "heat",
            "hot"
        ]
    },
    {
        "icon": "table-list",
        "label": "Table List",
        "search": [
            "category",
            "cheatsheet",
            "checklist",
            "completed",
            "done",
            "finished",
            "ol",
            "summary",
            "todo",
            "ul"
        ]
    },
    {
        "icon": "flask-vial",
        "label": "Flask Vial",
        "search": [
            "ampule",
            "beaker",
            "chemicals",
            "chemistry",
            "experiment",
            "experimental",
            "lab",
            "laboratory",
            "labs",
            "liquid",
            "potion",
            "science",
            "test",
            "test tube",
            "vial"
        ]
    },
    {
        "icon": "luchador-mask",
        "label": "Luchador Mask",
        "search": [
            "fight",
            "mexico",
            "nacho libre",
            "wrestle",
            "wrestling"
        ]
    },
    {
        "icon": "circle-exclamation",
        "label": "Circle Exclamation",
        "search": [
            "affect",
            "alert",
            "attention",
            "damage",
            "danger",
            "error",
            "failed",
            "important",
            "notice",
            "notification",
            "notify",
            "problem",
            "required",
            "warning"
        ]
    },
    {
        "icon": "block-brick",
        "label": "Block Brick",
        "search": [
            "block",
            "brick",
            "mortar",
            "super mario",
            "wall"
        ]
    },
    {
        "icon": "taxi",
        "label": "Taxi",
        "search": [
            "cab",
            "cabbie",
            "car",
            "car service",
            "lyft",
            "machine",
            "oncoming",
            "oncoming taxi",
            "taxi",
            "transportation",
            "travel",
            "uber",
            "vehicle"
        ]
    },
    {
        "icon": "text-slash",
        "label": "Text Slash",
        "search": [
            "cancel",
            "disabled",
            "font",
            "format",
            "remove",
            "style",
            "text"
        ]
    },
    {
        "icon": "people-pulling",
        "label": "People Pulling",
        "search": [
            "forced return",
            "together",
            "uer",
            "yanking"
        ]
    },
    {
        "icon": "backward",
        "label": "Backward",
        "search": [
            "arrow",
            "double",
            "fast reverse button",
            "previous",
            "rewind"
        ]
    },
    {
        "icon": "spade",
        "label": "Spade",
        "search": [
            "ace",
            "card",
            "game",
            "poker",
            "spade suit",
            "suit"
        ]
    },
    {
        "icon": "dreidel",
        "label": "Dreidel",
        "search": [
            "clay",
            "hanukkah",
            "holiday",
            "jewish",
            "judaism",
            "toy"
        ]
    },
    {
        "icon": "car-burst",
        "label": "Car Burst",
        "search": [
            "accident",
            "auto",
            "automobile",
            "insurance",
            "sedan",
            "transportation",
            "vehicle",
            "wreck"
        ]
    },
    {
        "icon": "comment-minus",
        "label": "Comment Minus",
        "search": [
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "delete",
            "feedback",
            "message",
            "negative",
            "note",
            "notification",
            "remove",
            "sms",
            "speech",
            "texting"
        ]
    },
    {
        "icon": "square-f",
        "label": "Square F",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "chess-queen-piece",
        "label": "Chess Queen Piece",
        "search": [
            "board",
            "checkmate",
            "game",
            "strategy"
        ]
    },
    {
        "icon": "turn-left-down",
        "label": "Turn Left Down",
        "search": [
            "backwards",
            "direction",
            "down",
            "left",
            "reverse",
            "south",
            "turn"
        ]
    },
    {
        "icon": "link",
        "label": "Link",
        "search": [
            "attach",
            "attachment",
            "chain",
            "connect",
            "lin",
            "link"
        ]
    },
    {
        "icon": "chart-line-down",
        "label": "Chart Line Down",
        "search": [
            "analytics",
            "chart",
            "chart decreasing",
            "dashboard",
            "decline",
            "down",
            "graph",
            "line",
            "loss",
            "performance",
            "revenue",
            "statistics",
            "trend"
        ]
    },
    {
        "icon": "backward-step",
        "label": "Backward Step",
        "search": [
            "beginning",
            "first",
            "previous",
            "rewind",
            "start"
        ]
    },
    {
        "icon": "clock-one",
        "label": "Clock One",
        "search": [
            "00",
            "1",
            "1:00",
            "clock",
            "hour",
            "minute",
            "o'clock",
            "ticking",
            "time"
        ]
    },
    {
        "icon": "dice-d4",
        "label": "Dice D4",
        "search": [
            "Dungeons & Dragons",
            "chance",
            "d&d",
            "dnd",
            "fantasy",
            "gambling",
            "game",
            "roll"
        ]
    },
    {
        "icon": "x",
        "label": "X",
        "search": [
            "Latin Capital Letter X",
            "Latin Small Letter X",
            "letter",
            "uncheck"
        ]
    },
    {
        "icon": "circle-user",
        "label": "Circle User",
        "search": [
            "employee",
            "uer",
            "username",
            "users-people"
        ]
    },
    {
        "icon": "rectangle-list",
        "label": "Rectangle List",
        "search": [
            "cheatsheet",
            "checklist",
            "completed",
            "done",
            "finished",
            "ol",
            "summary",
            "todo",
            "ul"
        ]
    },
    {
        "icon": "circle-wifi",
        "label": "Circle Wifi",
        "search": [
            "connection",
            "hotspot",
            "internet",
            "network",
            "signal",
            "wireless",
            "www"
        ]
    },
    {
        "icon": "hand",
        "label": "Hand",
        "search": [
            "Raised Hand",
            "backhand",
            "game",
            "halt",
            "palm",
            "raised",
            "raised back of hand",
            "request",
            "roshambo",
            "stop"
        ]
    },
    {
        "icon": "lasso-sparkles",
        "label": "Lasso Sparkles",
        "search": [
            "automatic",
            "cowboy",
            "magic",
            "select"
        ]
    },
    {
        "icon": "dhl",
        "label": "DHL",
        "search": [
            "Dalsey",
            "Hillblom and Lynn",
            "german",
            "package",
            "shipping"
        ]
    },
    {
        "icon": "arrow-up-from-square",
        "label": "Arrow Up From Square",
        "search": [
            "share",
            "transfer",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "circle-r",
        "label": "Circle R",
        "search": [
            "Circled Latin Capital Letter R",
            "letter"
        ]
    },
    {
        "icon": "snooze",
        "label": "Snooze",
        "search": [
            "alarm",
            "comic",
            "nap",
            "rest",
            "siesta",
            "sleep",
            "zzz"
        ]
    },
    {
        "icon": "pan-frying",
        "label": "Pan Frying",
        "search": [
            "breakfast",
            "cook",
            "egg",
            "fry"
        ]
    },
    {
        "icon": "van-shuttle",
        "label": "Van Shuttle",
        "search": [
            "airport",
            "bus",
            "machine",
            "minibus",
            "public-transportation",
            "transportation",
            "travel",
            "vehicle"
        ]
    },
    {
        "icon": "stairs",
        "label": "Stairs",
        "search": [
            "exit",
            "steps",
            "up"
        ]
    },
    {
        "icon": "claude",
        "label": "claude"
    },
    {
        "icon": "shuttlecock",
        "label": "Shuttlecock",
        "search": [
            "badminton",
            "birdie",
            "feather",
            "sport"
        ]
    },
    {
        "icon": "coin-vertical",
        "label": "Coin Vertical",
        "search": [
            "coin",
            "dime",
            "gold",
            "metal",
            "money",
            "nickel",
            "penny",
            "premium",
            "quarter",
            "silver",
            "super mario",
            "treasure"
        ]
    },
    {
        "icon": "sheep",
        "label": "Sheep",
        "search": [
            "agriculture",
            "animal",
            "ewe",
            "farming",
            "fauna",
            "female",
            "mammal",
            "sheep",
            "wool",
            "yarn"
        ]
    },
    {
        "icon": "horse-head",
        "label": "Horse Head",
        "search": [
            "equus",
            "fauna",
            "mammmal",
            "mare",
            "neigh",
            "pony"
        ]
    },
    {
        "icon": "circle-calendar",
        "label": "Circle Calendar",
        "search": [
            "date",
            "day",
            "month",
            "reminder",
            "year"
        ]
    },
    {
        "icon": "vault",
        "label": "Vault",
        "search": [
            "bank",
            "important",
            "investment",
            "lock",
            "money",
            "premium",
            "privacy",
            "safe",
            "salary"
        ]
    },
    {
        "icon": "closed-captioning-slash",
        "label": "Closed Captioning Slash",
        "search": [
            "cc",
            "deaf",
            "disabled",
            "hearing",
            "subtitle",
            "subtitling"
        ]
    },
    {
        "icon": "drum-steelpan",
        "label": "Drum Steelpan",
        "search": [
            "calypso",
            "instrument",
            "music",
            "percussion",
            "reggae",
            "snare",
            "sound",
            "steel",
            "tropical"
        ]
    },
    {
        "icon": "thumbs-up",
        "label": "Thumbs Up",
        "search": [
            "+1",
            "agree",
            "approve",
            "favorite",
            "hand",
            "like",
            "ok",
            "okay",
            "social",
            "success",
            "thumb",
            "thumbs up",
            "thumbs-o-up",
            "up",
            "yes",
            "you got it dude"
        ]
    },
    {
        "icon": "engine",
        "label": "Engine",
        "search": [
            "car",
            "engine"
        ]
    },
    {
        "icon": "shopify",
        "label": "Shopify",
        "search": []
    },
    {
        "icon": "user-alien",
        "label": "User Alien",
        "search": [
            "ET",
            "extraterrestrial",
            "humanoid",
            "monster",
            "space",
            "strange",
            "uer",
            "ufo"
        ]
    },
    {
        "icon": "square-reddit",
        "label": "Square Reddit",
        "search": []
    },
    {
        "icon": "creative-commons-nc",
        "label": "Creative Commons Noncommercial",
        "search": []
    },
    {
        "icon": "rectangle-history",
        "label": "Rectangle History",
        "search": [
            "album",
            "carousel",
            "collection",
            "gallery",
            "history",
            "multiple",
            "project",
            "summary",
            "windows"
        ]
    },
    {
        "icon": "stamp",
        "label": "Stamp",
        "search": [
            "art",
            "certificate",
            "imprint",
            "rubber",
            "seal"
        ]
    },
    {
        "icon": "menorah",
        "label": "Menorah",
        "search": [
            "candle",
            "hanukkah",
            "jewish",
            "judaism",
            "light"
        ]
    },
    {
        "icon": "turn-left",
        "label": "Turn Left",
        "search": [
            "back",
            "direction",
            "left",
            "return",
            "turn",
            "west"
        ]
    },
    {
        "icon": "presentation-screen",
        "label": "Presentation Screen",
        "search": [
            "flipchart",
            "keynote",
            "lecture",
            "panel",
            "powerpoint",
            "ppt",
            "seminar",
            "slides",
            "speak",
            "speaker",
            "talk"
        ]
    },
    {
        "icon": "camera-movie",
        "label": "Camera Movie",
        "search": [
            "camera",
            "cinema",
            "director",
            "film",
            "movie",
            "movie camera",
            "theater",
            "video"
        ]
    },
    {
        "icon": "galactic-republic",
        "label": "Galactic Republic",
        "search": [
            "politics",
            "star wars"
        ]
    },
    {
        "icon": "hat-chef",
        "label": "Hat Chef",
        "search": [
            "cook",
            "cuisine",
            "culinary",
            "dining",
            "kitchen"
        ]
    },
    {
        "icon": "children",
        "label": "Children",
        "search": [
            "boy",
            "child",
            "girl",
            "kid",
            "kids",
            "together",
            "uer",
            "young",
            "youth"
        ]
    },
    {
        "icon": "snow-blowing",
        "label": "Snow Blowing",
        "search": [
            "blizzard",
            "precipitation",
            "storm",
            "winter"
        ]
    },
    {
        "icon": "album-collection",
        "label": "Album Collection",
        "search": [
            "catalog",
            "collection",
            "library",
            "music",
            "record",
            "song",
            "vinyl"
        ]
    },
    {
        "icon": "chart-line",
        "label": "Chart Line",
        "search": [
            "activity",
            "analytics",
            "chart",
            "dashboard",
            "gain",
            "graph",
            "increase",
            "line",
            "performance",
            "revenue",
            "statistics"
        ]
    },
    {
        "icon": "circle-up-left",
        "label": "Circle Up Left",
        "search": [
            "diagonal"
        ]
    },
    {
        "icon": "facebook",
        "label": "Facebook",
        "search": [
            "fabook",
            "facebook-official",
            "fb",
            "social network"
        ]
    },
    {
        "icon": "tire",
        "label": "Tire",
        "search": [
            "auto",
            "car",
            "rim",
            "rubber",
            "wheel"
        ]
    },
    {
        "icon": "square-envelope",
        "label": "Square Envelope",
        "search": [
            "e-mail",
            "email",
            "letter",
            "mail",
            "message",
            "notification",
            "offer",
            "support"
        ]
    },
    {
        "icon": "object-exclude",
        "label": "Object Exclude",
        "search": [
            "boolean",
            "combine",
            "group",
            "join",
            "pathfinder"
        ]
    },
    {
        "icon": "gitlab",
        "label": "GitLab",
        "search": [
            "Axosoft"
        ]
    },
    {
        "icon": "qq",
        "label": "QQ",
        "search": []
    },
    {
        "icon": "user-group-crown",
        "label": "User Group Crown",
        "search": [
            "administrator",
            "crowd",
            "together",
            "uer",
            "users-people",
            "vip"
        ]
    },
    {
        "icon": "ban-smoking",
        "label": "Ban Smoking",
        "search": [
            "ban",
            "cancel",
            "deny",
            "disabled",
            "forbidden",
            "no",
            "no smoking",
            "non-smoking",
            "not",
            "prohibited",
            "smoking"
        ]
    },
    {
        "icon": "user-visor",
        "label": "User Visor",
        "search": [
            "geordi la forge",
            "star trek",
            "uer"
        ]
    },
    {
        "icon": "truck-front",
        "label": "Truck Front",
        "search": [
            "shuttle",
            "truck",
            "van"
        ]
    },
    {
        "icon": "blinds-open",
        "label": "Blinds Open",
        "search": [
            "privacy",
            "shutter",
            "window"
        ]
    },
    {
        "icon": "building",
        "label": "Building",
        "search": [
            "apartment",
            "building",
            "business",
            "city",
            "company",
            "office",
            "office building",
            "urban",
            "work"
        ]
    },
    {
        "icon": "bullseye",
        "label": "Bullseye",
        "search": [
            "archery",
            "goal",
            "objective",
            "strategy",
            "target"
        ]
    },
    {
        "icon": "album-circle-user",
        "label": "Album Circle User",
        "search": [
            "artist",
            "computer",
            "disk",
            "library",
            "minidisk",
            "music",
            "optical",
            "record",
            "shared",
            "song",
            "uer",
            "vinyl"
        ]
    },
    {
        "icon": "arrow-left-long",
        "label": "Arrow Left Long",
        "search": [
            "back",
            "long-arrow-left",
            "previous"
        ]
    },
    {
        "icon": "swap-arrows",
        "label": "Swap Arrows",
        "search": [
            "arrows",
            "change",
            "merge",
            "move",
            "route",
            "transfer"
        ]
    },
    {
        "icon": "chess-rook",
        "label": "Chess Rook",
        "search": [
            "Black Chess Rook",
            "board",
            "castle",
            "checkmate",
            "game",
            "strategy"
        ]
    },
    {
        "icon": "blender-phone",
        "label": "Blender Phone",
        "search": [
            "appliance",
            "cocktail",
            "fantasy",
            "milkshake",
            "mixer",
            "puree",
            "silly",
            "smoothie"
        ]
    },
    {
        "icon": "arrow-turn-up",
        "label": "Arrow Turn Up",
        "search": [
            "arrow"
        ]
    },
    {
        "icon": "shelves-empty",
        "label": "Shelves Empty",
        "search": [
            "bookshelf",
            "inventory",
            "stock"
        ]
    },
    {
        "icon": "note",
        "label": "Note",
        "search": [
            "Empty Note",
            "memo",
            "sticky note"
        ]
    },
    {
        "icon": "pen-field",
        "label": "Pen Field",
        "search": [
            "imput",
            "modify",
            "signature",
            "username"
        ]
    },
    {
        "icon": "hexagon-vertical-nft-slanted",
        "label": "Hexagon Vertical Nft Slanted",
        "search": [
            "NFT",
            "blockchain",
            "crypto",
            "data",
            "non-fungible token"
        ]
    },
    {
        "icon": "corn",
        "label": "Corn",
        "search": [
            "cob",
            "corn",
            "ear",
            "ear of corn",
            "fall",
            "grain",
            "kernel",
            "maize",
            "maze",
            "popcorn"
        ]
    },
    {
        "icon": "stripe",
        "label": "Stripe",
        "search": []
    },
    {
        "icon": "piano-keyboard",
        "label": "Piano Keyboard",
        "search": [
            "instrument",
            "keyboard",
            "keys",
            "midi",
            "music",
            "musical keyboard",
            "piano"
        ]
    },
    {
        "icon": "face-tongue-sweat",
        "label": "Face Tongue Sweat",
        "search": [
            "fever",
            "feverish",
            "heat stroke",
            "hot",
            "hot face",
            "overheat",
            "red-faced",
            "stroke",
            "sweating"
        ]
    },
    {
        "icon": "bicycle",
        "label": "Bicycle",
        "search": [
            "bicycle",
            "bike",
            "gears",
            "pedal",
            "transportation",
            "vehicle"
        ]
    },
    {
        "icon": "money-simple-from-bracket",
        "label": "Money Simple From Bracket",
        "search": [
            "atm",
            "automated",
            "cash",
            "deposit",
            "dispenser",
            "investment",
            "salary",
            "transaction",
            "withdrawl"
        ]
    },
    {
        "icon": "user-tie-hair-long",
        "label": "User Tie Hair Long",
        "search": [
            "administrator",
            "avatar",
            "business",
            "clothing",
            "employee",
            "formal",
            "professional",
            "suit",
            "uer"
        ]
    },
    {
        "icon": "badge",
        "label": "Badge",
        "search": [
            "discount",
            "guarantee",
            "meatball",
            "verified",
            "verify"
        ]
    },
    {
        "icon": "dailymotion",
        "label": "dailymotion",
        "search": []
    },
    {
        "icon": "truck-utensils",
        "label": "Truck Utensils",
        "search": [
            "cargo",
            "cook",
            "delivery",
            "delivery truck",
            "food",
            "food truck",
            "kitchen",
            "shipping",
            "truck",
            "vehicle"
        ]
    },
    {
        "icon": "circle-arrow-down",
        "label": "Circle Arrow Down",
        "search": [
            "download"
        ]
    },
    {
        "icon": "steam",
        "label": "Steam",
        "search": []
    },
    {
        "icon": "gear",
        "label": "Gear",
        "search": [
            "cog",
            "cogwheel",
            "configuration",
            "gear",
            "mechanical",
            "modify",
            "settings",
            "sprocket",
            "tool",
            "wheel"
        ]
    },
    {
        "icon": "films",
        "label": "Films",
        "search": [
            "films",
            "videos"
        ]
    },
    {
        "icon": "walker",
        "label": "Walker",
        "search": [
            "accessibility",
            "assistance",
            "disabled",
            "wheelchair"
        ]
    },
    {
        "icon": "square-arrow-right",
        "label": "Square Arrow Right",
        "search": [
            "forward",
            "next"
        ]
    },
    {
        "icon": "face-party",
        "label": "Face Party",
        "search": [
            "celebration",
            "hat",
            "horn",
            "party",
            "partying face"
        ]
    },
    {
        "icon": "mars-and-venus-burst",
        "label": "Mars And Venus Burst",
        "search": [
            "gender",
            "uer",
            "violence"
        ]
    },
    {
        "icon": "columns-3",
        "label": "Columns 3",
        "search": [
            "divide",
            "organize",
            "panes",
            "split"
        ]
    },
    {
        "icon": "otter",
        "label": "Otter",
        "search": [
            "animal",
            "badger",
            "fauna",
            "fishing",
            "fur",
            "mammal",
            "marten",
            "otter",
            "playful"
        ]
    },
    {
        "icon": "circle-9",
        "label": "Circle 9",
        "search": [
            "Circled Digit Nine",
            "Dingbat Circled Sans-Serif Digit Nine",
            "Dingbat Negative Circled Digit Nine",
            "Dingbat Negative Circled Sans-Serif Digit Nine",
            "nine"
        ]
    },
    {
        "icon": "circle-chevron-left",
        "label": "Circle Chevron Left",
        "search": [
            "arrow",
            "back",
            "previous"
        ]
    },
    {
        "icon": "circle-question",
        "label": "Circle Question",
        "search": [
            "faq",
            "help",
            "information",
            "support",
            "unknown"
        ]
    },
    {
        "icon": "snapchat",
        "label": "Snapchat",
        "search": []
    },
    {
        "icon": "walkie-talkie",
        "label": "Walkie Talkie",
        "search": [
            "communication",
            "copy",
            "intercom",
            "over",
            "portable",
            "radio",
            "two way radio"
        ]
    },
    {
        "icon": "user-group",
        "label": "User Group",
        "search": [
            "bust",
            "busts in silhouette",
            "crowd",
            "employee",
            "silhouette",
            "together",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "bed-front",
        "label": "Bed Front",
        "search": [
            "double",
            "king",
            "lodging",
            "mattress",
            "pillows",
            "queen",
            "rest",
            "sleep",
            "travel"
        ]
    },
    {
        "icon": "house-chimney",
        "label": "House Chimney",
        "search": [
            "abode",
            "building",
            "chimney",
            "house",
            "main",
            "residence",
            "smokestack"
        ]
    },
    {
        "icon": "right-from-bracket",
        "label": "Right From Bracket",
        "search": [
            "arrow",
            "exit",
            "leave",
            "log out",
            "logout",
            "sign-out"
        ]
    },
    {
        "icon": "peanuts",
        "label": "Peanuts",
        "search": [
            "goober",
            "legume",
            "nut",
            "shell"
        ]
    },
    {
        "icon": "triangle-instrument",
        "label": "Triangle Instrument",
        "search": [
            "ding",
            "idiophone",
            "instrument",
            "music",
            "percussion"
        ]
    },
    {
        "icon": "bowl-spoon",
        "label": "Bowl Spoon",
        "search": [
            "breakfast",
            "cereal",
            "congee",
            "oatmeal",
            "porridge"
        ]
    },
    {
        "icon": "file",
        "label": "File",
        "search": [
            "Empty Document",
            "cv",
            "document",
            "new",
            "page",
            "page facing up",
            "pdf",
            "resume"
        ]
    },
    {
        "icon": "plane-slash",
        "label": "Plane Slash",
        "search": [
            "airplane mode",
            "airport",
            "canceled",
            "covid-19",
            "delayed",
            "disabled",
            "grounded",
            "travel"
        ]
    },
    {
        "icon": "industry-windows",
        "label": "Industry Windows",
        "search": [
            "building",
            "factory",
            "industrial",
            "manufacturing",
            "mill",
            "warehouse"
        ]
    },
    {
        "icon": "cloud-showers-heavy",
        "label": "Cloud Showers Heavy",
        "search": [
            "precipitation",
            "rain",
            "sky",
            "storm"
        ]
    },
    {
        "icon": "bed-bunk",
        "label": "Bed Bunk",
        "search": [
            "lodging",
            "mattress",
            "rest",
            "siblings",
            "sleep",
            "sleepover",
            "travel"
        ]
    },
    {
        "icon": "person-falling",
        "label": "Person Falling",
        "search": [
            "accident",
            "fall",
            "trip",
            "uer"
        ]
    },
    {
        "icon": "square-chevron-down",
        "label": "Square Chevron Down",
        "search": [
            "arrow",
            "download",
            "dropdown",
            "expand",
            "insert",
            "menu",
            "more"
        ]
    },
    {
        "icon": "butter",
        "label": "Butter",
        "search": [
            "butter",
            "dairy",
            "margarine",
            "spread"
        ]
    },
    {
        "icon": "turn-down",
        "label": "Turn Down",
        "search": [
            "arrow",
            "down",
            "level-down",
            "right arrow curving down"
        ]
    },
    {
        "icon": "volume-slash",
        "label": "Volume Slash",
        "search": [
            "audio",
            "ban",
            "disabled",
            "music",
            "mute",
            "muted speaker",
            "quiet",
            "silent",
            "sound",
            "speaker"
        ]
    },
    {
        "icon": "up-right-and-down-left-from-center",
        "label": "Up Right And Down Left From Center",
        "search": [
            "arrows",
            "bigger",
            "enlarge",
            "expand",
            "fullscreen",
            "maximize",
            "resize",
            "resize",
            "scale",
            "size"
        ]
    },
    {
        "icon": "user-tag",
        "label": "User Tag",
        "search": [
            "employee",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "square-0",
        "label": "Square 0",
        "search": [
            "nada",
            "none",
            "zero",
            "zilch"
        ]
    },
    {
        "icon": "inbox-in",
        "label": "Inbox In",
        "search": [
            "archive",
            "box",
            "desk",
            "email",
            "inbox",
            "inbox tray",
            "insert",
            "letter",
            "mail",
            "message",
            "newsletter",
            "offer",
            "receive",
            "tray"
        ]
    },
    {
        "icon": "globe-snow",
        "label": "Globe Snow",
        "search": [
            "diorama",
            "scene",
            "seasonal",
            "shake",
            "souvenir",
            "winter"
        ]
    },
    {
        "icon": "hand-sparkles",
        "label": "Hand Sparkles",
        "search": [
            "clean",
            "covid-19",
            "hygiene",
            "magic",
            "palm",
            "soap",
            "wash"
        ]
    },
    {
        "icon": "file-ppt",
        "label": "File Ppt",
        "search": [
            "document",
            "file",
            "keynote",
            "lecture",
            "panel",
            "powerpoint",
            "ppt",
            "seminar",
            "slides",
            "speak",
            "speaker",
            "talk"
        ]
    },
    {
        "icon": "arrows-to-dot",
        "label": "Arrows To Dot",
        "search": [
            "assembly point",
            "center",
            "condense",
            "focus",
            "insert",
            "minimize"
        ]
    },
    {
        "icon": "face-sad-cry",
        "label": "Face Sad Cry",
        "search": [
            "cry",
            "emoticon",
            "face",
            "loudly crying face",
            "sad",
            "sob",
            "tear",
            "tears"
        ]
    },
    {
        "icon": "image-slash",
        "label": "Image Slash",
        "search": [
            "album",
            "disabled",
            "img",
            "landscape",
            "photo",
            "picture"
        ]
    },
    {
        "icon": "gitbook-assistant",
        "label": "gitbook-assistant"
    },
    {
        "icon": "trophy-star",
        "label": "Trophy Star",
        "search": [
            "achievement",
            "award",
            "cup",
            "game",
            "quality",
            "star",
            "winner"
        ]
    },
    {
        "icon": "dong-sign",
        "label": "Dong Sign",
        "search": [
            "Dong Sign",
            "currency"
        ]
    },
    {
        "icon": "people-line",
        "label": "People Line",
        "search": [
            "crowd",
            "group",
            "need",
            "together",
            "uer"
        ]
    },
    {
        "icon": "square-rss",
        "label": "Square Rss",
        "search": [
            "blog",
            "feed",
            "journal",
            "news",
            "writing"
        ]
    },
    {
        "icon": "island-tropical",
        "label": "Island Tropical",
        "search": [
            "castaway",
            "desert",
            "desert island",
            "island",
            "palm tree",
            "sand",
            "stranded",
            "summer",
            "vacation"
        ]
    },
    {
        "icon": "clock-twelve",
        "label": "Clock Twelve",
        "search": [
            "00",
            "12",
            "12:00",
            "clock",
            "hour",
            "midnight",
            "minute",
            "noon",
            "o'clock",
            "o’clock",
            "pending",
            "ticking",
            "time",
            "twelve",
            "twelve o’clock"
        ]
    },
    {
        "icon": "calendar-minus",
        "label": "Calendar Minus",
        "search": [
            "calendar",
            "date",
            "day",
            "delete",
            "event",
            "month",
            "negative",
            "remove",
            "schedule",
            "time",
            "when",
            "year"
        ]
    },
    {
        "icon": "galactic-senate",
        "label": "Galactic Senate",
        "search": [
            "star wars"
        ]
    },
    {
        "icon": "chart-diagram",
        "label": "Chart Diagram",
        "search": [
            "algorithm",
            "analytics",
            "flow",
            "graph"
        ]
    },
    {
        "icon": "phoenix-framework",
        "label": "Phoenix Framework",
        "search": []
    },
    {
        "icon": "git",
        "label": "Git",
        "search": []
    },
    {
        "icon": "ballot-check",
        "label": "Ballot Check",
        "search": [
            "checklist",
            "choice",
            "completed",
            "coupon",
            "done",
            "election",
            "enable",
            "finished",
            "select",
            "success",
            "tick",
            "validate",
            "vote",
            "voting",
            "working"
        ]
    },
    {
        "icon": "chf-sign",
        "label": "Chf Sign",
        "search": [
            "Swiss",
            "currency",
            "franc",
            "money"
        ]
    },
    {
        "icon": "calendar-image",
        "label": "Calendar Image",
        "search": [
            "date",
            "day",
            "month",
            "reminder",
            "year"
        ]
    },
    {
        "icon": "down-right",
        "label": "Down Right",
        "search": [
            "South East Black Arrow",
            "diagonal",
            "direction",
            "southeast"
        ]
    },
    {
        "icon": "calendar-circle-user",
        "label": "Calendar Circle User",
        "search": [
            "attendee",
            "calendar",
            "date",
            "day",
            "employee",
            "event",
            "important",
            "invitation",
            "invite",
            "month",
            "schedule",
            "time",
            "uer",
            "when",
            "year"
        ]
    },
    {
        "icon": "optin-monster",
        "label": "Optin Monster",
        "search": []
    },
    {
        "icon": "jenkins",
        "label": "Jenkis",
        "search": []
    },
    {
        "icon": "face-tired",
        "label": "Face Tired",
        "search": [
            "angry",
            "emoticon",
            "face",
            "grumpy",
            "tired",
            "tired face",
            "upset"
        ]
    },
    {
        "icon": "diagram-previous",
        "label": "Diagram Previous",
        "search": [
            "cells",
            "chart",
            "gantt",
            "predecessor",
            "previous",
            "row",
            "subtask",
            "table"
        ]
    },
    {
        "icon": "face-astonished",
        "label": "Face Astonished",
        "search": [
            "astonished",
            "astonished face",
            "disbelief",
            "face",
            "gasp",
            "shock",
            "shocked",
            "surprise",
            "totally"
        ]
    },
    {
        "icon": "ice-skate",
        "label": "Ice Skate",
        "search": [
            "blade",
            "clothing",
            "figure skating",
            "hockey",
            "ice",
            "ice skate",
            "seasonal",
            "shoe",
            "skate"
        ]
    },
    {
        "icon": "laptop-arrow-down",
        "label": "Laptop Arrow Down",
        "search": [
            "computer",
            "download",
            "insert",
            "laptop",
            "mobile",
            "remote"
        ]
    },
    {
        "icon": "raygun",
        "label": "Raygun",
        "search": [
            "flash gordon",
            "laser",
            "pew pew",
            "phaser",
            "space",
            "stun"
        ]
    },
    {
        "icon": "hand-point-right",
        "label": "Hand Point Right",
        "search": [
            "finger",
            "forward",
            "hand-o-right",
            "next",
            "point",
            "right"
        ]
    },
    {
        "icon": "conveyor-belt-empty",
        "label": "Conveyor Belt Empty",
        "search": [
            "inventory",
            "shipping"
        ]
    },
    {
        "icon": "arrow-right-from-arc",
        "label": "Arrow Right From Arc",
        "search": [
            "exit",
            "give",
            "leave",
            "send",
            "transfer"
        ]
    },
    {
        "icon": "slideshare",
        "label": "Slideshare",
        "search": []
    },
    {
        "icon": "uber",
        "label": "Uber",
        "search": []
    },
    {
        "icon": "signal-stream-slash",
        "label": "Signal Stream Slash",
        "search": [
            "disabled",
            "disconnect",
            "podcast",
            "radio",
            "sisngal",
            "streaming",
            "wave",
            "wifi",
            "wireless",
            "www"
        ]
    },
    {
        "icon": "court-sport",
        "label": "Court Sport",
        "search": [
            "basketball",
            "court",
            "field",
            "football",
            "futbol",
            "soccer",
            "sport"
        ]
    },
    {
        "icon": "digital-ocean",
        "label": "Digital Ocean",
        "search": []
    },
    {
        "icon": "train-track",
        "label": "Train Track",
        "search": [
            "rail",
            "railroad",
            "tracks",
            "train"
        ]
    },
    {
        "icon": "cars",
        "label": "Cars",
        "search": [
            "automobiles",
            "autos",
            "transportation",
            "travel"
        ]
    },
    {
        "icon": "nfc-pen",
        "label": "Nfc Pen",
        "search": [
            "connect",
            "data",
            "edit",
            "near field communication",
            "nfc",
            "scan",
            "signal",
            "transfer",
            "wireless"
        ]
    },
    {
        "icon": "arrow-up",
        "label": "Arrow Up",
        "search": [
            "Upwards Arrow",
            "forward",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "xmark-large",
        "label": "Xmark Large",
        "search": [
            "cancel",
            "cancellation X",
            "close",
            "cross",
            "cross mark",
            "error",
            "exit",
            "incorrect",
            "mark",
            "multiplication",
            "multiplication Sign",
            "multiplication X",
            "multiply",
            "notice",
            "notification",
            "notify",
            "problem",
            "sign",
            "uncheck",
            "wrong",
            "x",
            "×"
        ]
    },
    {
        "icon": "soundcloud",
        "label": "Soundcloud",
        "search": []
    },
    {
        "icon": "cubes-stacked",
        "label": "Cubes Stacked",
        "search": [
            "blocks",
            "cubes",
            "sugar"
        ]
    },
    {
        "icon": "child-combatant",
        "label": "Child Combatant",
        "search": [
            "combatant"
        ]
    },
    {
        "icon": "square-g",
        "label": "Square G",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "vest-patches",
        "label": "Vest Patches",
        "search": [
            "biker",
            "fashion",
            "style"
        ]
    },
    {
        "icon": "creative-commons-sa",
        "label": "Creative Commons Share Alike",
        "search": []
    },
    {
        "icon": "chrome",
        "label": "Chrome",
        "search": [
            "browser"
        ]
    },
    {
        "icon": "martini-glass-empty",
        "label": "Martini Glass Empty",
        "search": [
            "alcohol",
            "bar",
            "beverage",
            "drink",
            "liquor"
        ]
    },
    {
        "icon": "kidneys",
        "label": "Kidneys",
        "search": [
            "blood",
            "body",
            "organ",
            "surgery",
            "urine"
        ]
    },
    {
        "icon": "brackets-curly",
        "label": "Brackets Curly",
        "search": [
            "code",
            "developer",
            "development",
            "parentheses"
        ]
    },
    {
        "icon": "diamond-exclamation",
        "label": "Diamond Exclamation",
        "search": [
            "attention",
            "caution",
            "danger",
            "failed",
            "required",
            "warning"
        ]
    },
    {
        "icon": "magnet",
        "label": "Magnet",
        "search": [
            "Attract",
            "attraction",
            "horseshoe",
            "lodestone",
            "magnet",
            "magnetic",
            "tool"
        ]
    },
    {
        "icon": "road-barrier",
        "label": "Road Barrier",
        "search": [
            "block",
            "border",
            "no entry",
            "roadblock"
        ]
    },
    {
        "icon": "compass-drafting",
        "label": "Compass Drafting",
        "search": [
            "design",
            "map",
            "mechanical drawing",
            "plot",
            "plotting"
        ]
    },
    {
        "icon": "rectangle",
        "label": "Rectangle",
        "search": [
            "Black Rectangle",
            "geometry",
            "shape"
        ]
    },
    {
        "icon": "hand-holding-skull",
        "label": "Hand Holding Skull",
        "search": [
            "hamlet",
            "shakespeare",
            "yorick"
        ]
    },
    {
        "icon": "square-person-confined",
        "label": "Square Person Confined",
        "search": [
            "captivity",
            "confined",
            "uer"
        ]
    },
    {
        "icon": "grid",
        "label": "Grid",
        "search": [
            "app",
            "collection",
            "compact",
            "filter",
            "grid",
            "sort"
        ]
    },
    {
        "icon": "cabinet-filing",
        "label": "Cabinet Filing",
        "search": [
            "archive",
            "cabinet",
            "file",
            "file cabinet",
            "files",
            "filing",
            "records",
            "register",
            "storage"
        ]
    },
    {
        "icon": "plate-wheat",
        "label": "Plate Wheat",
        "search": [
            "bowl",
            "hunger",
            "rations",
            "wheat"
        ]
    },
    {
        "icon": "trade-federation",
        "label": "Trade Federation",
        "search": []
    },
    {
        "icon": "rectangle-vertical-history",
        "label": "Rectangle Vertical History",
        "search": [
            "album",
            "carousel",
            "collection",
            "gallery",
            "history",
            "multiple",
            "project",
            "windows"
        ]
    },
    {
        "icon": "sign-hanging",
        "label": "Sign Hanging",
        "search": [
            "directions",
            "real estate",
            "signage",
            "wayfinding"
        ]
    },
    {
        "icon": "circle-8",
        "label": "Circle 8",
        "search": [
            "Circled Digit Eight",
            "Dingbat Circled Sans-Serif Digit Eight",
            "Dingbat Negative Circled Digit Eight",
            "Dingbat Negative Circled Sans-Serif Digit Eight",
            "eight"
        ]
    },
    {
        "icon": "car-battery",
        "label": "Car Battery",
        "search": [
            "auto",
            "electric",
            "mechanic",
            "power"
        ]
    },
    {
        "icon": "shirt",
        "label": "Shirt",
        "search": [
            "clothing",
            "fashion",
            "garment",
            "shirt",
            "short sleeve",
            "t-shirt",
            "tshirt"
        ]
    },
    {
        "icon": "paragraph",
        "label": "Paragraph",
        "search": [
            "Pilcrow Sign",
            "edit",
            "format",
            "text",
            "writing"
        ]
    },
    {
        "icon": "envelopes-bulk",
        "label": "Envelopes Bulk",
        "search": [
            "archive",
            "envelope",
            "letter",
            "newsletter",
            "offer",
            "post office",
            "postal",
            "postcard",
            "send",
            "stamp",
            "usps"
        ]
    },
    {
        "icon": "file-doc",
        "label": "File Doc",
        "search": [
            "document",
            "file",
            "microsoft",
            "paper",
            "writing"
        ]
    },
    {
        "icon": "vaadin",
        "label": "Vaadin",
        "search": []
    },
    {
        "icon": "deviantart",
        "label": "deviantART",
        "search": []
    },
    {
        "icon": "guitar",
        "label": "Guitar",
        "search": [
            "acoustic",
            "instrument",
            "music",
            "rock",
            "rock and roll",
            "song",
            "strings"
        ]
    },
    {
        "icon": "flying-disc",
        "label": "Flying Disc",
        "search": [
            "flying disc",
            "frisbee",
            "ultimate"
        ]
    },
    {
        "icon": "suitcase",
        "label": "Suitcase",
        "search": [
            "baggage",
            "luggage",
            "move",
            "packing",
            "suitcase",
            "travel",
            "trip"
        ]
    },
    {
        "icon": "circle-up",
        "label": "Circle Up",
        "search": [
            "arrow-circle-o-up",
            "upgrade"
        ]
    },
    {
        "icon": "f",
        "label": "F",
        "search": [
            "Latin Capital Letter F",
            "Latin Small Letter F",
            "letter"
        ]
    },
    {
        "icon": "xmarks-lines",
        "label": "Xmarks Lines",
        "search": [
            "barricade",
            "barrier",
            "fence",
            "poison",
            "roadblock"
        ]
    },
    {
        "icon": "hashtag-lock",
        "label": "Hashtag Lock",
        "search": [
            "number lock",
            "numeric lock",
            "numlock",
            "padlock",
            "privacy"
        ]
    },
    {
        "icon": "garage-open",
        "label": "Garage Open",
        "search": [
            "auto",
            "car",
            "door",
            "storage",
            "structure",
            "warehouse"
        ]
    },
    {
        "icon": "basket-shopping-plus",
        "label": "Basket Shopping Plus",
        "search": [
            "add",
            "buy",
            "checkout",
            "grocery",
            "payment",
            "purchase"
        ]
    },
    {
        "icon": "hand-fingers-crossed",
        "label": "Hand Fingers Crossed",
        "search": [
            "cross",
            "crossed fingers",
            "finger",
            "hand",
            "hope",
            "luck",
            "promise"
        ]
    },
    {
        "icon": "brain-arrow-curved-right",
        "label": "Brain Arrow Curved Right",
        "search": [
            "brain",
            "brainstorming",
            "meeting",
            "planning"
        ]
    },
    {
        "icon": "person-sign",
        "label": "Person Sign",
        "search": [
            "announce",
            "protest",
            "uer"
        ]
    },
    {
        "icon": "circle-trash",
        "label": "Circle Trash",
        "search": [
            "delete",
            "garbage",
            "hide",
            "remove"
        ]
    },
    {
        "icon": "earth-oceania",
        "label": "Earth Oceania",
        "search": [
            "all",
            "australia",
            "country",
            "earth",
            "global",
            "globe",
            "gps",
            "language",
            "localize",
            "location",
            "map",
            "melanesia",
            "micronesia",
            "new zealand",
            "online",
            "place",
            "planet",
            "polynesia",
            "translate",
            "travel",
            "world"
        ]
    },
    {
        "icon": "medium",
        "label": "Medium",
        "search": []
    },
    {
        "icon": "comment-slash",
        "label": "Comment Slash",
        "search": [
            "answer",
            "bubble",
            "cancel",
            "chat",
            "commenting",
            "conversation",
            "disabled",
            "feedback",
            "message",
            "mute",
            "note",
            "notification",
            "quiet",
            "sms",
            "speech",
            "texting"
        ]
    },
    {
        "icon": "play",
        "label": "Play",
        "search": [
            "arrow",
            "audio",
            "music",
            "play",
            "play button",
            "playing",
            "right",
            "sound",
            "start",
            "triangle",
            "video"
        ]
    },
    {
        "icon": "house-window",
        "label": "House Window",
        "search": [
            "abode",
            "building",
            "family",
            "home",
            "residence"
        ]
    },
    {
        "icon": "vial-circle-check",
        "label": "Vial Circle Check",
        "search": [
            "ampule",
            "chemist",
            "chemistry",
            "enable",
            "not affected",
            "ok",
            "okay",
            "success",
            "test tube",
            "tube",
            "vaccine",
            "validate",
            "working"
        ]
    },
    {
        "icon": "bridge-circle-check",
        "label": "Bridge Circle Check",
        "search": [
            "bridge",
            "enable",
            "not affected",
            "ok",
            "okay",
            "road",
            "validate",
            "working"
        ]
    },
    {
        "icon": "cedi-sign",
        "label": "Cedi Sign",
        "search": [
            "Cedi Sign",
            "currency"
        ]
    },
    {
        "icon": "hat-santa",
        "label": "Hat Santa",
        "search": [
            "accessory",
            "christmas",
            "claus",
            "clothing",
            "head",
            "holiday",
            "santa",
            "xmas"
        ]
    },
    {
        "icon": "puzzle-piece",
        "label": "Puzzle Piece",
        "search": [
            "add-on",
            "addon",
            "clue",
            "game",
            "interlocking",
            "jigsaw",
            "piece",
            "puzzle",
            "puzzle piece",
            "section"
        ]
    },
    {
        "icon": "helmet-un",
        "label": "Helmet Un",
        "search": [
            "helmet",
            "united nations"
        ]
    },
    {
        "icon": "glass-water",
        "label": "Glass Water",
        "search": [
            "potable",
            "water"
        ]
    },
    {
        "icon": "pen-fancy-slash",
        "label": "Pen Fancy Slash",
        "search": [
            "disabled",
            "modify",
            "remove",
            "style"
        ]
    },
    {
        "icon": "heart-circle-bolt",
        "label": "Heart Circle Bolt",
        "search": [
            "cardiogram",
            "ekg",
            "electric",
            "heart",
            "love",
            "pacemaker"
        ]
    },
    {
        "icon": "fire-hydrant",
        "label": "Fire Hydrant",
        "search": [
            "fire",
            "irrigate",
            "water"
        ]
    },
    {
        "icon": "memo-circle-check",
        "label": "Memo Circle Check",
        "search": [
            "check",
            "cv",
            "done",
            "enable",
            "file",
            "idea",
            "not affected",
            "note",
            "notepad",
            "ok",
            "okay",
            "page",
            "paper",
            "validate",
            "working"
        ]
    },
    {
        "icon": "opencart",
        "label": "OpenCart",
        "search": []
    },
    {
        "icon": "pump-soap",
        "label": "Pump Soap",
        "search": [
            "anti-bacterial",
            "clean",
            "covid-19",
            "disinfect",
            "hygiene",
            "sanitizer",
            "soap"
        ]
    },
    {
        "icon": "hand-scissors",
        "label": "Hand Scissors",
        "search": [
            "cut",
            "game",
            "roshambo"
        ]
    },
    {
        "icon": "sandwich",
        "label": "Sandwich",
        "search": [
            "bread",
            "deli",
            "grilled cheese",
            "sandwich",
            "toast"
        ]
    },
    {
        "icon": "dolly",
        "label": "Dolly",
        "search": [
            "carry",
            "shipping",
            "transport"
        ]
    },
    {
        "icon": "paperclip",
        "label": "Paperclip",
        "search": [
            "attach",
            "attachment",
            "connect",
            "link",
            "papercli",
            "paperclip"
        ]
    },
    {
        "icon": "meter-fire",
        "label": "Meter Fire",
        "search": [
            "electricity",
            "transmission",
            "utilities"
        ]
    },
    {
        "icon": "democrat",
        "label": "Democrat",
        "search": [
            "american",
            "democratic party",
            "donkey",
            "election",
            "left",
            "left-wing",
            "liberal",
            "politics",
            "usa"
        ]
    },
    {
        "icon": "square-arrow-up-right",
        "label": "Square Arrow Up Right",
        "search": [
            "diagonal",
            "new",
            "open",
            "send",
            "share"
        ]
    },
    {
        "icon": "square-exclamation",
        "label": "Square Exclamation",
        "search": [
            "alert",
            "attention",
            "danger",
            "error",
            "failed",
            "important",
            "notice",
            "notification",
            "notify",
            "problem",
            "required",
            "warning"
        ]
    },
    {
        "icon": "wave",
        "label": "Wave",
        "search": [
            "barrel",
            "beach",
            "break",
            "bro",
            "flotsam",
            "jetsam",
            "shore",
            "surf",
            "tsunami",
            "water",
            "wave"
        ]
    },
    {
        "icon": "ferry",
        "label": "Ferry",
        "search": [
            "barge",
            "boat",
            "carry",
            "ferryboat",
            "ship"
        ]
    },
    {
        "icon": "mosquito",
        "label": "Mosquito",
        "search": [
            "bite",
            "bug",
            "mosquito",
            "west nile"
        ]
    },
    {
        "icon": "hexagon-minus",
        "label": "Hexagon Minus",
        "search": [
            "delete",
            "hide",
            "negative",
            "remove",
            "shape",
            "trash"
        ]
    },
    {
        "icon": "building-circle-arrow-right",
        "label": "Building Circle Arrow Right",
        "search": [
            "building",
            "city",
            "distribution center",
            "office"
        ]
    },
    {
        "icon": "face-hand-peeking",
        "label": "Face Hand Peeking",
        "search": [
            "disgust",
            "embarass",
            "eye",
            "fright",
            "hide",
            "look",
            "sneak"
        ]
    },
    {
        "icon": "arrow-left-from-line",
        "label": "Arrow Left From Line",
        "search": [
            "Leftwards Arrow from Bar",
            "forward",
            "next"
        ]
    },
    {
        "icon": "y-combinator",
        "label": "Y Combinator",
        "search": []
    },
    {
        "icon": "line",
        "label": "Line",
        "search": []
    },
    {
        "icon": "left-right",
        "label": "Left Right",
        "search": [
            "arrow",
            "arrows-h",
            "expand",
            "horizontal",
            "landscape",
            "left-right arrow",
            "resize",
            "wide"
        ]
    },
    {
        "icon": "signal-bars-weak",
        "label": "Signal Bars Weak",
        "search": [
            "bars",
            "graph",
            "online",
            "reception",
            "status"
        ]
    },
    {
        "icon": "lightbulb-gear",
        "label": "Lightbulb Gear",
        "search": [
            "bulb",
            "comic",
            "electric",
            "energy",
            "idea",
            "innovation",
            "inspiration",
            "light",
            "light bulb",
            "mechanical"
        ]
    },
    {
        "icon": "rectangle-terminal",
        "label": "Rectangle Terminal",
        "search": [
            "code",
            "coding",
            "command",
            "console",
            "development",
            "prompt",
            "terminal"
        ]
    },
    {
        "icon": "square-down-left",
        "label": "Square Down Left",
        "search": [
            "arrow",
            "diagonal",
            "direction",
            "down-left arrow",
            "intercardinal",
            "southwest"
        ]
    },
    {
        "icon": "pepper",
        "label": "Pepper",
        "search": [
            "bell pepper",
            "capsicum"
        ]
    },
    {
        "icon": "moon-stars",
        "label": "Moon Stars",
        "search": [
            "clear",
            "crescent",
            "lunar",
            "space",
            "star"
        ]
    },
    {
        "icon": "amilia",
        "label": "Amilia",
        "search": []
    },
    {
        "icon": "clock-five",
        "label": "Clock Five",
        "search": [
            "00",
            "5",
            "5:00",
            "clock",
            "five",
            "five o’clock",
            "hour",
            "minute",
            "o'clock",
            "o’clock",
            "pending",
            "ticking",
            "time"
        ]
    },
    {
        "icon": "corner",
        "label": "Corner",
        "search": [
            "Not Sign",
            "angle",
            "not"
        ]
    },
    {
        "icon": "virus",
        "label": "Virus",
        "search": [
            "bug",
            "coronavirus",
            "covid-19",
            "flu",
            "health",
            "infection",
            "pandemic",
            "sick",
            "vaccine",
            "viral"
        ]
    },
    {
        "icon": "gem",
        "label": "Gem",
        "search": [
            "diamond",
            "gem",
            "gem stone",
            "jewel",
            "jewelry",
            "sapphire",
            "stone",
            "treasure"
        ]
    },
    {
        "icon": "asymmetrik",
        "label": "Asymmetrik, Ltd.",
        "search": []
    },
    {
        "icon": "toilet",
        "label": "Toilet",
        "search": [
            "bathroom",
            "flush",
            "john",
            "loo",
            "pee",
            "plumbing",
            "poop",
            "porcelain",
            "potty",
            "restroom",
            "throne",
            "toile",
            "toilet",
            "washroom",
            "waste",
            "wc"
        ]
    },
    {
        "icon": "phabricator",
        "label": "Phabricator",
        "search": []
    },
    {
        "icon": "burger-fries",
        "label": "Burger Fries",
        "search": [
            "chips",
            "fast food",
            "french fries",
            "junk food",
            "sandwich",
            "takeout"
        ]
    },
    {
        "icon": "paperclip-vertical",
        "label": "Paperclip Vertical",
        "search": [
            "attach",
            "attachment",
            "connect",
            "link"
        ]
    },
    {
        "icon": "shirt-long-sleeve",
        "label": "Shirt Long Sleeve",
        "search": [
            "blouse",
            "sweater"
        ]
    },
    {
        "icon": "handshake-simple",
        "label": "Handshake Simple",
        "search": [
            "agreement",
            "greeting",
            "hand",
            "handshake",
            "meeting",
            "partnership",
            "shake"
        ]
    },
    {
        "icon": "trash-can-check",
        "label": "Trash Can Check",
        "search": [
            "confirm",
            "delete",
            "enable",
            "garbage",
            "hide",
            "remove",
            "validate",
            "working"
        ]
    },
    {
        "icon": "money-bills",
        "label": "Money Bills",
        "search": [
            "atm",
            "cash",
            "investment",
            "money",
            "moolah",
            "premium",
            "revenue",
            "salary"
        ]
    },
    {
        "icon": "bots",
        "label": "Bots",
        "search": []
    },
    {
        "icon": "car-circle-bolt",
        "label": "Car Circle Bolt",
        "search": [
            "auto",
            "automobile",
            "electric",
            "ev",
            "sedan",
            "tesla",
            "transportation",
            "travel",
            "vehicle"
        ]
    },
    {
        "icon": "tablet-button",
        "label": "Tablet Button",
        "search": [
            "apple",
            "device",
            "ipad",
            "kindle",
            "screen"
        ]
    },
    {
        "icon": "square-arrow-down-left",
        "label": "Square Arrow Down Left",
        "search": [
            "diagonal"
        ]
    },
    {
        "icon": "vine",
        "label": "Vine",
        "search": []
    },
    {
        "icon": "bulldozer",
        "label": "Bulldozer",
        "search": [
            "dirt",
            "earth",
            "mover"
        ]
    },
    {
        "icon": "calendar-pen",
        "label": "Calendar Pen",
        "search": [
            "date",
            "day",
            "edit",
            "event",
            "modify",
            "month",
            "pen",
            "pencil",
            "schedule",
            "time",
            "update",
            "when",
            "write",
            "year"
        ]
    },
    {
        "icon": "bell-on",
        "label": "Bell On",
        "search": [
            "Ringing Bell",
            "alarm",
            "alert",
            "chime",
            "notification",
            "reminder",
            "request"
        ]
    },
    {
        "icon": "excavator",
        "label": "Excavator",
        "search": [
            "construction",
            "dig",
            "digger",
            "dirt",
            "earth"
        ]
    },
    {
        "icon": "rectangle-xmark",
        "label": "Rectangle Xmark",
        "search": [
            "browser",
            "cancel",
            "computer",
            "development",
            "uncheck"
        ]
    },
    {
        "icon": "wrench",
        "label": "Wrench",
        "search": [
            "configuration",
            "construction",
            "equipment",
            "fix",
            "mechanic",
            "modify",
            "plumbing",
            "settings",
            "spanner",
            "tool",
            "update",
            "wrench"
        ]
    },
    {
        "icon": "message-slash",
        "label": "Message Slash",
        "search": [
            "answer",
            "bubble",
            "cancel",
            "chat",
            "commenting",
            "conversation",
            "disabled",
            "feedback",
            "message",
            "mute",
            "note",
            "notification",
            "quiet",
            "sms",
            "speech",
            "texting"
        ]
    },
    {
        "icon": "mace",
        "label": "Mace",
        "search": [
            "Dungeons & Dragons",
            "d&d",
            "dnd",
            "fantasy",
            "melee attack",
            "weapon",
            "windu"
        ]
    },
    {
        "icon": "medrt",
        "label": "MRT",
        "search": []
    },
    {
        "icon": "osi",
        "label": "Open Source Initiative",
        "search": []
    },
    {
        "icon": "watch",
        "label": "Watch",
        "search": [
            "alert",
            "clock",
            "time",
            "watch",
            "wristwatch"
        ]
    },
    {
        "icon": "tally-1",
        "label": "Tally 1",
        "search": [
            "calculate",
            "count",
            "hash",
            "number"
        ]
    },
    {
        "icon": "trash-can",
        "label": "Trash Can",
        "search": [
            "delete",
            "garbage",
            "hide",
            "remove",
            "trash-o"
        ]
    },
    {
        "icon": "puzzle",
        "label": "Puzzle",
        "search": [
            "add-on",
            "addon",
            "clue",
            "game",
            "interlocking",
            "jigsaw",
            "piece",
            "puzzle",
            "puzzle piece",
            "section"
        ]
    },
    {
        "icon": "table-cells",
        "label": "Table Cells",
        "search": [
            "blocks",
            "boxes",
            "category",
            "excel",
            "grid",
            "spreadsheet",
            "squares"
        ]
    },
    {
        "icon": "trash-can-list",
        "label": "Trash Can List",
        "search": [
            "cheatsheet",
            "delete",
            "garbage",
            "hide",
            "remove"
        ]
    },
    {
        "icon": "ribbon",
        "label": "Ribbon",
        "search": [
            "badge",
            "cause",
            "celebration",
            "lapel",
            "pin",
            "reminder",
            "reminder ribbon",
            "ribbon"
        ]
    },
    {
        "icon": "landmark-flag",
        "label": "Landmark Flag",
        "search": [
            "capitol",
            "flag",
            "landmark",
            "memorial"
        ]
    },
    {
        "icon": "badminton",
        "label": "Badminton",
        "search": [
            "badminton",
            "birdie",
            "game",
            "racquet",
            "shuttlecock"
        ]
    },
    {
        "icon": "gg",
        "label": "GG Currency",
        "search": []
    },
    {
        "icon": "buysellads",
        "label": "BuySellAds",
        "search": []
    },
    {
        "icon": "up-to-bracket",
        "label": "Up To Bracket",
        "search": [
            "enter",
            "share",
            "transfer",
            "upload"
        ]
    },
    {
        "icon": "chart-line-up-down",
        "label": "Chart Line Up Down",
        "search": [
            "chart",
            "chart increasing",
            "decreasing",
            "down",
            "graph",
            "growth",
            "track",
            "trend",
            "upward",
            "volatility"
        ]
    },
    {
        "icon": "up-down-left-right",
        "label": "Up Down Left Right",
        "search": [
            "arrow",
            "arrows",
            "bigger",
            "enlarge",
            "expand",
            "fullscreen",
            "move",
            "position",
            "reorder",
            "resize"
        ]
    },
    {
        "icon": "google-plus",
        "label": "Google Plus",
        "search": [
            "google-plus-circle",
            "google-plus-official"
        ]
    },
    {
        "icon": "car-side",
        "label": "Car Side",
        "search": [
            "auto",
            "automobile",
            "car",
            "sedan",
            "transportation",
            "travel",
            "vehicle"
        ]
    },
    {
        "icon": "screenpal",
        "label": "Screenpal",
        "search": []
    },
    {
        "icon": "trash-arrow-up",
        "label": "Trash Arrow Up",
        "search": [
            "back",
            "control z",
            "delete",
            "garbage",
            "hide",
            "oops",
            "remove",
            "undo",
            "upgrade"
        ]
    },
    {
        "icon": "life-ring",
        "label": "Life Ring",
        "search": [
            "coast guard",
            "help",
            "overboard",
            "save",
            "support"
        ]
    },
    {
        "icon": "copyright",
        "label": "Copyright",
        "search": [
            "brand",
            "c",
            "copyright",
            "mark",
            "register",
            "trademark"
        ]
    },
    {
        "icon": "leafy-green",
        "label": "Leafy Green",
        "search": [
            "bok choy",
            "cabbage",
            "kale",
            "leafy green",
            "lettuce"
        ]
    },
    {
        "icon": "highlighter-line",
        "label": "Highlighter Line",
        "search": [
            "highlight",
            "marker",
            "select"
        ]
    },
    {
        "icon": "rectangle-history-circle-user",
        "label": "Rectangle History Circle User",
        "search": [
            "album",
            "carousel",
            "collection",
            "gallery",
            "history",
            "multiple",
            "project",
            "shared",
            "uer",
            "user",
            "windows"
        ]
    },
    {
        "icon": "ferris-wheel",
        "label": "Ferris Wheel",
        "search": [
            "amusement park",
            "fair",
            "ferris",
            "ferris wheel",
            "ride",
            "theme park",
            "wheel"
        ]
    },
    {
        "icon": "arrow-up-from-arc",
        "label": "Arrow Up From Arc",
        "search": [
            "import",
            "share",
            "transfer",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "grid-dividers",
        "label": "Grid Dividers",
        "search": [
            "app",
            "collection",
            "grid",
            "grid",
            "line",
            "square"
        ]
    },
    {
        "icon": "lightbulb-dollar",
        "label": "Lightbulb Dollar",
        "search": [
            "energy",
            "idea",
            "inspiration",
            "light",
            "money"
        ]
    },
    {
        "icon": "coffin",
        "label": "Coffin",
        "search": [
            "box",
            "burial",
            "casket",
            "cemetery",
            "coffin",
            "death",
            "eulogy",
            "funeral",
            "halloween",
            "vampire"
        ]
    },
    {
        "icon": "bitcoin",
        "label": "Bitcoin",
        "search": []
    },
    {
        "icon": "file-prescription",
        "label": "File Prescription",
        "search": [
            "document",
            "drugs",
            "medical",
            "medicine",
            "rx"
        ]
    },
    {
        "icon": "eraser",
        "label": "Eraser",
        "search": [
            "art",
            "delete",
            "remove",
            "rubber"
        ]
    },
    {
        "icon": "flask-round-poison",
        "label": "Flask Round Poison",
        "search": [
            "beaker",
            "beverage",
            "chemicals",
            "container",
            "drink",
            "experiment",
            "experimental",
            "halloween",
            "health",
            "holiday",
            "labs",
            "liquid",
            "potion",
            "power",
            "science",
            "vial"
        ]
    },
    {
        "icon": "square-t",
        "label": "Square T",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "space-station-moon-construction",
        "label": "Space Station Moon Construction",
        "search": [
            "death star",
            "empire",
            "kyber crystal",
            "laser",
            "not a moon",
            "star wars",
            "under construction"
        ]
    },
    {
        "icon": "swift",
        "label": "Swift",
        "search": []
    },
    {
        "icon": "basketball-hoop",
        "label": "Basketball Hoop",
        "search": [
            "backboard",
            "dunk",
            "hoop",
            "nba"
        ]
    },
    {
        "icon": "code-simple",
        "label": "Code Simple",
        "search": [
            "code",
            "computer",
            "developer"
        ]
    },
    {
        "icon": "files-pinwheel",
        "label": "Files Pinwheel",
        "search": []
    },
    {
        "icon": "hockey-stick-puck",
        "label": "Hockey Stick Puck",
        "search": [
            "game",
            "hockey",
            "ice",
            "ice hockey",
            "nhl",
            "puck",
            "sport",
            "stick"
        ]
    },
    {
        "icon": "hourglass-start",
        "label": "Hourglass Start",
        "search": [
            "hour",
            "minute",
            "sand",
            "stopwatch",
            "time",
            "waiting"
        ]
    },
    {
        "icon": "circle-left",
        "label": "Circle Left",
        "search": [
            "arrow-circle-o-left",
            "back",
            "previous"
        ]
    },
    {
        "icon": "restroom-simple",
        "label": "Restroom Simple",
        "search": [
            "WC",
            "bathroom",
            "lavatory",
            "restroom",
            "toilet",
            "uer",
            "water closet",
            "wc"
        ]
    },
    {
        "icon": "cruzeiro-sign",
        "label": "Cruzeiro Sign",
        "search": [
            "Cruzeiro Sign",
            "currency"
        ]
    },
    {
        "icon": "smoking",
        "label": "Smoking",
        "search": [
            "cancer",
            "cigarette",
            "nicotine",
            "smoking",
            "smoking status",
            "tobacco"
        ]
    },
    {
        "icon": "chart-pie-simple-circle-dollar",
        "label": "Chart Pie Simple Circle Dollar",
        "search": [
            "analytics",
            "chart",
            "currency",
            "diagram",
            "graph",
            "margin",
            "money",
            "pie"
        ]
    },
    {
        "icon": "user-vneck-hair",
        "label": "User Vneck Hair",
        "search": [
            "bust",
            "bust in silhouette",
            "person",
            "profile",
            "silhouette",
            "uer"
        ]
    },
    {
        "icon": "square-poll-vertical",
        "label": "Square Poll Vertical",
        "search": [
            "chart",
            "graph",
            "results",
            "revenue",
            "statistics",
            "survey",
            "trend",
            "vote",
            "voting"
        ]
    },
    {
        "icon": "person-circle-minus",
        "label": "Person Circle Minus",
        "search": [
            "delete",
            "remove",
            "uer"
        ]
    },
    {
        "icon": "envelope-open-dollar",
        "label": "Envelope Open Dollar",
        "search": [
            "e-mail",
            "email",
            "letter",
            "mail",
            "message",
            "money",
            "newsletter",
            "notification",
            "offer",
            "pay",
            "revenue",
            "salary",
            "transfer"
        ]
    },
    {
        "icon": "biohazard",
        "label": "Biohazard",
        "search": [
            "biohazard",
            "covid-19",
            "danger",
            "dangerous",
            "epidemic",
            "hazmat",
            "medical",
            "pandemic",
            "radioactive",
            "sign",
            "toxic",
            "waste",
            "zombie"
        ]
    },
    {
        "icon": "objects-align-bottom",
        "label": "Objects Align Bottom",
        "search": [
            "align",
            "distribute",
            "line",
            "rectangles"
        ]
    },
    {
        "icon": "scroll-old",
        "label": "Scroll Old",
        "search": [
            "Dungeons & Dragons",
            "ancient",
            "announcement",
            "d&d",
            "dnd",
            "fantasy",
            "paper",
            "relic",
            "scholar",
            "script",
            "worn"
        ]
    },
    {
        "icon": "bell-concierge",
        "label": "Bell Concierge",
        "search": [
            "attention",
            "bell",
            "bellhop",
            "bellhop bell",
            "hotel",
            "receptionist",
            "request",
            "service",
            "support"
        ]
    },
    {
        "icon": "ruler-horizontal",
        "label": "Ruler Horizontal",
        "search": [
            "design",
            "draft",
            "length",
            "measure",
            "planning"
        ]
    },
    {
        "icon": "horse",
        "label": "Horse",
        "search": [
            "equestrian",
            "equus",
            "fauna",
            "horse",
            "mammmal",
            "mare",
            "neigh",
            "pony",
            "racehorse",
            "racing"
        ]
    },
    {
        "icon": "angle-90",
        "label": "Angle 90",
        "search": [
            "Right Angle with Arc",
            "measure",
            "right angle"
        ]
    },
    {
        "icon": "down-to-bracket",
        "label": "Down To Bracket",
        "search": [
            "download",
            "enter",
            "insert",
            "save",
            "share",
            "transfer"
        ]
    },
    {
        "icon": "book-copy",
        "label": "Book Copy",
        "search": [
            "knowledge",
            "library",
            "research"
        ]
    },
    {
        "icon": "laravel",
        "label": "Laravel",
        "search": []
    },
    {
        "icon": "wpforms",
        "label": "WPForms",
        "search": []
    },
    {
        "icon": "calendar",
        "label": "Calendar",
        "search": [
            "calendar",
            "calendar-o",
            "date",
            "day",
            "event",
            "month",
            "schedule",
            "tear-off calendar",
            "time",
            "when",
            "year"
        ]
    },
    {
        "icon": "hands-holding-child",
        "label": "Hands Holding Child",
        "search": [
            "care",
            "give",
            "help",
            "hold",
            "parent",
            "protect"
        ]
    },
    {
        "icon": "speaker-deck",
        "label": "Speaker Deck",
        "search": []
    },
    {
        "icon": "flickr",
        "label": "Flickr",
        "search": []
    },
    {
        "icon": "poll-people",
        "label": "Poll People",
        "search": [
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "cc-visa",
        "label": "Visa Credit Card",
        "search": []
    },
    {
        "icon": "bracket-round",
        "label": "Bracket Round",
        "search": [
            "Left Parenthesis",
            "parentheses"
        ]
    },
    {
        "icon": "user-large-slash",
        "label": "User Large Slash",
        "search": [
            "disabled",
            "disconnect",
            "employee",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "truck-container",
        "label": "Truck Container",
        "search": [
            "cargo",
            "crate",
            "delivery",
            "maintenance",
            "shipping",
            "vehicle"
        ]
    },
    {
        "icon": "eye-evil",
        "label": "Eye Evil",
        "search": [
            "Dungeons & Dragons",
            "d&d",
            "dnd",
            "fantasy",
            "sauron",
            "see",
            "seen",
            "show",
            "sight"
        ]
    },
    {
        "icon": "upwork",
        "label": "Upwork",
        "search": []
    },
    {
        "icon": "border-inner",
        "label": "Border Inner",
        "search": [
            "cell",
            "grid",
            "outline",
            "stroke",
            "table"
        ]
    },
    {
        "icon": "italic",
        "label": "Italic",
        "search": [
            "edit",
            "emphasis",
            "font",
            "format",
            "text",
            "type"
        ]
    },
    {
        "icon": "down-to-line",
        "label": "Down To Line",
        "search": [
            "download",
            "export",
            "insert",
            "transfer"
        ]
    },
    {
        "icon": "cloud-binary",
        "label": "Cloud Binary",
        "search": [
            "binary",
            "cloud",
            "data",
            "data",
            "infrastructure",
            "programming",
            "upload"
        ]
    },
    {
        "icon": "card-club",
        "label": "Card Club",
        "search": [
            "ace",
            "card",
            "gamble",
            "playing card",
            "poker",
            "suit"
        ]
    },
    {
        "icon": "light-switch-on",
        "label": "Light Switch On",
        "search": [
            "light",
            "off",
            "on"
        ]
    },
    {
        "icon": "khanda",
        "label": "Khanda",
        "search": [
            "Adi Shakti",
            "chakkar",
            "sikh",
            "sikhism",
            "sword"
        ]
    },
    {
        "icon": "face-frown-open",
        "label": "Face Frown Open",
        "search": [
            "disapprove",
            "emoticon",
            "face",
            "frown",
            "frowning face with open mouth",
            "mouth",
            "open",
            "rating",
            "sad"
        ]
    },
    {
        "icon": "check",
        "label": "Check",
        "search": [
            "Check Mark",
            "accept",
            "agree",
            "check",
            "check mark",
            "checkmark",
            "confirm",
            "correct",
            "coupon",
            "done",
            "enable",
            "mark",
            "notice",
            "notification",
            "notify",
            "ok",
            "select",
            "success",
            "tick",
            "todo",
            "true",
            "validate",
            "working",
            "yes",
            "✓"
        ]
    },
    {
        "icon": "bow-arrow",
        "label": "Bow Arrow",
        "search": [
            "Dungeons & Dragons",
            "Sagittarius",
            "archer",
            "archery",
            "arrow",
            "bow",
            "bow and arrow",
            "d&d",
            "dnd",
            "fantasy",
            "legolas",
            "ranged attack",
            "ranger",
            "weapon",
            "zodiac"
        ]
    },
    {
        "icon": "ban-bug",
        "label": "Ban Bug",
        "search": [
            "deny",
            "disabled",
            "error",
            "fix",
            "glitch",
            "optimize",
            "repair",
            "warning"
        ]
    },
    {
        "icon": "arrow-down-from-dotted-line",
        "label": "Arrow Down From Dotted Line",
        "search": [
            "download",
            "export",
            "transfer"
        ]
    },
    {
        "icon": "fingerprint",
        "label": "Fingerprint",
        "search": [
            "human",
            "id",
            "identification",
            "lock",
            "privacy",
            "smudge",
            "touch",
            "unique",
            "unlock"
        ]
    },
    {
        "icon": "bowl-scoop",
        "label": "Bowl Scoop",
        "search": [
            "dessert",
            "ice cream",
            "scoop",
            "shaved ice",
            "sherbert",
            "sherbet",
            "sorbet"
        ]
    },
    {
        "icon": "charging-station",
        "label": "Charging Station",
        "search": [
            "electric",
            "ev",
            "tesla",
            "vehicle"
        ]
    },
    {
        "icon": "plane-up-slash",
        "label": "Plane Up Slash",
        "search": [
            "airplane",
            "airport",
            "disabled",
            "internet",
            "signal",
            "sky",
            "wifi",
            "wireless"
        ]
    },
    {
        "icon": "user-lock",
        "label": "User Lock",
        "search": [
            "employee",
            "padlock",
            "privacy",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "mobile-screen-button",
        "label": "Mobile Screen Button",
        "search": [
            "apple",
            "call",
            "cell phone",
            "device",
            "iphone",
            "number",
            "screen",
            "telephone"
        ]
    },
    {
        "icon": "olive",
        "label": "Olive",
        "search": [
            "oil",
            "olive",
            "pimento",
            "pit"
        ]
    },
    {
        "icon": "anchor-circle-check",
        "label": "Anchor Circle Check",
        "search": [
            "enable",
            "marina",
            "not affected",
            "ok",
            "okay",
            "port",
            "validate",
            "working"
        ]
    },
    {
        "icon": "flutter",
        "label": "Flutter",
        "search": []
    },
    {
        "icon": "scalpel",
        "label": "Scalpel",
        "search": [
            "blade",
            "cut",
            "doctor",
            "knife",
            "surgeon",
            "surgery"
        ]
    },
    {
        "icon": "person-walking-with-cane",
        "label": "Person Walking With Cane",
        "search": [
            "blind",
            "cane",
            "follow",
            "uer"
        ]
    },
    {
        "icon": "buffer",
        "label": "Buffer",
        "search": []
    },
    {
        "icon": "candle-holder",
        "label": "Candle Holder",
        "search": [
            "candle",
            "fire",
            "flame",
            "halloween",
            "holiday",
            "hot",
            "light",
            "lit",
            "wick"
        ]
    },
    {
        "icon": "gratipay",
        "label": "Gratipay (Gittip)",
        "search": [
            "favorite",
            "heart",
            "like",
            "love"
        ]
    },
    {
        "icon": "file-waveform",
        "label": "File Waveform",
        "search": [
            "document",
            "health",
            "history",
            "prescription",
            "record"
        ]
    },
    {
        "icon": "face-spiral-eyes",
        "label": "Face Spiral Eyes",
        "search": [
            "disorient",
            "dizzy",
            "hypnosis",
            "hypnotize"
        ]
    },
    {
        "icon": "calendar-arrow-up",
        "label": "Calendar Arrow Up",
        "search": [
            "date",
            "day",
            "month",
            "reminder",
            "upgrade",
            "upload",
            "year"
        ]
    },
    {
        "icon": "person-dress-fairy",
        "label": "Person Dress Fairy",
        "search": [
            "elf",
            "faerie",
            "faery",
            "fairy",
            "fantasy",
            "magic",
            "sprite",
            "wings"
        ]
    },
    {
        "icon": "chart-kanban",
        "label": "Chart Kanban",
        "search": [
            "board",
            "chart",
            "graph",
            "kanban",
            "list",
            "organize",
            "project",
            "statistics"
        ]
    },
    {
        "icon": "toilet-paper-blank-under",
        "label": "Toilet Paper Blank Under",
        "search": [
            "bathroom",
            "lavatory",
            "privy",
            "restroom",
            "roll",
            "toilet",
            "wipe"
        ]
    },
    {
        "icon": "cloud-music",
        "label": "Cloud Music",
        "search": [
            "download",
            "music",
            "spotify",
            "streaming"
        ]
    },
    {
        "icon": "watch-smart",
        "label": "Watch Smart",
        "search": [
            "apps",
            "fitness",
            "time"
        ]
    },
    {
        "icon": "google-pay",
        "label": "Google Pay",
        "search": []
    },
    {
        "icon": "apple",
        "label": "Apple",
        "search": [
            "fruit",
            "ios",
            "mac",
            "operating system",
            "os",
            "osx"
        ]
    },
    {
        "icon": "left-to-bracket",
        "label": "Left To Bracket",
        "search": [
            "enter",
            "exit",
            "login"
        ]
    },
    {
        "icon": "grate-droplet",
        "label": "Grate Droplet",
        "search": [
            "drain",
            "manhole"
        ]
    },
    {
        "icon": "house-crack",
        "label": "House Crack",
        "search": [
            "building",
            "devastation",
            "disaster",
            "earthquake",
            "home",
            "insurance"
        ]
    },
    {
        "icon": "tumblr",
        "label": "Tumblr",
        "search": []
    },
    {
        "icon": "phoenix-squadron",
        "label": "Phoenix Squadron",
        "search": []
    },
    {
        "icon": "wifi-slash",
        "label": "Wifi Slash",
        "search": [
            "ban",
            "broken",
            "connection",
            "deny",
            "disabled",
            "disconnect",
            "hotspot",
            "internet",
            "network",
            "signal",
            "unavailable",
            "wireless",
            "www"
        ]
    },
    {
        "icon": "hat-wizard",
        "label": "Hat Wizard",
        "search": [
            "Dungeons & Dragons",
            "accessory",
            "buckle",
            "clothing",
            "d&d",
            "dnd",
            "fantasy",
            "halloween",
            "head",
            "holiday",
            "mage",
            "magic",
            "pointy",
            "witch"
        ]
    },
    {
        "icon": "football-helmet",
        "label": "Football Helmet",
        "search": [
            "ball",
            "concussion",
            "fall",
            "nfl",
            "pigskin",
            "protection",
            "seasonal"
        ]
    },
    {
        "icon": "user-doctor",
        "label": "User Doctor",
        "search": [
            "covid-19",
            "health",
            "job",
            "medical",
            "nurse",
            "occupation",
            "physician",
            "profile",
            "surgeon",
            "uer",
            "worker"
        ]
    },
    {
        "icon": "glasses-round",
        "label": "Glasses Round",
        "search": [
            "clothing",
            "eye",
            "eyeglasses",
            "eyewear",
            "glasses",
            "hipster",
            "nerd",
            "reading",
            "sight",
            "spectacles",
            "vision"
        ]
    },
    {
        "icon": "rocket-launch",
        "label": "Rocket Launch",
        "search": [
            "aircraft",
            "app",
            "ignition",
            "jet",
            "launch",
            "nasa",
            "rocket",
            "space",
            "thrusters"
        ]
    },
    {
        "icon": "hand-holding-circle-dollar",
        "label": "Hand Holding Circle Dollar",
        "search": [
            "carry",
            "coupon",
            "dollar sign",
            "donate",
            "donation",
            "giving",
            "investment",
            "money",
            "premium",
            "price",
            "revenue",
            "salary"
        ]
    },
    {
        "icon": "chart-bar",
        "label": "Chart Bar",
        "search": [
            "analytics",
            "bar",
            "chart",
            "graph",
            "performance",
            "statistics"
        ]
    },
    {
        "icon": "centercode",
        "label": "Centercode",
        "search": []
    },
    {
        "icon": "message-dollar",
        "label": "Message Dollar",
        "search": [
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "feedback",
            "message",
            "money",
            "note",
            "notification",
            "pay",
            "salary",
            "sms",
            "speech",
            "spend",
            "texting",
            "transfer"
        ]
    },
    {
        "icon": "debian",
        "label": "Debian",
        "search": []
    },
    {
        "icon": "spray-can-sparkles",
        "label": "Spray Can Sparkles",
        "search": [
            "car",
            "clean",
            "deodorize",
            "fresh",
            "pine",
            "scent"
        ]
    },
    {
        "icon": "mastodon",
        "label": "Mastodon",
        "search": []
    },
    {
        "icon": "baht-sign",
        "label": "Baht Sign",
        "search": [
            "currency"
        ]
    },
    {
        "icon": "face-beam-hand-over-mouth",
        "label": "Face Beam Hand Over Mouth",
        "search": [
            "awe",
            "face with hand over mouth",
            "realization",
            "shock",
            "sudden",
            "sudden realization",
            "surprise",
            "whoops"
        ]
    },
    {
        "icon": "temperature-arrow-up",
        "label": "Temperature Arrow Up",
        "search": [
            "air conditioner",
            "cold",
            "heater",
            "mercury",
            "thermometer",
            "winter"
        ]
    },
    {
        "icon": "sketch",
        "label": "Sketch",
        "search": [
            "app",
            "design",
            "interface"
        ]
    },
    {
        "icon": "web-awesome",
        "label": "Web Awesome",
        "search": [
            "awesome",
            "coding",
            "components",
            "crown",
            "web"
        ]
    },
    {
        "icon": "shield-slash",
        "label": "Shield Slash",
        "search": [
            "disabled",
            "protect",
            "remove",
            "safety"
        ]
    },
    {
        "icon": "floppy-disks",
        "label": "Floppy Disks",
        "search": [
            "save",
            "save as"
        ]
    },
    {
        "icon": "n",
        "label": "N",
        "search": [
            "Latin Capital Letter N",
            "Latin Small Letter N",
            "letter",
            "nay",
            "no"
        ]
    },
    {
        "icon": "arrows-up-down-left-right",
        "label": "Arrows Up Down Left Right",
        "search": [
            "arrow",
            "arrows",
            "bigger",
            "enlarge",
            "expand",
            "fullscreen",
            "move",
            "position",
            "reorder",
            "resize"
        ]
    },
    {
        "icon": "house",
        "label": "House",
        "search": [
            "abode",
            "building",
            "home",
            "house",
            "main",
            "residence"
        ]
    },
    {
        "icon": "spinner",
        "label": "Spinner",
        "search": [
            "circle",
            "loading",
            "pending",
            "progress"
        ]
    },
    {
        "icon": "square-y",
        "label": "Square Y",
        "search": [
            "letter",
            "yay",
            "yes"
        ]
    },
    {
        "icon": "gavel",
        "label": "Gavel",
        "search": [
            "hammer",
            "judge",
            "law",
            "lawyer",
            "opinion"
        ]
    },
    {
        "icon": "trash-clock",
        "label": "Trash Clock",
        "search": [
            "delay",
            "delete",
            "garbage",
            "hide",
            "remove"
        ]
    },
    {
        "icon": "circle-phone",
        "label": "Circle Phone",
        "search": [
            "answer",
            "call",
            "handset",
            "telephone"
        ]
    },
    {
        "icon": "bolt-auto",
        "label": "Bolt Auto",
        "search": [
            "automatic",
            "flash"
        ]
    },
    {
        "icon": "arrow-turn-left-down",
        "label": "Arrow Turn Left Down",
        "search": [
            "backwards",
            "direction",
            "down",
            "left",
            "reverse",
            "south",
            "turn"
        ]
    },
    {
        "icon": "ticket-simple",
        "label": "Ticket Simple",
        "search": [
            "admission",
            "coupon",
            "movie",
            "pass",
            "support",
            "ticket",
            "voucher"
        ]
    },
    {
        "icon": "dove",
        "label": "Dove",
        "search": [
            "bird",
            "dove",
            "fauna",
            "fly",
            "flying",
            "peace",
            "war"
        ]
    },
    {
        "icon": "circle-yen",
        "label": "Circle Yen",
        "search": [
            "coin",
            "currency",
            "yen sign"
        ]
    },
    {
        "icon": "sass",
        "label": "Sass",
        "search": []
    },
    {
        "icon": "tarp-droplet",
        "label": "Tarp Droplet",
        "search": [
            "protection",
            "tarp",
            "tent",
            "waterproof"
        ]
    },
    {
        "icon": "broom-wide",
        "label": "Broom Wide",
        "search": [
            "broom",
            "brush",
            "clean",
            "clear",
            "delete",
            "dust",
            "erase",
            "remove",
            "sweep",
            "witch"
        ]
    },
    {
        "icon": "play-pause",
        "label": "Play Pause",
        "search": [
            "arrow",
            "pause",
            "play",
            "play or pause button",
            "right",
            "stop",
            "triangle"
        ]
    },
    {
        "icon": "tree-city",
        "label": "Tree City",
        "search": [
            "building",
            "city",
            "urban"
        ]
    },
    {
        "icon": "calendar-range",
        "label": "Calendar Range",
        "search": [
            "date",
            "day",
            "month",
            "reminder",
            "year"
        ]
    },
    {
        "icon": "turn-up",
        "label": "Turn Up",
        "search": [
            "arrow",
            "level-up",
            "right arrow curving up"
        ]
    },
    {
        "icon": "credit-card-front",
        "label": "Credit Card Front",
        "search": [
            "buy",
            "checkout",
            "chip",
            "debit",
            "money",
            "payment",
            "purchase"
        ]
    },
    {
        "icon": "temperature-quarter",
        "label": "Temperature Quarter",
        "search": [
            "mercury",
            "status",
            "temperature"
        ]
    },
    {
        "icon": "chestnut",
        "label": "Chestnut",
        "search": [
            "nut",
            "plant"
        ]
    },
    {
        "icon": "crystal-ball",
        "label": "Crystal Ball",
        "search": [
            "ball",
            "crystal",
            "crystal ball",
            "fairy tale",
            "fantasy",
            "fortune",
            "future",
            "glass",
            "globe",
            "tool"
        ]
    },
    {
        "icon": "flag-swallowtail",
        "label": "Flag Swallowtail",
        "search": [
            "country",
            "notice",
            "notification",
            "notify",
            "pole",
            "report",
            "symbol"
        ]
    },
    {
        "icon": "sliders",
        "label": "Sliders",
        "search": [
            "adjust",
            "configuration",
            "modify",
            "settings",
            "sliders",
            "toggle"
        ]
    },
    {
        "icon": "person-sledding",
        "label": "Person Sledding",
        "search": [
            "fun",
            "slide",
            "uer",
            "winter"
        ]
    },
    {
        "icon": "mosque",
        "label": "Mosque",
        "search": [
            "Muslim",
            "building",
            "islam",
            "landmark",
            "mosque",
            "muslim",
            "religion"
        ]
    },
    {
        "icon": "folder-magnifying-glass",
        "label": "Folder Magnifying Glass",
        "search": [
            "file",
            "magnifier",
            "search"
        ]
    },
    {
        "icon": "link-horizontal",
        "label": "Link Horizontal",
        "search": [
            "attachment",
            "chain",
            "hotspot"
        ]
    },
    {
        "icon": "h",
        "label": "H",
        "search": [
            "Latin Capital Letter H",
            "Latin Small Letter H",
            "letter"
        ]
    },
    {
        "icon": "message-bot",
        "label": "Message Bot",
        "search": [
            "ai",
            "answer",
            "automated",
            "chat",
            "chatbot",
            "comment",
            "help",
            "support"
        ]
    },
    {
        "icon": "info",
        "label": "Info",
        "search": [
            "details",
            "help",
            "information",
            "more",
            "support"
        ]
    },
    {
        "icon": "person-walking",
        "label": "Person Walking",
        "search": [
            "crosswalk",
            "exercise",
            "follow",
            "hike",
            "move",
            "person walking",
            "uer",
            "walk",
            "walking",
            "workout"
        ]
    },
    {
        "icon": "square-whatsapp",
        "label": "Square Whatsapp",
        "search": []
    },
    {
        "icon": "radio-tuner",
        "label": "Radio Tuner",
        "search": [
            "am",
            "broadcast",
            "fm",
            "frequency",
            "music",
            "news",
            "receiver",
            "transmitter",
            "tuner"
        ]
    },
    {
        "icon": "computer-mouse-scrollwheel",
        "label": "Computer Mouse Scrollwheel",
        "search": [
            "click",
            "computer",
            "cursor",
            "input",
            "peripheral"
        ]
    },
    {
        "icon": "skype",
        "label": "Skype",
        "search": []
    },
    {
        "icon": "up-right",
        "label": "Up Right",
        "search": [
            "North East Black Arrow",
            "diagonal",
            "direction",
            "northeast"
        ]
    },
    {
        "icon": "angular",
        "label": "Angular",
        "search": []
    },
    {
        "icon": "circle-arrow-up-right",
        "label": "Circle Arrow Up Right",
        "search": [
            "diagonal",
            "northeast"
        ]
    },
    {
        "icon": "arrow-turn-down",
        "label": "Arrow Turn Down",
        "search": [
            "arrow"
        ]
    },
    {
        "icon": "road",
        "label": "Road",
        "search": [
            "highway",
            "map",
            "motorway",
            "pavement",
            "road",
            "route",
            "street",
            "travel"
        ]
    },
    {
        "icon": "buoy",
        "label": "Buoy",
        "search": [
            "anchor",
            "float",
            "hazard",
            "mooring",
            "nautical",
            "navigation",
            "warning",
            "water"
        ]
    },
    {
        "icon": "paintbrush-pencil",
        "label": "Paintbrush Pencil",
        "search": [
            "art",
            "creative",
            "modify"
        ]
    },
    {
        "icon": "file-cad",
        "label": "File Cad",
        "search": [
            "3d",
            "document",
            "drafting",
            "file",
            "vector"
        ]
    },
    {
        "icon": "people-pants-simple",
        "label": "People Pants Simple",
        "search": [
            "together",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "face-frown",
        "label": "Face Frown",
        "search": [
            "disapprove",
            "emoticon",
            "face",
            "frown",
            "frowning face",
            "rating",
            "sad",
            "uer"
        ]
    },
    {
        "icon": "wine-glass-empty",
        "label": "Wine Glass Empty",
        "search": [
            "alcohol",
            "beverage",
            "cabernet",
            "drink",
            "grapes",
            "merlot",
            "sauvignon"
        ]
    },
    {
        "icon": "clapperboard",
        "label": "Clapperboard",
        "search": [
            "camera",
            "clapper",
            "clapper board",
            "director",
            "film",
            "movie",
            "record"
        ]
    },
    {
        "icon": "oil-can-drip",
        "label": "Oil Can Drip",
        "search": [
            "grease",
            "oil",
            "petroleum"
        ]
    },
    {
        "icon": "phone-plus",
        "label": "Phone Plus",
        "search": [
            "add",
            "call",
            "earphone",
            "number",
            "positive",
            "support",
            "telephone",
            "voice"
        ]
    },
    {
        "icon": "forward-step",
        "label": "Forward Step",
        "search": [
            "end",
            "last",
            "next"
        ]
    },
    {
        "icon": "file-dashed-line",
        "label": "File Dashed Line",
        "search": [
            "begin",
            "divide",
            "edit",
            "end",
            "format",
            "split"
        ]
    },
    {
        "icon": "scribble",
        "label": "Scribble",
        "search": [
            "doodle",
            "draw",
            "line",
            "road",
            "scrawl",
            "switchback"
        ]
    },
    {
        "icon": "gauge-min",
        "label": "Gauge Min",
        "search": [
            "dashboard",
            "fast",
            "odometer",
            "speed",
            "speedometer"
        ]
    },
    {
        "icon": "square-up-right",
        "label": "Square Up Right",
        "search": [
            "arrow",
            "diagonal",
            "direction",
            "external-link-square",
            "intercardinal",
            "new",
            "northeast",
            "open",
            "share",
            "up-right arrow"
        ]
    },
    {
        "icon": "wifi-exclamation",
        "label": "Wifi Exclamation",
        "search": [
            "attention",
            "connection",
            "fail",
            "failed",
            "internet",
            "wireless",
            "www"
        ]
    },
    {
        "icon": "book-journal-whills",
        "label": "Book Journal Whills",
        "search": [
            "book",
            "force",
            "jedi",
            "sith",
            "star wars",
            "yoda"
        ]
    },
    {
        "icon": "octagon-minus",
        "label": "Octagon Minus",
        "search": [
            "delete",
            "hide",
            "negative",
            "remove",
            "shape",
            "trash"
        ]
    },
    {
        "icon": "champagne-glasses",
        "label": "Champagne Glasses",
        "search": [
            "alcohol",
            "bar",
            "beverage",
            "celebrate",
            "celebration",
            "champagne",
            "clink",
            "clinking glasses",
            "drink",
            "glass",
            "holiday",
            "new year's eve",
            "party",
            "toast"
        ]
    },
    {
        "icon": "folder-xmark",
        "label": "Folder Xmark",
        "search": [
            "archive",
            "delete",
            "directory",
            "document",
            "file",
            "remove",
            "uncheck",
            "x"
        ]
    },
    {
        "icon": "trash-list",
        "label": "Trash List",
        "search": [
            "cheatsheet",
            "delete",
            "garbage",
            "hide",
            "remove"
        ]
    },
    {
        "icon": "dumpster",
        "label": "Dumpster",
        "search": [
            "alley",
            "bin",
            "commercial",
            "trash",
            "waste"
        ]
    },
    {
        "icon": "circle-envelope",
        "label": "Circle Envelope",
        "search": [
            "email",
            "message",
            "send"
        ]
    },
    {
        "icon": "mobile-notch",
        "label": "Mobile Notch",
        "search": [
            "display",
            "iPhone X",
            "iphone",
            "smartphone"
        ]
    },
    {
        "icon": "opensuse",
        "label": "Opensuse",
        "search": []
    },
    {
        "icon": "mobile-signal",
        "label": "Mobile Signal",
        "search": [
            "android",
            "iphone",
            "nfc",
            "scan"
        ]
    },
    {
        "icon": "heart-circle-xmark",
        "label": "Heart Circle Xmark",
        "search": [
            "favorite",
            "heart",
            "love",
            "uncheck"
        ]
    },
    {
        "icon": "computer",
        "label": "Computer",
        "search": [
            "computer",
            "desktop",
            "display",
            "monitor",
            "tower"
        ]
    },
    {
        "icon": "wand-magic",
        "label": "Wand Magic",
        "search": [
            "autocomplete",
            "automatic",
            "mage",
            "magic",
            "spell",
            "wand",
            "witch",
            "wizard"
        ]
    },
    {
        "icon": "brain",
        "label": "Brain",
        "search": [
            "brain",
            "cerebellum",
            "gray matter",
            "intellect",
            "intelligent",
            "knowledge",
            "medulla oblongata",
            "mind",
            "noodle",
            "scholar",
            "wit"
        ]
    },
    {
        "icon": "dropbox",
        "label": "Dropbox",
        "search": []
    },
    {
        "icon": "people-pants",
        "label": "People Pants",
        "search": [
            "Gemini",
            "couple",
            "holding hands",
            "man",
            "men",
            "men holding hands",
            "together",
            "twins",
            "uer",
            "users-people",
            "zodiac"
        ]
    },
    {
        "icon": "deezer",
        "label": "Deezer",
        "search": []
    },
    {
        "icon": "briefcase-medical",
        "label": "Briefcase Medical",
        "search": [
            "doctor",
            "emt",
            "first aid",
            "health"
        ]
    },
    {
        "icon": "creative-commons-sampling",
        "label": "Creative Commons Sampling",
        "search": []
    },
    {
        "icon": "smoke",
        "label": "Smoke",
        "search": [
            "cloud",
            "fire",
            "fog",
            "haze"
        ]
    },
    {
        "icon": "jedi-order",
        "label": "Jedi Order",
        "search": [
            "star wars"
        ]
    },
    {
        "icon": "house-medical-circle-exclamation",
        "label": "House Medical Circle Exclamation",
        "search": [
            "affected",
            "clinic",
            "failed",
            "hospital"
        ]
    },
    {
        "icon": "face-monocle",
        "label": "Face Monocle",
        "search": [
            "face with monocle",
            "stuffy",
            "thinking",
            "wealthy"
        ]
    },
    {
        "icon": "line-columns",
        "label": "Line Columns",
        "search": [
            "divide",
            "organize",
            "panes",
            "split"
        ]
    },
    {
        "icon": "face-vomit",
        "label": "Face Vomit",
        "search": [
            "face vomiting",
            "flu",
            "poison",
            "sick",
            "spew",
            "throw up",
            "vomit"
        ]
    },
    {
        "icon": "person-dolly",
        "label": "Person Dolly",
        "search": [
            "carry",
            "deliver",
            "transport",
            "uer"
        ]
    },
    {
        "icon": "code-commit",
        "label": "Code Commit",
        "search": [
            "commit",
            "git",
            "github",
            "hash",
            "rebase",
            "svn",
            "vcs",
            "version"
        ]
    },
    {
        "icon": "person-breastfeeding",
        "label": "Person Breastfeeding",
        "search": [
            "baby",
            "child",
            "infant",
            "mother",
            "nutrition",
            "parent",
            "sustenance",
            "uer"
        ]
    },
    {
        "icon": "person-rays",
        "label": "Person Rays",
        "search": [
            "affected",
            "focus",
            "shine",
            "uer"
        ]
    },
    {
        "icon": "water-arrow-down",
        "label": "Water Arrow Down",
        "search": [
            "flood",
            "insert",
            "lake",
            "liquid",
            "ocean",
            "recede",
            "sea",
            "swim",
            "wet"
        ]
    },
    {
        "icon": "symbols",
        "label": "Symbols",
        "search": [
            "bolt",
            "category",
            "emoji",
            "heart",
            "image",
            "input",
            "input symbols",
            "music",
            "photo",
            "symbols",
            "〒♪&%"
        ]
    },
    {
        "icon": "chart-mixed-up-circle-currency",
        "label": "Chart Mixed Up Circle Currency",
        "search": [
            "analytics",
            "chart",
            "currency",
            "data",
            "forecast",
            "graph",
            "investment",
            "measure",
            "money",
            "roi",
            "tracking",
            "trend"
        ]
    },
    {
        "icon": "manat-sign",
        "label": "Manat Sign",
        "search": [
            "Manat Sign",
            "currency"
        ]
    },
    {
        "icon": "bag-seedling",
        "label": "Bag Seedling",
        "search": [
            "agriculture",
            "bag",
            "fertilizer",
            "garden",
            "grow",
            "plant",
            "sack",
            "seed"
        ]
    },
    {
        "icon": "sort",
        "label": "Sort",
        "search": [
            "filter",
            "order"
        ]
    },
    {
        "icon": "r-project",
        "label": "R Project",
        "search": []
    },
    {
        "icon": "instalod",
        "label": "InstaLOD",
        "search": []
    },
    {
        "icon": "circle-radiation",
        "label": "Circle Radiation",
        "search": [
            "danger",
            "dangerous",
            "deadly",
            "hazard",
            "nuclear",
            "radioactive",
            "sign",
            "warning"
        ]
    },
    {
        "icon": "canadian-maple-leaf",
        "label": "Canadian Maple Leaf",
        "search": [
            "canada",
            "flag",
            "flora",
            "nature",
            "plant"
        ]
    },
    {
        "icon": "laptop-code",
        "label": "Laptop Code",
        "search": [
            "computer",
            "cpu",
            "dell",
            "demo",
            "develop",
            "device",
            "fabook",
            "fb",
            "mac",
            "macbook",
            "machine",
            "mysql",
            "pc",
            "sql"
        ]
    },
    {
        "icon": "ethereum",
        "label": "Ethereum",
        "search": []
    },
    {
        "icon": "houzz",
        "label": "Houzz",
        "search": []
    },
    {
        "icon": "sink",
        "label": "Sink",
        "search": [
            "bathroom",
            "covid-19",
            "faucet",
            "kitchen",
            "wash"
        ]
    },
    {
        "icon": "arrow-up-from-water-pump",
        "label": "Arrow Up From Water Pump",
        "search": [
            "flood",
            "groundwater",
            "pump",
            "submersible",
            "sump pump",
            "upgrade"
        ]
    },
    {
        "icon": "microphone-lines-slash",
        "label": "Microphone Lines Slash",
        "search": [
            "audio",
            "disable",
            "disabled",
            "disconnect",
            "disconnect",
            "mute",
            "podcast",
            "record",
            "sing",
            "sound",
            "voice"
        ]
    },
    {
        "icon": "viber",
        "label": "Viber",
        "search": []
    },
    {
        "icon": "browser",
        "label": "Browser",
        "search": [
            "Desktop Window",
            "app",
            "application",
            "desktop",
            "explorer",
            "internet",
            "web",
            "website",
            "www"
        ]
    },
    {
        "icon": "face-sleepy",
        "label": "Face Sleepy",
        "search": [
            "bubble",
            "face",
            "sleep",
            "sleepy face",
            "snooze",
            "snot",
            "tear",
            "tired"
        ]
    },
    {
        "icon": "server",
        "label": "Server",
        "search": [
            "computer",
            "cpu",
            "database",
            "hardware",
            "mysql",
            "network",
            "sql"
        ]
    },
    {
        "icon": "kickstarter",
        "label": "Kickstarter",
        "search": []
    },
    {
        "icon": "user",
        "label": "User",
        "search": [
            "adult",
            "bust",
            "bust in silhouette",
            "default",
            "employee",
            "gender-neutral",
            "person",
            "profile",
            "silhouette",
            "uer",
            "unspecified gender",
            "username",
            "users-people"
        ]
    },
    {
        "icon": "signal-bars",
        "label": "Signal Bars",
        "search": [
            "bars",
            "graph",
            "online",
            "reception",
            "status"
        ]
    },
    {
        "icon": "starship-freighter",
        "label": "Starship Freighter",
        "search": [
            "chewbacca",
            "han solo",
            "millenium falcon",
            "rebel",
            "spaceship",
            "star wars",
            "yt-1300"
        ]
    },
    {
        "icon": "spotify",
        "label": "Spotify",
        "search": []
    },
    {
        "icon": "snowflake",
        "label": "Snowflake",
        "search": [
            "Heavy Chevron Snowflake",
            "cold",
            "precipitation",
            "rain",
            "snow",
            "snowfall",
            "snowflake",
            "winter"
        ]
    },
    {
        "icon": "dial-med",
        "label": "Dial Med",
        "search": [
            "dial",
            "level"
        ]
    },
    {
        "icon": "skull-crossbones",
        "label": "Skull Crossbones",
        "search": [
            "Black Skull and Crossbones",
            "Dungeons & Dragons",
            "alert",
            "bones",
            "crossbones",
            "d&d",
            "danger",
            "dangerous area",
            "dead",
            "deadly",
            "death",
            "dnd",
            "face",
            "fantasy",
            "halloween",
            "holiday",
            "jolly-roger",
            "monster",
            "pirate",
            "poison",
            "skeleton",
            "skull",
            "skull and crossbones",
            "warning"
        ]
    },
    {
        "icon": "peso-sign",
        "label": "Peso Sign",
        "search": [
            "Peso Sign",
            "currency"
        ]
    },
    {
        "icon": "leanpub",
        "label": "Leanpub",
        "search": []
    },
    {
        "icon": "wine-glass",
        "label": "Wine Glass",
        "search": [
            "alcohol",
            "bar",
            "beverage",
            "cabernet",
            "drink",
            "glass",
            "grapes",
            "merlot",
            "sauvignon",
            "wine",
            "wine glass"
        ]
    },
    {
        "icon": "temperature-half",
        "label": "Temperature Half",
        "search": [
            "mercury",
            "status",
            "temperature",
            "thermometer",
            "weather"
        ]
    },
    {
        "icon": "chart-tree-map",
        "label": "Chart Tree Map",
        "search": [
            "collection",
            "grid",
            "performance"
        ]
    },
    {
        "icon": "ticket",
        "label": "Ticket",
        "search": [
            "admission",
            "admission tickets",
            "coupon",
            "movie",
            "pass",
            "support",
            "ticket",
            "voucher"
        ]
    },
    {
        "icon": "java",
        "label": "Java",
        "search": []
    },
    {
        "icon": "nfc-symbol",
        "label": "Nfc Symbol",
        "search": [
            "connect",
            "data",
            "near field communication",
            "nfc",
            "scan",
            "signal",
            "transfer",
            "wireless"
        ]
    },
    {
        "icon": "tire-rugged",
        "label": "Tire Rugged",
        "search": [
            "auto",
            "car",
            "offroad",
            "rim",
            "rubber",
            "wheel"
        ]
    },
    {
        "icon": "wheat-awn-circle-exclamation",
        "label": "Wheat Awn Circle Exclamation",
        "search": [
            "affected",
            "failed",
            "famine",
            "food",
            "gluten",
            "hunger",
            "starve",
            "straw"
        ]
    },
    {
        "icon": "circle-l",
        "label": "Circle L",
        "search": [
            "Circled Latin Capital Letter L",
            "letter"
        ]
    },
    {
        "icon": "arrows-turn-right",
        "label": "Arrows Turn Right",
        "search": [
            "arrows"
        ]
    },
    {
        "icon": "route-interstate",
        "label": "Route Interstate",
        "search": [
            "directions",
            "highway",
            "interstate",
            "navigation",
            "sign",
            "travel"
        ]
    },
    {
        "icon": "candy-cane",
        "label": "Candy Cane",
        "search": [
            "candy",
            "christmas",
            "holiday",
            "mint",
            "peppermint",
            "striped",
            "xmas"
        ]
    },
    {
        "icon": "circle-6",
        "label": "Circle 6",
        "search": [
            "Circled Digit Six",
            "Dingbat Circled Sans-Serif Digit Six",
            "Dingbat Negative Circled Digit Six",
            "Dingbat Negative Circled Sans-Serif Digit Six",
            "six"
        ]
    },
    {
        "icon": "citrus",
        "label": "Citrus",
        "search": [
            "fruit",
            "grapefruit",
            "juice",
            "mandarin",
            "orange",
            "tangerine"
        ]
    },
    {
        "icon": "wheelchair",
        "label": "Wheelchair",
        "search": [
            "disabled",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "expand-wide",
        "label": "Expand Wide",
        "search": [
            "arrows",
            "bigger",
            "enlarge",
            "expand",
            "fullscreen",
            "maximize",
            "resize",
            "resize",
            "scale",
            "size",
            "viewfinder"
        ]
    },
    {
        "icon": "spell-check",
        "label": "Spell Check",
        "search": [
            "dictionary",
            "edit",
            "editor",
            "enable",
            "grammar",
            "text",
            "validate",
            "working"
        ]
    },
    {
        "icon": "turn-down-right",
        "label": "Turn Down Right",
        "search": [
            "forward",
            "move"
        ]
    },
    {
        "icon": "volume-off",
        "label": "Volume Off",
        "search": [
            "audio",
            "ban",
            "music",
            "mute",
            "quiet",
            "silent",
            "sound"
        ]
    },
    {
        "icon": "saxophone",
        "label": "Saxophone",
        "search": [
            "brass",
            "instrument",
            "jazz",
            "music",
            "sax",
            "saxophone",
            "woodwind"
        ]
    },
    {
        "icon": "sensor-triangle-exclamation",
        "label": "Sensor Triangle Exclamation",
        "search": [
            "alarm",
            "alert",
            "carbon monoxide",
            "detector",
            "failed",
            "fire",
            "smoke"
        ]
    },
    {
        "icon": "lungs",
        "label": "Lungs",
        "search": [
            "air",
            "breath",
            "covid-19",
            "exhalation",
            "inhalation",
            "lungs",
            "organ",
            "respiration",
            "respiratory"
        ]
    },
    {
        "icon": "car-wrench",
        "label": "Car Wrench",
        "search": [
            "auto",
            "automobile",
            "mechanic",
            "repair",
            "sedan",
            "transportation",
            "vehicle"
        ]
    },
    {
        "icon": "popsicle",
        "label": "Popsicle",
        "search": [
            "dessert",
            "frozen",
            "ice lolly",
            "lollipop",
            "lolly",
            "popsicle",
            "sweet"
        ]
    },
    {
        "icon": "bookmark",
        "label": "Bookmark",
        "search": [
            "bookmark",
            "favorite",
            "library",
            "mark",
            "marker",
            "read",
            "remember",
            "research",
            "save"
        ]
    },
    {
        "icon": "barcode",
        "label": "Barcode",
        "search": [
            "info",
            "laser",
            "price",
            "scan",
            "upc"
        ]
    },
    {
        "icon": "wheat-awn-slash",
        "label": "Wheat Awn Slash",
        "search": [
            "disabled",
            "gluten",
            "gluten free",
            "wheat"
        ]
    },
    {
        "icon": "list-ol",
        "label": "List Ol",
        "search": [
            "cheatsheet",
            "checklist",
            "completed",
            "done",
            "finished",
            "numbers",
            "ol",
            "summary",
            "todo",
            "ul"
        ]
    },
    {
        "icon": "typewriter",
        "label": "Typewriter",
        "search": [
            "keyboard",
            "letterpress",
            "movable type",
            "newspaper",
            "novel",
            "retro",
            "typing",
            "vintage",
            "writing"
        ]
    },
    {
        "icon": "file-circle-xmark",
        "label": "File Circle Xmark",
        "search": [
            "document",
            "file",
            "paper",
            "uncheck"
        ]
    },
    {
        "icon": "inbox-out",
        "label": "Inbox Out",
        "search": [
            "archive",
            "box",
            "desk",
            "email",
            "letter",
            "mail",
            "message",
            "newsletter",
            "offer",
            "outbox",
            "outbox tray",
            "sent",
            "tray",
            "upgrade"
        ]
    },
    {
        "icon": "cube",
        "label": "Cube",
        "search": [
            "3d",
            "block",
            "dice",
            "package",
            "square",
            "tesseract"
        ]
    },
    {
        "icon": "tape",
        "label": "Tape",
        "search": [
            "design",
            "package",
            "sticky"
        ]
    },
    {
        "icon": "bomb",
        "label": "Bomb",
        "search": [
            "bomb",
            "comic",
            "error",
            "explode",
            "fuse",
            "grenade",
            "warning"
        ]
    },
    {
        "icon": "camera-web",
        "label": "Camera Web",
        "search": [
            "chat",
            "conference call",
            "facetime",
            "podcast",
            "video",
            "videoconferencing",
            "youtube"
        ]
    },
    {
        "icon": "lacrosse-stick",
        "label": "Lacrosse Stick",
        "search": [
            "lacrosse"
        ]
    },
    {
        "icon": "display-chart-up",
        "label": "Display Chart Up",
        "search": [
            "analytics",
            "chart",
            "computer",
            "display",
            "exchange",
            "graph",
            "investment",
            "measure",
            "monitor",
            "roi",
            "tracking",
            "trading",
            "trend"
        ]
    },
    {
        "icon": "trash-slash",
        "label": "Trash Slash",
        "search": [
            "delete",
            "disabled",
            "garbage",
            "hide",
            "remove"
        ]
    },
    {
        "icon": "sd-cards",
        "label": "Sd Cards",
        "search": [
            "memory",
            "storage"
        ]
    },
    {
        "icon": "wodu",
        "label": "Wodu",
        "search": []
    },
    {
        "icon": "scale-unbalanced",
        "label": "Scale Unbalanced",
        "search": [
            "justice",
            "legal",
            "measure",
            "unbalanced",
            "weight"
        ]
    },
    {
        "icon": "book-circle-arrow-right",
        "label": "Book Circle Arrow Right",
        "search": [
            "library",
            "research"
        ]
    },
    {
        "icon": "square-caret-left",
        "label": "Square Caret Left",
        "search": [
            "arrow",
            "back",
            "caret-square-o-left",
            "previous",
            "triangle"
        ]
    },
    {
        "icon": "ruler",
        "label": "Ruler",
        "search": [
            "design",
            "draft",
            "length",
            "measure",
            "planning",
            "ruler",
            "straight edge",
            "straight ruler"
        ]
    },
    {
        "icon": "cards-blank",
        "label": "Cards Blank",
        "search": [
            "card",
            "magic the gathering",
            "mtg",
            "playing card",
            "pokemon"
        ]
    },
    {
        "icon": "i",
        "label": "I",
        "search": [
            "Latin Capital Letter I",
            "Latin Small Letter I",
            "letter"
        ]
    },
    {
        "icon": "airplay",
        "label": "Airplay",
        "search": [
            "apple",
            "share",
            "stream"
        ]
    },
    {
        "icon": "volume-xmark",
        "label": "Volume Xmark",
        "search": [
            "audio",
            "music",
            "quiet",
            "sound",
            "speaker"
        ]
    },
    {
        "icon": "archway",
        "label": "Archway",
        "search": [
            "arc",
            "monument",
            "road",
            "street",
            "tunnel"
        ]
    },
    {
        "icon": "person-digging",
        "label": "Person Digging",
        "search": [
            "bury",
            "construction",
            "debris",
            "dig",
            "maintenance",
            "men at work",
            "uer"
        ]
    },
    {
        "icon": "gauge-high",
        "label": "Gauge High",
        "search": [
            "dashboard",
            "fast",
            "odometer",
            "quick",
            "speed",
            "speedometer"
        ]
    },
    {
        "icon": "square-steam",
        "label": "Square Steam",
        "search": []
    },
    {
        "icon": "genderless",
        "label": "Genderless",
        "search": [
            "androgynous",
            "asexual",
            "gender",
            "sexless"
        ]
    },
    {
        "icon": "clock-ten",
        "label": "Clock Ten",
        "search": [
            "00",
            "10",
            "10:00",
            "clock",
            "hour",
            "minute",
            "o'clock",
            "o’clock",
            "pending",
            "ten",
            "ten o’clock",
            "ticking",
            "time"
        ]
    },
    {
        "icon": "cloud-sun",
        "label": "Cloud Sun",
        "search": [
            "clear",
            "cloud",
            "day",
            "daytime",
            "fall",
            "outdoors",
            "overcast",
            "partly cloudy",
            "sun",
            "sun behind cloud"
        ]
    },
    {
        "icon": "arrow-right",
        "label": "Arrow Right",
        "search": [
            "Rightwards Arrow",
            "forward",
            "next"
        ]
    },
    {
        "icon": "square-info",
        "label": "Square Info",
        "search": [
            "details",
            "help",
            "information",
            "more",
            "support"
        ]
    },
    {
        "icon": "handshake",
        "label": "Handshake",
        "search": [
            "agreement",
            "greeting",
            "meeting",
            "partnership"
        ]
    },
    {
        "icon": "creative-commons-nc-eu",
        "label": "Creative Commons Noncommercial (Euro Sign)",
        "search": []
    },
    {
        "icon": "npm",
        "label": "npm",
        "search": []
    },
    {
        "icon": "cloud-question",
        "label": "Cloud Question",
        "search": [
            "alert",
            "connection",
            "faq",
            "help",
            "online",
            "question",
            "support",
            "wifi"
        ]
    },
    {
        "icon": "person-skiing",
        "label": "Person Skiing",
        "search": [
            "downhill",
            "olympics",
            "ski",
            "skier",
            "snow",
            "uer",
            "winter"
        ]
    },
    {
        "icon": "bridge-water",
        "label": "Bridge Water",
        "search": [
            "bridge",
            "road"
        ]
    },
    {
        "icon": "building-ngo",
        "label": "Building Ngo",
        "search": [
            "building",
            "city",
            "non governmental organization",
            "office"
        ]
    },
    {
        "icon": "cloudscale",
        "label": "cloudscale.ch",
        "search": []
    },
    {
        "icon": "moped",
        "label": "Moped",
        "search": [
            "delivery",
            "motorbike",
            "scooter"
        ]
    },
    {
        "icon": "grid-round-2",
        "label": "Grid Round 2",
        "search": [
            "app",
            "collection",
            "filter",
            "grid",
            "sort"
        ]
    },
    {
        "icon": "igloo",
        "label": "Igloo",
        "search": [
            "dome",
            "dwelling",
            "eskimo",
            "home",
            "house",
            "ice",
            "snow"
        ]
    },
    {
        "icon": "chess-knight-piece",
        "label": "Chess Knight Piece",
        "search": [
            "board",
            "checkmate",
            "game",
            "horse",
            "strategy"
        ]
    },
    {
        "icon": "hand-holding-magic",
        "label": "Hand Holding Magic",
        "search": [
            "Dungeons & Dragons",
            "carry",
            "cast",
            "d&d",
            "dnd",
            "fantasy",
            "lift",
            "mage",
            "spell",
            "witch",
            "wizard"
        ]
    },
    {
        "icon": "circle-dollar-to-slot",
        "label": "Circle Dollar To Slot",
        "search": [
            "contribute",
            "generosity",
            "gift",
            "give",
            "premium"
        ]
    },
    {
        "icon": "themeco",
        "label": "Themeco",
        "search": []
    },
    {
        "icon": "award-simple",
        "label": "Award Simple",
        "search": [
            "guarantee",
            "honor",
            "ribbon",
            "warranty"
        ]
    },
    {
        "icon": "conveyor-belt-boxes",
        "label": "Conveyor Belt Boxes",
        "search": [
            "carousel",
            "inventory",
            "manufacture",
            "packaging",
            "shipping"
        ]
    },
    {
        "icon": "file-svg",
        "label": "File Svg",
        "search": [
            "document",
            "image",
            "scalable vector graphic",
            "svg",
            "vector"
        ]
    },
    {
        "icon": "y",
        "label": "Y",
        "search": [
            "Latin Capital Letter Y",
            "Latin Small Letter Y",
            "letter",
            "yay",
            "yes"
        ]
    },
    {
        "icon": "face-smile-wink",
        "label": "Face Smile Wink",
        "search": [
            "emoticon",
            "face",
            "happy",
            "hint",
            "joke",
            "wink",
            "winking face"
        ]
    },
    {
        "icon": "dice-four",
        "label": "Dice Four",
        "search": [
            "Die Face-4",
            "chance",
            "gambling",
            "game",
            "roll"
        ]
    },
    {
        "icon": "file-minus",
        "label": "File Minus",
        "search": [
            "delete",
            "document",
            "negative",
            "remove"
        ]
    },
    {
        "icon": "google-play",
        "label": "Google Play",
        "search": [
            "playstore"
        ]
    },
    {
        "icon": "arrow-left-to-arc",
        "label": "Arrow Left To Arc",
        "search": [
            "enter",
            "give",
            "into",
            "login",
            "send",
            "sign in"
        ]
    },
    {
        "icon": "car-tilt",
        "label": "Car Tilt",
        "search": [
            "accident",
            "auto",
            "automobile",
            "insurance",
            "sedan",
            "transportation",
            "vehicle",
            "wreck"
        ]
    },
    {
        "icon": "cloud-bolt-sun",
        "label": "Cloud Bolt Sun",
        "search": [
            "bolt",
            "lightning",
            "precipitation",
            "rain",
            "solar",
            "storm",
            "sun",
            "weather"
        ]
    },
    {
        "icon": "face-grin-squint-tears",
        "label": "Face Grin Squint Tears",
        "search": [
            "emoticon",
            "face",
            "floor",
            "happy",
            "laugh",
            "rolling",
            "rolling on the floor laughing",
            "smile"
        ]
    },
    {
        "icon": "korvue",
        "label": "KORVUE",
        "search": []
    },
    {
        "icon": "snowflakes",
        "label": "Snowflakes",
        "search": [
            "precipitation",
            "rain",
            "winter"
        ]
    },
    {
        "icon": "pretzel",
        "label": "Pretzel",
        "search": [
            "bakery",
            "convoluted",
            "dough",
            "knot",
            "pretzel",
            "twisted"
        ]
    },
    {
        "icon": "glass",
        "label": "Glass",
        "search": [
            "alcohol",
            "beverage",
            "drink",
            "glass",
            "glass of milk",
            "milk",
            "water"
        ]
    },
    {
        "icon": "file-audio",
        "label": "File Audio",
        "search": [
            "document",
            "mp3",
            "music",
            "page",
            "play",
            "sound"
        ]
    },
    {
        "icon": "arrows-down-to-line",
        "label": "Arrows Down To Line",
        "search": [
            "insert",
            "scale down",
            "sink"
        ]
    },
    {
        "icon": "video-arrow-down-left",
        "label": "Video Arrow Down Left",
        "search": [
            "download",
            "film",
            "import",
            "movie"
        ]
    },
    {
        "icon": "grav",
        "label": "Grav",
        "search": []
    },
    {
        "icon": "aws",
        "label": "Amazon Web Services (AWS)",
        "search": []
    },
    {
        "icon": "right-long-to-line",
        "label": "Right Long To Line",
        "search": [
            "forward",
            "right",
            "skip",
            "tab"
        ]
    },
    {
        "icon": "g",
        "label": "G",
        "search": [
            "Latin Capital Letter G",
            "Latin Small Letter G",
            "letter"
        ]
    },
    {
        "icon": "vihara",
        "label": "Vihara",
        "search": [
            "buddhism",
            "buddhist",
            "building",
            "monastery"
        ]
    },
    {
        "icon": "flag-checkered",
        "label": "Flag Checkered",
        "search": [
            "checkered",
            "chequered",
            "chequered flag",
            "finish",
            "notice",
            "notification",
            "notify",
            "pole",
            "racing",
            "report",
            "start",
            "symbol",
            "win"
        ]
    },
    {
        "icon": "briefcase-arrow-right",
        "label": "Briefcase Arrow Right",
        "search": [
            "suitcase",
            "tomorrow",
            "travel"
        ]
    },
    {
        "icon": "heart-half-stroke",
        "label": "Heart Half Stroke",
        "search": [
            "favorite",
            "heart",
            "rating"
        ]
    },
    {
        "icon": "comment-captions",
        "label": "Comment Captions",
        "search": [
            "answer",
            "chat",
            "closed captions",
            "subtitle",
            "subtitling"
        ]
    },
    {
        "icon": "gauge-simple",
        "label": "Gauge Simple",
        "search": [
            "dashboard",
            "fast",
            "odometer",
            "speed",
            "speedometer"
        ]
    },
    {
        "icon": "shredder",
        "label": "Shredder",
        "search": [
            "destroy",
            "document",
            "office",
            "paper",
            "print"
        ]
    },
    {
        "icon": "fondue-pot",
        "label": "Fondue Pot",
        "search": [
            "cheese",
            "chocolate",
            "fondu",
            "fondue",
            "melted",
            "pot",
            "swiss"
        ]
    },
    {
        "icon": "right-left",
        "label": "Right Left",
        "search": [
            "arrow",
            "arrows",
            "exchange",
            "reciprocate",
            "return",
            "swap",
            "transfer"
        ]
    },
    {
        "icon": "planet-ringed",
        "label": "Planet Ringed",
        "search": [
            "orbit",
            "premium",
            "ringed planet",
            "saturn",
            "saturnine",
            "solar system",
            "space",
            "universe"
        ]
    },
    {
        "icon": "pills",
        "label": "Pills",
        "search": [
            "drugs",
            "medicine",
            "prescription",
            "tablets"
        ]
    },
    {
        "icon": "explosion",
        "label": "Explosion",
        "search": [
            "blast",
            "blowup",
            "boom",
            "crash",
            "detonation",
            "explosion"
        ]
    },
    {
        "icon": "arrows-down-to-people",
        "label": "Arrows Down To People",
        "search": [
            "affected",
            "focus",
            "insert",
            "targeted",
            "together",
            "uer"
        ]
    },
    {
        "icon": "users-viewfinder",
        "label": "Users Viewfinder",
        "search": [
            "crowd",
            "focus",
            "group",
            "people",
            "targeted",
            "uer"
        ]
    },
    {
        "icon": "music-note",
        "label": "Music Note",
        "search": [
            "lyrics",
            "melody",
            "note",
            "sing",
            "sound"
        ]
    },
    {
        "icon": "car-on",
        "label": "Car On",
        "search": [
            "alarm",
            "car",
            "carjack",
            "warning"
        ]
    },
    {
        "icon": "circle-camera",
        "label": "Circle Camera",
        "search": [
            "img",
            "photos"
        ]
    },
    {
        "icon": "sun-bright",
        "label": "Sun Bright",
        "search": [
            "brightness",
            "sky",
            "summer"
        ]
    },
    {
        "icon": "battery-bolt",
        "label": "Battery Bolt",
        "search": [
            "charge",
            "power",
            "status"
        ]
    },
    {
        "icon": "mushroom",
        "label": "Mushroom",
        "search": [
            "1-up",
            "fungus",
            "toadstool"
        ]
    },
    {
        "icon": "glide-g",
        "label": "Glide G",
        "search": []
    },
    {
        "icon": "globe-wifi",
        "label": "Globe Wifi",
        "search": [
            "communication",
            "internet",
            "ip address",
            "network",
            "web",
            "world"
        ]
    },
    {
        "icon": "sleigh",
        "label": "Sleigh",
        "search": [
            "christmas",
            "claus",
            "fly",
            "holiday",
            "santa",
            "sled",
            "snow",
            "xmas"
        ]
    },
    {
        "icon": "arrow-down-left-and-arrow-up-right-to-center",
        "label": "Arrow Down Left And Arrow Up Right To Center",
        "search": [
            "download",
            "export",
            "minimize",
            "resize",
            "scale",
            "size",
            "transfer"
        ]
    },
    {
        "icon": "dial-high",
        "label": "Dial High",
        "search": [
            "dial",
            "level"
        ]
    },
    {
        "icon": "dumbbell",
        "label": "Dumbbell",
        "search": [
            "exercise",
            "gym",
            "strength",
            "weight",
            "weight-lifting",
            "workout"
        ]
    },
    {
        "icon": "baby-carriage",
        "label": "Baby Carriage",
        "search": [
            "buggy",
            "carrier",
            "infant",
            "push",
            "stroller",
            "transportation",
            "walk",
            "wheels"
        ]
    },
    {
        "icon": "clouds",
        "label": "Clouds",
        "search": [
            "cloudy",
            "fog",
            "haze",
            "overcast",
            "smoke",
            "storm",
            "weather"
        ]
    },
    {
        "icon": "camera-cctv",
        "label": "Camera Cctv",
        "search": [
            "1984",
            "Big Brother",
            "George Orwell",
            "camera",
            "security",
            "surveillance",
            "video"
        ]
    },
    {
        "icon": "buildings",
        "label": "Buildings",
        "search": [
            "apartment",
            "business",
            "city",
            "company",
            "office",
            "urban",
            "work"
        ]
    },
    {
        "icon": "rectangle-barcode",
        "label": "Rectangle Barcode",
        "search": [
            "info",
            "laser",
            "price",
            "scan",
            "upc"
        ]
    },
    {
        "icon": "truck-fire",
        "label": "Truck Fire",
        "search": [
            "Dalmatian",
            "arson",
            "burning",
            "emergency",
            "emt",
            "engine",
            "fight",
            "fire",
            "flame",
            "hose",
            "ladder",
            "rescue"
        ]
    },
    {
        "icon": "arrow-down-big-small",
        "label": "Arrow Down Big Small",
        "search": [
            "arrange",
            "filter",
            "order",
            "rectangle"
        ]
    },
    {
        "icon": "hand-love",
        "label": "Hand Love",
        "search": [
            "ILY",
            "hand",
            "love-you gesture",
            "peace"
        ]
    },
    {
        "icon": "bag-shopping-minus",
        "label": "Bag Shopping Minus",
        "search": [
            "buy",
            "checkout",
            "grocery",
            "payment",
            "purchase",
            "remove",
            "subtract"
        ]
    },
    {
        "icon": "clock-eleven-thirty",
        "label": "Clock Eleven Thirty",
        "search": [
            "11",
            "11:30",
            "clock",
            "eleven",
            "eleven-thirty",
            "hour",
            "minute",
            "o'clock",
            "pending",
            "thirty",
            "ticking",
            "time"
        ]
    },
    {
        "icon": "slash-forward",
        "label": "Slash Forward",
        "search": [
            "Division Slash",
            "Solidus",
            "divide",
            "fraction"
        ]
    },
    {
        "icon": "pineapple",
        "label": "Pineapple",
        "search": [
            "ananas",
            "fruit",
            "pineapple",
            "tropical"
        ]
    },
    {
        "icon": "face-persevering",
        "label": "Face Persevering",
        "search": [
            "face",
            "frustration",
            "helpless",
            "persevere",
            "persevering face",
            "scrunched"
        ]
    },
    {
        "icon": "card-diamond",
        "label": "Card Diamond",
        "search": [
            "ace",
            "card",
            "gamble",
            "playing card",
            "poker",
            "suit"
        ]
    },
    {
        "icon": "raccoon",
        "label": "Raccoon",
        "search": [
            "mammal",
            "mask",
            "panda",
            "paw",
            "raccoon",
            "tail",
            "trash"
        ]
    },
    {
        "icon": "folder-bookmark",
        "label": "Folder Bookmark",
        "search": [
            "favorite",
            "file",
            "remember"
        ]
    },
    {
        "icon": "jsfiddle",
        "label": "jsFiddle",
        "search": []
    },
    {
        "icon": "key-skeleton-left-right",
        "label": "Key Skeleton Left Right",
        "search": [
            "connect",
            "lock",
            "private",
            "public"
        ]
    },
    {
        "icon": "circle-i",
        "label": "Circle I",
        "search": [
            "Circled Latin Capital Letter I",
            "letter"
        ]
    },
    {
        "icon": "kiwi-bird",
        "label": "Kiwi Bird",
        "search": [
            "bird",
            "fauna",
            "new zealand"
        ]
    },
    {
        "icon": "keybase",
        "label": "Keybase",
        "search": []
    },
    {
        "icon": "calendar-xmark",
        "label": "Calendar Xmark",
        "search": [
            "archive",
            "calendar",
            "date",
            "day",
            "delete",
            "event",
            "month",
            "remove",
            "schedule",
            "time",
            "uncheck",
            "when",
            "x",
            "year"
        ]
    },
    {
        "icon": "circle-down",
        "label": "Circle Down",
        "search": [
            "arrow-circle-o-down",
            "download"
        ]
    },
    {
        "icon": "file-medical",
        "label": "File Medical",
        "search": [
            "document",
            "health",
            "history",
            "prescription",
            "record"
        ]
    },
    {
        "icon": "xmark",
        "label": "Xmark",
        "search": [
            "Cancellation X",
            "Multiplication Sign",
            "Multiplication X",
            "cancel",
            "close",
            "cross",
            "cross mark",
            "error",
            "exit",
            "incorrect",
            "mark",
            "multiplication",
            "multiply",
            "notice",
            "notification",
            "notify",
            "problem",
            "sign",
            "uncheck",
            "wrong",
            "x",
            "×"
        ]
    },
    {
        "icon": "shapes",
        "label": "Shapes",
        "search": [
            "blocks",
            "build",
            "circle",
            "square",
            "triangle"
        ]
    },
    {
        "icon": "dice-one",
        "label": "Dice One",
        "search": [
            "Die Face-1",
            "chance",
            "gambling",
            "game",
            "roll"
        ]
    },
    {
        "icon": "knife-kitchen",
        "label": "Knife Kitchen",
        "search": [
            "chef",
            "cooking",
            "cut",
            "equipment",
            "halloween",
            "hocho",
            "kitchen knife",
            "knife",
            "sharp",
            "slice",
            "tool",
            "weapon"
        ]
    },
    {
        "icon": "arrows-cross",
        "label": "Arrows Cross",
        "search": [
            "North East Arrow Crossing South East Arrow",
            "swap",
            "switch",
            "transfer"
        ]
    },
    {
        "icon": "compass-slash",
        "label": "Compass Slash",
        "search": [
            "directions",
            "directory",
            "disabled",
            "location",
            "lost",
            "menu",
            "navigation",
            "safari",
            "travel"
        ]
    },
    {
        "icon": "lock-open",
        "label": "Lock Open",
        "search": [
            "admin",
            "lock",
            "open",
            "padlock",
            "password",
            "privacy",
            "private",
            "protect",
            "security",
            "unlock"
        ]
    },
    {
        "icon": "pepper-hot",
        "label": "Pepper Hot",
        "search": [
            "buffalo wings",
            "capsicum",
            "chili",
            "chilli",
            "habanero",
            "hot",
            "hot pepper",
            "jalapeno",
            "mexican",
            "pepper",
            "spicy",
            "tabasco",
            "vegetable"
        ]
    },
    {
        "icon": "droplet-slash",
        "label": "Droplet Slash",
        "search": [
            "blood",
            "color",
            "disabled",
            "drop",
            "droplet",
            "raindrop",
            "waterdrop"
        ]
    },
    {
        "icon": "droplet",
        "label": "Droplet",
        "search": [
            "blood",
            "cold",
            "color",
            "comic",
            "drop",
            "droplet",
            "raindrop",
            "sweat",
            "waterdrop"
        ]
    },
    {
        "icon": "file-lines",
        "label": "File Lines",
        "search": [
            "Document",
            "Document with Text",
            "document",
            "file-text",
            "invoice",
            "new",
            "page",
            "pdf"
        ]
    },
    {
        "icon": "comments-dollar",
        "label": "Comments Dollar",
        "search": [
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "feedback",
            "message",
            "money",
            "note",
            "notification",
            "pay",
            "salary",
            "sms",
            "speech",
            "spend",
            "texting",
            "transfer"
        ]
    },
    {
        "icon": "trash-check",
        "label": "Trash Check",
        "search": [
            "confirm",
            "delete",
            "enable",
            "garbage",
            "hide",
            "remove",
            "validate",
            "working"
        ]
    },
    {
        "icon": "magnifying-glass-location",
        "label": "Magnifying Glass Location",
        "search": [
            "bigger",
            "enlarge",
            "find",
            "magnifier",
            "magnify",
            "preview",
            "zoom"
        ]
    },
    {
        "icon": "floppy-disk-circle-arrow-right",
        "label": "Floppy Disk Circle Arrow Right",
        "search": [
            "disk",
            "download",
            "floppy",
            "floppy-o"
        ]
    },
    {
        "icon": "magnifying-glass-play",
        "label": "Magnifying Glass Play",
        "search": [
            "audio",
            "find",
            "glass",
            "inspection",
            "magnifier",
            "magnify",
            "magnifying",
            "magnifying glass tilted left",
            "music",
            "play",
            "preview",
            "search",
            "song",
            "tool",
            "video",
            "zoom"
        ]
    },
    {
        "icon": "file-invoice",
        "label": "File Invoice",
        "search": [
            "account",
            "bill",
            "charge",
            "document",
            "payment",
            "receipt"
        ]
    },
    {
        "icon": "vector-circle",
        "label": "Vector Circle",
        "search": [
            "anchors",
            "lines",
            "objects",
            "render",
            "shape"
        ]
    },
    {
        "icon": "phone-office",
        "label": "Phone Office",
        "search": [
            "call",
            "earphone",
            "number",
            "support",
            "telephone",
            "voice"
        ]
    },
    {
        "icon": "weebly",
        "label": "Weebly",
        "search": []
    },
    {
        "icon": "tree-palm",
        "label": "Tree Palm",
        "search": [
            "coconut",
            "frond",
            "palm",
            "palm tree",
            "tree",
            "tropical"
        ]
    },
    {
        "icon": "onion",
        "label": "Onion",
        "search": [
            "onion"
        ]
    },
    {
        "icon": "value-absolute",
        "label": "Value Absolute",
        "search": [
            "Math"
        ]
    },
    {
        "icon": "docker",
        "label": "Docker",
        "search": []
    },
    {
        "icon": "republican",
        "label": "Republican",
        "search": [
            "american",
            "conservative",
            "election",
            "elephant",
            "politics",
            "republican party",
            "right",
            "right-wing",
            "usa"
        ]
    },
    {
        "icon": "shop",
        "label": "Shop",
        "search": [
            "bodega",
            "building",
            "buy",
            "market",
            "purchase",
            "shopping",
            "store"
        ]
    },
    {
        "icon": "magento",
        "label": "Magento",
        "search": []
    },
    {
        "icon": "film",
        "label": "Film",
        "search": [
            "cinema",
            "film",
            "film frames",
            "frames",
            "movie",
            "strip",
            "video"
        ]
    },
    {
        "icon": "washing-machine",
        "label": "Washing Machine",
        "search": [
            "clean",
            "clothes",
            "laundromat",
            "laundry",
            "washing machine"
        ]
    },
    {
        "icon": "building-circle-xmark",
        "label": "Building Circle Xmark",
        "search": [
            "building",
            "city",
            "destroy",
            "office",
            "uncheck"
        ]
    },
    {
        "icon": "comments",
        "label": "Comments",
        "search": [
            "Two Speech Bubbles",
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "conversation",
            "discussion",
            "feedback",
            "message",
            "note",
            "notification",
            "sms",
            "speech",
            "talk",
            "talking",
            "texting"
        ]
    },
    {
        "icon": "tags",
        "label": "Tags",
        "search": [
            "discount",
            "label",
            "price",
            "shopping"
        ]
    },
    {
        "icon": "file-spreadsheet",
        "label": "File Spreadsheet",
        "search": [
            "csv",
            "document",
            "excel",
            "numbers",
            "sheets",
            "xls"
        ]
    },
    {
        "icon": "gun",
        "label": "Gun",
        "search": [
            "firearm",
            "pistol",
            "weapon"
        ]
    },
    {
        "icon": "nesting-dolls",
        "label": "Nesting Dolls",
        "search": [
            "babushka",
            "doll",
            "matryoshka",
            "nesting",
            "nesting dolls",
            "russia",
            "stacking",
            "tea"
        ]
    },
    {
        "icon": "dial",
        "label": "Dial",
        "search": [
            "dial",
            "level"
        ]
    },
    {
        "icon": "truck-flatbed",
        "label": "Truck Flatbed",
        "search": [
            "container",
            "flatbed",
            "shipping"
        ]
    },
    {
        "icon": "pen-nib-slash",
        "label": "Pen Nib Slash",
        "search": [
            "design",
            "disabled",
            "edit",
            "fountain pen",
            "modify",
            "update",
            "write"
        ]
    },
    {
        "icon": "circle-check",
        "label": "Circle Check",
        "search": [
            "accept",
            "affected",
            "agree",
            "clear",
            "confirm",
            "correct",
            "coupon",
            "done",
            "enable",
            "ok",
            "select",
            "success",
            "tick",
            "todo",
            "validate",
            "working",
            "yes"
        ]
    },
    {
        "icon": "house-tree",
        "label": "House Tree",
        "search": [
            "abode",
            "city",
            "garden",
            "home",
            "house",
            "house with garden",
            "residence",
            "suburbs",
            "urban"
        ]
    },
    {
        "icon": "user-pilot",
        "label": "User Pilot",
        "search": [
            "airplane",
            "airport",
            "flight",
            "fly",
            "navigate",
            "pilot",
            "uer"
        ]
    },
    {
        "icon": "git-alt",
        "label": "Git Alt",
        "search": []
    },
    {
        "icon": "bracket-square",
        "label": "Bracket Square",
        "search": [
            "Left Square Bracket",
            "code",
            "crotchets"
        ]
    },
    {
        "icon": "id-card-clip",
        "label": "Id Card Clip",
        "search": [
            "contact",
            "demographics",
            "document",
            "identification",
            "issued",
            "profile",
            "uer",
            "username"
        ]
    },
    {
        "icon": "moon",
        "label": "Moon",
        "search": [
            "Power Sleep Symbol",
            "contrast",
            "crescent",
            "crescent moon",
            "dark",
            "lunar",
            "moon",
            "night"
        ]
    },
    {
        "icon": "firefox-browser",
        "label": "Firefox Browser",
        "search": [
            "browser"
        ]
    },
    {
        "icon": "lamp",
        "label": "Lamp",
        "search": [
            "bright",
            "furniture",
            "light"
        ]
    },
    {
        "icon": "file-plus",
        "label": "File Plus",
        "search": [
            "add",
            "create",
            "document",
            "medical",
            "new",
            "positive"
        ]
    },
    {
        "icon": "image-user",
        "label": "Image User",
        "search": [
            "employee",
            "img",
            "portrait",
            "selfie",
            "uer"
        ]
    },
    {
        "icon": "turn-right",
        "label": "Turn Right",
        "search": [
            "direction",
            "east",
            "forward",
            "next",
            "right",
            "turn"
        ]
    },
    {
        "icon": "hexagon-vertical-nft",
        "label": "Hexagon Vertical Nft",
        "search": [
            "NFT",
            "blockchain",
            "crypto",
            "data",
            "non-fungible token"
        ]
    },
    {
        "icon": "skull-cow",
        "label": "Skull Cow",
        "search": [
            "barren",
            "cowboy",
            "dead",
            "desert",
            "horns",
            "old west",
            "skeleton",
            "western"
        ]
    },
    {
        "icon": "oil-well",
        "label": "Oil Well",
        "search": [
            "drill",
            "oil",
            "rig"
        ]
    },
    {
        "icon": "rhombus",
        "label": "Rhombus",
        "search": [
            "diamond",
            "parallelogram"
        ]
    },
    {
        "icon": "cloudsmith",
        "label": "Cloudsmith",
        "search": []
    },
    {
        "icon": "apartment",
        "label": "Apartment",
        "search": [
            "apartment",
            "building",
            "city",
            "condo",
            "condominium",
            "flat"
        ]
    },
    {
        "icon": "user-bounty-hunter",
        "label": "User Bounty Hunter",
        "search": [
            "beskar",
            "boba fett",
            "jango fett",
            "mando",
            "mandolorian",
            "star wars",
            "uer"
        ]
    },
    {
        "icon": "wizards-of-the-coast",
        "label": "Wizards of the Coast",
        "search": [
            "Dungeons & Dragons",
            "d&d",
            "dnd",
            "fantasy",
            "game",
            "gaming",
            "tabletop"
        ]
    },
    {
        "icon": "eye-dropper-half",
        "label": "Eye Dropper Half",
        "search": [
            "color",
            "eyedrop"
        ]
    },
    {
        "icon": "comment-code",
        "label": "Comment Code",
        "search": [
            "answer",
            "coding",
            "contact",
            "discussion"
        ]
    },
    {
        "icon": "tachograph-digital",
        "label": "Tachograph Digital",
        "search": [
            "data",
            "distance",
            "speed",
            "tachometer"
        ]
    },
    {
        "icon": "hand-back-point-ribbon",
        "label": "Hand Back Point Ribbon",
        "search": [
            "remember",
            "remind"
        ]
    },
    {
        "icon": "laptop-binary",
        "label": "Laptop Binary",
        "search": [
            "binary",
            "code",
            "computer",
            "cpu",
            "dell",
            "demo",
            "develop",
            "device",
            "information",
            "mac",
            "macbook",
            "machine",
            "pc"
        ]
    },
    {
        "icon": "tablet",
        "label": "Tablet",
        "search": [
            "device",
            "kindle",
            "screen"
        ]
    },
    {
        "icon": "creative-commons-nd",
        "label": "Creative Commons No Derivative Works",
        "search": []
    },
    {
        "icon": "ruble-sign",
        "label": "Ruble Sign",
        "search": [
            "Ruble Sign",
            "currency"
        ]
    },
    {
        "icon": "closed-captioning",
        "label": "Closed Captioning",
        "search": [
            "cc",
            "deaf",
            "hearing",
            "subtitle",
            "subtitling",
            "text",
            "video"
        ]
    },
    {
        "icon": "interrobang",
        "label": "Interrobang",
        "search": [
            "exclamation",
            "question"
        ]
    },
    {
        "icon": "pen",
        "label": "Pen",
        "search": [
            "ballpoint",
            "design",
            "edit",
            "modify",
            "pen",
            "update",
            "write"
        ]
    },
    {
        "icon": "pallet-boxes",
        "label": "Pallet Boxes",
        "search": [
            "archive",
            "box",
            "inventory",
            "shipping",
            "warehouse"
        ]
    },
    {
        "icon": "chatgpt",
        "label": "chatgpt"
    },
    {
        "icon": "plane",
        "label": "Plane",
        "search": [
            "airplane",
            "airport",
            "destination",
            "fly",
            "location",
            "mode",
            "travel",
            "trip"
        ]
    },
    {
        "icon": "book-arrow-right",
        "label": "Book Arrow Right",
        "search": [
            "library",
            "research"
        ]
    },
    {
        "icon": "images",
        "label": "Images",
        "search": [
            "album",
            "img",
            "landscape",
            "photo",
            "picture"
        ]
    },
    {
        "icon": "mobile-screen",
        "label": "Mobile Screen",
        "search": [
            "android",
            "call",
            "cell phone",
            "device",
            "number",
            "screen",
            "telephone",
            "text"
        ]
    },
    {
        "icon": "guarani-sign",
        "label": "Guarani Sign",
        "search": [
            "Guarani Sign",
            "currency"
        ]
    },
    {
        "icon": "bag-shopping",
        "label": "Bag Shopping",
        "search": [
            "buy",
            "checkout",
            "grocery",
            "payment",
            "purchase"
        ]
    },
    {
        "icon": "usps",
        "label": "United States Postal Service",
        "search": [
            "american",
            "package",
            "shipping",
            "usa"
        ]
    },
    {
        "icon": "circle-right",
        "label": "Circle Right",
        "search": [
            "arrow-circle-o-right",
            "forward",
            "next"
        ]
    },
    {
        "icon": "person-running-fast",
        "label": "Person Running Fast",
        "search": [
            "exit",
            "fast",
            "flee",
            "marathon",
            "person running",
            "race",
            "running"
        ]
    },
    {
        "icon": "cloud-sleet",
        "label": "Cloud Sleet",
        "search": [
            "freezing",
            "hail",
            "precipitation",
            "rain",
            "winter",
            "wintry mix"
        ]
    },
    {
        "icon": "piano",
        "label": "Piano",
        "search": [
            "grand piano",
            "instrument",
            "keyboard",
            "keys",
            "midi",
            "music"
        ]
    },
    {
        "icon": "square-letterboxd",
        "label": "Square Letterboxd",
        "search": []
    },
    {
        "icon": "phone-volume",
        "label": "Phone Volume",
        "search": [
            "call",
            "earphone",
            "number",
            "ring",
            "ringing",
            "sound",
            "support",
            "talking",
            "telephone",
            "voice",
            "volume-control-phone"
        ]
    },
    {
        "icon": "cubes",
        "label": "Cubes",
        "search": [
            "3d",
            "block",
            "dice",
            "package",
            "pyramid",
            "square",
            "stack",
            "tesseract"
        ]
    },
    {
        "icon": "file-magnifying-glass",
        "label": "File Magnifying Glass",
        "search": [
            "document",
            "find",
            "look",
            "magnifier",
            "scan"
        ]
    },
    {
        "icon": "mandalorian",
        "label": "Mandalorian",
        "search": []
    },
    {
        "icon": "phone",
        "label": "Phone",
        "search": [
            "Left Hand Telephone Receiver",
            "call",
            "earphone",
            "number",
            "phone",
            "receiver",
            "support",
            "talking",
            "telephone",
            "telephone receiver",
            "voice"
        ]
    },
    {
        "icon": "hexagon-check",
        "label": "Hexagon Check",
        "search": [
            "accept",
            "agree",
            "box",
            "button",
            "check",
            "checkmark",
            "confirm",
            "correct",
            "done",
            "enable",
            "mark",
            "ok",
            "select",
            "success",
            "tick",
            "todo",
            "validate",
            "working",
            "yes",
            "✓"
        ]
    },
    {
        "icon": "user-beard-bolt",
        "label": "User Beard Bolt",
        "search": [
            "deity",
            "god",
            "greek",
            "jupiter",
            "lightning",
            "mythology",
            "roman",
            "zeus"
        ]
    },
    {
        "icon": "torii-gate",
        "label": "Torii Gate",
        "search": [
            "building",
            "religion",
            "shinto",
            "shinto shrine",
            "shintoism",
            "shrine"
        ]
    },
    {
        "icon": "dice-d8",
        "label": "Dice D8",
        "search": [
            "Dungeons & Dragons",
            "chance",
            "d&d",
            "dnd",
            "fantasy",
            "gambling",
            "game",
            "roll"
        ]
    },
    {
        "icon": "clock-nine",
        "label": "Clock Nine",
        "search": [
            "00",
            "9",
            "9:00",
            "clock",
            "hour",
            "minute",
            "nine",
            "nine o’clock",
            "o'clock",
            "o’clock",
            "pending",
            "ticking",
            "time"
        ]
    },
    {
        "icon": "file-mp3",
        "label": "File Mp3",
        "search": [
            "document",
            "mp3",
            "music",
            "page",
            "play",
            "sound"
        ]
    },
    {
        "icon": "user-tie-hair",
        "label": "User Tie Hair",
        "search": [
            "administrator",
            "avatar",
            "business",
            "clothing",
            "employee",
            "formal",
            "professional",
            "suit",
            "uer"
        ]
    },
    {
        "icon": "coffin-cross",
        "label": "Coffin Cross",
        "search": [
            "box",
            "burial",
            "casket",
            "catholicism",
            "cemetery",
            "christianity",
            "death",
            "eulogy",
            "funeral",
            "halloween",
            "vampire"
        ]
    },
    {
        "icon": "bacon",
        "label": "Bacon",
        "search": [
            "bacon",
            "blt",
            "breakfast",
            "food",
            "ham",
            "lard",
            "meat",
            "pancetta",
            "pork",
            "rasher"
        ]
    },
    {
        "icon": "images-user",
        "label": "Images User",
        "search": [
            "employee",
            "img",
            "portrait",
            "selfie",
            "uer"
        ]
    },
    {
        "icon": "person-falling-burst",
        "label": "Person Falling Burst",
        "search": [
            "accident",
            "crash",
            "death",
            "fall",
            "homicide",
            "murder",
            "uer"
        ]
    },
    {
        "icon": "caduceus",
        "label": "Caduceus",
        "search": [
            "fast",
            "hermes",
            "mercury",
            "messenger"
        ]
    },
    {
        "icon": "quote-right",
        "label": "Quote Right",
        "search": [
            "Right Double Quotation Mark",
            "mention",
            "note",
            "phrase",
            "text",
            "type"
        ]
    },
    {
        "icon": "house-medical-flag",
        "label": "House Medical Flag",
        "search": [
            "clinic",
            "hospital",
            "mash"
        ]
    },
    {
        "icon": "slack",
        "label": "Slack Logo",
        "search": [
            "anchor",
            "hash",
            "hashtag"
        ]
    },
    {
        "icon": "prescription",
        "label": "Prescription",
        "search": [
            "drugs",
            "medical",
            "medicine",
            "pharmacy",
            "rx"
        ]
    },
    {
        "icon": "face-weary",
        "label": "Face Weary",
        "search": [
            "distraught",
            "face",
            "tired",
            "wailing",
            "weary",
            "weary face"
        ]
    },
    {
        "icon": "up-left",
        "label": "Up Left",
        "search": [
            "North West Black Arrow",
            "diagonal",
            "direction",
            "northwest"
        ]
    },
    {
        "icon": "angellist",
        "label": "AngelList",
        "search": []
    },
    {
        "icon": "hand-back-point-up",
        "label": "Hand Back Point Up",
        "search": [
            "backhand",
            "backhand index pointing up",
            "direction",
            "finger",
            "hand",
            "point",
            "up"
        ]
    },
    {
        "icon": "rectangle-history-circle-plus",
        "label": "Rectangle History Circle Plus",
        "search": [
            "add",
            "album",
            "carousel",
            "collection",
            "gallery",
            "history",
            "multiple",
            "new",
            "project",
            "windows"
        ]
    },
    {
        "icon": "beer-mug",
        "label": "Beer Mug",
        "search": [
            "alcohol",
            "ale",
            "bar",
            "beer",
            "beer mug",
            "beverage",
            "brew",
            "brewery",
            "drink",
            "foam",
            "lager",
            "mug",
            "stein"
        ]
    },
    {
        "icon": "dice-three",
        "label": "Dice Three",
        "search": [
            "Die Face-3",
            "chance",
            "gambling",
            "game",
            "roll"
        ]
    },
    {
        "icon": "android",
        "label": "Android",
        "search": [
            "robot"
        ]
    },
    {
        "icon": "lasso",
        "label": "Lasso",
        "search": [
            "cowboy",
            "rodeo",
            "rope",
            "select",
            "selection",
            "western"
        ]
    },
    {
        "icon": "building-lock",
        "label": "Building Lock",
        "search": [
            "building",
            "city",
            "closed",
            "lock",
            "lockdown",
            "padlock",
            "privacy",
            "quarantine",
            "secure"
        ]
    },
    {
        "icon": "id-card",
        "label": "Id Card",
        "search": [
            "contact",
            "demographics",
            "document",
            "identification",
            "issued",
            "profile",
            "registration",
            "uer",
            "username"
        ]
    },
    {
        "icon": "clock-desk",
        "label": "Clock Desk",
        "search": [
            "alarm",
            "clock",
            "mantelpiece clock",
            "pending",
            "timer"
        ]
    },
    {
        "icon": "circle-play",
        "label": "Circle Play",
        "search": [
            "audio",
            "music",
            "playing",
            "sound",
            "start",
            "video"
        ]
    },
    {
        "icon": "face-laugh-beam",
        "label": "Face Laugh Beam",
        "search": [
            "LOL",
            "beaming face with smiling eyes",
            "emoticon",
            "eye",
            "face",
            "grin",
            "happy",
            "smile"
        ]
    },
    {
        "icon": "leaf",
        "label": "Leaf",
        "search": [
            "eco",
            "flora",
            "nature",
            "plant",
            "vegan"
        ]
    },
    {
        "icon": "house-chimney-user",
        "label": "House Chimney User",
        "search": [
            "covid-19",
            "home",
            "isolation",
            "quarantine",
            "uer"
        ]
    },
    {
        "icon": "rotate-right",
        "label": "Rotate Right",
        "search": [
            "forward",
            "refresh",
            "reload",
            "renew",
            "repeat",
            "retry"
        ]
    },
    {
        "icon": "books-medical",
        "label": "Books Medical",
        "search": [
            "add",
            "diary",
            "documentation",
            "health",
            "journal",
            "library",
            "read",
            "records",
            "research"
        ]
    },
    {
        "icon": "meetup",
        "label": "Meetup",
        "search": []
    },
    {
        "icon": "tooth",
        "label": "Tooth",
        "search": [
            "bicuspid",
            "dental",
            "dentist",
            "molar",
            "mouth",
            "teeth",
            "tooth"
        ]
    },
    {
        "icon": "house-chimney-window",
        "label": "House Chimney Window",
        "search": [
            "abode",
            "building",
            "family",
            "home",
            "residence"
        ]
    },
    {
        "icon": "square-ellipsis",
        "label": "Square Ellipsis",
        "search": [
            "dots",
            "menu",
            "three dots"
        ]
    },
    {
        "icon": "motorcycle",
        "label": "Motorcycle",
        "search": [
            "bike",
            "machine",
            "motorcycle",
            "racing",
            "transportation",
            "vehicle"
        ]
    },
    {
        "icon": "shield-minus",
        "label": "Shield Minus",
        "search": [
            "minus",
            "protect",
            "remove",
            "safety"
        ]
    },
    {
        "icon": "backward-fast",
        "label": "Backward Fast",
        "search": [
            "arrow",
            "beginning",
            "first",
            "last track button",
            "previous",
            "previous scene",
            "previous track",
            "quick",
            "rewind",
            "start",
            "triangle"
        ]
    },
    {
        "icon": "dolly-empty",
        "label": "Dolly Empty",
        "search": [
            "carry",
            "inventory",
            "shipping",
            "transport"
        ]
    },
    {
        "icon": "address-book",
        "label": "Address Book",
        "search": [
            "contact",
            "directory",
            "employee",
            "index",
            "little black book",
            "portfolio",
            "rolodex",
            "uer",
            "username"
        ]
    },
    {
        "icon": "clouds-moon",
        "label": "Clouds Moon",
        "search": [
            "cloudy",
            "moonlight",
            "night",
            "overcast",
            "sky"
        ]
    },
    {
        "icon": "fonticons-fi",
        "label": "Fonticons Fi",
        "search": []
    },
    {
        "icon": "car-building",
        "label": "Car Building",
        "search": [
            "city",
            "office",
            "transportation",
            "travel",
            "urban",
            "work"
        ]
    },
    {
        "icon": "face-awesome",
        "label": "Face Awesome",
        "search": [
            "amazing",
            "awesome",
            "grin",
            "look",
            "smile",
            "troll"
        ]
    },
    {
        "icon": "palfed",
        "label": "Palfed",
        "search": []
    },
    {
        "icon": "blinds",
        "label": "Blinds",
        "search": [
            "privacy",
            "shutter",
            "window"
        ]
    },
    {
        "icon": "sailboat",
        "label": "Sailboat",
        "search": [
            "dinghy",
            "mast",
            "sailboat",
            "sailing",
            "yacht"
        ]
    },
    {
        "icon": "arrow-up-left-from-circle",
        "label": "Arrow Up Left From Circle",
        "search": [
            "Broken Circle with Northwest Arrow",
            "escape",
            "logout",
            "upgrade"
        ]
    },
    {
        "icon": "book-bookmark",
        "label": "Book Bookmark",
        "search": [
            "knowledge",
            "library",
            "research"
        ]
    },
    {
        "icon": "magnifying-glass-arrow-right",
        "label": "Magnifying Glass Arrow Right",
        "search": [
            "find",
            "magnifier",
            "next",
            "search"
        ]
    },
    {
        "icon": "split",
        "label": "Split",
        "search": [
            "code",
            "divide"
        ]
    },
    {
        "icon": "face-pensive",
        "label": "Face Pensive",
        "search": [
            "dejected",
            "face",
            "pensive",
            "pensive face",
            "remorse",
            "sad",
            "sorrow"
        ]
    },
    {
        "icon": "book-circle-arrow-up",
        "label": "Book Circle Arrow Up",
        "search": [
            "library",
            "research",
            "upgrade"
        ]
    },
    {
        "icon": "wpbeginner",
        "label": "WPBeginner",
        "search": []
    },
    {
        "icon": "heart-half",
        "label": "Heart Half",
        "search": [
            "favorite",
            "heart",
            "rating"
        ]
    },
    {
        "icon": "microphone-lines",
        "label": "Microphone Lines",
        "search": [
            "audio",
            "mic",
            "microphone",
            "music",
            "podcast",
            "record",
            "sing",
            "sound",
            "studio",
            "studio microphone",
            "talking",
            "voice"
        ]
    },
    {
        "icon": "reply-all",
        "label": "Reply All",
        "search": [
            "mail",
            "message",
            "respond"
        ]
    },
    {
        "icon": "diaspora",
        "label": "Diaspora",
        "search": []
    },
    {
        "icon": "product-hunt",
        "label": "Product Hunt",
        "search": []
    },
    {
        "icon": "square-upwork",
        "label": "Square Upwork",
        "search": []
    },
    {
        "icon": "cuttlefish",
        "label": "Cuttlefish",
        "search": []
    },
    {
        "icon": "square-list",
        "label": "Square List",
        "search": [
            "cheatsheet",
            "checklist",
            "completed",
            "done",
            "menu",
            "ol",
            "summary",
            "ul"
        ]
    },
    {
        "icon": "universal-access",
        "label": "Universal Access",
        "search": [
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "shield-cross",
        "label": "Shield Cross",
        "search": [
            "Black Cross On Shield",
            "Dungeons & Dragons",
            "block",
            "catholicism",
            "christianity",
            "crusader",
            "d&d",
            "defend",
            "dnd",
            "fantasy",
            "protect",
            "safety",
            "security",
            "templar"
        ]
    },
    {
        "icon": "medapps",
        "label": "MedApps",
        "search": []
    },
    {
        "icon": "toilet-paper",
        "label": "Toilet Paper",
        "search": [
            "bathroom",
            "covid-19",
            "halloween",
            "holiday",
            "lavatory",
            "paper towels",
            "prank",
            "privy",
            "restroom",
            "roll",
            "roll of paper",
            "toilet",
            "toilet paper",
            "wipe"
        ]
    },
    {
        "icon": "square-code",
        "label": "Square Code",
        "search": [
            "code",
            "coding",
            "command",
            "console",
            "development",
            "prompt",
            "terminal"
        ]
    },
    {
        "icon": "vr-cardboard",
        "label": "Vr Cardboard",
        "search": [
            "3d",
            "augment",
            "google",
            "reality",
            "virtual"
        ]
    },
    {
        "icon": "pizza-slice",
        "label": "Pizza Slice",
        "search": [
            "cheese",
            "chicago",
            "italian",
            "mozzarella",
            "new york",
            "pepperoni",
            "pie",
            "slice",
            "teenage mutant ninja turtles",
            "tomato"
        ]
    },
    {
        "icon": "pix",
        "label": "Pix",
        "search": []
    },
    {
        "icon": "spray-can",
        "label": "Spray Can",
        "search": [
            "Paint",
            "aerosol",
            "design",
            "graffiti",
            "tag"
        ]
    },
    {
        "icon": "nfc-trash",
        "label": "Nfc Trash",
        "search": [
            "connect",
            "data",
            "delete",
            "near field communication",
            "nfc",
            "scan",
            "signal",
            "transfer",
            "wireless"
        ]
    },
    {
        "icon": "temperature-list",
        "label": "Temperature List",
        "search": [
            "cheatsheet",
            "gauge",
            "heat",
            "thermometer"
        ]
    },
    {
        "icon": "square-tumblr",
        "label": "Square Tumblr",
        "search": []
    },
    {
        "icon": "shovel-snow",
        "label": "Shovel Snow",
        "search": [
            "construction",
            "dig",
            "equipment",
            "excavate",
            "maintenance",
            "plow",
            "tool",
            "trench"
        ]
    },
    {
        "icon": "volume-low",
        "label": "Volume Low",
        "search": [
            "audio",
            "lower",
            "music",
            "quieter",
            "soft",
            "sound",
            "speaker",
            "speaker low volume"
        ]
    },
    {
        "icon": "solar-system",
        "label": "Solar System",
        "search": [
            "galaxy",
            "orbit",
            "planets",
            "premium",
            "space",
            "sun",
            "universe"
        ]
    },
    {
        "icon": "react",
        "label": "React",
        "search": []
    },
    {
        "icon": "cross",
        "label": "Cross",
        "search": [
            "Christian",
            "Heavy Latin Cross",
            "catholicism",
            "christianity",
            "church",
            "cross",
            "jesus",
            "latin cross",
            "religion"
        ]
    },
    {
        "icon": "person",
        "label": "Person",
        "search": [
            "default",
            "man",
            "person standing",
            "stand",
            "standing",
            "uer",
            "woman"
        ]
    },
    {
        "icon": "mp3-player",
        "label": "Mp3 Player",
        "search": [
            "audio",
            "handheld",
            "ipod",
            "itunes",
            "music",
            "zune"
        ]
    },
    {
        "icon": "circle-bolt",
        "label": "Circle Bolt",
        "search": [
            "energy",
            "flash",
            "lightning"
        ]
    },
    {
        "icon": "hourglass",
        "label": "Hourglass",
        "search": [
            "hour",
            "hourglass",
            "hourglass not done",
            "minute",
            "sand",
            "stopwatch",
            "time",
            "timer"
        ]
    },
    {
        "icon": "trash-can-slash",
        "label": "Trash Can Slash",
        "search": [
            "delete",
            "disabled",
            "garbage",
            "hide",
            "remove"
        ]
    },
    {
        "icon": "fish",
        "label": "Fish",
        "search": [
            "Pisces",
            "fauna",
            "fish",
            "gold",
            "seafood",
            "swimming",
            "zodiac"
        ]
    },
    {
        "icon": "drumstick-bite",
        "label": "Drumstick Bite",
        "search": [
            "bone",
            "chicken",
            "leg",
            "meat",
            "poultry",
            "turkey"
        ]
    },
    {
        "icon": "file-jpg",
        "label": "File Jpg",
        "search": [
            "Document with Picture",
            "document",
            "image",
            "jpg",
            "photo"
        ]
    },
    {
        "icon": "chart-simple",
        "label": "Chart Simple",
        "search": [
            "analytics",
            "bar",
            "chart",
            "column",
            "graph",
            "performance",
            "revenue",
            "row",
            "statistics",
            "trend"
        ]
    },
    {
        "icon": "circle-ellipsis-vertical",
        "label": "Circle Ellipsis Vertical",
        "search": [
            "menu",
            "more",
            "three dots"
        ]
    },
    {
        "icon": "atom",
        "label": "Atom",
        "search": [
            "atheism",
            "atheist",
            "atom",
            "atom symbol",
            "chemistry",
            "electron",
            "ion",
            "isotope",
            "knowledge",
            "neutron",
            "nuclear",
            "proton",
            "science"
        ]
    },
    {
        "icon": "print-magnifying-glass",
        "label": "Print Magnifying Glass",
        "search": [
            "business",
            "copy",
            "document",
            "find",
            "magnifier",
            "office",
            "paper",
            "search"
        ]
    },
    {
        "icon": "image-polaroid",
        "label": "Image Polaroid",
        "search": [
            "capture",
            "film",
            "img",
            "instant camera",
            "lens",
            "photo",
            "photography",
            "retro",
            "snapshot",
            "vintage"
        ]
    },
    {
        "icon": "square-terminal",
        "label": "Square Terminal",
        "search": [
            "code",
            "coding",
            "command",
            "console",
            "development",
            "prompt",
            "terminal"
        ]
    },
    {
        "icon": "lightbulb-message",
        "label": "Lightbulb Message",
        "search": [
            "chat",
            "communication",
            "conversation",
            "jabber"
        ]
    },
    {
        "icon": "hands-holding-diamond",
        "label": "Hands Holding Diamond",
        "search": [
            "carry",
            "gift",
            "handling",
            "package",
            "shipping"
        ]
    },
    {
        "icon": "circle-j",
        "label": "Circle J",
        "search": [
            "Circled Latin Capital Letter J",
            "letter"
        ]
    },
    {
        "icon": "pedestal",
        "label": "Pedestal",
        "search": [
            "electricity",
            "reading"
        ]
    },
    {
        "icon": "p",
        "label": "P",
        "search": [
            "Latin Capital Letter P",
            "Latin Small Letter P",
            "letter"
        ]
    },
    {
        "icon": "dagger",
        "label": "Dagger",
        "search": [
            "Dungeons & Dragons",
            "blade",
            "d&d",
            "dnd",
            "fantasy",
            "melee attack",
            "rogue",
            "sting",
            "weapon"
        ]
    },
    {
        "icon": "jet-fighter-up",
        "label": "Jet Fighter Up",
        "search": [
            "airforce",
            "airplane",
            "airport",
            "fast",
            "fly",
            "goose",
            "marines",
            "maverick",
            "military",
            "plane",
            "quick",
            "top gun",
            "transportation",
            "travel"
        ]
    },
    {
        "icon": "field-hockey-stick-ball",
        "label": "Field Hockey Stick Ball",
        "search": [
            "ball",
            "field",
            "field hockey",
            "game",
            "hockey",
            "sport",
            "stick"
        ]
    },
    {
        "icon": "plug-circle-xmark",
        "label": "Plug Circle Xmark",
        "search": [
            "destroy",
            "disconnect",
            "electric",
            "electricity",
            "outage",
            "plug",
            "power",
            "uncheck"
        ]
    },
    {
        "icon": "sheet-plastic",
        "label": "Sheet Plastic",
        "search": [
            "plastic",
            "plastic wrap",
            "protect",
            "tarp",
            "tarpaulin",
            "waterproof"
        ]
    },
    {
        "icon": "v",
        "label": "V",
        "search": [
            "Latin Capital Letter V",
            "Latin Small Letter V",
            "letter"
        ]
    },
    {
        "icon": "list",
        "label": "List",
        "search": [
            "bullet",
            "category",
            "cheatsheet",
            "checklist",
            "completed",
            "done",
            "finished",
            "ol",
            "summary",
            "todo",
            "ul"
        ]
    },
    {
        "icon": "olive-branch",
        "label": "Olive Branch",
        "search": [
            "branch",
            "food",
            "oil",
            "olive",
            "peace",
            "victory"
        ]
    },
    {
        "icon": "gif",
        "label": "Gif",
        "search": [
            "animation",
            "img"
        ]
    },
    {
        "icon": "hose-reel",
        "label": "Hose Reel",
        "search": [
            "fire",
            "irrigation",
            "water"
        ]
    },
    {
        "icon": "circle-s",
        "label": "Circle S",
        "search": [
            "Circled Latin Capital Letter S",
            "letter"
        ]
    },
    {
        "icon": "square-m",
        "label": "Square M",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "circle-caret-left",
        "label": "Circle Caret Left",
        "search": [
            "arrow",
            "back",
            "previous",
            "triangle"
        ]
    },
    {
        "icon": "circle-quarters",
        "label": "Circle Quarters",
        "search": [
            "emergency",
            "light",
            "spiderman"
        ]
    },
    {
        "icon": "solar-panel",
        "label": "Solar Panel",
        "search": [
            "clean",
            "eco-friendly",
            "energy",
            "green",
            "sun"
        ]
    },
    {
        "icon": "land-mine-on",
        "label": "Land Mine On",
        "search": [
            "bomb",
            "danger",
            "explosion",
            "war"
        ]
    },
    {
        "icon": "ballot",
        "label": "Ballot",
        "search": [
            "checklist",
            "choice",
            "election",
            "vote",
            "voting"
        ]
    },
    {
        "icon": "jxl",
        "label": "JXL",
        "search": []
    },
    {
        "icon": "gift-card",
        "label": "Gift Card",
        "search": [
            "christmas",
            "generosity",
            "giving",
            "holiday",
            "money",
            "party",
            "present",
            "salary",
            "wrapped",
            "xmas"
        ]
    },
    {
        "icon": "headphones",
        "label": "Headphones",
        "search": [
            "audio",
            "earbud",
            "headphone",
            "listen",
            "music",
            "sound",
            "speaker"
        ]
    },
    {
        "icon": "bus",
        "label": "Bus",
        "search": [
            "bus",
            "oncoming",
            "oncoming bus",
            "public transportation",
            "transportation",
            "travel",
            "vehicle"
        ]
    },
    {
        "icon": "file-powerpoint",
        "label": "File Powerpoint",
        "search": [
            "display",
            "document",
            "keynote",
            "presentation"
        ]
    },
    {
        "icon": "messages",
        "label": "Messages",
        "search": [
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "conversation",
            "discussion",
            "feedback",
            "message",
            "note",
            "notification",
            "sms",
            "speech",
            "talk",
            "talking",
            "texting"
        ]
    },
    {
        "icon": "barcode-read",
        "label": "Barcode Read",
        "search": [
            "info",
            "laser",
            "price",
            "scan",
            "upc"
        ]
    },
    {
        "icon": "quote-left",
        "label": "Quote Left",
        "search": [
            "Left Double Quotation Mark",
            "mention",
            "note",
            "phrase",
            "text",
            "type"
        ]
    },
    {
        "icon": "screencast",
        "label": "Screencast",
        "search": [
            "airplay",
            "share",
            "stream"
        ]
    },
    {
        "icon": "ski-boot",
        "label": "Ski Boot",
        "search": [
            "boot",
            "ski",
            "snow",
            "winter"
        ]
    },
    {
        "icon": "family-pants",
        "label": "Family Pants",
        "search": [
            "adults",
            "child",
            "family",
            "folk",
            "kid",
            "parent",
            "together",
            "uer"
        ]
    },
    {
        "icon": "eye-dropper-full",
        "label": "Eye Dropper Full",
        "search": [
            "color",
            "eyedrop"
        ]
    },
    {
        "icon": "chevron-down",
        "label": "Chevron Down",
        "search": [
            "arrow",
            "download",
            "expand",
            "insert"
        ]
    },
    {
        "icon": "earth-asia",
        "label": "Earth Asia",
        "search": [
            "all",
            "asia",
            "australia",
            "country",
            "earth",
            "global",
            "globe",
            "gps",
            "language",
            "localize",
            "location",
            "map",
            "online",
            "place",
            "planet",
            "translate",
            "travel",
            "world"
        ]
    },
    {
        "icon": "cent-sign",
        "label": "Cent Sign",
        "search": [
            "Cent Sign",
            "currency"
        ]
    },
    {
        "icon": "shield-cat",
        "label": "Shield Cat",
        "search": [
            "animal",
            "feline",
            "pet",
            "protect",
            "safety",
            "veterinary"
        ]
    },
    {
        "icon": "school-circle-check",
        "label": "School Circle Check",
        "search": [
            "enable",
            "not affected",
            "ok",
            "okay",
            "schoolhouse",
            "validate",
            "working"
        ]
    },
    {
        "icon": "martini-glass",
        "label": "Martini Glass",
        "search": [
            "alcohol",
            "bar",
            "beverage",
            "cocktail",
            "cocktail glass",
            "drink",
            "glass",
            "liquor"
        ]
    },
    {
        "icon": "user-unlock",
        "label": "User Unlock",
        "search": [
            "employee",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "plug",
        "label": "Plug",
        "search": [
            "connect",
            "electric",
            "electric plug",
            "electricity",
            "online",
            "plug",
            "power"
        ]
    },
    {
        "icon": "spinner-third",
        "label": "Spinner Third",
        "search": [
            "circle",
            "loading",
            "pending",
            "progress"
        ]
    },
    {
        "icon": "wind-warning",
        "label": "Wind Warning",
        "search": [
            "air",
            "alert",
            "blow",
            "breeze",
            "failed",
            "fall",
            "hurricane",
            "seasonal",
            "tornado",
            "weather"
        ]
    },
    {
        "icon": "panorama",
        "label": "Panorama",
        "search": [
            "image",
            "img",
            "landscape",
            "photo",
            "wide"
        ]
    },
    {
        "icon": "clock-rotate-left",
        "label": "Clock Rotate Left",
        "search": [
            "Rewind",
            "clock",
            "pending",
            "reverse",
            "time",
            "time machine",
            "time travel",
            "waiting"
        ]
    },
    {
        "icon": "wifi-weak",
        "label": "Wifi Weak",
        "search": [
            "connection",
            "hotspot",
            "internet",
            "network",
            "signal",
            "weak",
            "wireless",
            "www"
        ]
    },
    {
        "icon": "waveform",
        "label": "Waveform",
        "search": [
            "amplitude",
            "sound",
            "soundwave"
        ]
    },
    {
        "icon": "ticket-airline",
        "label": "Ticket Airline",
        "search": [
            "airplane",
            "arrival",
            "boarding pass",
            "departure",
            "ticket",
            "travel"
        ]
    },
    {
        "icon": "css",
        "label": "Css",
        "search": [
            "rebecca purple"
        ]
    },
    {
        "icon": "link-simple",
        "label": "Link Simple",
        "search": [
            "attach",
            "attachment",
            "chain",
            "connect"
        ]
    },
    {
        "icon": "rectangle-wide",
        "label": "Rectangle Wide",
        "search": [
            "geometry",
            "landscape",
            "shape"
        ]
    },
    {
        "icon": "pig",
        "label": "Pig",
        "search": [
            "agriculture",
            "animal",
            "farm",
            "fauna",
            "mammal",
            "oink",
            "pig",
            "sow"
        ]
    },
    {
        "icon": "jar-wheat",
        "label": "Jar Wheat",
        "search": [
            "flour",
            "storage"
        ]
    },
    {
        "icon": "hashnode",
        "label": "Hashnode",
        "search": []
    },
    {
        "icon": "reddit-alien",
        "label": "Reddit Alien",
        "search": []
    },
    {
        "icon": "bookmark-slash",
        "label": "Bookmark Slash",
        "search": [
            "disabled",
            "library",
            "research"
        ]
    },
    {
        "icon": "arrow-up-right",
        "label": "Arrow Up Right",
        "search": [
            "diagonal",
            "northeast"
        ]
    },
    {
        "icon": "square-v",
        "label": "Square V",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "tiktok",
        "label": "TikTok",
        "search": []
    },
    {
        "icon": "cloud-arrow-down",
        "label": "Cloud Arrow Down",
        "search": [
            "download",
            "export",
            "save"
        ]
    },
    {
        "icon": "keyboard-left",
        "label": "Keyboard Left",
        "search": [
            "hide",
            "keyboard"
        ]
    },
    {
        "icon": "badge-check",
        "label": "Badge Check",
        "search": [
            "accept",
            "achievement",
            "agree",
            "award",
            "confirm",
            "correct",
            "done",
            "enable",
            "guarantee",
            "ok",
            "security",
            "select",
            "success",
            "validate",
            "verified",
            "verify",
            "warranty",
            "winner",
            "working",
            "yes"
        ]
    },
    {
        "icon": "truck-ramp-box",
        "label": "Truck Ramp Box",
        "search": [
            "box",
            "cargo",
            "delivery",
            "inventory",
            "moving",
            "rental",
            "vehicle"
        ]
    },
    {
        "icon": "face-dotted",
        "label": "Face Dotted",
        "search": [
            "default",
            "depression",
            "hidden",
            "hide",
            "invisible",
            "quiet"
        ]
    },
    {
        "icon": "circle-1",
        "label": "Circle 1",
        "search": [
            "Circled Digit One",
            "Dingbat Circled Sans-Serif Digit One",
            "Dingbat Negative Circled Digit One",
            "Dingbat Negative Circled Sans-Serif Digit One",
            "one"
        ]
    },
    {
        "icon": "octopus",
        "label": "Octopus",
        "search": [
            "eight",
            "illithid",
            "ink",
            "mind flayer",
            "mollusk",
            "ocean",
            "sea",
            "squid",
            "tentacle",
            "underwater"
        ]
    },
    {
        "icon": "angle-down",
        "label": "Angle Down",
        "search": [
            "Down Arrowhead",
            "arrow",
            "caret",
            "download",
            "expand",
            "insert"
        ]
    },
    {
        "icon": "square-kanban",
        "label": "Square Kanban",
        "search": [
            "board",
            "chart",
            "graph",
            "kanban",
            "list",
            "organize",
            "project",
            "statistics"
        ]
    },
    {
        "icon": "circle-three-quarters-stroke",
        "label": "Circle Three Quarters Stroke",
        "search": [
            "adjust",
            "chart",
            "fill",
            "pie",
            "progress"
        ]
    },
    {
        "icon": "plug-circle-check",
        "label": "Plug Circle Check",
        "search": [
            "electric",
            "electricity",
            "enable",
            "not affected",
            "ok",
            "okay",
            "plug",
            "power",
            "validate",
            "working"
        ]
    },
    {
        "icon": "window-maximize",
        "label": "Window Maximize",
        "search": [
            "Maximize",
            "browser",
            "computer",
            "development",
            "expand"
        ]
    },
    {
        "icon": "tv-music",
        "label": "Tv Music",
        "search": [
            "audio",
            "mtv",
            "music",
            "music video",
            "sound",
            "television",
            "vh1"
        ]
    },
    {
        "icon": "hands-holding-circle",
        "label": "Hands Holding Circle",
        "search": [
            "circle",
            "gift",
            "protection"
        ]
    },
    {
        "icon": "wreath",
        "label": "Wreath",
        "search": [
            "christmas",
            "decoration",
            "door",
            "holiday",
            "welcome",
            "xmas"
        ]
    },
    {
        "icon": "location-pin",
        "label": "Location Pin",
        "search": [
            "address",
            "coordinates",
            "destination",
            "gps",
            "localize",
            "location",
            "map",
            "navigation",
            "paper",
            "pin",
            "place",
            "point of interest",
            "position",
            "route",
            "travel"
        ]
    },
    {
        "icon": "bowling-ball",
        "label": "Bowling Ball",
        "search": [
            "alley",
            "candlepin",
            "gutter",
            "lane",
            "strike",
            "tenpin"
        ]
    },
    {
        "icon": "cart-flatbed",
        "label": "Cart Flatbed",
        "search": [
            "carry",
            "inventory",
            "shipping",
            "transport"
        ]
    },
    {
        "icon": "house-user",
        "label": "House User",
        "search": [
            "house",
            "uer"
        ]
    },
    {
        "icon": "brain-circuit",
        "label": "Brain Circuit",
        "search": [
            "ai",
            "android",
            "artificial intelligence",
            "brain",
            "genius",
            "knowledge",
            "scholar"
        ]
    },
    {
        "icon": "envelopes",
        "label": "Envelopes",
        "search": [
            "email"
        ]
    },
    {
        "icon": "escalator",
        "label": "Escalator",
        "search": [
            "elevator",
            "rise",
            "stairs"
        ]
    },
    {
        "icon": "ghost",
        "label": "Ghost",
        "search": [
            "apparition",
            "blinky",
            "clyde",
            "creature",
            "face",
            "fairy tale",
            "fantasy",
            "floating",
            "ghost",
            "halloween",
            "holiday",
            "inky",
            "monster",
            "pacman",
            "pinky",
            "spirit"
        ]
    },
    {
        "icon": "floppy-disk-circle-xmark",
        "label": "Floppy Disk Circle Xmark",
        "search": [
            "disk",
            "download",
            "floppy",
            "floppy-o",
            "uncheck"
        ]
    },
    {
        "icon": "display-code",
        "label": "Display Code",
        "search": [
            "coding",
            "computer",
            "desktop",
            "developing",
            "mysql",
            "sql"
        ]
    },
    {
        "icon": "balloons",
        "label": "Balloons",
        "search": [
            "birthday",
            "celebrate",
            "celebration",
            "helium",
            "party",
            "pop",
            "up"
        ]
    },
    {
        "icon": "comment-nodes",
        "label": "Comment Nodes",
        "search": [
            "ai",
            "artificial intelligence",
            "cluster",
            "language",
            "model",
            "network",
            "neuronal"
        ]
    },
    {
        "icon": "tree-christmas",
        "label": "Tree Christmas",
        "search": [
            "Christmas",
            "Christmas tree",
            "celebration",
            "christmas",
            "decorated",
            "decorations",
            "flora",
            "holiday",
            "lights",
            "plant",
            "star",
            "tree",
            "xmas"
        ]
    },
    {
        "icon": "person-arrow-down-to-line",
        "label": "Person Arrow Down To Line",
        "search": [
            "ground",
            "indigenous",
            "insert",
            "native",
            "uer"
        ]
    },
    {
        "icon": "plug-circle-plus",
        "label": "Plug Circle Plus",
        "search": [
            "electric",
            "electricity",
            "plug",
            "power"
        ]
    },
    {
        "icon": "person-swimming",
        "label": "Person Swimming",
        "search": [
            "ocean",
            "person swimming",
            "pool",
            "sea",
            "swim",
            "uer",
            "water"
        ]
    },
    {
        "icon": "comment-dots",
        "label": "Comment Dots",
        "search": [
            "answer",
            "balloon",
            "bubble",
            "chat",
            "comic",
            "commenting",
            "conversation",
            "dialog",
            "feedback",
            "message",
            "more",
            "note",
            "notification",
            "reply",
            "request",
            "sms",
            "speech",
            "speech balloon",
            "texting"
        ]
    },
    {
        "icon": "chart-pie",
        "label": "Chart Pie",
        "search": [
            "analytics",
            "chart",
            "diagram",
            "graph",
            "performance",
            "pie",
            "revenue",
            "statistics"
        ]
    },
    {
        "icon": "shirt-running",
        "label": "Shirt Running",
        "search": [
            "athletics",
            "running",
            "running shirt",
            "sash",
            "shirt",
            "tank top"
        ]
    },
    {
        "icon": "bus-school",
        "label": "Bus School",
        "search": [
            "education",
            "school",
            "transportation",
            "vehicle"
        ]
    },
    {
        "icon": "phone-arrow-right",
        "label": "Phone Arrow Right",
        "search": [
            "answer",
            "call",
            "forward",
            "next",
            "reply",
            "send",
            "telephone"
        ]
    },
    {
        "icon": "list-music",
        "label": "List Music",
        "search": [
            "album",
            "cheatsheet",
            "itunes",
            "music",
            "playlist",
            "podcast",
            "soundtrack",
            "summary"
        ]
    },
    {
        "icon": "leaf-heart",
        "label": "Leaf Heart",
        "search": [
            "eco",
            "flora",
            "nature",
            "plant",
            "vegan",
            "wishlist"
        ]
    },
    {
        "icon": "chart-bullet",
        "label": "Chart Bullet",
        "search": [
            "chart",
            "graph",
            "performance",
            "statistics"
        ]
    },
    {
        "icon": "face-smile-hearts",
        "label": "Face Smile Hearts",
        "search": [
            "adore",
            "crush",
            "happy",
            "hearts",
            "in love",
            "love",
            "smiling face with hearts"
        ]
    },
    {
        "icon": "calendar-arrow-down",
        "label": "Calendar Arrow Down",
        "search": [
            "date",
            "day",
            "download",
            "insert",
            "month",
            "reminder",
            "year"
        ]
    },
    {
        "icon": "mobile-signal-out",
        "label": "Mobile Signal Out",
        "search": [
            "android",
            "iphone",
            "nfc",
            "scan"
        ]
    },
    {
        "icon": "frog",
        "label": "Frog",
        "search": [
            "amphibian",
            "bullfrog",
            "fauna",
            "hop",
            "kermit",
            "kiss",
            "prince",
            "ribbit",
            "toad",
            "wart"
        ]
    },
    {
        "icon": "wrench-simple",
        "label": "Wrench Simple",
        "search": [
            "configuration",
            "equipment",
            "maintenance",
            "modify",
            "settings",
            "tool"
        ]
    },
    {
        "icon": "wordpress",
        "label": "WordPress Logo",
        "search": []
    },
    {
        "icon": "wine-bottle",
        "label": "Wine Bottle",
        "search": [
            "alcohol",
            "beverage",
            "cabernet",
            "drink",
            "glass",
            "grapes",
            "merlot",
            "sauvignon"
        ]
    },
    {
        "icon": "pancakes",
        "label": "Pancakes",
        "search": [
            "breakfast",
            "crepe",
            "flapjack",
            "hotcake",
            "pancake",
            "stack",
            "syrup"
        ]
    },
    {
        "icon": "inbox",
        "label": "Inbox",
        "search": [
            "archive",
            "desk",
            "email",
            "mail",
            "message"
        ]
    },
    {
        "icon": "bolt-slash",
        "label": "Bolt Slash",
        "search": [
            "charge",
            "disabled",
            "electricity",
            "flash",
            "lightning",
            "weather",
            "zap"
        ]
    },
    {
        "icon": "star-shooting",
        "label": "Star Shooting",
        "search": [
            "asteroid",
            "comet",
            "falling",
            "meteor",
            "shooting",
            "shooting star",
            "space",
            "star",
            "wish"
        ]
    },
    {
        "icon": "horizontal-rule",
        "label": "Horizontal Rule",
        "search": [
            "Horizontal Bar",
            "divider",
            "hr",
            "line",
            "page break"
        ]
    },
    {
        "icon": "cloud-bolt-moon",
        "label": "Cloud Bolt Moon",
        "search": [
            "bolt",
            "lightning",
            "lunar",
            "moon",
            "precipitation",
            "rain",
            "storm",
            "weather"
        ]
    },
    {
        "icon": "ideal",
        "label": "iDeal",
        "search": []
    },
    {
        "icon": "nfc-slash",
        "label": "Nfc Slash",
        "search": [
            "cancel",
            "connect",
            "data",
            "disabled",
            "near field communication",
            "nfc",
            "scan",
            "signal",
            "transfer",
            "wireless"
        ]
    },
    {
        "icon": "pied-piper-pp",
        "label": "Pied Piper PP Logo (Old)",
        "search": []
    },
    {
        "icon": "square-h",
        "label": "Square H",
        "search": [
            "directions",
            "emergency",
            "hospital",
            "hotel",
            "letter",
            "map"
        ]
    },
    {
        "icon": "house-medical",
        "label": "House Medical",
        "search": [
            "covid-19",
            "doctor",
            "facility",
            "general practitioner",
            "health",
            "hospital",
            "infirmary",
            "medicine",
            "office",
            "outpatient"
        ]
    },
    {
        "icon": "circle-chevron-right",
        "label": "Circle Chevron Right",
        "search": [
            "arrow",
            "forward",
            "next"
        ]
    },
    {
        "icon": "file-csv",
        "label": "File Csv",
        "search": [
            "document",
            "excel",
            "numbers",
            "spreadsheets",
            "table"
        ]
    },
    {
        "icon": "hat-cowboy",
        "label": "Hat Cowboy",
        "search": [
            "buckaroo",
            "horse",
            "jackeroo",
            "john b.",
            "old west",
            "pardner",
            "ranch",
            "rancher",
            "rodeo",
            "western",
            "wrangler"
        ]
    },
    {
        "icon": "ussunnah",
        "label": "us-Sunnah Foundation",
        "search": []
    },
    {
        "icon": "face-grin-tongue-wink",
        "label": "Face Grin Tongue Wink",
        "search": [
            "LOL",
            "emoticon",
            "eye",
            "face",
            "joke",
            "tongue",
            "wink",
            "winking face with tongue"
        ]
    },
    {
        "icon": "shelves",
        "label": "Shelves",
        "search": [
            "archive",
            "box",
            "shipping",
            "warehouse"
        ]
    },
    {
        "icon": "hexagon-exclamation",
        "label": "Hexagon Exclamation",
        "search": [
            "alert",
            "attention",
            "danger",
            "error",
            "failed",
            "important",
            "notice",
            "notification",
            "notify",
            "problem",
            "required",
            "warning"
        ]
    },
    {
        "icon": "arrows-repeat-1",
        "label": "Arrows Repeat 1",
        "search": [
            "flip",
            "reload",
            "renew",
            "retry",
            "rewind",
            "switch"
        ]
    },
    {
        "icon": "l",
        "label": "L",
        "search": [
            "Latin Capital Letter L",
            "Latin Small Letter L",
            "letter"
        ]
    },
    {
        "icon": "phone-missed",
        "label": "Phone Missed",
        "search": [
            "call",
            "rebound"
        ]
    },
    {
        "icon": "arrow-down-short-wide",
        "label": "Arrow Down Short Wide",
        "search": [
            "arrange",
            "filter",
            "order",
            "sort-amount-asc"
        ]
    },
    {
        "icon": "hourglass-half",
        "label": "Hourglass Half",
        "search": [
            "hour",
            "minute",
            "pending",
            "sand",
            "stopwatch",
            "time",
            "waiting"
        ]
    },
    {
        "icon": "scalpel-line-dashed",
        "label": "Scalpel Line Dashed",
        "search": [
            "blade",
            "cut",
            "doctor",
            "knife",
            "surgeon",
            "surgery"
        ]
    },
    {
        "icon": "cloud-snow",
        "label": "Cloud Snow",
        "search": [
            "blizzard",
            "cloud",
            "cloud with snow",
            "cold",
            "noreaster",
            "precipitation",
            "snow",
            "winter"
        ]
    },
    {
        "icon": "fort-awesome-alt",
        "label": "Alternate Fort Awesome",
        "search": [
            "castle"
        ]
    },
    {
        "icon": "square-down-right",
        "label": "Square Down Right",
        "search": [
            "arrow",
            "diagonal",
            "direction",
            "down-right arrow",
            "intercardinal",
            "southeast"
        ]
    },
    {
        "icon": "spoon",
        "label": "Spoon",
        "search": [
            "cutlery",
            "dining",
            "scoop",
            "silverware",
            "spoon",
            "tableware"
        ]
    },
    {
        "icon": "clock-eleven",
        "label": "Clock Eleven",
        "search": [
            "00",
            "11",
            "11:00",
            "clock",
            "eleven",
            "eleven o’clock",
            "hour",
            "minute",
            "o'clock",
            "o’clock",
            "pending",
            "ticking",
            "time"
        ]
    },
    {
        "icon": "credit-card",
        "label": "Credit Card",
        "search": [
            "buy",
            "card",
            "checkout",
            "credit",
            "credit card",
            "credit-card-alt",
            "debit",
            "money",
            "payment",
            "purchase"
        ]
    },
    {
        "icon": "file-invoice-dollar",
        "label": "File Invoice Dollar",
        "search": [
            "$",
            "account",
            "bill",
            "charge",
            "document",
            "dollar-sign",
            "money",
            "payment",
            "receipt",
            "revenue",
            "salary",
            "usd"
        ]
    },
    {
        "icon": "violin",
        "label": "Violin",
        "search": [
            "bow",
            "cello",
            "fiddle",
            "instrument",
            "music",
            "orchestra",
            "string",
            "violin"
        ]
    },
    {
        "icon": "spaghetti-monster-flying",
        "label": "Spaghetti Monster Flying",
        "search": [
            "agnosticism",
            "atheism",
            "flying spaghetti monster",
            "fsm"
        ]
    },
    {
        "icon": "martini-glass-citrus",
        "label": "Martini Glass Citrus",
        "search": [
            "alcohol",
            "beverage",
            "drink",
            "gin",
            "glass",
            "margarita",
            "martini",
            "vodka"
        ]
    },
    {
        "icon": "chart-mixed-up-circle-dollar",
        "label": "Chart Mixed Up Circle Dollar",
        "search": [
            "analytics",
            "chart",
            "currency",
            "data",
            "forecast",
            "graph",
            "investment",
            "measure",
            "money",
            "roi",
            "tracking",
            "trend"
        ]
    },
    {
        "icon": "clock-one-thirty",
        "label": "Clock One Thirty",
        "search": [
            "1",
            "1:30",
            "clock",
            "hour",
            "minute",
            "o'clock",
            "pending",
            "thirty",
            "ticking",
            "time"
        ]
    },
    {
        "icon": "bullhorn",
        "label": "Bullhorn",
        "search": [
            "Bullhorn",
            "announcement",
            "broadcast",
            "loud",
            "louder",
            "loudspeaker",
            "megaphone",
            "public address",
            "request",
            "share"
        ]
    },
    {
        "icon": "box-tissue",
        "label": "Box Tissue",
        "search": [
            "cough",
            "covid-19",
            "kleenex",
            "mucus",
            "nose",
            "sneeze",
            "snot"
        ]
    },
    {
        "icon": "do-not-enter",
        "label": "Do Not Enter",
        "search": [
            "404",
            "closed",
            "not found",
            "traffic",
            "warning"
        ]
    },
    {
        "icon": "angle",
        "label": "Angle",
        "search": [
            "Measured Angle",
            "acute",
            "measure"
        ]
    },
    {
        "icon": "mattress-pillow",
        "label": "Mattress Pillow",
        "search": [
            "air mattress",
            "mattress",
            "pillow",
            "rest",
            "sleep"
        ]
    },
    {
        "icon": "cricket-bat-ball",
        "label": "Cricket Bat Ball",
        "search": [
            "ball",
            "bat",
            "bowling",
            "cricket game",
            "game",
            "wicket"
        ]
    },
    {
        "icon": "buromobelexperte",
        "label": "Büromöbel-Experte GmbH & Co. KG.",
        "search": []
    },
    {
        "icon": "bilibili",
        "label": "Bilibili",
        "search": []
    },
    {
        "icon": "chevron-left",
        "label": "Chevron Left",
        "search": [
            "Left-Pointing Angle Bracket",
            "arrow",
            "back",
            "bracket",
            "previous"
        ]
    },
    {
        "icon": "cloud-moon-rain",
        "label": "Cloud Moon Rain",
        "search": [
            "crescent",
            "evening",
            "lunar",
            "night",
            "partly cloudy",
            "precipitation",
            "rain",
            "sky",
            "storm"
        ]
    },
    {
        "icon": "neos",
        "label": "Neos",
        "search": []
    },
    {
        "icon": "arrow-down-1-9",
        "label": "Arrow Down 1 9",
        "search": [
            "arrange",
            "filter",
            "numbers",
            "order",
            "sort-numeric-asc"
        ]
    },
    {
        "icon": "bin-bottles-recycle",
        "label": "Bin Bottles Recycle",
        "search": [
            "collect",
            "jug",
            "plastics",
            "recycle"
        ]
    },
    {
        "icon": "bring-front",
        "label": "Bring Front",
        "search": [
            "arrange",
            "forward",
            "layer",
            "order",
            "stack"
        ]
    },
    {
        "icon": "seat-airline",
        "label": "Seat Airline",
        "search": [
            "airplane",
            "chair",
            "recline",
            "seat"
        ]
    },
    {
        "icon": "user-large",
        "label": "User Large",
        "search": [
            "employee",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "hand-spock",
        "label": "Hand Spock",
        "search": [
            "finger",
            "hand",
            "live long",
            "palm",
            "prosper",
            "salute",
            "spock",
            "star trek",
            "vulcan",
            "vulcan salute"
        ]
    },
    {
        "icon": "dev",
        "label": "DEV",
        "search": []
    },
    {
        "icon": "wand-magic-sparkles",
        "label": "Wand Magic Sparkles",
        "search": [
            "auto",
            "magic",
            "magic wand",
            "trick",
            "witch",
            "wizard"
        ]
    },
    {
        "icon": "panel-ews",
        "label": "Panel Ews",
        "search": [
            "emergency",
            "intercom",
            "phone"
        ]
    },
    {
        "icon": "comment-medical",
        "label": "Comment Medical",
        "search": [
            "advice",
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "diagnose",
            "feedback",
            "message",
            "note",
            "notification",
            "prescription",
            "sms",
            "speech",
            "texting"
        ]
    },
    {
        "icon": "bell-slash",
        "label": "Bell Slash",
        "search": [
            "alert",
            "bell",
            "bell with slash",
            "cancel",
            "disabled",
            "forbidden",
            "mute",
            "notification",
            "off",
            "quiet",
            "reminder",
            "silent"
        ]
    },
    {
        "icon": "handshake-slash",
        "label": "Handshake Slash",
        "search": [
            "broken",
            "covid-19",
            "disabled",
            "social distance"
        ]
    },
    {
        "icon": "pizza",
        "label": "Pizza",
        "search": [
            "cheese",
            "chicago",
            "italian",
            "mozzarella",
            "new york",
            "pepperoni",
            "pie",
            "pizza",
            "slice",
            "teenage mutant ninja turtles",
            "tomato"
        ]
    },
    {
        "icon": "bottle-water",
        "label": "Bottle Water",
        "search": [
            "h2o",
            "plastic",
            "water"
        ]
    },
    {
        "icon": "folders",
        "label": "Folders",
        "search": [
            "archive",
            "copy",
            "directory",
            "document",
            "duplicate",
            "file"
        ]
    },
    {
        "icon": "sun-dust",
        "label": "Sun Dust",
        "search": [
            "day",
            "dry",
            "haze",
            "heat"
        ]
    },
    {
        "icon": "dice-d20",
        "label": "Dice D20",
        "search": [
            "Dungeons & Dragons",
            "chance",
            "d&d",
            "dnd",
            "fantasy",
            "gambling",
            "game",
            "roll"
        ]
    },
    {
        "icon": "folder-gear",
        "label": "Folder Gear",
        "search": [
            "admin",
            "cog",
            "configuration",
            "file",
            "modify",
            "preferences",
            "settings"
        ]
    },
    {
        "icon": "arrow-down-z-a",
        "label": "Arrow Down Z A",
        "search": [
            "alphabetical",
            "arrange",
            "filter",
            "order",
            "sort-alpha-asc"
        ]
    },
    {
        "icon": "brush",
        "label": "Brush",
        "search": [
            "art",
            "bristles",
            "color",
            "handle",
            "maintenance",
            "modify",
            "paint"
        ]
    },
    {
        "icon": "person-walking-dashed-line-arrow-right",
        "label": "Person Walking Dashed Line Arrow Right",
        "search": [
            "exit",
            "follow",
            "refugee",
            "uer"
        ]
    },
    {
        "icon": "arrow-up-short-wide",
        "label": "Arrow Up Short Wide",
        "search": [
            "arrange",
            "filter",
            "order",
            "sort-amount-desc"
        ]
    },
    {
        "icon": "grip-vertical",
        "label": "Grip Vertical",
        "search": [
            "affordance",
            "drag",
            "drop",
            "grab",
            "handle"
        ]
    },
    {
        "icon": "car-tunnel",
        "label": "Car Tunnel",
        "search": [
            "road",
            "tunnel"
        ]
    },
    {
        "icon": "chart-column",
        "label": "Chart Column",
        "search": [
            "bar",
            "bar chart",
            "chart",
            "graph",
            "performance",
            "revenue",
            "statistics",
            "track",
            "trend"
        ]
    },
    {
        "icon": "send-back",
        "label": "Send Back",
        "search": [
            "arrange",
            "backward",
            "layer",
            "order",
            "stack"
        ]
    },
    {
        "icon": "comment-arrow-up-right",
        "label": "Comment Arrow Up Right",
        "search": [
            "answer",
            "chat",
            "contact",
            "discussion",
            "send",
            "upload"
        ]
    },
    {
        "icon": "hotjar",
        "label": "Hotjar",
        "search": []
    },
    {
        "icon": "truck-arrow-right",
        "label": "Truck Arrow Right",
        "search": [
            "access",
            "fast",
            "shipping",
            "transport"
        ]
    },
    {
        "icon": "tv",
        "label": "Tv",
        "search": [
            "computer",
            "display",
            "monitor",
            "television"
        ]
    },
    {
        "icon": "section",
        "label": "Section",
        "search": [
            "Section Sign",
            "law",
            "legal",
            "silcrow"
        ]
    },
    {
        "icon": "paragraph-left",
        "label": "Paragraph Left",
        "search": [
            "edit",
            "format",
            "text",
            "writing"
        ]
    },
    {
        "icon": "tree-decorated",
        "label": "Tree Decorated",
        "search": [
            "christmas",
            "decorations",
            "flora",
            "holiday",
            "lights",
            "plant",
            "xmas"
        ]
    },
    {
        "icon": "bin-bottles",
        "label": "Bin Bottles",
        "search": [
            "collect",
            "jug",
            "plastics",
            "recycle"
        ]
    },
    {
        "icon": "peace",
        "label": "Peace",
        "search": [
            "peace",
            "peace symbol",
            "serenity",
            "tranquility",
            "truce",
            "war"
        ]
    },
    {
        "icon": "star",
        "label": "Star",
        "search": [
            "achievement",
            "award",
            "favorite",
            "important",
            "night",
            "quality",
            "rating",
            "score",
            "star",
            "vip"
        ]
    },
    {
        "icon": "store-lock",
        "label": "Store Lock",
        "search": [
            "buy",
            "lock",
            "padlock",
            "privacy",
            "purchase",
            "shop",
            "store"
        ]
    },
    {
        "icon": "flag",
        "label": "Flag",
        "search": [
            "black flag",
            "country",
            "notice",
            "notification",
            "notify",
            "pole",
            "report",
            "symbol",
            "waving"
        ]
    },
    {
        "icon": "square-e",
        "label": "Square E",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "triangle-exclamation",
        "label": "Triangle Exclamation",
        "search": [
            "alert",
            "attention",
            "danger",
            "error",
            "failed",
            "important",
            "notice",
            "notification",
            "notify",
            "problem",
            "required",
            "warnin",
            "warning"
        ]
    },
    {
        "icon": "face-smirking",
        "label": "Face Smirking",
        "search": [
            "face",
            "flirt",
            "grin",
            "sexual",
            "smirk",
            "smirking face",
            "suggestive",
            "wry"
        ]
    },
    {
        "icon": "code-pull-request-draft",
        "label": "Code Pull Request Draft",
        "search": [
            "git",
            "github",
            "pr",
            "svn",
            "version"
        ]
    },
    {
        "icon": "dochub",
        "label": "DocHub",
        "search": []
    },
    {
        "icon": "school-circle-exclamation",
        "label": "School Circle Exclamation",
        "search": [
            "affected",
            "failed",
            "schoolhouse"
        ]
    },
    {
        "icon": "graduation-cap",
        "label": "Graduation Cap",
        "search": [
            "cap",
            "celebration",
            "ceremony",
            "clothing",
            "college",
            "graduate",
            "graduation",
            "graduation cap",
            "hat",
            "learning",
            "school",
            "student"
        ]
    },
    {
        "icon": "cloud-hail",
        "label": "Cloud Hail",
        "search": [
            "golf balls",
            "ice",
            "precipitation",
            "sleet",
            "snow",
            "storm"
        ]
    },
    {
        "icon": "arrow-right-from-line",
        "label": "Arrow Right From Line",
        "search": [
            "Rightwards Arrow from Bar",
            "back",
            "previous"
        ]
    },
    {
        "icon": "store",
        "label": "Store",
        "search": [
            "bodega",
            "building",
            "buy",
            "market",
            "purchase",
            "shopping",
            "store"
        ]
    },
    {
        "icon": "user-astronaut",
        "label": "User Astronaut",
        "search": [
            "avatar",
            "clothing",
            "cosmonaut",
            "nasa",
            "space",
            "suit",
            "uer"
        ]
    },
    {
        "icon": "cabin",
        "label": "Cabin",
        "search": [
            "cabin",
            "camp",
            "log",
            "lumber",
            "ranger"
        ]
    },
    {
        "icon": "building-flag",
        "label": "Building Flag",
        "search": [
            "building",
            "city",
            "diplomat",
            "embassy",
            "flag",
            "headquarters",
            "united nations"
        ]
    },
    {
        "icon": "wifi-fair",
        "label": "Wifi Fair",
        "search": [
            "average",
            "connection",
            "hotspot",
            "internet",
            "network",
            "signal",
            "wireless",
            "www"
        ]
    },
    {
        "icon": "mug-saucer",
        "label": "Mug Saucer",
        "search": [
            "beverage",
            "breakfast",
            "cafe",
            "drink",
            "fall",
            "morning",
            "mug",
            "seasonal",
            "tea"
        ]
    },
    {
        "icon": "lemon",
        "label": "Lemon",
        "search": [
            "citrus",
            "fruit",
            "lemon",
            "lemonade",
            "lime",
            "tart"
        ]
    },
    {
        "icon": "circle-phone-hangup",
        "label": "Circle Phone Hangup",
        "search": [
            "answer",
            "call",
            "handset",
            "telephone"
        ]
    },
    {
        "icon": "comment-check",
        "label": "Comment Check",
        "search": [
            "accept",
            "agree",
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "enable",
            "feedback",
            "message",
            "note",
            "notification",
            "select",
            "sms",
            "speech",
            "success",
            "synced",
            "texting",
            "tick",
            "todo",
            "validate",
            "working"
        ]
    },
    {
        "icon": "filter-list",
        "label": "Filter List",
        "search": [
            "cheatsheet",
            "funnel",
            "options",
            "separate",
            "sort",
            "summary"
        ]
    },
    {
        "icon": "caravan",
        "label": "Caravan",
        "search": [
            "camper",
            "motor home",
            "rv",
            "trailer",
            "travel"
        ]
    },
    {
        "icon": "vimeo",
        "label": "Vimeo",
        "search": []
    },
    {
        "icon": "maxcdn",
        "label": "MaxCDN",
        "search": []
    },
    {
        "icon": "square-font-awesome-stroke",
        "label": "Square Font Awesome Stroke",
        "search": [
            "awesome",
            "flag",
            "font",
            "icons",
            "typeface"
        ]
    },
    {
        "icon": "leaf-oak",
        "label": "Leaf Oak",
        "search": [
            "eco",
            "fall",
            "flora",
            "nature",
            "plant",
            "seasonal"
        ]
    },
    {
        "icon": "speakap",
        "label": "Speakap",
        "search": []
    },
    {
        "icon": "q",
        "label": "Q",
        "search": [
            "Latin Capital Letter Q",
            "Latin Small Letter Q",
            "letter"
        ]
    },
    {
        "icon": "lock",
        "label": "Lock",
        "search": [
            "admin",
            "closed",
            "lock",
            "locked",
            "open",
            "padlock",
            "password",
            "privacy",
            "private",
            "protect",
            "security"
        ]
    },
    {
        "icon": "paint-roller",
        "label": "Paint Roller",
        "search": [
            "acrylic",
            "art",
            "brush",
            "color",
            "fill",
            "maintenance",
            "paint",
            "pigment",
            "watercolor"
        ]
    },
    {
        "icon": "volume-high",
        "label": "Volume High",
        "search": [
            "audio",
            "higher",
            "loud",
            "louder",
            "music",
            "sound",
            "speaker",
            "speaker high volume"
        ]
    },
    {
        "icon": "face-tissue",
        "label": "Face Tissue",
        "search": [
            "face",
            "gesundheit",
            "sneeze",
            "sneezing face",
            "tears"
        ]
    },
    {
        "icon": "folder-plus",
        "label": "Folder Plus",
        "search": [
            "add",
            "archive",
            "create",
            "directory",
            "document",
            "file",
            "new",
            "positive"
        ]
    },
    {
        "icon": "refrigerator",
        "label": "Refrigerator",
        "search": [
            "cold",
            "cool",
            "freezer",
            "fridge",
            "icebox",
            "kitchen"
        ]
    },
    {
        "icon": "nfc",
        "label": "Nfc",
        "search": [
            "connect",
            "data",
            "near field communication",
            "nfc",
            "scan",
            "signal",
            "transfer",
            "wireless"
        ]
    },
    {
        "icon": "user-group-simple",
        "label": "User Group Simple",
        "search": [
            "bust",
            "busts in silhouette",
            "silhouette",
            "users-people"
        ]
    },
    {
        "icon": "mercury",
        "label": "Mercury",
        "search": [
            "Mercury",
            "gender",
            "hybrid",
            "transgender"
        ]
    },
    {
        "icon": "message-quote",
        "label": "Message Quote",
        "search": [
            "answer",
            "chat",
            "quote"
        ]
    },
    {
        "icon": "mailbox-flag-up",
        "label": "Mailbox Flag Up",
        "search": [
            "archive",
            "envelope",
            "letter",
            "mail",
            "mailbox",
            "open",
            "open mailbox with raised flag",
            "post office",
            "postal",
            "postbox",
            "postcard",
            "raised",
            "send",
            "stamp",
            "usps"
        ]
    },
    {
        "icon": "truck-clock",
        "label": "Truck Clock",
        "search": [
            "express",
            "fedex",
            "mail",
            "overnight",
            "package",
            "ups"
        ]
    },
    {
        "icon": "anchor",
        "label": "Anchor",
        "search": [
            "anchor",
            "berth",
            "boat",
            "dock",
            "embed",
            "link",
            "maritime",
            "moor",
            "port",
            "secure",
            "ship",
            "tool"
        ]
    },
    {
        "icon": "display-arrow-down",
        "label": "Display Arrow Down",
        "search": [
            "computer",
            "desktop",
            "download",
            "insert"
        ]
    },
    {
        "icon": "circle-k",
        "label": "Circle K",
        "search": [
            "Circled Latin Capital Letter K",
            "letter"
        ]
    },
    {
        "icon": "soft-serve",
        "label": "Soft Serve",
        "search": [
            "cone",
            "creemee",
            "frozen yogurt",
            "ice cream",
            "icecream",
            "softserve"
        ]
    },
    {
        "icon": "fantasy-flight-games",
        "label": "Fantasy Flight-games",
        "search": [
            "Dungeons & Dragons",
            "d&d",
            "dnd",
            "fantasy",
            "game",
            "gaming",
            "tabletop"
        ]
    },
    {
        "icon": "heat",
        "label": "Heat",
        "search": [
            "ac",
            "air conditioner",
            "boiler",
            "heating",
            "hot",
            "sauna",
            "spa",
            "summer",
            "temperature"
        ]
    },
    {
        "icon": "vector-polygon",
        "label": "Vector Polygon",
        "search": [
            "anchors",
            "lines",
            "objects",
            "render",
            "shape"
        ]
    },
    {
        "icon": "square-parking",
        "label": "Square Parking",
        "search": [
            "auto",
            "car",
            "garage",
            "meter",
            "parking"
        ]
    },
    {
        "icon": "hanukiah",
        "label": "Hanukiah",
        "search": [
            "candelabrum",
            "candle",
            "candlestick",
            "hanukkah",
            "jewish",
            "judaism",
            "light",
            "menorah",
            "religion"
        ]
    },
    {
        "icon": "linux",
        "label": "Linux",
        "search": [
            "tux"
        ]
    },
    {
        "icon": "rotate-left",
        "label": "Rotate Left",
        "search": [
            "back",
            "control z",
            "exchange",
            "oops",
            "return",
            "swap"
        ]
    },
    {
        "icon": "cake-slice",
        "label": "Cake Slice",
        "search": [
            "birthday",
            "cake",
            "dessert",
            "frosting",
            "icing"
        ]
    },
    {
        "icon": "heading",
        "label": "Heading",
        "search": [
            "format",
            "header",
            "text",
            "title"
        ]
    },
    {
        "icon": "cotton-bureau",
        "label": "Cotton Bureau",
        "search": [
            "clothing",
            "t-shirts",
            "tshirts"
        ]
    },
    {
        "icon": "lambda",
        "label": "Lambda",
        "search": [
            "calculus",
            "equation",
            "function",
            "math"
        ]
    },
    {
        "icon": "train-tunnel",
        "label": "Train Tunnel",
        "search": [
            "rail",
            "subway",
            "tracks",
            "train",
            "tunnel"
        ]
    },
    {
        "icon": "cart-minus",
        "label": "Cart Minus",
        "search": [
            "checkout",
            "food",
            "grocery"
        ]
    },
    {
        "icon": "face-thinking",
        "label": "Face Thinking",
        "search": [
            "chin",
            "face",
            "idea",
            "shade",
            "thinking",
            "thinking face",
            "thumb"
        ]
    },
    {
        "icon": "face-eyes-xmarks",
        "label": "Face Eyes Xmarks",
        "search": [
            "awe",
            "crossed",
            "dead",
            "disbelief",
            "dizzy",
            "face",
            "knocked out",
            "knocked-out face",
            "shock",
            "sick"
        ]
    },
    {
        "icon": "magnifying-glass-music",
        "label": "Magnifying Glass Music",
        "search": [
            "audio",
            "find",
            "glass",
            "inspection",
            "magnifier",
            "magnify",
            "magnifying",
            "magnifying glass tilted left",
            "music",
            "note",
            "preview",
            "search",
            "song",
            "sound",
            "tool",
            "zoom"
        ]
    },
    {
        "icon": "calendar-lines-pen",
        "label": "Calendar Lines Pen",
        "search": [
            "date",
            "day",
            "edit",
            "event",
            "modify",
            "month",
            "pen",
            "pencil",
            "schedule",
            "time",
            "update",
            "when",
            "write",
            "year"
        ]
    },
    {
        "icon": "crosshairs",
        "label": "Crosshairs",
        "search": [
            "aim",
            "bullseye",
            "gpd",
            "picker",
            "position"
        ]
    },
    {
        "icon": "circle-nodes",
        "label": "Circle Nodes",
        "search": [
            "cluster",
            "connect",
            "network"
        ]
    },
    {
        "icon": "google-wallet",
        "label": "Google Wallet",
        "search": []
    },
    {
        "icon": "window-restore",
        "label": "Window Restore",
        "search": [
            "browser",
            "computer",
            "development"
        ]
    },
    {
        "icon": "foursquare",
        "label": "Foursquare",
        "search": []
    },
    {
        "icon": "r",
        "label": "R",
        "search": [
            "Latin Capital Letter R",
            "Latin Small Letter R",
            "letter"
        ]
    },
    {
        "icon": "filter-circle-xmark",
        "label": "Filter Circle Xmark",
        "search": [
            "cancel",
            "funnel",
            "options",
            "remove",
            "separate",
            "sort",
            "uncheck"
        ]
    },
    {
        "icon": "microchip-ai",
        "label": "Microchip Ai",
        "search": [
            "artificial intelligence",
            "computer",
            "silicon"
        ]
    },
    {
        "icon": "circle-quarter",
        "label": "Circle Quarter",
        "search": [
            "chart",
            "fill",
            "pie",
            "pie chart",
            "progress",
            "revenue"
        ]
    },
    {
        "icon": "gopuram",
        "label": "Gopuram",
        "search": [
            "building",
            "entrance",
            "hinduism",
            "temple",
            "tower"
        ]
    },
    {
        "icon": "shirtsinbulk",
        "label": "Shirts in Bulk",
        "search": []
    },
    {
        "icon": "ant",
        "label": "Ant",
        "search": [
            "ant",
            "anthill",
            "bug",
            "crawl",
            "insect"
        ]
    },
    {
        "icon": "hydra",
        "label": "Hydra",
        "search": [
            "animal",
            "beast",
            "fantasy",
            "greek",
            "head",
            "monster",
            "mythology",
            "scylla"
        ]
    },
    {
        "icon": "heart-circle-minus",
        "label": "Heart Circle Minus",
        "search": [
            "favorite",
            "heart",
            "love"
        ]
    },
    {
        "icon": "star-of-life",
        "label": "Star Of Life",
        "search": [
            "doctor",
            "emt",
            "first aid",
            "health",
            "medical"
        ]
    },
    {
        "icon": "boombox",
        "label": "Boombox",
        "search": [
            "Portable Stereo",
            "cassette",
            "jambox",
            "john cusack",
            "music",
            "radio",
            "say anything"
        ]
    },
    {
        "icon": "business-time",
        "label": "Business Time",
        "search": [
            "alarm",
            "briefcase",
            "business socks",
            "clock",
            "flight of the conchords",
            "portfolio",
            "reminder",
            "wednesday"
        ]
    },
    {
        "icon": "fire-extinguisher",
        "label": "Fire Extinguisher",
        "search": [
            "burn",
            "caliente",
            "extinguish",
            "fire",
            "fire extinguisher",
            "fire fighter",
            "flame",
            "heat",
            "hot",
            "quench",
            "rescue"
        ]
    },
    {
        "icon": "mintbit",
        "label": "Mintbit",
        "search": []
    },
    {
        "icon": "staylinked",
        "label": "StayLinked",
        "search": [
            "linkin"
        ]
    },
    {
        "icon": "arrow-down-long",
        "label": "Arrow Down Long",
        "search": [
            "download",
            "long-arrow-down"
        ]
    },
    {
        "icon": "clock-three-thirty",
        "label": "Clock Three Thirty",
        "search": [
            "3",
            "3:30",
            "clock",
            "hour",
            "minute",
            "o'clock",
            "pending",
            "thirty",
            "three",
            "three-thirty",
            "ticking",
            "time"
        ]
    },
    {
        "icon": "object-subtract",
        "label": "Object Subtract",
        "search": [
            "boolean",
            "combine",
            "group",
            "join",
            "pathfinder"
        ]
    },
    {
        "icon": "tickets-simple",
        "label": "Tickets Simple",
        "search": [
            "admission",
            "admission tickets",
            "coupon",
            "movie",
            "pass",
            "support",
            "ticket",
            "voucher"
        ]
    },
    {
        "icon": "user-minus",
        "label": "User Minus",
        "search": [
            "delete",
            "employee",
            "negative",
            "remove",
            "uer"
        ]
    },
    {
        "icon": "money-check",
        "label": "Money Check",
        "search": [
            "bank check",
            "buy",
            "checkout",
            "cheque",
            "money",
            "payment",
            "price",
            "purchase",
            "salary"
        ]
    },
    {
        "icon": "video-plus",
        "label": "Video Plus",
        "search": [
            "add",
            "create",
            "film",
            "new",
            "positive",
            "record",
            "video"
        ]
    },
    {
        "icon": "house-laptop",
        "label": "House Laptop",
        "search": [
            "computer",
            "covid-19",
            "device",
            "office",
            "remote",
            "work from home"
        ]
    },
    {
        "icon": "download",
        "label": "Download",
        "search": [
            "export",
            "hard drive",
            "insert",
            "save",
            "transfer"
        ]
    },
    {
        "icon": "webflow",
        "label": "Webflow",
        "search": []
    },
    {
        "icon": "input-numeric",
        "label": "Input Numeric",
        "search": [
            "age",
            "date",
            "field"
        ]
    },
    {
        "icon": "renren",
        "label": "Renren",
        "search": []
    },
    {
        "icon": "couch",
        "label": "Couch",
        "search": [
            "chair",
            "cushion",
            "furniture",
            "relax",
            "sofa"
        ]
    },
    {
        "icon": "gauge-simple-max",
        "label": "Gauge Simple Max",
        "search": [
            "dashboard",
            "fast",
            "odometer",
            "quick",
            "speed",
            "speedometer"
        ]
    },
    {
        "icon": "road-lock",
        "label": "Road Lock",
        "search": [
            "closed",
            "freeway",
            "highway",
            "lockdown",
            "padlock",
            "pavement",
            "privacy",
            "quarantine",
            "road"
        ]
    },
    {
        "icon": "can-food",
        "label": "Can Food",
        "search": [
            "canned",
            "ration",
            "soup",
            "tin"
        ]
    },
    {
        "icon": "circle-x",
        "label": "Circle X",
        "search": [
            "Circled Latin Capital Letter X",
            "letter",
            "uncheck"
        ]
    },
    {
        "icon": "user-robot-xmarks",
        "label": "User Robot Xmarks",
        "search": [
            "android",
            "automate",
            "computer",
            "cyborg",
            "dead",
            "offline",
            "uer"
        ]
    },
    {
        "icon": "scissors",
        "label": "Scissors",
        "search": [
            "Black Safety Scissors",
            "White Scissors",
            "clip",
            "cutting",
            "equipment",
            "modify",
            "scissors",
            "snip",
            "tool"
        ]
    },
    {
        "icon": "bug",
        "label": "Bug",
        "search": [
            "beetle",
            "error",
            "glitch",
            "insect",
            "repair",
            "report"
        ]
    },
    {
        "icon": "arrow-right-from-bracket",
        "label": "Arrow Right From Bracket",
        "search": [
            "arrow",
            "exit",
            "leave",
            "log out",
            "logout"
        ]
    },
    {
        "icon": "file-zip",
        "label": "File Zip",
        "search": [
            "archive",
            "document",
            "file",
            "paper"
        ]
    },
    {
        "icon": "cupcake",
        "label": "Cupcake",
        "search": [
            "birthday",
            "dessert",
            "frosting",
            "sweet"
        ]
    },
    {
        "icon": "hand-holding-hand",
        "label": "Hand Holding Hand",
        "search": [
            "care",
            "give",
            "help",
            "hold",
            "protect"
        ]
    },
    {
        "icon": "stroopwafel",
        "label": "Stroopwafel",
        "search": [
            "caramel",
            "cookie",
            "dessert",
            "sweets",
            "waffle"
        ]
    },
    {
        "icon": "child",
        "label": "Child",
        "search": [
            "boy",
            "girl",
            "kid",
            "toddler",
            "uer",
            "young",
            "youth"
        ]
    },
    {
        "icon": "ice-cream",
        "label": "Ice Cream",
        "search": [
            "chocolate",
            "cone",
            "cream",
            "dessert",
            "frozen",
            "ice",
            "ice cream",
            "scoop",
            "sorbet",
            "sweet",
            "vanilla",
            "yogurt"
        ]
    },
    {
        "icon": "computer-mouse",
        "label": "Computer Mouse",
        "search": [
            "click",
            "computer",
            "computer mouse",
            "cursor",
            "input",
            "peripheral"
        ]
    },
    {
        "icon": "circle-a",
        "label": "Circle A",
        "search": [
            "Circled Latin Capital Letter A",
            "letter"
        ]
    },
    {
        "icon": "faucet",
        "label": "Faucet",
        "search": [
            "covid-19",
            "drinking",
            "drip",
            "house",
            "hygiene",
            "kitchen",
            "potable",
            "potable water",
            "sanitation",
            "sink",
            "water"
        ]
    },
    {
        "icon": "face-smile-horns",
        "label": "Face Smile Horns",
        "search": [
            "face",
            "fairy tale",
            "fantasy",
            "goblin",
            "horns",
            "imp",
            "smile",
            "smiling face with horns"
        ]
    },
    {
        "icon": "award",
        "label": "Award",
        "search": [
            "guarantee",
            "honor",
            "praise",
            "prize",
            "recognition",
            "ribbon",
            "trophy",
            "warranty"
        ]
    },
    {
        "icon": "person-drowning",
        "label": "Person Drowning",
        "search": [
            "drown",
            "emergency",
            "swim",
            "uer"
        ]
    },
    {
        "icon": "rev",
        "label": "Rev.io",
        "search": []
    },
    {
        "icon": "arrow-up-to-arc",
        "label": "Arrow Up To Arc",
        "search": [
            "import",
            "share",
            "transfer",
            "upload"
        ]
    },
    {
        "icon": "note-medical",
        "label": "Note Medical",
        "search": [
            "memo",
            "sticky note"
        ]
    },
    {
        "icon": "transporter-3",
        "label": "Transporter 3",
        "search": [
            "move",
            "teleport",
            "transfer",
            "translocate",
            "travel"
        ]
    },
    {
        "icon": "keycdn",
        "label": "KeyCDN",
        "search": []
    },
    {
        "icon": "snowflake-droplets",
        "label": "Snowflake Droplets",
        "search": [
            "cold",
            "droplets",
            "melt",
            "rain",
            "snow",
            "spring",
            "thaw",
            "winter"
        ]
    },
    {
        "icon": "camera-rotate",
        "label": "Camera Rotate",
        "search": [
            "flip",
            "front-facing",
            "img",
            "photo",
            "selfie"
        ]
    },
    {
        "icon": "loader",
        "label": "Loader",
        "search": [
            "loading",
            "pending",
            "progress"
        ]
    },
    {
        "icon": "hire-a-helper",
        "label": "HireAHelper",
        "search": []
    },
    {
        "icon": "user-hoodie",
        "label": "User Hoodie",
        "search": [
            "attack",
            "black hat",
            "crime",
            "cyber",
            "hack",
            "hacker",
            "security",
            "sweatshirt",
            "vulnerability",
            "white hat"
        ]
    },
    {
        "icon": "face-grin-hearts",
        "label": "Face Grin Hearts",
        "search": [
            "emoticon",
            "eye",
            "face",
            "love",
            "smile",
            "smiling face with heart-eyes"
        ]
    },
    {
        "icon": "file-fragment",
        "label": "File Fragment",
        "search": [
            "block",
            "data",
            "partial",
            "piece"
        ]
    },
    {
        "icon": "loveseat",
        "label": "Loveseat",
        "search": [
            "chair",
            "couch",
            "cushion",
            "furniture",
            "relax",
            "sofa"
        ]
    },
    {
        "icon": "person-military-rifle",
        "label": "Person Military Rifle",
        "search": [
            "armed forces",
            "army",
            "military",
            "rifle",
            "uer",
            "war"
        ]
    },
    {
        "icon": "toggle-on",
        "label": "Toggle On",
        "search": [
            "button",
            "off",
            "on",
            "switch"
        ]
    },
    {
        "icon": "square-hacker-news",
        "label": "Square Hacker News",
        "search": []
    },
    {
        "icon": "arrow-up-to-line",
        "label": "Arrow Up To Line",
        "search": [
            "import",
            "transfer",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "pompebled",
        "label": "Pompebled",
        "search": [
            "frisian",
            "leaf",
            "lily pad",
            "netherlands",
            "seeblatt",
            "water lily"
        ]
    },
    {
        "icon": "creative-commons-pd-alt",
        "label": "Alternate Creative Commons Public Domain",
        "search": []
    },
    {
        "icon": "orcid",
        "label": "ORCID",
        "search": []
    },
    {
        "icon": "lungs-virus",
        "label": "Lungs Virus",
        "search": [
            "breath",
            "coronavirus",
            "covid-19",
            "flu",
            "infection",
            "pandemic",
            "respiratory",
            "sick"
        ]
    },
    {
        "icon": "table-tennis-paddle-ball",
        "label": "Table Tennis Paddle Ball",
        "search": [
            "ball",
            "bat",
            "game",
            "paddle",
            "ping pong",
            "table tennis"
        ]
    },
    {
        "icon": "boxes-packing",
        "label": "Boxes Packing",
        "search": [
            "archive",
            "box",
            "package",
            "storage",
            "supplies"
        ]
    },
    {
        "icon": "sidebar-flip",
        "label": "Sidebar Flip",
        "search": [
            "browser",
            "ui",
            "window"
        ]
    },
    {
        "icon": "book-font",
        "label": "Book Font",
        "search": [
            "library",
            "research"
        ]
    },
    {
        "icon": "hose",
        "label": "Hose",
        "search": [
            "fire",
            "irrigation",
            "water"
        ]
    },
    {
        "icon": "tree-large",
        "label": "Tree Large",
        "search": [
            "bark",
            "fall",
            "flora",
            "forest",
            "nature",
            "plant",
            "seasonal"
        ]
    },
    {
        "icon": "face-frown-slight",
        "label": "Face Frown Slight",
        "search": [
            "disapprove",
            "face",
            "frown",
            "sad",
            "slightly frowning face"
        ]
    },
    {
        "icon": "person-chalkboard",
        "label": "Person Chalkboard",
        "search": [
            "blackboard",
            "instructor",
            "keynote",
            "lesson",
            "presentation",
            "teacher",
            "uer"
        ]
    },
    {
        "icon": "dice-two",
        "label": "Dice Two",
        "search": [
            "Die Face-2",
            "chance",
            "gambling",
            "game",
            "roll"
        ]
    },
    {
        "icon": "transformer-bolt",
        "label": "Transformer Bolt",
        "search": [
            "electricity",
            "energy",
            "substation",
            "thunderbolt"
        ]
    },
    {
        "icon": "arrow-right-arrow-left",
        "label": "Arrow Right Arrow Left",
        "search": [
            "Rightwards Arrow Over Leftwards Arrow",
            "arrow",
            "arrows",
            "reciprocate",
            "return",
            "swap",
            "transfer"
        ]
    },
    {
        "icon": "football",
        "label": "Football",
        "search": [
            "american",
            "american football",
            "ball",
            "fall",
            "football",
            "nfl",
            "pigskin",
            "seasonal"
        ]
    },
    {
        "icon": "truck-monster",
        "label": "Truck Monster",
        "search": [
            "offroad",
            "vehicle",
            "wheel"
        ]
    },
    {
        "icon": "taco",
        "label": "Taco",
        "search": [
            "corn",
            "maize",
            "mexican",
            "salsa",
            "taco",
            "tortilla"
        ]
    },
    {
        "icon": "mask-snorkel",
        "label": "Mask Snorkel",
        "search": [
            "dive",
            "diving",
            "diving mask",
            "scuba",
            "snorkeling",
            "swimming",
            "underwater"
        ]
    },
    {
        "icon": "arrow-up-from-line",
        "label": "Arrow Up From Line",
        "search": [
            "import",
            "transfer",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "asterisk",
        "label": "Asterisk",
        "search": [
            "Asterisk",
            "Heavy Asterisk",
            "annotation",
            "details",
            "reference",
            "required",
            "star"
        ]
    },
    {
        "icon": "clothes-hanger",
        "label": "Clothes Hanger",
        "search": [
            "clothing",
            "dry cleaner",
            "hang",
            "wire"
        ]
    },
    {
        "icon": "battery-full",
        "label": "Battery Full",
        "search": [
            "batter",
            "battery",
            "charge",
            "power",
            "status"
        ]
    },
    {
        "icon": "child-dress",
        "label": "Child Dress",
        "search": [
            "boy",
            "girl",
            "kid",
            "toddler",
            "uer",
            "young",
            "youth"
        ]
    },
    {
        "icon": "face-kiss-beam",
        "label": "Face Kiss Beam",
        "search": [
            "beso",
            "emoticon",
            "eye",
            "face",
            "kiss",
            "kissing face with smiling eyes",
            "love",
            "smile",
            "smooch"
        ]
    },
    {
        "icon": "behance",
        "label": "Behance",
        "search": []
    },
    {
        "icon": "taxi-bus",
        "label": "Taxi Bus",
        "search": [
            "bus",
            "cab",
            "coach",
            "hack",
            "motorbus",
            "public transportation",
            "taxicab"
        ]
    },
    {
        "icon": "monero",
        "label": "Monero",
        "search": []
    },
    {
        "icon": "figma",
        "label": "Figma",
        "search": [
            "app",
            "design",
            "interface"
        ]
    },
    {
        "icon": "instagram",
        "label": "Instagram",
        "search": []
    },
    {
        "icon": "square-arrow-up-left",
        "label": "Square Arrow Up Left",
        "search": [
            "diagonal"
        ]
    },
    {
        "icon": "trash-can-arrow-up",
        "label": "Trash Can Arrow Up",
        "search": [
            "back",
            "control z",
            "delete",
            "garbage",
            "hide",
            "oops",
            "remove",
            "undo",
            "upgrade"
        ]
    },
    {
        "icon": "font",
        "label": "Font",
        "search": [
            "alphabet",
            "glyph",
            "text",
            "type",
            "typeface"
        ]
    },
    {
        "icon": "face-kiss-closed-eyes",
        "label": "Face Kiss Closed Eyes",
        "search": [
            "closed",
            "eye",
            "face",
            "heart",
            "kiss",
            "kissing face with closed eyes",
            "love"
        ]
    },
    {
        "icon": "bore-hole",
        "label": "Bore Hole",
        "search": [
            "bore",
            "bury",
            "drill",
            "hole"
        ]
    },
    {
        "icon": "virus-covid",
        "label": "Virus Covid",
        "search": [
            "bug",
            "covid-19",
            "flu",
            "health",
            "infection",
            "pandemic",
            "vaccine",
            "viral",
            "virus"
        ]
    },
    {
        "icon": "perbyte",
        "label": "PerByte",
        "search": []
    },
    {
        "icon": "left",
        "label": "Left",
        "search": [
            "back",
            "previous"
        ]
    },
    {
        "icon": "gauge-circle-bolt",
        "label": "Gauge Circle Bolt",
        "search": [
            "dashboard",
            "electric",
            "ev",
            "fast",
            "odometer",
            "speed",
            "speedometer"
        ]
    },
    {
        "icon": "square-vimeo",
        "label": "Square Vimeo",
        "search": []
    },
    {
        "icon": "rectangles-mixed",
        "label": "Rectangles Mixed",
        "search": [
            "mission control",
            "random",
            "sizing"
        ]
    },
    {
        "icon": "brackets-round",
        "label": "Brackets Round",
        "search": [
            "parentheses"
        ]
    },
    {
        "icon": "omega",
        "label": "Omega",
        "search": [
            "alphabet",
            "greek",
            "math"
        ]
    },
    {
        "icon": "blinds-raised",
        "label": "Blinds Raised",
        "search": [
            "privacy",
            "shutter",
            "window"
        ]
    },
    {
        "icon": "file-pdf",
        "label": "File Pdf",
        "search": [
            "acrobat",
            "document",
            "preview",
            "save"
        ]
    },
    {
        "icon": "language",
        "label": "Language",
        "search": [
            "dialect",
            "idiom",
            "localize",
            "speech",
            "translate",
            "vernacular"
        ]
    },
    {
        "icon": "shield-halved",
        "label": "Shield Halved",
        "search": [
            "achievement",
            "armor",
            "award",
            "block",
            "cleric",
            "defend",
            "defense",
            "holy",
            "paladin",
            "privacy",
            "security",
            "shield",
            "weapon",
            "winner"
        ]
    },
    {
        "icon": "fork",
        "label": "Fork",
        "search": [
            "cutlery",
            "dining",
            "food",
            "fork",
            "silverware"
        ]
    },
    {
        "icon": "user-hair",
        "label": "User Hair",
        "search": [
            "bust",
            "bust in silhouette",
            "person",
            "profile",
            "silhouette",
            "uer"
        ]
    },
    {
        "icon": "circle-f",
        "label": "Circle F",
        "search": [
            "Circled Latin Capital Letter F",
            "letter"
        ]
    },
    {
        "icon": "caret-up",
        "label": "Caret Up",
        "search": [
            "arrow",
            "collapse",
            "triangle",
            "upgrade"
        ]
    },
    {
        "icon": "person-seat",
        "label": "Person Seat",
        "search": [
            "airplane",
            "chair",
            "recline",
            "seat",
            "travel",
            "uer"
        ]
    },
    {
        "icon": "pegasus",
        "label": "Pegasus",
        "search": [
            "fantasy",
            "horse",
            "unicorn",
            "wings"
        ]
    },
    {
        "icon": "file-pen",
        "label": "File Pen",
        "search": [
            "edit",
            "memo",
            "modify",
            "pen",
            "pencil",
            "update",
            "write"
        ]
    },
    {
        "icon": "person-biking",
        "label": "Person Biking",
        "search": [
            "bicycle",
            "bike",
            "biking",
            "cyclist",
            "pedal",
            "person biking",
            "summer",
            "uer",
            "wheel"
        ]
    },
    {
        "icon": "book-open-reader",
        "label": "Book Open Reader",
        "search": [
            "flyer",
            "library",
            "notebook",
            "open book",
            "pamphlet",
            "reading",
            "research"
        ]
    },
    {
        "icon": "circle-star",
        "label": "Circle Star",
        "search": [
            "Circled White Star",
            "favorite",
            "quality",
            "vip"
        ]
    },
    {
        "icon": "pushed",
        "label": "Pushed",
        "search": []
    },
    {
        "icon": "phone-xmark",
        "label": "Phone Xmark",
        "search": [
            "call",
            "end",
            "hangup",
            "phone"
        ]
    },
    {
        "icon": "glass-water-droplet",
        "label": "Glass Water Droplet",
        "search": [
            "potable",
            "water"
        ]
    },
    {
        "icon": "scrubber",
        "label": "Scrubber",
        "search": [
            "circle",
            "dot",
            "toggle"
        ]
    },
    {
        "icon": "gun-slash",
        "label": "Gun Slash",
        "search": [
            "disabled",
            "firearm",
            "pistol",
            "weapon"
        ]
    },
    {
        "icon": "mixcloud",
        "label": "Mixcloud",
        "search": []
    },
    {
        "icon": "camera-web-slash",
        "label": "Camera Web Slash",
        "search": [
            "chat",
            "conference call",
            "disabled",
            "disconnect",
            "facetime",
            "podcast",
            "video",
            "videoconferencing",
            "youtube"
        ]
    },
    {
        "icon": "objects-column",
        "label": "Objects Column",
        "search": [
            "array",
            "grid",
            "organize",
            "scroll",
            "windows"
        ]
    },
    {
        "icon": "tower-broadcast",
        "label": "Tower Broadcast",
        "search": [
            "airwaves",
            "antenna",
            "communication",
            "emergency",
            "radio",
            "reception",
            "signal",
            "waves"
        ]
    },
    {
        "icon": "turkey",
        "label": "Turkey",
        "search": [
            "bird",
            "chicken",
            "meal",
            "meat",
            "poultry",
            "seasonal",
            "thanksgiving"
        ]
    },
    {
        "icon": "sword",
        "label": "Sword",
        "search": [
            "Dungeons & Dragons",
            "blade",
            "d&d",
            "dagger",
            "dnd",
            "fantasy",
            "fight",
            "knife",
            "sharp",
            "weapon"
        ]
    },
    {
        "icon": "head-side-goggles",
        "label": "Head Side Goggles",
        "search": [
            "3d",
            "augmented",
            "face",
            "occulus",
            "profile",
            "reality",
            "uer",
            "virtual"
        ]
    },
    {
        "icon": "minimize",
        "label": "Minimize",
        "search": [
            "collapse",
            "fullscreen",
            "minimize",
            "move",
            "resize",
            "shrink",
            "smaller"
        ]
    },
    {
        "icon": "arrow-right-to-city",
        "label": "Arrow Right To City",
        "search": [
            "building",
            "city",
            "exodus",
            "insert",
            "rural",
            "urban"
        ]
    },
    {
        "icon": "laptop-medical",
        "label": "Laptop Medical",
        "search": [
            "computer",
            "device",
            "ehr",
            "electronic health records",
            "history"
        ]
    },
    {
        "icon": "bread-slice",
        "label": "Bread Slice",
        "search": [
            "bake",
            "bakery",
            "baking",
            "dough",
            "flour",
            "gluten",
            "grain",
            "sandwich",
            "sourdough",
            "toast",
            "wheat",
            "yeast"
        ]
    },
    {
        "icon": "spider-web",
        "label": "Spider Web",
        "search": [
            "cobweb",
            "gossamer",
            "halloween",
            "spider",
            "spider web",
            "web"
        ]
    },
    {
        "icon": "user-nurse-hair",
        "label": "User Nurse Hair",
        "search": [
            "doctor",
            "md",
            "midwife",
            "physician",
            "practitioner",
            "surgeon",
            "uer"
        ]
    },
    {
        "icon": "yandex-international",
        "label": "Yandex International",
        "search": []
    },
    {
        "icon": "globe",
        "label": "Globe",
        "search": [
            "all",
            "coordinates",
            "country",
            "earth",
            "global",
            "globe",
            "globe with meridians",
            "gps",
            "internet",
            "language",
            "localize",
            "location",
            "map",
            "meridians",
            "network",
            "online",
            "place",
            "planet",
            "translate",
            "travel",
            "world",
            "www"
        ]
    },
    {
        "icon": "dice-d12",
        "label": "Dice D12",
        "search": [
            "Dungeons & Dragons",
            "chance",
            "d&d",
            "dnd",
            "fantasy",
            "gambling",
            "game",
            "roll"
        ]
    },
    {
        "icon": "location-dot-slash",
        "label": "Location Dot Slash",
        "search": [
            "address",
            "coordinates",
            "destination",
            "disabled",
            "gps",
            "localize",
            "location",
            "map",
            "navigation",
            "paper",
            "pin",
            "place",
            "point of interest",
            "position",
            "route",
            "travel"
        ]
    },
    {
        "icon": "folder-minus",
        "label": "Folder Minus",
        "search": [
            "archive",
            "delete",
            "directory",
            "document",
            "file",
            "negative",
            "remove"
        ]
    },
    {
        "icon": "mask-face",
        "label": "Mask Face",
        "search": [
            "breath",
            "coronavirus",
            "covid-19",
            "filter",
            "flu",
            "infection",
            "pandemic",
            "respirator",
            "virus"
        ]
    },
    {
        "icon": "bong",
        "label": "Bong",
        "search": [
            "aparatus",
            "cannabis",
            "marijuana",
            "pipe",
            "smoke",
            "smoking"
        ]
    },
    {
        "icon": "cup-togo",
        "label": "Cup Togo",
        "search": [
            "beverage",
            "breakfast",
            "cafe",
            "drink",
            "latte",
            "morning",
            "mug",
            "starbucks",
            "takeout",
            "tea",
            "travel"
        ]
    },
    {
        "icon": "hive",
        "label": "Hive Blockchain Network",
        "search": []
    },
    {
        "icon": "road-bridge",
        "label": "Road Bridge",
        "search": [
            "bridge",
            "infrastructure",
            "road",
            "travel"
        ]
    },
    {
        "icon": "arrow-up-9-1",
        "label": "Arrow Up 9 1",
        "search": [
            "arrange",
            "filter",
            "numbers",
            "order",
            "sort-numeric-desc"
        ]
    },
    {
        "icon": "mountain-city",
        "label": "Mountain City",
        "search": [
            "location",
            "rural",
            "urban"
        ]
    },
    {
        "icon": "creative-commons-zero",
        "label": "Creative Commons CC0",
        "search": []
    },
    {
        "icon": "arrow-down-9-1",
        "label": "Arrow Down 9 1",
        "search": [
            "arrange",
            "filter",
            "numbers",
            "order",
            "sort-numeric-asc"
        ]
    },
    {
        "icon": "money-bills-simple",
        "label": "Money Bills Simple",
        "search": [
            "atm",
            "cash",
            "investment",
            "money",
            "moolah",
            "premium",
            "salary"
        ]
    },
    {
        "icon": "face-grin-wide",
        "label": "Face Grin Wide",
        "search": [
            "emoticon",
            "face",
            "grinning face with big eyes",
            "laugh",
            "mouth",
            "open",
            "smile"
        ]
    },
    {
        "icon": "arrows-to-line",
        "label": "Arrows To Line",
        "search": [
            "collapse",
            "shrink"
        ]
    },
    {
        "icon": "turntable",
        "label": "Turntable",
        "search": [
            "album",
            "music",
            "phonograph",
            "record",
            "record player",
            "vinyl"
        ]
    },
    {
        "icon": "crab",
        "label": "Crab",
        "search": [
            "cancer",
            "claws",
            "crabmeat",
            "crustacean",
            "seafood",
            "shellfish",
            "zodiac"
        ]
    },
    {
        "icon": "angel",
        "label": "Angel",
        "search": [
            "christmas",
            "decoration",
            "halo",
            "holiday",
            "holy",
            "michael landon",
            "uer",
            "wings",
            "xmas"
        ]
    },
    {
        "icon": "square-snapchat",
        "label": "Snapchat Square",
        "search": []
    },
    {
        "icon": "location-pen",
        "label": "Location Pen",
        "search": [
            "agree",
            "coordinates",
            "destination",
            "edit",
            "location",
            "map",
            "modify",
            "navigation",
            "pen",
            "pencil",
            "pin",
            "place",
            "update",
            "write"
        ]
    },
    {
        "icon": "tickets-perforated",
        "label": "Tickets Perforated",
        "search": [
            "admission",
            "admission tickets",
            "arrival",
            "boarding",
            "coupon",
            "movie",
            "pass",
            "support",
            "ticket",
            "voucher"
        ]
    },
    {
        "icon": "trash-xmark",
        "label": "Trash Xmark",
        "search": [
            "delete",
            "garbage",
            "hide",
            "remove",
            "uncheck"
        ]
    },
    {
        "icon": "rv",
        "label": "Rv",
        "search": [
            "camping",
            "cousin eddie",
            "recreational",
            "travel",
            "vehicle"
        ]
    },
    {
        "icon": "face-zany",
        "label": "Face Zany",
        "search": [
            "crazy",
            "excited",
            "eye",
            "goofy",
            "large",
            "small",
            "tongue",
            "wild",
            "zany face"
        ]
    },
    {
        "icon": "themeisle",
        "label": "ThemeIsle",
        "search": []
    },
    {
        "icon": "poop",
        "label": "Poop",
        "search": [
            "crap",
            "poop",
            "shit",
            "smile",
            "turd"
        ]
    },
    {
        "icon": "bars-filter",
        "label": "Bars Filter",
        "search": [
            "list",
            "menu",
            "sort"
        ]
    },
    {
        "icon": "house-chimney-heart",
        "label": "House Chimney Heart",
        "search": [
            "care",
            "home",
            "love",
            "wishlist"
        ]
    },
    {
        "icon": "bowl-scoops",
        "label": "Bowl Scoops",
        "search": [
            "dessert",
            "ice cream",
            "scoop",
            "shaved ice",
            "sherbert",
            "sherbet",
            "sorbet"
        ]
    },
    {
        "icon": "dharmachakra",
        "label": "Dharmachakra",
        "search": [
            "Buddhist",
            "buddhism",
            "buddhist",
            "dharma",
            "religion",
            "wheel",
            "wheel of dharma"
        ]
    },
    {
        "icon": "clock-twelve-thirty",
        "label": "Clock Twelve Thirty",
        "search": [
            "12",
            "12:30",
            "clock",
            "hour",
            "minute",
            "o'clock",
            "thirty",
            "ticking",
            "time",
            "twelve",
            "twelve-thirty"
        ]
    },
    {
        "icon": "boxing-glove",
        "label": "Boxing Glove",
        "search": [
            "boxer",
            "boxing",
            "boxing glove",
            "fight",
            "glove",
            "heavyweight",
            "spar"
        ]
    },
    {
        "icon": "dart-lang",
        "label": "Dart Lang",
        "search": []
    },
    {
        "icon": "speaker",
        "label": "Speaker",
        "search": [
            "audio",
            "device",
            "music",
            "sound",
            "subwoofer",
            "transducer",
            "tweeter"
        ]
    },
    {
        "icon": "dice-d10",
        "label": "Dice D10",
        "search": [
            "Dungeons & Dragons",
            "chance",
            "d&d",
            "dnd",
            "fantasy",
            "gambling",
            "game",
            "roll"
        ]
    },
    {
        "icon": "ram",
        "label": "Ram",
        "search": [
            "Aries",
            "animal",
            "fauna",
            "horns",
            "male",
            "mammal",
            "ram",
            "sheep",
            "zodiac"
        ]
    },
    {
        "icon": "battery-quarter",
        "label": "Battery Quarter",
        "search": [
            "charge",
            "low",
            "power",
            "status"
        ]
    },
    {
        "icon": "basket-shopping-simple",
        "label": "Basket Shopping Simple",
        "search": [
            "cart",
            "checkout",
            "grocery",
            "shopping"
        ]
    },
    {
        "icon": "monitor-waveform",
        "label": "Monitor Waveform",
        "search": [
            "EKG",
            "electrocardiogram",
            "health",
            "life",
            "vital"
        ]
    },
    {
        "icon": "deploydog",
        "label": "deploy.dog",
        "search": []
    },
    {
        "icon": "ankh",
        "label": "Ankh",
        "search": [
            "Ankh",
            "amulet",
            "copper",
            "coptic christianity",
            "copts",
            "crux ansata",
            "egypt",
            "venus"
        ]
    },
    {
        "icon": "diamond",
        "label": "Diamond",
        "search": [
            "ace",
            "card",
            "cards",
            "diamond suit",
            "game",
            "gem",
            "gemstone",
            "poker",
            "suit"
        ]
    },
    {
        "icon": "subscript",
        "label": "Subscript",
        "search": [
            "edit",
            "font",
            "format",
            "text",
            "type"
        ]
    },
    {
        "icon": "square-right",
        "label": "Square Right",
        "search": [
            "arrow",
            "cardinal",
            "direction",
            "east",
            "forward",
            "next",
            "right arrow"
        ]
    },
    {
        "icon": "computer-classic",
        "label": "Computer Classic",
        "search": [
            "apple II",
            "hardware",
            "machine",
            "macintosh",
            "programming",
            "retro",
            "vintage"
        ]
    },
    {
        "icon": "rupee-sign",
        "label": "Rupee Sign",
        "search": [
            "Rupee Sign",
            "currency"
        ]
    },
    {
        "icon": "person-rifle",
        "label": "Person Rifle",
        "search": [
            "army",
            "combatant",
            "gun",
            "military",
            "rifle",
            "uer",
            "war"
        ]
    },
    {
        "icon": "octagon-exclamation",
        "label": "Octagon Exclamation",
        "search": [
            "attention",
            "close",
            "end",
            "failed",
            "required",
            "stop"
        ]
    },
    {
        "icon": "flipboard",
        "label": "Flipboard",
        "search": []
    },
    {
        "icon": "pipe-collar",
        "label": "Pipe Collar",
        "search": [
            "drain",
            "plumbing",
            "supply",
            "water"
        ]
    },
    {
        "icon": "brightness-low",
        "label": "Brightness Low",
        "search": [
            "bright",
            "brightness",
            "dim",
            "dim button",
            "display",
            "light",
            "low",
            "sun"
        ]
    },
    {
        "icon": "buy-n-large",
        "label": "Buy n Large",
        "search": []
    },
    {
        "icon": "face-smile-relaxed",
        "label": "Face Smile Relaxed",
        "search": [
            "face",
            "outlined",
            "relaxed",
            "smile",
            "smiling face"
        ]
    },
    {
        "icon": "watchman-monitoring",
        "label": "Watchman Monitoring",
        "search": []
    },
    {
        "icon": "messages-question",
        "label": "Messages Question",
        "search": [
            "chat",
            "faq",
            "help",
            "question",
            "request",
            "support"
        ]
    },
    {
        "icon": "d",
        "label": "D",
        "search": [
            "Latin Capital Letter D",
            "Latin Small Letter D",
            "letter"
        ]
    },
    {
        "icon": "up-to-dotted-line",
        "label": "Up To Dotted Line",
        "search": [
            "import",
            "transfer",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "hips",
        "label": "Hips",
        "search": []
    },
    {
        "icon": "kiwi-fruit",
        "label": "Kiwi Fruit",
        "search": [
            "food",
            "fruit",
            "gooseberry",
            "kiwi",
            "kiwi fruit"
        ]
    },
    {
        "icon": "grid-round",
        "label": "Grid Round",
        "search": [
            "app",
            "collection",
            "filter",
            "grid",
            "sort"
        ]
    },
    {
        "icon": "starship",
        "label": "Starship",
        "search": [
            "engage",
            "enterprise",
            "james t kirk",
            "jean-luc picard",
            "make it so",
            "ncc-1701",
            "spacecraft",
            "spaceship",
            "star trek"
        ]
    },
    {
        "icon": "clock-two-thirty",
        "label": "Clock Two Thirty",
        "search": [
            "1",
            "1:30",
            "2",
            "2:30",
            "clock",
            "hour",
            "minute",
            "o'clock",
            "one",
            "one-thirty",
            "pending",
            "thirty",
            "ticking",
            "time",
            "two",
            "two-thirty"
        ]
    },
    {
        "icon": "cloudversify",
        "label": "cloudversify",
        "search": []
    },
    {
        "icon": "square-nfi",
        "label": "Square Nfi",
        "search": [
            "non-food item",
            "supplies"
        ]
    },
    {
        "icon": "drone-front",
        "label": "Drone Front",
        "search": [
            "aerial",
            "big brother",
            "surveillance",
            "uav",
            "unmanned",
            "vehicle"
        ]
    },
    {
        "icon": "goodreads",
        "label": "Goodreads",
        "search": []
    },
    {
        "icon": "teeth",
        "label": "Teeth",
        "search": [
            "bite",
            "dental",
            "dentist",
            "gums",
            "mouth",
            "smile",
            "tooth"
        ]
    },
    {
        "icon": "magnifying-glass-dollar",
        "label": "Magnifying Glass Dollar",
        "search": [
            "bigger",
            "enlarge",
            "find",
            "magnifier",
            "magnify",
            "money",
            "preview",
            "zoom"
        ]
    },
    {
        "icon": "dumpster-fire",
        "label": "Dumpster Fire",
        "search": [
            "alley",
            "bin",
            "commercial",
            "danger",
            "dangerous",
            "euphemism",
            "flame",
            "heat",
            "hot",
            "trash",
            "waste"
        ]
    },
    {
        "icon": "unity",
        "label": "Unity 3D",
        "search": []
    },
    {
        "icon": "tencent-weibo",
        "label": "Tencent Weibo",
        "search": []
    },
    {
        "icon": "egg-fried",
        "label": "Egg Fried",
        "search": [
            "breakfast",
            "chicken",
            "yolk"
        ]
    },
    {
        "icon": "free-code-camp",
        "label": "freeCodeCamp",
        "search": []
    },
    {
        "icon": "x-twitter",
        "label": "X Twitter",
        "search": [
            "elon",
            "twitter",
            "x"
        ]
    },
    {
        "icon": "line-height",
        "label": "Line Height",
        "search": [
            "baseline",
            "letter",
            "spacing",
            "text"
        ]
    },
    {
        "icon": "sticker-mule",
        "label": "Sticker Mule",
        "search": []
    },
    {
        "icon": "upload",
        "label": "Upload",
        "search": [
            "hard drive",
            "import",
            "publish",
            "upgrade"
        ]
    },
    {
        "icon": "gingerbread-man",
        "label": "Gingerbread Man",
        "search": [
            "cookie",
            "decoration",
            "frosting",
            "holiday"
        ]
    },
    {
        "icon": "filter-slash",
        "label": "Filter Slash",
        "search": [
            "disabled",
            "funnel",
            "options",
            "separate",
            "sort"
        ]
    },
    {
        "icon": "user-slash",
        "label": "User Slash",
        "search": [
            "ban",
            "delete",
            "deny",
            "disabled",
            "disconnect",
            "employee",
            "remove",
            "uer"
        ]
    },
    {
        "icon": "twitch",
        "label": "Twitch",
        "search": []
    },
    {
        "icon": "arrow-left",
        "label": "Arrow Left",
        "search": [
            "Leftwards Arrow",
            "back",
            "previous"
        ]
    },
    {
        "icon": "vial-virus",
        "label": "Vial Virus",
        "search": [
            "ampule",
            "coronavirus",
            "covid-19",
            "flue",
            "infection",
            "lab",
            "laboratory",
            "pandemic",
            "test",
            "test tube",
            "vaccine"
        ]
    },
    {
        "icon": "check-double",
        "label": "Check Double",
        "search": [
            "accept",
            "agree",
            "checkmark",
            "confirm",
            "correct",
            "coupon",
            "done",
            "enable",
            "notice",
            "notification",
            "notify",
            "ok",
            "select",
            "select all",
            "success",
            "tick",
            "todo",
            "validate",
            "working"
        ]
    },
    {
        "icon": "kickstarter-k",
        "label": "Kickstarter K",
        "search": []
    },
    {
        "icon": "critical-role",
        "label": "Critical Role",
        "search": [
            "Dungeons & Dragons",
            "d&d",
            "dnd",
            "fantasy",
            "game",
            "gaming",
            "tabletop"
        ]
    },
    {
        "icon": "swords",
        "label": "Swords",
        "search": [
            "Dungeons & Dragons",
            "blade",
            "crossed",
            "crossed swords",
            "d&d",
            "dnd",
            "fantasy",
            "fight",
            "sharp",
            "swords",
            "weapon"
        ]
    },
    {
        "icon": "transporter-5",
        "label": "Transporter 5",
        "search": [
            "move",
            "teleport",
            "transfer",
            "translocate",
            "travel"
        ]
    },
    {
        "icon": "square-sliders",
        "label": "Square Sliders",
        "search": [
            "adjust",
            "configuration",
            "modify",
            "settings",
            "sliders",
            "toggle"
        ]
    },
    {
        "icon": "circle-sort-up",
        "label": "Circle Sort Up",
        "search": [
            "down",
            "elevator",
            "lower",
            "raise",
            "temperature",
            "thermostat",
            "up",
            "upgrade"
        ]
    },
    {
        "icon": "paw",
        "label": "Paw",
        "search": [
            "animal",
            "cat",
            "dog",
            "pet",
            "print"
        ]
    },
    {
        "icon": "helmet-safety",
        "label": "Helmet Safety",
        "search": [
            "construction",
            "hardhat",
            "helmet",
            "maintenance",
            "safety"
        ]
    },
    {
        "icon": "e",
        "label": "E",
        "search": [
            "Latin Capital Letter E",
            "Latin Small Letter E",
            "letter"
        ]
    },
    {
        "icon": "face-laugh-squint",
        "label": "Face Laugh Squint",
        "search": [
            "LOL",
            "emoticon",
            "face",
            "happy",
            "smile"
        ]
    },
    {
        "icon": "pear",
        "label": "Pear",
        "search": [
            "fruit",
            "pear"
        ]
    },
    {
        "icon": "down-left-and-up-right-to-center",
        "label": "Down Left And Up Right To Center",
        "search": [
            "collapse",
            "fullscreen",
            "minimize",
            "move",
            "resize",
            "scale",
            "shrink",
            "size",
            "smaller"
        ]
    },
    {
        "icon": "puzzle-piece-simple",
        "label": "Puzzle Piece Simple",
        "search": [
            "assemble",
            "plugin"
        ]
    },
    {
        "icon": "gifts",
        "label": "Gifts",
        "search": [
            "christmas",
            "generosity",
            "giving",
            "holiday",
            "party",
            "present",
            "wrapped",
            "xmas"
        ]
    },
    {
        "icon": "hospitals",
        "label": "Hospitals",
        "search": [
            "emergency",
            "insurance",
            "network"
        ]
    },
    {
        "icon": "bed",
        "label": "Bed",
        "search": [
            "hospital",
            "hotel",
            "lodging",
            "mattress",
            "patient",
            "person in bed",
            "rest",
            "sleep",
            "travel",
            "uer"
        ]
    },
    {
        "icon": "window-flip",
        "label": "Window Flip",
        "search": [
            "browser",
            "computer",
            "development"
        ]
    },
    {
        "icon": "steam-symbol",
        "label": "Steam Symbol",
        "search": []
    },
    {
        "icon": "money-bill-transfer",
        "label": "Money Bill Transfer",
        "search": [
            "bank",
            "conversion",
            "deposit",
            "investment",
            "money",
            "salary",
            "transfer",
            "withdrawal"
        ]
    },
    {
        "icon": "person-running",
        "label": "Person Running",
        "search": [
            "exit",
            "flee",
            "follow",
            "marathon",
            "person running",
            "race",
            "running",
            "uer",
            "workout"
        ]
    },
    {
        "icon": "circle-chevron-down",
        "label": "Circle Chevron Down",
        "search": [
            "arrow",
            "download",
            "dropdown",
            "menu",
            "more"
        ]
    },
    {
        "icon": "manhole",
        "label": "Manhole",
        "search": [
            "grate",
            "sewer"
        ]
    },
    {
        "icon": "user-nurse",
        "label": "User Nurse",
        "search": [
            "covid-19",
            "doctor",
            "health",
            "md",
            "medical",
            "midwife",
            "physician",
            "practitioner",
            "surgeon",
            "uer",
            "worker"
        ]
    },
    {
        "icon": "mailchimp",
        "label": "Mailchimp",
        "search": []
    },
    {
        "icon": "arrows-repeat",
        "label": "Arrows Repeat",
        "search": [
            "flip",
            "reload",
            "renew",
            "retry",
            "rewind",
            "switch"
        ]
    },
    {
        "icon": "waffle",
        "label": "Waffle",
        "search": [
            "breakfast",
            "indecisive",
            "iron",
            "waffle"
        ]
    },
    {
        "icon": "arrow-left-from-arc",
        "label": "Arrow Left From Arc",
        "search": [
            "exit",
            "give",
            "leave",
            "send",
            "transfer"
        ]
    },
    {
        "icon": "square-divide",
        "label": "Square Divide",
        "search": [
            "algebra",
            "arithmetic",
            "division"
        ]
    },
    {
        "icon": "circle-e",
        "label": "Circle E",
        "search": [
            "Circled Latin Capital Letter E",
            "letter"
        ]
    },
    {
        "icon": "face-kiss-wink-heart",
        "label": "Face Kiss Wink Heart",
        "search": [
            "beso",
            "emoticon",
            "face",
            "face blowing a kiss",
            "kiss",
            "love",
            "smooch"
        ]
    },
    {
        "icon": "fill",
        "label": "Fill",
        "search": [
            "bucket",
            "color",
            "paint",
            "paint bucket"
        ]
    },
    {
        "icon": "user-doctor-hair",
        "label": "User Doctor Hair",
        "search": [
            "covid-19",
            "job",
            "medical",
            "nurse",
            "occupation",
            "physician",
            "profile",
            "surgeon",
            "uer"
        ]
    },
    {
        "icon": "sensor-fire",
        "label": "Sensor Fire",
        "search": [
            "alarm",
            "alert",
            "carbon monoxide",
            "detector",
            "fire",
            "smoke"
        ]
    },
    {
        "icon": "money-bill-1-wave",
        "label": "Money Bill 1 Wave",
        "search": [
            "buy",
            "cash",
            "checkout",
            "money",
            "payment",
            "premium",
            "price",
            "purchase",
            "salary"
        ]
    },
    {
        "icon": "landmark",
        "label": "Landmark",
        "search": [
            "building",
            "classical",
            "historic",
            "memorable",
            "monument",
            "museum",
            "politics",
            "society"
        ]
    },
    {
        "icon": "comment-music",
        "label": "Comment Music",
        "search": [
            "answer",
            "chat",
            "commenting",
            "conversation",
            "create",
            "message",
            "music",
            "note",
            "notification",
            "sing",
            "sms",
            "song",
            "texting"
        ]
    },
    {
        "icon": "hammer-crash",
        "label": "Hammer Crash",
        "search": [
            "break",
            "crash",
            "glass",
            "maintenance",
            "pound",
            "smash"
        ]
    },
    {
        "icon": "sword-laser",
        "label": "Sword Laser",
        "search": [
            "jedi",
            "lightsaber",
            "luke skywalker",
            "rebel",
            "star wars"
        ]
    },
    {
        "icon": "music",
        "label": "Music",
        "search": [
            "lyrics",
            "melody",
            "music",
            "musical note",
            "note",
            "sing",
            "sound"
        ]
    },
    {
        "icon": "files",
        "label": "Files",
        "search": [
            "history",
            "multiple"
        ]
    },
    {
        "icon": "message-arrow-up-right",
        "label": "Message Arrow Up Right",
        "search": [
            "chat",
            "contact",
            "discussion",
            "send",
            "upload"
        ]
    },
    {
        "icon": "book-medical",
        "label": "Book Medical",
        "search": [
            "diary",
            "documentation",
            "health",
            "history",
            "journal",
            "library",
            "read",
            "record",
            "research"
        ]
    },
    {
        "icon": "music-note-slash",
        "label": "Music Note Slash",
        "search": [
            "cancel",
            "disabled",
            "lyrics",
            "melody",
            "mute",
            "note",
            "off",
            "sing",
            "sound"
        ]
    },
    {
        "icon": "shuffle",
        "label": "Shuffle",
        "search": [
            "arrow",
            "arrows",
            "crossed",
            "shuffle",
            "shuffle tracks button",
            "sort",
            "swap",
            "switch",
            "transfer"
        ]
    },
    {
        "icon": "underline",
        "label": "Underline",
        "search": [
            "edit",
            "emphasis",
            "format",
            "modify",
            "text",
            "writing"
        ]
    },
    {
        "icon": "building-user",
        "label": "Building User",
        "search": [
            "apartment",
            "building",
            "city",
            "employee",
            "uer"
        ]
    },
    {
        "icon": "nutritionix",
        "label": "Nutritionix",
        "search": []
    },
    {
        "icon": "creative-commons-sampling-plus",
        "label": "Creative Commons Sampling +",
        "search": []
    },
    {
        "icon": "sushi-roll",
        "label": "Sushi Roll",
        "search": [
            "fish",
            "maki",
            "nori",
            "raw",
            "rice",
            "salmon",
            "seafood",
            "seaweed",
            "tuna"
        ]
    },
    {
        "icon": "dial-off",
        "label": "Dial Off",
        "search": [
            "dial",
            "level"
        ]
    },
    {
        "icon": "robot",
        "label": "Robot",
        "search": [
            "android",
            "automate",
            "computer",
            "cyborg",
            "face",
            "monster",
            "robot"
        ]
    },
    {
        "icon": "redhat",
        "label": "Redhat",
        "search": [
            "linux",
            "operating system",
            "os"
        ]
    },
    {
        "icon": "plus",
        "label": "Plus",
        "search": [
            "+",
            "Plus Sign",
            "add",
            "create",
            "expand",
            "follow",
            "math",
            "modify",
            "new",
            "plus",
            "positive",
            "shape",
            "sign"
        ]
    },
    {
        "icon": "square-pied-piper",
        "label": "Pied Piper Square Logo (Old)",
        "search": []
    },
    {
        "icon": "objects-align-top",
        "label": "Objects Align Top",
        "search": [
            "align",
            "distribute",
            "line",
            "rectangles"
        ]
    },
    {
        "icon": "bell-ring",
        "label": "Bell Ring",
        "search": [
            "Ringing Bell",
            "alarm",
            "alert",
            "chime",
            "notification",
            "reminder",
            "request"
        ]
    },
    {
        "icon": "copy",
        "label": "Copy",
        "search": [
            "clone",
            "duplicate",
            "file",
            "files-o",
            "paper",
            "paste"
        ]
    },
    {
        "icon": "chess-king",
        "label": "Chess King",
        "search": [
            "Black Chess King",
            "board",
            "checkmate",
            "game",
            "strategy"
        ]
    },
    {
        "icon": "whatsapp",
        "label": "What's App",
        "search": []
    },
    {
        "icon": "house-flood-water",
        "label": "House Flood Water",
        "search": [
            "damage",
            "flood",
            "water"
        ]
    },
    {
        "icon": "money-from-bracket",
        "label": "Money From Bracket",
        "search": [
            "atm",
            "automated",
            "cash",
            "deposit",
            "dispenser",
            "investment",
            "salary",
            "transaction",
            "withdrawl"
        ]
    },
    {
        "icon": "bitcoin-sign",
        "label": "Bitcoin Sign",
        "search": [
            "Bitcoin Sign",
            "currency"
        ]
    },
    {
        "icon": "box",
        "label": "Box",
        "search": [
            "archive",
            "box",
            "container",
            "package",
            "parcel",
            "storage"
        ]
    },
    {
        "icon": "imdb",
        "label": "IMDB",
        "search": []
    },
    {
        "icon": "face-anguished",
        "label": "Face Anguished",
        "search": [
            "anguished",
            "anguished face",
            "confusion",
            "face",
            "frown",
            "pain",
            "sadness"
        ]
    },
    {
        "icon": "location-arrow-up",
        "label": "Location Arrow Up",
        "search": [
            "address",
            "compass",
            "coordinate",
            "direction",
            "gps",
            "map",
            "navigation",
            "north",
            "place"
        ]
    },
    {
        "icon": "head-side-heart",
        "label": "Head Side Heart",
        "search": [
            "care",
            "love",
            "thought",
            "uer",
            "wishlist"
        ]
    },
    {
        "icon": "square-plus",
        "label": "Square Plus",
        "search": [
            "add",
            "create",
            "expand",
            "new",
            "positive",
            "shape"
        ]
    },
    {
        "icon": "memo",
        "label": "Memo",
        "search": [
            "cv",
            "file",
            "idea",
            "note",
            "notepad",
            "page",
            "paper"
        ]
    },
    {
        "icon": "arrows-left-right",
        "label": "Arrows Left Right",
        "search": [
            "expand",
            "horizontal",
            "landscape",
            "resize",
            "wide"
        ]
    },
    {
        "icon": "fan",
        "label": "Fan",
        "search": [
            "ac",
            "air conditioning",
            "blade",
            "blower",
            "cool",
            "hot"
        ]
    },
    {
        "icon": "crow",
        "label": "Crow",
        "search": [
            "bird",
            "bullfrog",
            "fauna",
            "halloween",
            "holiday",
            "toad"
        ]
    },
    {
        "icon": "square-8",
        "label": "Square 8",
        "search": [
            "eight"
        ]
    },
    {
        "icon": "file-circle-check",
        "label": "File Circle Check",
        "search": [
            "document",
            "enable",
            "file",
            "not affected",
            "ok",
            "okay",
            "paper",
            "validate",
            "working"
        ]
    },
    {
        "icon": "bracket-curly-right",
        "label": "Bracket Curly Right",
        "search": [
            "Right Curly Bracket",
            "braces",
            "code"
        ]
    },
    {
        "icon": "chart-network",
        "label": "Chart Network",
        "search": [
            "activity",
            "analytics",
            "association",
            "dashboard",
            "diagram",
            "distribution",
            "map",
            "network",
            "performance"
        ]
    },
    {
        "icon": "badge-dollar",
        "label": "Badge Dollar",
        "search": [
            "coupon",
            "deal",
            "discount",
            "guarantee",
            "investment",
            "money",
            "salary",
            "save",
            "usd"
        ]
    },
    {
        "icon": "link-slash",
        "label": "Link Slash",
        "search": [
            "attachment",
            "chain",
            "chain-broken",
            "disabled",
            "disconnect",
            "remove"
        ]
    },
    {
        "icon": "arrow-rotate-right",
        "label": "Arrow Rotate Right",
        "search": [
            "Clockwise Open Circle Arrow",
            "forward",
            "refresh",
            "reload",
            "renew",
            "repeat",
            "retry"
        ]
    },
    {
        "icon": "person-to-portal",
        "label": "Person To Portal",
        "search": [
            "portal",
            "run",
            "transport",
            "travel",
            "uer"
        ]
    },
    {
        "icon": "signal-bars-slash",
        "label": "Signal Bars Slash",
        "search": [
            "bars",
            "disabled",
            "disconnect",
            "graph",
            "online",
            "reception",
            "status"
        ]
    },
    {
        "icon": "pen-clip",
        "label": "Pen Clip",
        "search": [
            "design",
            "edit",
            "modify",
            "update",
            "write"
        ]
    },
    {
        "icon": "python",
        "label": "Python",
        "search": []
    },
    {
        "icon": "door-closed",
        "label": "Door Closed",
        "search": [
            "doo",
            "door",
            "enter",
            "exit",
            "locked",
            "privacy"
        ]
    },
    {
        "icon": "lock-a",
        "label": "Lock A",
        "search": [
            "capital",
            "capslock",
            "letter",
            "padlock",
            "privacy"
        ]
    },
    {
        "icon": "arrow-down-wide-short",
        "label": "Arrow Down Wide Short",
        "search": [
            "arrange",
            "filter",
            "number",
            "order",
            "sort-amount-asc"
        ]
    },
    {
        "icon": "face-melting",
        "label": "Face Melting",
        "search": [
            "embarass",
            "hot",
            "sarcasm",
            "shame"
        ]
    },
    {
        "icon": "face-disguise",
        "label": "Face Disguise",
        "search": [
            "disguise",
            "disguised face",
            "face",
            "glasses",
            "groucho",
            "incognito",
            "mustache",
            "nose",
            "spy"
        ]
    },
    {
        "icon": "sportsball",
        "label": "Sportsball",
        "search": [
            "baseball",
            "basketball",
            "football",
            "sports",
            "sportsball"
        ]
    },
    {
        "icon": "caret-down",
        "label": "Caret Down",
        "search": [
            "arrow",
            "dropdown",
            "expand",
            "menu",
            "more",
            "triangle"
        ]
    },
    {
        "icon": "radar",
        "label": "Radar",
        "search": [
            "blip",
            "find",
            "lidar",
            "radio",
            "scan",
            "search",
            "sonar",
            "space"
        ]
    },
    {
        "icon": "pinterest-p",
        "label": "Pinterest P",
        "search": []
    },
    {
        "icon": "whmcs",
        "label": "WHMCS",
        "search": []
    },
    {
        "icon": "image-landscape",
        "label": "Image Landscape",
        "search": [
            "image",
            "img",
            "mountain",
            "photo"
        ]
    },
    {
        "icon": "rotate-reverse",
        "label": "Rotate Reverse",
        "search": [
            "anticlockwise",
            "arrow",
            "counterclockwise",
            "exchange",
            "modify",
            "refresh",
            "reload",
            "renew",
            "retry",
            "rotate",
            "swap",
            "withershins"
        ]
    },
    {
        "icon": "ticket-perforated",
        "label": "Ticket Perforated",
        "search": [
            "admission",
            "admission tickets",
            "arrival",
            "boarding",
            "coupon",
            "movie",
            "pass",
            "support",
            "ticket",
            "voucher"
        ]
    },
    {
        "icon": "square-c",
        "label": "Square C",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "k",
        "label": "K",
        "search": [
            "Latin Capital Letter K",
            "Latin Small Letter K",
            "letter"
        ]
    },
    {
        "icon": "joget",
        "label": "Joget",
        "search": []
    },
    {
        "icon": "check-to-slot",
        "label": "Check To Slot",
        "search": [
            "accept",
            "cast",
            "election",
            "enable",
            "politics",
            "positive",
            "validate",
            "voting",
            "working",
            "yes"
        ]
    },
    {
        "icon": "square-j",
        "label": "Square J",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "fish-fins",
        "label": "Fish Fins",
        "search": [
            "fish",
            "fishery",
            "pisces",
            "seafood"
        ]
    },
    {
        "icon": "bell-school",
        "label": "Bell School",
        "search": [
            "alert",
            "chime",
            "class",
            "notification",
            "reminder"
        ]
    },
    {
        "icon": "lamp-floor",
        "label": "Lamp Floor",
        "search": [
            "bright",
            "furniture",
            "light"
        ]
    },
    {
        "icon": "compress",
        "label": "Compress",
        "search": [
            "collapse",
            "fullscreen",
            "minimize",
            "move",
            "resize",
            "shrink",
            "smaller"
        ]
    },
    {
        "icon": "trash-plus",
        "label": "Trash Plus",
        "search": [
            "delete",
            "garbage",
            "hide",
            "remove"
        ]
    },
    {
        "icon": "arrow-up-a-z",
        "label": "Arrow Up A Z",
        "search": [
            "alphabetical",
            "arrange",
            "filter",
            "order",
            "sort-alpha-desc"
        ]
    },
    {
        "icon": "comma",
        "label": "Comma",
        "search": [
            "Comma",
            "interval",
            "punctuation"
        ]
    },
    {
        "icon": "semicolon",
        "label": "Semicolon",
        "search": [
            "Semicolon",
            "semicolon"
        ]
    },
    {
        "icon": "rugby-ball",
        "label": "Rugby Ball",
        "search": [
            "ball",
            "football",
            "rugby",
            "rugby football"
        ]
    },
    {
        "icon": "toilet-paper-blank",
        "label": "Toilet Paper Blank",
        "search": [
            "bathroom",
            "halloween",
            "lavatory",
            "prank",
            "privy",
            "restroom",
            "roll",
            "toilet",
            "wipe"
        ]
    },
    {
        "icon": "grid-round-2-plus",
        "label": "Grid Round 2 Plus",
        "search": [
            "add",
            "app",
            "collection",
            "filter",
            "grid",
            "sort"
        ]
    },
    {
        "icon": "user-graduate",
        "label": "User Graduate",
        "search": [
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "file-code",
        "label": "File Code",
        "search": [
            "css",
            "development",
            "document",
            "html",
            "mysql",
            "sql"
        ]
    },
    {
        "icon": "cup-straw",
        "label": "Cup Straw",
        "search": [
            "caffeine",
            "fast food",
            "orange mocha frappuccino",
            "pop",
            "soda",
            "soft drink",
            "takeout"
        ]
    },
    {
        "icon": "soap",
        "label": "Soap",
        "search": [
            "bar",
            "bathing",
            "bubbles",
            "clean",
            "cleaning",
            "covid-19",
            "hygiene",
            "lather",
            "soap",
            "soapdish",
            "wash"
        ]
    },
    {
        "icon": "square-youtube",
        "label": "Square Youtube",
        "search": []
    },
    {
        "icon": "recycle",
        "label": "Recycle",
        "search": [
            "Recycling Symbol For Generic Materials",
            "Universal Recycling Symbol",
            "Waste",
            "compost",
            "garbage",
            "recycle",
            "recycling symbol",
            "reuse",
            "trash"
        ]
    },
    {
        "icon": "sliders-up",
        "label": "Sliders Up",
        "search": [
            "adjust",
            "configuration",
            "modify",
            "settings",
            "sliders",
            "toggle"
        ]
    },
    {
        "icon": "atlassian",
        "label": "Atlassian",
        "search": []
    },
    {
        "icon": "car-bus",
        "label": "Car Bus",
        "search": [
            "directions",
            "ground transportation",
            "map",
            "transportation",
            "travel"
        ]
    },
    {
        "icon": "pied-piper-hat",
        "label": "Pied Piper Hat (Old)",
        "search": [
            "clothing"
        ]
    },
    {
        "icon": "pumpkin",
        "label": "Pumpkin",
        "search": [
            "autumn",
            "gourd",
            "halloween",
            "harvest",
            "squash",
            "thanksgiving",
            "vegetable"
        ]
    },
    {
        "icon": "face-grin-wink",
        "label": "Face Grin Wink",
        "search": [
            "emoticon",
            "face",
            "flirt",
            "laugh",
            "smile"
        ]
    },
    {
        "icon": "folder-arrow-down",
        "label": "Folder Arrow Down",
        "search": [
            "archive",
            "directory",
            "document",
            "download",
            "file",
            "insert",
            "save"
        ]
    },
    {
        "icon": "sign-posts",
        "label": "Sign Posts",
        "search": [
            "directions",
            "directory",
            "map",
            "signage",
            "wayfinding"
        ]
    },
    {
        "icon": "skeleton-ribs",
        "label": "Skeleton Ribs",
        "search": [
            "arms",
            "body",
            "bone",
            "ribs",
            "shoulder",
            "skeleton",
            "vertebrae",
            "x-ray"
        ]
    },
    {
        "icon": "circle-dollar",
        "label": "Circle Dollar",
        "search": [
            "$",
            "currency",
            "dollar-sign",
            "investment",
            "money",
            "premium",
            "price",
            "salary",
            "usd"
        ]
    },
    {
        "icon": "siren",
        "label": "Siren",
        "search": [
            "alarm",
            "alert",
            "ambulance",
            "loud",
            "police",
            "warning"
        ]
    },
    {
        "icon": "water-ladder",
        "label": "Water Ladder",
        "search": [
            "ladder",
            "recreation",
            "swim",
            "water"
        ]
    },
    {
        "icon": "tty-answer",
        "label": "Tty Answer",
        "search": [
            "answer",
            "listen",
            "teletype"
        ]
    },
    {
        "icon": "internet-explorer",
        "label": "Internet-explorer",
        "search": [
            "browser",
            "ie"
        ]
    },
    {
        "icon": "square-this-way-up",
        "label": "Square This Way Up",
        "search": [
            "archive",
            "container",
            "package",
            "shipping",
            "storage",
            "upgrade"
        ]
    },
    {
        "icon": "tower-cell",
        "label": "Tower Cell",
        "search": [
            "airwaves",
            "antenna",
            "communication",
            "radio",
            "reception",
            "signal",
            "waves"
        ]
    },
    {
        "icon": "gallery-thumbnails",
        "label": "Gallery Thumbnails",
        "search": [
            "carousel",
            "gallery",
            "grid",
            "screen",
            "view"
        ]
    },
    {
        "icon": "colon-sign",
        "label": "Colon Sign",
        "search": [
            "Colon Sign",
            "currency"
        ]
    },
    {
        "icon": "laptop-file",
        "label": "Laptop File",
        "search": [
            "computer",
            "education",
            "laptop",
            "learning",
            "remote work"
        ]
    },
    {
        "icon": "bahai",
        "label": "Bahai",
        "search": [
            "bahai",
            "bahá'í",
            "star"
        ]
    },
    {
        "icon": "money-bill-1",
        "label": "Money Bill 1",
        "search": [
            "buy",
            "cash",
            "checkout",
            "money",
            "payment",
            "premium",
            "price",
            "purchase",
            "salary"
        ]
    },
    {
        "icon": "cloud-bolt",
        "label": "Cloud Bolt",
        "search": [
            "bolt",
            "cloud",
            "cloud with lightning",
            "lightning",
            "precipitation",
            "rain",
            "storm",
            "weather"
        ]
    },
    {
        "icon": "circle-bookmark",
        "label": "Circle Bookmark",
        "search": [
            "library",
            "research"
        ]
    },
    {
        "icon": "ethernet",
        "label": "Ethernet",
        "search": [
            "cable",
            "cat 5",
            "cat 6",
            "connection",
            "hardware",
            "internet",
            "network",
            "wired"
        ]
    },
    {
        "icon": "circles-overlap-3",
        "label": "Circles Overlap 3",
        "search": [
            "circle",
            "color",
            "diagram",
            "overlap",
            "pronoun",
            "rgb",
            "stack"
        ]
    },
    {
        "icon": "airbnb",
        "label": "Airbnb",
        "search": []
    },
    {
        "icon": "js",
        "label": "JavaScript (JS)",
        "search": []
    },
    {
        "icon": "hryvnia-sign",
        "label": "Hryvnia Sign",
        "search": [
            "Hryvnia Sign",
            "currency"
        ]
    },
    {
        "icon": "atom-simple",
        "label": "Atom Simple",
        "search": [
            "atheism",
            "chemistry",
            "electron",
            "ion",
            "isotope",
            "knowledge",
            "neutron",
            "nuclear",
            "proton",
            "science",
            "space"
        ]
    },
    {
        "icon": "files-medical",
        "label": "Files Medical",
        "search": [
            "document",
            "health",
            "history",
            "prescription",
            "record"
        ]
    },
    {
        "icon": "salad",
        "label": "Salad",
        "search": [
            "bowl",
            "food",
            "green",
            "green salad",
            "health",
            "lettuce",
            "salad",
            "spinach",
            "vegan",
            "vegetable",
            "vegetarian"
        ]
    },
    {
        "icon": "paw-simple",
        "label": "Paw Simple",
        "search": [
            "animal",
            "cat",
            "dog",
            "pet",
            "print"
        ]
    },
    {
        "icon": "eye-slash",
        "label": "Eye Slash",
        "search": [
            "blind",
            "disabled",
            "hide",
            "show",
            "toggle",
            "unseen",
            "views",
            "visible",
            "visiblity"
        ]
    },
    {
        "icon": "plate-utensils",
        "label": "Plate Utensils",
        "search": [
            "dinner",
            "food",
            "fork",
            "knife",
            "plate"
        ]
    },
    {
        "icon": "circle-o",
        "label": "Circle O",
        "search": [
            "Circled Latin Capital Letter O",
            "letter"
        ]
    },
    {
        "icon": "quinscape",
        "label": "QuinScape",
        "search": []
    },
    {
        "icon": "jug-bottle",
        "label": "Jug Bottle",
        "search": [
            "collect",
            "container",
            "jug",
            "plastics",
            "recycle"
        ]
    },
    {
        "icon": "clock-two",
        "label": "Clock Two",
        "search": [
            "00",
            "1",
            "1:00",
            "2",
            "2:00",
            "clock",
            "hour",
            "minute",
            "o'clock",
            "one",
            "one o’clock",
            "o’clock",
            "pending",
            "ticking",
            "time",
            "two",
            "two o’clock"
        ]
    },
    {
        "icon": "adversal",
        "label": "Adversal",
        "search": []
    },
    {
        "icon": "cart-flatbed-suitcase",
        "label": "Cart Flatbed Suitcase",
        "search": [
            "airport",
            "bag",
            "baggage",
            "suitcase",
            "travel"
        ]
    },
    {
        "icon": "folder-image",
        "label": "Folder Image",
        "search": [
            "file",
            "image",
            "img",
            "photos"
        ]
    },
    {
        "icon": "radiation",
        "label": "Radiation",
        "search": [
            "danger",
            "dangerous",
            "deadly",
            "hazard",
            "nuclear",
            "radioactive",
            "warning"
        ]
    },
    {
        "icon": "file-word",
        "label": "File Word",
        "search": [
            "document",
            "edit",
            "page",
            "text",
            "writing"
        ]
    },
    {
        "icon": "bed-pulse",
        "label": "Bed Pulse",
        "search": [
            "EKG",
            "bed",
            "electrocardiogram",
            "health",
            "hospital",
            "life",
            "patient",
            "vital"
        ]
    },
    {
        "icon": "block",
        "label": "Block",
        "search": [
            "block",
            "brick",
            "empty",
            "mystery",
            "super mario"
        ]
    },
    {
        "icon": "shovel",
        "label": "Shovel",
        "search": [
            "construction",
            "dig",
            "equipment",
            "excavate",
            "maintenance",
            "tool",
            "trench"
        ]
    },
    {
        "icon": "tents",
        "label": "Tents",
        "search": [
            "bivouac",
            "bivouac",
            "campground",
            "campground",
            "campsite",
            "refugee",
            "refugee",
            "shelter",
            "shelter",
            "tent",
            "tent"
        ]
    },
    {
        "icon": "droplet-percent",
        "label": "Droplet Percent",
        "search": [
            "blood",
            "evaporation",
            "fog",
            "oxygen",
            "precipitation",
            "rain"
        ]
    },
    {
        "icon": "mug-hot",
        "label": "Mug Hot",
        "search": [
            "beverage",
            "caliente",
            "cocoa",
            "coffee",
            "cup",
            "drink",
            "holiday",
            "hot",
            "hot beverage",
            "hot chocolate",
            "steam",
            "steaming",
            "tea",
            "warmth"
        ]
    },
    {
        "icon": "bolt",
        "label": "Bolt",
        "search": [
            "charge",
            "danger",
            "electric",
            "electricity",
            "flash",
            "high voltage",
            "lightning",
            "voltage",
            "weather",
            "zap"
        ]
    },
    {
        "icon": "user-vneck-hair-long",
        "label": "User Vneck Hair Long",
        "search": [
            "bust",
            "bust in silhouette",
            "person",
            "profile",
            "silhouette",
            "uer"
        ]
    },
    {
        "icon": "reflect-vertical",
        "label": "Reflect Vertical",
        "search": [
            "edit",
            "exchange",
            "flip",
            "inverse",
            "invert",
            "mirror",
            "negative",
            "reflect",
            "swap",
            "tool",
            "vertical"
        ]
    },
    {
        "icon": "money-bill-simple-wave",
        "label": "Money Bill Simple Wave",
        "search": [
            "atm",
            "cash",
            "money",
            "moolah",
            "premium",
            "salary"
        ]
    },
    {
        "icon": "lightbulb-exclamation",
        "label": "Lightbulb Exclamation",
        "search": [
            "alert",
            "energy",
            "failed",
            "idea",
            "inspiration",
            "light"
        ]
    },
    {
        "icon": "aperture",
        "label": "Aperture",
        "search": [
            "aperture",
            "camera",
            "exposure",
            "lens",
            "photo"
        ]
    },
    {
        "icon": "jar",
        "label": "Jar",
        "search": [
            "jam",
            "jelly",
            "storage"
        ]
    },
    {
        "icon": "arrow-down-from-arc",
        "label": "Arrow Down From Arc",
        "search": [
            "download",
            "enter",
            "save",
            "share",
            "transfer"
        ]
    },
    {
        "icon": "truck-plane",
        "label": "Truck Plane",
        "search": [
            "airplane",
            "plane",
            "transportation",
            "truck",
            "vehicle"
        ]
    },
    {
        "icon": "signal-fair",
        "label": "Signal Fair",
        "search": [
            "bars",
            "graph",
            "online",
            "reception",
            "status"
        ]
    },
    {
        "icon": "hand-holding-heart",
        "label": "Hand Holding Heart",
        "search": [
            "carry",
            "charity",
            "gift",
            "lift",
            "package",
            "wishlist"
        ]
    },
    {
        "icon": "arrow-rotate-left",
        "label": "Arrow Rotate Left",
        "search": [
            "Anticlockwise Open Circle Arrow",
            "back",
            "control z",
            "exchange",
            "oops",
            "return",
            "rotate",
            "swap"
        ]
    },
    {
        "icon": "angles-up-down",
        "label": "Angles Up Down",
        "search": [
            "down",
            "elevator",
            "filter",
            "order",
            "up"
        ]
    },
    {
        "icon": "truck-plow",
        "label": "Truck Plow",
        "search": [
            "clean up",
            "cold",
            "seasonal",
            "snow",
            "winter"
        ]
    },
    {
        "icon": "users-medical",
        "label": "Users Medical",
        "search": [
            "employee",
            "group",
            "patients",
            "physician",
            "team",
            "together",
            "uer"
        ]
    },
    {
        "icon": "watch-apple",
        "label": "Watch Apple",
        "search": [
            "apps",
            "digital",
            "fitness",
            "smartwatch"
        ]
    },
    {
        "icon": "grid-round-4",
        "label": "Grid Round 4",
        "search": [
            "app",
            "collection",
            "filter",
            "grid",
            "sort"
        ]
    },
    {
        "icon": "book-open-cover",
        "label": "Book Open Cover",
        "search": [
            "knowledge",
            "library",
            "research",
            "scholar"
        ]
    },
    {
        "icon": "flashlight",
        "label": "Flashlight",
        "search": [
            "camping",
            "electric",
            "equipment",
            "flashlight",
            "hide and seek",
            "lamp",
            "light",
            "tool",
            "torch"
        ]
    },
    {
        "icon": "face-angry",
        "label": "Face Angry",
        "search": [
            "angry",
            "angry face",
            "disapprove",
            "emoticon",
            "face",
            "mad",
            "upset"
        ]
    },
    {
        "icon": "cheese-swiss",
        "label": "Cheese Swiss",
        "search": [
            "cheddar",
            "cheese",
            "cheese wedge",
            "curd",
            "gouda",
            "melt",
            "parmesan",
            "sandwich",
            "swiss",
            "wedge"
        ]
    },
    {
        "icon": "chart-pie-simple",
        "label": "Chart Pie Simple",
        "search": [
            "analytics",
            "chart",
            "diagram",
            "graph",
            "performance",
            "pie",
            "revenue",
            "statistics"
        ]
    },
    {
        "icon": "burst",
        "label": "Burst",
        "search": [
            "boom",
            "crash",
            "explosion"
        ]
    },
    {
        "icon": "z",
        "label": "Z",
        "search": [
            "Latin Capital Letter Z",
            "Latin Small Letter Z",
            "letter"
        ]
    },
    {
        "icon": "head-side-headphones",
        "label": "Head Side Headphones",
        "search": [
            "amplifier",
            "bluetooth",
            "earphone",
            "headset",
            "listen",
            "microphone",
            "music",
            "uer"
        ]
    },
    {
        "icon": "bandage",
        "label": "Bandage",
        "search": [
            "adhesive bandage",
            "bandage",
            "boo boo",
            "first aid",
            "modify",
            "ouch"
        ]
    },
    {
        "icon": "plane-circle-exclamation",
        "label": "Plane Circle Exclamation",
        "search": [
            "affected",
            "airplane",
            "airport",
            "failed",
            "flight",
            "fly",
            "travel"
        ]
    },
    {
        "icon": "bugs",
        "label": "Bugs",
        "search": [
            "bedbug",
            "infestation",
            "lice",
            "plague",
            "ticks"
        ]
    },
    {
        "icon": "creative-commons",
        "label": "Creative Commons",
        "search": []
    },
    {
        "icon": "book-user",
        "label": "Book User",
        "search": [
            "address",
            "biography",
            "diary",
            "documentation",
            "employee",
            "journal",
            "library",
            "read",
            "research",
            "uer"
        ]
    },
    {
        "icon": "chevrons-right",
        "label": "Chevrons Right",
        "search": [
            "arrow",
            "bracket",
            "forward",
            "next"
        ]
    },
    {
        "icon": "beer-mug-empty",
        "label": "Beer Mug Empty",
        "search": [
            "alcohol",
            "ale",
            "bar",
            "beverage",
            "brew",
            "brewery",
            "drink",
            "foam",
            "lager",
            "liquor",
            "mug",
            "stein"
        ]
    },
    {
        "icon": "person-circle-check",
        "label": "Person Circle Check",
        "search": [
            "approved",
            "enable",
            "not affected",
            "ok",
            "okay",
            "uer",
            "validate",
            "working"
        ]
    },
    {
        "icon": "cart-circle-plus",
        "label": "Cart Circle Plus",
        "search": [
            "cart",
            "grocery",
            "market",
            "shopping"
        ]
    },
    {
        "icon": "stapler",
        "label": "Stapler",
        "search": [
            "desktop",
            "milton",
            "office",
            "paperclip",
            "staple"
        ]
    },
    {
        "icon": "candy-corn",
        "label": "Candy Corn",
        "search": [
            "halloween",
            "holiday",
            "sugar",
            "triangles"
        ]
    },
    {
        "icon": "clipboard-prescription",
        "label": "Clipboard Prescription",
        "search": [
            "copy",
            "history",
            "medical",
            "notes",
            "paste",
            "record"
        ]
    },
    {
        "icon": "compress-wide",
        "label": "Compress Wide",
        "search": [
            "collapse",
            "fullscreen",
            "minimize",
            "move",
            "resize",
            "shrink",
            "smaller"
        ]
    },
    {
        "icon": "house-medical-circle-check",
        "label": "House Medical Circle Check",
        "search": [
            "clinic",
            "enable",
            "hospital",
            "not affected",
            "ok",
            "okay",
            "validate",
            "working"
        ]
    },
    {
        "icon": "comment-pen",
        "label": "Comment Pen",
        "search": [
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "edit",
            "feedback",
            "message",
            "modify",
            "note",
            "notification",
            "pen",
            "pencil",
            "sms",
            "speech",
            "texting",
            "update",
            "write"
        ]
    },
    {
        "icon": "chromecast",
        "label": "Chromecast",
        "search": []
    },
    {
        "icon": "naira-sign",
        "label": "Naira Sign",
        "search": [
            "Naira Sign",
            "currency"
        ]
    },
    {
        "icon": "file-png",
        "label": "File Png",
        "search": [
            "Document with Picture",
            "document",
            "image",
            "jpg",
            "photo"
        ]
    },
    {
        "icon": "hundred-points",
        "label": "Hundred Points",
        "search": [
            "100",
            "agree",
            "one hundred",
            "percent",
            "perfect score",
            "win"
        ]
    },
    {
        "icon": "table-tree",
        "label": "Table Tree",
        "search": [
            "directory",
            "file",
            "folder",
            "structure"
        ]
    },
    {
        "icon": "wifi",
        "label": "Wifi",
        "search": [
            "connection",
            "hotspot",
            "internet",
            "network",
            "signal",
            "wireless",
            "www"
        ]
    },
    {
        "icon": "wikipedia-w",
        "label": "Wikipedia W",
        "search": []
    },
    {
        "icon": "page",
        "label": "Page",
        "search": [
            "cv",
            "document",
            "empty",
            "file",
            "new",
            "pdf",
            "resume"
        ]
    },
    {
        "icon": "square-chevron-left",
        "label": "Square Chevron Left",
        "search": [
            "arrow",
            "back",
            "previous"
        ]
    },
    {
        "icon": "chart-mixed",
        "label": "Chart Mixed",
        "search": [
            "analytics",
            "chart",
            "data",
            "forecast",
            "graph",
            "measure",
            "performance",
            "revenue",
            "roi",
            "tracking",
            "trend"
        ]
    },
    {
        "icon": "calendar-exclamation",
        "label": "Calendar Exclamation",
        "search": [
            "alert",
            "attention",
            "calendar",
            "date",
            "day",
            "error",
            "event",
            "failed",
            "important",
            "month",
            "schedule",
            "time",
            "when",
            "year"
        ]
    },
    {
        "icon": "money-check-dollar",
        "label": "Money Check Dollar",
        "search": [
            "bank check",
            "buy",
            "checkout",
            "cheque",
            "money",
            "payment",
            "price",
            "purchase",
            "salary"
        ]
    },
    {
        "icon": "camcorder",
        "label": "Camcorder",
        "search": [
            "camera",
            "cinema",
            "director",
            "film",
            "handheld",
            "movie",
            "retro",
            "theater",
            "video",
            "video camera",
            "vintage"
        ]
    },
    {
        "icon": "house-chimney-blank",
        "label": "House Chimney Blank",
        "search": [
            "abode",
            "building",
            "house",
            "main"
        ]
    },
    {
        "icon": "eye-low-vision",
        "label": "Eye Low Vision",
        "search": [
            "blind",
            "eye",
            "sight"
        ]
    },
    {
        "icon": "circle-arrow-up",
        "label": "Circle Arrow Up",
        "search": [
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "camera-retro",
        "label": "Camera Retro",
        "search": [
            "camera",
            "image",
            "img",
            "lens",
            "photo",
            "picture",
            "record",
            "shutter",
            "video"
        ]
    },
    {
        "icon": "film-simple",
        "label": "Film Simple",
        "search": [
            "cinema",
            "movie",
            "strip",
            "video"
        ]
    },
    {
        "icon": "capsules",
        "label": "Capsules",
        "search": [
            "drugs",
            "medicine",
            "pills",
            "prescription"
        ]
    },
    {
        "icon": "block-brick-fire",
        "label": "Block Brick Fire",
        "search": [
            "brick",
            "fire",
            "firewall",
            "network",
            "wall"
        ]
    },
    {
        "icon": "filters",
        "label": "Filters",
        "search": [
            "funnel",
            "options",
            "separate",
            "sort"
        ]
    },
    {
        "icon": "bowling-pins",
        "label": "Bowling Pins",
        "search": [
            "alley",
            "candlepin",
            "gutter",
            "lane",
            "strike",
            "tenpin"
        ]
    },
    {
        "icon": "calendar-users",
        "label": "Calendar Users",
        "search": [
            "attendee",
            "calendar",
            "date",
            "day",
            "event",
            "img",
            "important",
            "invitation",
            "invite",
            "month",
            "networking",
            "schedule",
            "time",
            "when",
            "year"
        ]
    },
    {
        "icon": "people-simple",
        "label": "People Simple",
        "search": [
            "together",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "sitrox",
        "label": "Sitrox",
        "search": []
    },
    {
        "icon": "poo",
        "label": "Poo",
        "search": [
            "crap",
            "dung",
            "face",
            "monster",
            "pile of poo",
            "poo",
            "poop",
            "shit",
            "smile",
            "turd",
            "uer"
        ]
    },
    {
        "icon": "square-5",
        "label": "Square 5",
        "search": [
            "five"
        ]
    },
    {
        "icon": "volume",
        "label": "Volume",
        "search": [
            "audio",
            "control",
            "medium",
            "music",
            "sound",
            "speaker",
            "speaker medium volume"
        ]
    },
    {
        "icon": "flower-daffodil",
        "label": "Flower Daffodil",
        "search": [
            "Flower",
            "nature",
            "spring",
            "summer"
        ]
    },
    {
        "icon": "elevator",
        "label": "Elevator",
        "search": [
            "accessibility",
            "elevator",
            "hoist",
            "lift",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "wave-pulse",
        "label": "Wave Pulse",
        "search": [
            "EKG",
            "activity",
            "electrocardiogram",
            "health",
            "life",
            "vital"
        ]
    },
    {
        "icon": "book-heart",
        "label": "Book Heart",
        "search": [
            "charity",
            "diary",
            "documentation",
            "donation",
            "health",
            "history",
            "journal",
            "library",
            "read",
            "research",
            "wishlist"
        ]
    },
    {
        "icon": "square-z",
        "label": "Square Z",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "square-gitlab",
        "label": "Square Gitlab",
        "search": []
    },
    {
        "icon": "tag",
        "label": "Tag",
        "search": [
            "discount",
            "labe",
            "label",
            "price",
            "shopping"
        ]
    },
    {
        "icon": "wagon-covered",
        "label": "Wagon Covered",
        "search": [
            "contestoga",
            "dysentery",
            "oregon trail",
            "stagecoach",
            "vehicle",
            "western",
            "wheel"
        ]
    },
    {
        "icon": "file-circle-minus",
        "label": "File Circle Minus",
        "search": [
            "document",
            "file",
            "paper"
        ]
    },
    {
        "icon": "message-code",
        "label": "Message Code",
        "search": [
            "coding",
            "contact",
            "discussion"
        ]
    },
    {
        "icon": "gear-complex",
        "label": "Gear Complex",
        "search": [
            "cog",
            "cogwheel",
            "gear",
            "mechanical",
            "settings",
            "sprocket",
            "tool",
            "wheel"
        ]
    },
    {
        "icon": "circle-c",
        "label": "Circle C",
        "search": [
            "Circled Latin Capital Letter C",
            "letter"
        ]
    },
    {
        "icon": "down-long",
        "label": "Down Long",
        "search": [
            "download",
            "long-arrow-down"
        ]
    },
    {
        "icon": "shoelace",
        "label": "Shoelace",
        "search": []
    },
    {
        "icon": "compact-disc",
        "label": "Compact Disc",
        "search": [
            "Optical Disc Icon",
            "album",
            "blu-ray",
            "bluray",
            "cd",
            "computer",
            "disc",
            "disk",
            "dvd",
            "media",
            "movie",
            "music",
            "optical",
            "optical disk",
            "record",
            "video",
            "vinyl"
        ]
    },
    {
        "icon": "suitcase-rolling",
        "label": "Suitcase Rolling",
        "search": [
            "baggage",
            "luggage",
            "move",
            "suitcase",
            "travel",
            "trip"
        ]
    },
    {
        "icon": "webhook",
        "label": "Webhook",
        "search": [
            "api",
            "automate",
            "callback",
            "code",
            "communication",
            "http",
            "infastructure",
            "json",
            "message"
        ]
    },
    {
        "icon": "clock-five-thirty",
        "label": "Clock Five Thirty",
        "search": [
            "5",
            "5:30",
            "clock",
            "five",
            "five-thirty",
            "hour",
            "minute",
            "o'clock",
            "pending",
            "thirty",
            "ticking",
            "time"
        ]
    },
    {
        "icon": "arrow-down-arrow-up",
        "label": "Arrow Down Arrow Up",
        "search": [
            "arrange",
            "arrows",
            "exchange",
            "filter",
            "order",
            "transfer"
        ]
    },
    {
        "icon": "book-quran",
        "label": "Book Quran",
        "search": [
            "book",
            "islam",
            "muslim",
            "religion"
        ]
    },
    {
        "icon": "telescope",
        "label": "Telescope",
        "search": [
            "astronomy",
            "knowledge",
            "lens",
            "look",
            "microscope",
            "observatory",
            "science",
            "scope",
            "search",
            "space",
            "telescope",
            "tool",
            "view"
        ]
    },
    {
        "icon": "phone-slash",
        "label": "Phone Slash",
        "search": [
            "call",
            "cancel",
            "disabled",
            "disconnect",
            "earphone",
            "mute",
            "number",
            "support",
            "telephone",
            "voice"
        ]
    },
    {
        "icon": "road-circle-check",
        "label": "Road Circle Check",
        "search": [
            "enable",
            "freeway",
            "highway",
            "not affected",
            "ok",
            "okay",
            "pavement",
            "road",
            "validate",
            "working"
        ]
    },
    {
        "icon": "sellcast",
        "label": "Sellcast",
        "search": [
            "eercast"
        ]
    },
    {
        "icon": "shop-lock",
        "label": "Shop Lock",
        "search": [
            "bodega",
            "building",
            "buy",
            "closed",
            "lock",
            "lockdown",
            "market",
            "padlock",
            "privacy",
            "purchase",
            "quarantine",
            "shop",
            "shopping",
            "store"
        ]
    },
    {
        "icon": "image-portrait",
        "label": "Image Portrait",
        "search": [
            "id",
            "image",
            "img",
            "photo",
            "picture",
            "selfie",
            "uer",
            "username"
        ]
    },
    {
        "icon": "books",
        "label": "Books",
        "search": [
            "book",
            "books",
            "diary",
            "documentation",
            "journal",
            "knowledge",
            "library",
            "read",
            "research",
            "scholar"
        ]
    },
    {
        "icon": "mix",
        "label": "Mix",
        "search": []
    },
    {
        "icon": "grid-2",
        "label": "Grid 2",
        "search": [
            "app",
            "collection",
            "filter",
            "grid",
            "sort"
        ]
    },
    {
        "icon": "cart-arrow-up",
        "label": "Cart Arrow Up",
        "search": [
            "cart",
            "grocery",
            "market",
            "shopping",
            "upgrade"
        ]
    },
    {
        "icon": "bridge-lock",
        "label": "Bridge Lock",
        "search": [
            "bridge",
            "closed",
            "lockdown",
            "padlock",
            "privacy",
            "quarantine",
            "road"
        ]
    },
    {
        "icon": "paper-plane-top",
        "label": "Paper Plane Top",
        "search": [
            "email",
            "fold",
            "send"
        ]
    },
    {
        "icon": "clock-nine-thirty",
        "label": "Clock Nine Thirty",
        "search": [
            "9",
            "9:30",
            "clock",
            "hour",
            "minute",
            "nine",
            "nine-thirty",
            "o'clock",
            "pending",
            "thirty",
            "ticking",
            "time"
        ]
    },
    {
        "icon": "burger-lettuce",
        "label": "Burger Lettuce",
        "search": [
            "burger",
            "fast food",
            "grill",
            "sandwich",
            "vegetables",
            "veggie burger"
        ]
    },
    {
        "icon": "hammer",
        "label": "Hammer",
        "search": [
            "admin",
            "configuration",
            "equipment",
            "fix",
            "hammer",
            "maintenance",
            "modify",
            "recovery",
            "repair",
            "settings",
            "tool"
        ]
    },
    {
        "icon": "cc-apple-pay",
        "label": "Apple Pay Credit Card",
        "search": []
    },
    {
        "icon": "square-up-left",
        "label": "Square Up Left",
        "search": [
            "arrow",
            "diagonal",
            "direction",
            "intercardinal",
            "northwest",
            "up-left arrow"
        ]
    },
    {
        "icon": "transporter-7",
        "label": "Transporter 7",
        "search": [
            "move",
            "teleport",
            "transfer",
            "translocate",
            "travel"
        ]
    },
    {
        "icon": "arrow-up-1-9",
        "label": "Arrow Up 1 9",
        "search": [
            "arrange",
            "filter",
            "numbers",
            "order",
            "sort-numeric-desc"
        ]
    },
    {
        "icon": "chess-knight",
        "label": "Chess Knight",
        "search": [
            "Black Chess Knight",
            "board",
            "checkmate",
            "game",
            "horse",
            "strategy"
        ]
    },
    {
        "icon": "brave",
        "label": "Brave",
        "search": []
    },
    {
        "icon": "house-flood-water-circle-arrow-right",
        "label": "House Flood Water Circle Arrow Right",
        "search": [
            "damage",
            "flood",
            "water"
        ]
    },
    {
        "icon": "nfc-magnifying-glass",
        "label": "Nfc Magnifying Glass",
        "search": [
            "connect",
            "data",
            "magnifier",
            "near field communication",
            "nfc",
            "scan",
            "search",
            "signal",
            "transfer",
            "wireless"
        ]
    },
    {
        "icon": "melon-slice",
        "label": "Melon Slice",
        "search": [
            "cantaloupe",
            "honeydew",
            "muskmelon",
            "wedge"
        ]
    },
    {
        "icon": "prescription-bottle-pill",
        "label": "Prescription Bottle Pill",
        "search": [
            "drugs",
            "medical",
            "medicine",
            "pharmacy",
            "rx"
        ]
    },
    {
        "icon": "clock-eight-thirty",
        "label": "Clock Eight Thirty",
        "search": [
            "8",
            "8:30",
            "clock",
            "eight",
            "eight-thirty",
            "hour",
            "minute",
            "o'clock",
            "pending",
            "thirty",
            "ticking",
            "time"
        ]
    },
    {
        "icon": "cloud-minus",
        "label": "Cloud Minus",
        "search": [
            "remove",
            "subtract"
        ]
    },
    {
        "icon": "etsy",
        "label": "Etsy",
        "search": []
    },
    {
        "icon": "laptop-mobile",
        "label": "Laptop Mobile",
        "search": [
            "computer",
            "device",
            "mobile",
            "platform",
            "technology"
        ]
    },
    {
        "icon": "bag-shopping-plus",
        "label": "Bag Shopping Plus",
        "search": [
            "add",
            "buy",
            "checkout",
            "grocery",
            "payment",
            "purchase"
        ]
    },
    {
        "icon": "clapperboard-play",
        "label": "Clapperboard Play",
        "search": [
            "camera",
            "director",
            "film",
            "movie",
            "record"
        ]
    },
    {
        "icon": "left-from-line",
        "label": "Left From Line",
        "search": [
            "forward",
            "next"
        ]
    },
    {
        "icon": "engine-warning",
        "label": "Engine Warning",
        "search": [
            "alert",
            "automobile",
            "car",
            "failed",
            "mechanic",
            "warning"
        ]
    },
    {
        "icon": "pickleball",
        "label": "Pickleball",
        "search": [
            "paddle",
            "pickleball",
            "wiffle"
        ]
    },
    {
        "icon": "arrow-up-right-from-square",
        "label": "Arrow Up Right From Square",
        "search": [
            "new",
            "open",
            "send",
            "share",
            "upgrade"
        ]
    },
    {
        "icon": "border-right",
        "label": "Border Right",
        "search": [
            "cell",
            "grid",
            "outline",
            "stroke",
            "table"
        ]
    },
    {
        "icon": "arrow-down-up-across-line",
        "label": "Arrow Down Up Across Line",
        "search": [
            "border",
            "crossing",
            "transfer"
        ]
    },
    {
        "icon": "face-grin-beam",
        "label": "Face Grin Beam",
        "search": [
            "emoticon",
            "eye",
            "face",
            "grinning face with smiling eyes",
            "laugh",
            "mouth",
            "open",
            "smile"
        ]
    },
    {
        "icon": "rectangle-ad",
        "label": "Rectangle Ad",
        "search": [
            "advertisement",
            "media",
            "newspaper",
            "promotion",
            "publicity"
        ]
    },
    {
        "icon": "car-side-bolt",
        "label": "Car Side Bolt",
        "search": [
            "auto",
            "automobile",
            "electric",
            "ev",
            "sedan",
            "tesla",
            "transportation",
            "travel",
            "vehicle"
        ]
    },
    {
        "icon": "circle-up-right",
        "label": "Circle Up Right",
        "search": [
            "diagonal"
        ]
    },
    {
        "icon": "person-ski-jumping",
        "label": "Person Ski Jumping",
        "search": [
            "olympics",
            "skiing",
            "uer",
            "winter"
        ]
    },
    {
        "icon": "user-vneck",
        "label": "User Vneck",
        "search": [
            "bust",
            "bust in silhouette",
            "person",
            "profile",
            "silhouette",
            "uer"
        ]
    },
    {
        "icon": "clarinet",
        "label": "Clarinet",
        "search": [
            "instrument",
            "jazz",
            "music",
            "woodwind"
        ]
    },
    {
        "icon": "book-tanakh",
        "label": "Book Tanakh",
        "search": [
            "book",
            "jewish",
            "judaism",
            "religion"
        ]
    },
    {
        "icon": "file-xmark",
        "label": "File Xmark",
        "search": [
            "archive",
            "delete",
            "document",
            "remove",
            "uncheck",
            "x"
        ]
    },
    {
        "icon": "square-user",
        "label": "Square User",
        "search": [
            "employee",
            "person",
            "profile",
            "uer"
        ]
    },
    {
        "icon": "clock-six",
        "label": "Clock Six",
        "search": [
            "00",
            "6",
            "6:00",
            "clock",
            "hour",
            "minute",
            "o'clock",
            "o’clock",
            "pending",
            "six",
            "six o’clock",
            "ticking",
            "time"
        ]
    },
    {
        "icon": "dinosaur",
        "label": "Dinosaur",
        "search": [
            "brachiosaurus",
            "dino",
            "dinosaur",
            "herbivore",
            "jurassic",
            "sauropod"
        ]
    },
    {
        "icon": "btc",
        "label": "BTC",
        "search": []
    },
    {
        "icon": "french-fries",
        "label": "French Fries",
        "search": [
            "chips",
            "fast food",
            "french",
            "french fries",
            "fried",
            "fries",
            "ketchup",
            "potato",
            "poutine"
        ]
    },
    {
        "icon": "hot-tub-person",
        "label": "Hot Tub Person",
        "search": [
            "jacuzzi",
            "spa",
            "uer"
        ]
    },
    {
        "icon": "file-half-dashed",
        "label": "File Half Dashed",
        "search": [
            "data",
            "fragment",
            "partial",
            "piece"
        ]
    },
    {
        "icon": "reflect-horizontal",
        "label": "Reflect Horizontal",
        "search": [
            "edit",
            "exchange",
            "flip",
            "horizontal",
            "inverse",
            "invert",
            "mirror",
            "negative",
            "reflect",
            "swap",
            "tool"
        ]
    },
    {
        "icon": "cart-circle-exclamation",
        "label": "Cart Circle Exclamation",
        "search": [
            "cart",
            "failed",
            "grocery",
            "market",
            "shopping"
        ]
    },
    {
        "icon": "adn",
        "label": "App.net",
        "search": []
    },
    {
        "icon": "outdent",
        "label": "Outdent",
        "search": [
            "align",
            "justify",
            "paragraph",
            "tab"
        ]
    },
    {
        "icon": "square-x-twitter",
        "label": "Square X Twitter",
        "search": [
            "elon",
            "twitter",
            "x"
        ]
    },
    {
        "icon": "brake-warning",
        "label": "Brake Warning",
        "search": [
            "ABS",
            "accident",
            "alert",
            "dashboard"
        ]
    },
    {
        "icon": "square-star",
        "label": "Square Star",
        "search": [
            "favorite",
            "quality"
        ]
    },
    {
        "icon": "hand-peace",
        "label": "Hand Peace",
        "search": [
            "hand",
            "rest",
            "truce",
            "v",
            "victory",
            "victory hand"
        ]
    },
    {
        "icon": "square-font-awesome",
        "label": "Square Font Awesome",
        "search": []
    },
    {
        "icon": "head-side-virus",
        "label": "Head Side Virus",
        "search": [
            "cold",
            "coronavirus",
            "covid-19",
            "flu",
            "infection",
            "pandemic",
            "sick",
            "uer"
        ]
    },
    {
        "icon": "forumbee",
        "label": "Forumbee",
        "search": []
    },
    {
        "icon": "square-down",
        "label": "Square Down",
        "search": [
            "arrow",
            "cardinal",
            "direction",
            "down",
            "down arrow",
            "download",
            "south"
        ]
    },
    {
        "icon": "crutches",
        "label": "Crutches",
        "search": [
            "cane",
            "injury",
            "mobility",
            "wheelchair"
        ]
    },
    {
        "icon": "gramophone",
        "label": "Gramophone",
        "search": [
            "award",
            "grammy",
            "music",
            "phonograph",
            "record",
            "turntable",
            "victrola"
        ]
    },
    {
        "icon": "h3",
        "label": "H3",
        "search": [
            "format",
            "header",
            "text",
            "title"
        ]
    },
    {
        "icon": "compass",
        "label": "Compass",
        "search": [
            "compass",
            "directions",
            "directory",
            "location",
            "magnetic",
            "menu",
            "navigation",
            "orienteering",
            "safari",
            "travel"
        ]
    },
    {
        "icon": "roller-coaster",
        "label": "Roller Coaster",
        "search": [
            "amusement park",
            "coaster",
            "fair",
            "ride",
            "roller",
            "roller coaster",
            "theme park"
        ]
    },
    {
        "icon": "pen-nib",
        "label": "Pen Nib",
        "search": [
            "design",
            "edit",
            "fountain pen",
            "modify",
            "update",
            "write"
        ]
    },
    {
        "icon": "tent-arrows-down",
        "label": "Tent Arrows Down",
        "search": [
            "bivouac",
            "campground",
            "campsite",
            "insert",
            "refugee",
            "refugee",
            "shelter",
            "shelter",
            "spontaneous",
            "tent"
        ]
    },
    {
        "icon": "duck",
        "label": "Duck",
        "search": [
            "bath",
            "bird",
            "duck",
            "fauna",
            "quack",
            "rubber"
        ]
    },
    {
        "icon": "draw-circle",
        "label": "Draw Circle",
        "search": [
            "anchors",
            "lines",
            "object",
            "render",
            "shape"
        ]
    },
    {
        "icon": "forward-fast",
        "label": "Forward Fast",
        "search": [
            "arrow",
            "end",
            "last",
            "next",
            "next scene",
            "next track",
            "next track button",
            "quick",
            "triangle"
        ]
    },
    {
        "icon": "42-group",
        "label": "42.group",
        "search": []
    },
    {
        "icon": "trees",
        "label": "Trees",
        "search": [
            "bark",
            "fall",
            "flora",
            "forest",
            "nature",
            "plant",
            "seasonal"
        ]
    },
    {
        "icon": "crop",
        "label": "Crop",
        "search": [
            "design",
            "frame",
            "mask",
            "modify",
            "resize",
            "shrink"
        ]
    },
    {
        "icon": "whiskey-glass",
        "label": "Whiskey Glass",
        "search": [
            "alcohol",
            "bar",
            "beverage",
            "bourbon",
            "drink",
            "glass",
            "liquor",
            "neat",
            "rye",
            "scotch",
            "shot",
            "tumbler",
            "tumbler glass",
            "whisky"
        ]
    },
    {
        "icon": "stumbleupon-circle",
        "label": "StumbleUpon Circle",
        "search": []
    },
    {
        "icon": "down-from-bracket",
        "label": "Down From Bracket",
        "search": [
            "download",
            "exit",
            "share",
            "transfer"
        ]
    },
    {
        "icon": "gear-complex-code",
        "label": "Gear Complex Code",
        "search": [
            "code",
            "cog",
            "cogwheel",
            "develop",
            "digital",
            "gear",
            "mechanical",
            "settings",
            "sprocket",
            "tool",
            "wheel"
        ]
    },
    {
        "icon": "square-n",
        "label": "Square N",
        "search": [
            "letter",
            "nay",
            "no"
        ]
    },
    {
        "icon": "square-3",
        "label": "Square 3",
        "search": [
            "three"
        ]
    },
    {
        "icon": "ufo-beam",
        "label": "Ufo Beam",
        "search": [
            "abduct",
            "alien",
            "extraterrestrial",
            "flying saucer",
            "probe",
            "space",
            "spacecraft",
            "spaceship",
            "t-craft",
            "tractor beam",
            "travel",
            "unidentified flying object"
        ]
    },
    {
        "icon": "square",
        "label": "Square",
        "search": [
            "Black Square",
            "black medium square",
            "block",
            "box",
            "geometric",
            "shape",
            "square",
            "white medium square"
        ]
    },
    {
        "icon": "symfony",
        "label": "Symfony",
        "search": []
    },
    {
        "icon": "garlic",
        "label": "Garlic",
        "search": [
            "ail",
            "flavor",
            "garlic",
            "vampire"
        ]
    },
    {
        "icon": "backpack",
        "label": "Backpack",
        "search": [
            "backpack",
            "bag",
            "book",
            "carry",
            "hiking",
            "rucksack",
            "satchel",
            "school",
            "travel"
        ]
    },
    {
        "icon": "file-certificate",
        "label": "File Certificate",
        "search": [
            "award",
            "diploma",
            "document",
            "license"
        ]
    },
    {
        "icon": "people",
        "label": "People",
        "search": [
            "couple",
            "hand",
            "hold",
            "holding hands",
            "man",
            "together",
            "uer",
            "users-people",
            "woman",
            "woman and man holding hands"
        ]
    },
    {
        "icon": "salesforce",
        "label": "Salesforce",
        "search": []
    },
    {
        "icon": "landmark-magnifying-glass",
        "label": "Landmark Magnifying Glass",
        "search": [
            "building",
            "classical",
            "find",
            "historic",
            "memorable",
            "monument",
            "museum",
            "politics",
            "preservation",
            "preserve",
            "records",
            "search",
            "society"
        ]
    },
    {
        "icon": "clipboard-medical",
        "label": "Clipboard Medical",
        "search": [
            "copy",
            "paste",
            "patient",
            "records"
        ]
    },
    {
        "icon": "sourcetree",
        "label": "Sourcetree",
        "search": []
    },
    {
        "icon": "face-grin",
        "label": "Face Grin",
        "search": [
            "emoticon",
            "face",
            "grin",
            "grinning face",
            "laugh",
            "smile"
        ]
    },
    {
        "icon": "linkedin-in",
        "label": "LinkedIn In",
        "search": [
            "linkedin",
            "linkin"
        ]
    },
    {
        "icon": "file-contract",
        "label": "File Contract",
        "search": [
            "agreement",
            "binding",
            "document",
            "legal",
            "signature",
            "username"
        ]
    },
    {
        "icon": "border-bottom-right",
        "label": "Border Bottom Right",
        "search": [
            "cell",
            "grid",
            "outline",
            "stroke",
            "table"
        ]
    },
    {
        "icon": "cassette-tape",
        "label": "Cassette Tape",
        "search": [
            "Tape Cartridge",
            "mixtape",
            "music",
            "play",
            "recording",
            "walkman"
        ]
    },
    {
        "icon": "angle-up",
        "label": "Angle Up",
        "search": [
            "Up Arrowhead",
            "arrow",
            "caret",
            "collapse",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "folder-grid",
        "label": "Folder Grid",
        "search": [
            "contents",
            "file"
        ]
    },
    {
        "icon": "arrow-right-to-arc",
        "label": "Arrow Right To Arc",
        "search": [
            "enter",
            "give",
            "insert",
            "into",
            "login",
            "send",
            "sign in"
        ]
    },
    {
        "icon": "face-smile",
        "label": "Face Smile",
        "search": [
            "approve",
            "default",
            "emoticon",
            "face",
            "happy",
            "rating",
            "satisfied",
            "slightly smiling face",
            "smile",
            "uer"
        ]
    },
    {
        "icon": "location-pin-slash",
        "label": "Location Pin Slash",
        "search": [
            "agree",
            "cancel",
            "coordinates",
            "destination",
            "disabled",
            "location",
            "map",
            "missing",
            "navigation",
            "pin",
            "place"
        ]
    },
    {
        "icon": "person-dress-burst",
        "label": "Person Dress Burst",
        "search": [
            "abuse",
            "accident",
            "crash",
            "explode",
            "uer",
            "violence"
        ]
    },
    {
        "icon": "html5",
        "label": "HTML 5 Logo",
        "search": []
    },
    {
        "icon": "divide",
        "label": "Divide",
        "search": [
            "Division Sign",
            "arithmetic",
            "calculus",
            "divide",
            "division",
            "math",
            "sign",
            "÷"
        ]
    },
    {
        "icon": "user-helmet-safety",
        "label": "User Helmet Safety",
        "search": [
            "construction",
            "construction worker",
            "employee",
            "hardhat",
            "hat",
            "helmet",
            "maintenance",
            "safety",
            "uer",
            "worker"
        ]
    },
    {
        "icon": "code-fork",
        "label": "Code Fork",
        "search": [
            "fork",
            "git",
            "github",
            "svn",
            "version"
        ]
    },
    {
        "icon": "bags-shopping",
        "label": "Bags Shopping",
        "search": [
            "bag",
            "buy",
            "checkout",
            "hotel",
            "order",
            "shopping",
            "shopping bags",
            "store"
        ]
    },
    {
        "icon": "book-sparkles",
        "label": "Book Sparkles",
        "search": [
            "Dungeons & Dragons",
            "d&d",
            "dark arts",
            "dnd",
            "documentation",
            "evil",
            "fantasy",
            "halloween",
            "holiday",
            "library",
            "mage",
            "magic",
            "read",
            "research",
            "sorcery",
            "voodoo",
            "witch",
            "wizard"
        ]
    },
    {
        "icon": "sun-cloud",
        "label": "Sun Cloud",
        "search": [
            "cloud",
            "day",
            "lighter",
            "sol",
            "solar",
            "star",
            "sun",
            "sun behind small cloud",
            "weather"
        ]
    },
    {
        "icon": "house-flag",
        "label": "House Flag",
        "search": [
            "camp",
            "home"
        ]
    },
    {
        "icon": "bullseye-pointer",
        "label": "Bullseye Pointer",
        "search": [
            "archery",
            "goal",
            "objective",
            "strategy",
            "target"
        ]
    },
    {
        "icon": "building-columns",
        "label": "Building Columns",
        "search": [
            "bank",
            "building",
            "college",
            "education",
            "institution",
            "museum",
            "students"
        ]
    },
    {
        "icon": "cloud-showers",
        "label": "Cloud Showers",
        "search": [
            "precipitation",
            "rain",
            "sky",
            "storm"
        ]
    },
    {
        "icon": "rug",
        "label": "Rug",
        "search": [
            "blanket",
            "carpet",
            "rug",
            "textile"
        ]
    },
    {
        "icon": "truck-bolt",
        "label": "Truck Bolt",
        "search": [
            "cargo",
            "delivery",
            "electric",
            "ev",
            "shipping",
            "vehicle"
        ]
    },
    {
        "icon": "code-merge",
        "label": "Code Merge",
        "search": [
            "git",
            "github",
            "merge",
            "pr",
            "rebase",
            "svn",
            "vcs",
            "version"
        ]
    },
    {
        "icon": "cactus",
        "label": "Cactus",
        "search": [
            "cactus",
            "cowboy",
            "desert",
            "flora",
            "old west",
            "plant",
            "succulent",
            "western"
        ]
    },
    {
        "icon": "house-tsunami",
        "label": "House Tsunami",
        "search": [
            "damage",
            "flood",
            "tidal wave",
            "wave"
        ]
    },
    {
        "icon": "rust",
        "label": "Rust",
        "search": []
    },
    {
        "icon": "magnifying-glass-chart",
        "label": "Magnifying Glass Chart",
        "search": [
            "analysis",
            "chart",
            "data",
            "graph",
            "intelligence",
            "magnifier",
            "market",
            "revenue"
        ]
    },
    {
        "icon": "input-pipe",
        "label": "Input Pipe",
        "search": [
            "field",
            "input"
        ]
    },
    {
        "icon": "display-chart-up-circle-dollar",
        "label": "Display Chart Up Circle Dollar",
        "search": [
            "analytics",
            "chart",
            "computer",
            "currency",
            "display",
            "exchange",
            "graph",
            "investment",
            "measure",
            "money",
            "monitor",
            "roi",
            "tracking",
            "trading",
            "trend"
        ]
    },
    {
        "icon": "umbrella",
        "label": "Umbrella",
        "search": [
            "protection",
            "rain",
            "storm",
            "wet"
        ]
    },
    {
        "icon": "bone-break",
        "label": "Bone Break",
        "search": [
            "broken",
            "calcium",
            "dog",
            "fracture",
            "skeletal",
            "skeleton",
            "tibia"
        ]
    },
    {
        "icon": "message-question",
        "label": "Message Question",
        "search": [
            "chat",
            "faq",
            "help",
            "question",
            "support"
        ]
    },
    {
        "icon": "circle-5",
        "label": "Circle 5",
        "search": [
            "Circled Digit Five",
            "Dingbat Circled Sans-Serif Digit Five",
            "Dingbat Negative Circled Digit Five",
            "Dingbat Negative Circled Sans-Serif Digit Five",
            "five"
        ]
    },
    {
        "icon": "hill-rockslide",
        "label": "Hill Rockslide",
        "search": [
            "mudslide"
        ]
    },
    {
        "icon": "user-secret",
        "label": "User Secret",
        "search": [
            "detective",
            "sleuth",
            "spy",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "pager",
        "label": "Pager",
        "search": [
            "beeper",
            "cell phone",
            "communication",
            "page",
            "pager"
        ]
    },
    {
        "icon": "briefcase",
        "label": "Briefcase",
        "search": [
            "bag",
            "briefcas",
            "briefcase",
            "business",
            "luggage",
            "offer",
            "office",
            "portfolio",
            "work"
        ]
    },
    {
        "icon": "trowel-bricks",
        "label": "Trowel Bricks",
        "search": [
            "build",
            "construction",
            "maintenance",
            "reconstruction",
            "tool"
        ]
    },
    {
        "icon": "user-police-tie",
        "label": "User Police Tie",
        "search": [
            "cop",
            "five-o",
            "law enforcement",
            "officer",
            "patrol",
            "police",
            "trooper",
            "uer"
        ]
    },
    {
        "icon": "socks",
        "label": "Socks",
        "search": [
            "business socks",
            "business time",
            "clothing",
            "feet",
            "flight of the conchords",
            "socks",
            "stocking",
            "wednesday"
        ]
    },
    {
        "icon": "gauge-max",
        "label": "Gauge Max",
        "search": [
            "dashboard",
            "fast",
            "odometer",
            "quick",
            "speed",
            "speedometer"
        ]
    },
    {
        "icon": "comment-arrow-up",
        "label": "Comment Arrow Up",
        "search": [
            "answer",
            "chat",
            "contact",
            "discussion",
            "send",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "guitar-electric",
        "label": "Guitar Electric",
        "search": [
            "axe",
            "guitar",
            "instrument",
            "music",
            "rock",
            "rock and roll",
            "song",
            "strings"
        ]
    },
    {
        "icon": "coffee-bean",
        "label": "Coffee Bean",
        "search": [
            "berry",
            "brew",
            "coffee",
            "espresso",
            "java"
        ]
    },
    {
        "icon": "input-text",
        "label": "Input Text",
        "search": [
            "field",
            "input",
            "name"
        ]
    },
    {
        "icon": "lights-holiday",
        "label": "Lights Holiday",
        "search": [
            "bulb",
            "christmas",
            "decoration",
            "holiday",
            "string",
            "xmas"
        ]
    },
    {
        "icon": "t",
        "label": "T",
        "search": [
            "Latin Capital Letter T",
            "Latin Small Letter T",
            "letter"
        ]
    },
    {
        "icon": "microchip",
        "label": "Microchip",
        "search": [
            "cpu",
            "hardware",
            "processor",
            "technology"
        ]
    },
    {
        "icon": "key-skeleton",
        "label": "Key Skeleton",
        "search": [
            "clue",
            "halloween",
            "key",
            "lock",
            "old",
            "old key",
            "password",
            "private",
            "secret",
            "unlock"
        ]
    },
    {
        "icon": "truck-medical",
        "label": "Truck Medical",
        "search": [
            "ambulance",
            "clinic",
            "covid-19",
            "emergency",
            "emt",
            "er",
            "help",
            "hospital",
            "mobile",
            "support",
            "vehicle"
        ]
    },
    {
        "icon": "om",
        "label": "Om",
        "search": [
            "Hindu",
            "buddhism",
            "hinduism",
            "jainism",
            "mantra",
            "om",
            "religion"
        ]
    },
    {
        "icon": "mosquito-net",
        "label": "Mosquito Net",
        "search": [
            "bite",
            "malaria",
            "mosquito",
            "net"
        ]
    },
    {
        "icon": "prescription-bottle",
        "label": "Prescription Bottle",
        "search": [
            "drugs",
            "medical",
            "medicine",
            "pharmacy",
            "rx"
        ]
    },
    {
        "icon": "hornbill",
        "label": "Hornbill",
        "search": []
    },
    {
        "icon": "users-gear",
        "label": "Users Gear",
        "search": [
            "employee",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "php",
        "label": "PHP",
        "search": []
    },
    {
        "icon": "road-circle-exclamation",
        "label": "Road Circle Exclamation",
        "search": [
            "affected",
            "failed",
            "freeway",
            "highway",
            "pavement",
            "road"
        ]
    },
    {
        "icon": "500px",
        "label": "500px",
        "search": []
    },
    {
        "icon": "trash-can-clock",
        "label": "Trash Can Clock",
        "search": [
            "delay",
            "delete",
            "garbage",
            "hide",
            "remove"
        ]
    },
    {
        "icon": "pause",
        "label": "Pause",
        "search": [
            "bar",
            "double",
            "hold",
            "pause",
            "pause button",
            "vertical",
            "wait"
        ]
    },
    {
        "icon": "affiliatetheme",
        "label": "affiliatetheme",
        "search": []
    },
    {
        "icon": "staff-snake",
        "label": "Staff Snake",
        "search": [
            "asclepius",
            "asklepian",
            "health",
            "serpent",
            "wellness"
        ]
    },
    {
        "icon": "piggy-bank",
        "label": "Piggy Bank",
        "search": [
            "bank",
            "salary",
            "save",
            "savings"
        ]
    },
    {
        "icon": "monument",
        "label": "Monument",
        "search": [
            "building",
            "historic",
            "landmark",
            "memorable"
        ]
    },
    {
        "icon": "light-switch-off",
        "label": "Light Switch Off",
        "search": [
            "light",
            "off",
            "on"
        ]
    },
    {
        "icon": "tricycle",
        "label": "Tricycle",
        "search": [
            "bicycle",
            "bike",
            "peddle",
            "ride",
            "trike"
        ]
    },
    {
        "icon": "red-river",
        "label": "red river",
        "search": []
    },
    {
        "icon": "border-center-v",
        "label": "Border Center V",
        "search": [
            "cell",
            "grid",
            "outline",
            "stroke",
            "table"
        ]
    },
    {
        "icon": "circle-y",
        "label": "Circle Y",
        "search": [
            "Circled Latin Capital Letter Y",
            "letter",
            "yay",
            "yes"
        ]
    },
    {
        "icon": "folder-music",
        "label": "Folder Music",
        "search": [
            "audio",
            "mp3"
        ]
    },
    {
        "icon": "angles-right",
        "label": "Angles Right",
        "search": [
            "Right-Pointing Double Angle Quotation Mark",
            "arrows",
            "caret",
            "forward",
            "more",
            "next",
            "quote",
            "raquo"
        ]
    },
    {
        "icon": "circle-t",
        "label": "Circle T",
        "search": [
            "Circled Latin Capital Letter T",
            "letter"
        ]
    },
    {
        "icon": "user-crown",
        "label": "User Crown",
        "search": [
            "administrator",
            "uer",
            "users-people",
            "vip"
        ]
    },
    {
        "icon": "desktop",
        "label": "Desktop",
        "search": [
            "computer",
            "cpu",
            "demo",
            "desktop",
            "desktop computer",
            "device",
            "imac",
            "machine",
            "monitor",
            "pc",
            "screen"
        ]
    },
    {
        "icon": "donut",
        "label": "Donut",
        "search": [
            "donut",
            "doughnut",
            "frosting",
            "homer simpson",
            "jimmies",
            "sprinkles"
        ]
    },
    {
        "icon": "plane-circle-xmark",
        "label": "Plane Circle Xmark",
        "search": [
            "airplane",
            "airport",
            "destroy",
            "flight",
            "fly",
            "travel",
            "uncheck"
        ]
    },
    {
        "icon": "twitter",
        "label": "Twitter",
        "search": [
            "social network",
            "tweet"
        ]
    },
    {
        "icon": "projector",
        "label": "Projector",
        "search": [
            "cinema",
            "keynote",
            "movie",
            "powerpoint",
            "presentation",
            "shadow puppets",
            "slides"
        ]
    },
    {
        "icon": "up-from-line",
        "label": "Up From Line",
        "search": [
            "import",
            "transfer",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "retweet",
        "label": "Retweet",
        "search": [
            "refresh",
            "reload",
            "renew",
            "retry",
            "share",
            "swap"
        ]
    },
    {
        "icon": "user-gear",
        "label": "User Gear",
        "search": [
            "employee",
            "together",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "handshake-simple-slash",
        "label": "Handshake Simple Slash",
        "search": [
            "broken",
            "covid-19",
            "disabled",
            "social distance"
        ]
    },
    {
        "icon": "user-hair-buns",
        "label": "User Hair Buns",
        "search": [
            "hairstyle",
            "leia",
            "organa",
            "princess",
            "rebel",
            "skywalker",
            "star wars",
            "uer"
        ]
    },
    {
        "icon": "border-all",
        "label": "Border All",
        "search": [
            "cell",
            "grid",
            "outline",
            "stroke",
            "table"
        ]
    },
    {
        "icon": "coin",
        "label": "Coin",
        "search": [
            "coin",
            "dime",
            "gold",
            "metal",
            "money",
            "nickel",
            "penny",
            "premium",
            "quarter",
            "silver",
            "treasure"
        ]
    },
    {
        "icon": "lock-keyhole-open",
        "label": "Lock Keyhole Open",
        "search": [
            "admin",
            "lock",
            "open",
            "padlock",
            "password",
            "privacy",
            "private",
            "protect",
            "security",
            "unlock"
        ]
    },
    {
        "icon": "coins",
        "label": "Coins",
        "search": [
            "currency",
            "dime",
            "financial",
            "gold",
            "money",
            "penny",
            "premium"
        ]
    },
    {
        "icon": "clock-four-thirty",
        "label": "Clock Four Thirty",
        "search": [
            "4",
            "4:30",
            "clock",
            "four",
            "four-thirty",
            "hour",
            "minute",
            "o'clock",
            "pending",
            "thirty",
            "ticking",
            "time"
        ]
    },
    {
        "icon": "00",
        "label": "00",
        "search": [
            "double zero",
            "hundred",
            "zero"
        ]
    },
    {
        "icon": "amp-guitar",
        "label": "Amp Guitar",
        "search": [
            "audio",
            "guitar",
            "loudspeaker",
            "music",
            "pa",
            "volume"
        ]
    },
    {
        "icon": "mars-stroke",
        "label": "Mars Stroke",
        "search": [
            "Male with Stroke Sign",
            "gender",
            "transgender"
        ]
    },
    {
        "icon": "fort-awesome",
        "label": "Fort Awesome",
        "search": [
            "castle"
        ]
    },
    {
        "icon": "circle-dashed",
        "label": "Circle Dashed",
        "search": [
            "add",
            "copy",
            "dashed",
            "dotted",
            "marquee",
            "select",
            "selection"
        ]
    },
    {
        "icon": "mixer",
        "label": "Mixer",
        "search": []
    },
    {
        "icon": "lyft",
        "label": "lyft",
        "search": []
    },
    {
        "icon": "handshake-angle",
        "label": "Handshake Angle",
        "search": [
            "aid",
            "assistance",
            "handshake",
            "partnership",
            "volunteering"
        ]
    },
    {
        "icon": "gauge-simple-low",
        "label": "Gauge Simple Low",
        "search": [
            "dashboard",
            "fast",
            "odometer",
            "speed",
            "speedometer"
        ]
    },
    {
        "icon": "arrow-down",
        "label": "Arrow Down",
        "search": [
            "Downwards Arrow",
            "download"
        ]
    },
    {
        "icon": "apple-pay",
        "label": "Apple Pay",
        "search": []
    },
    {
        "icon": "location-dot",
        "label": "Location Dot",
        "search": [
            "address",
            "coordinates",
            "destination",
            "gps",
            "localize",
            "location",
            "map",
            "navigation",
            "paper",
            "pin",
            "place",
            "point of interest",
            "position",
            "route",
            "travel"
        ]
    },
    {
        "icon": "artstation",
        "label": "Artstation",
        "search": []
    },
    {
        "icon": "deer-rudolph",
        "label": "Deer Rudolph",
        "search": [
            "animal",
            "antlers",
            "fauna",
            "mammal",
            "reindeer"
        ]
    },
    {
        "icon": "node-js",
        "label": "Node.js JS",
        "search": []
    },
    {
        "icon": "ufo",
        "label": "Ufo",
        "search": [
            "UFO",
            "abduct",
            "alien",
            "extraterrestrial",
            "flying saucer",
            "space",
            "spacecraft",
            "spaceship",
            "t-craft",
            "travel",
            "unidentified flying object"
        ]
    },
    {
        "icon": "plug-circle-exclamation",
        "label": "Plug Circle Exclamation",
        "search": [
            "affected",
            "electric",
            "electricity",
            "failed",
            "plug",
            "power"
        ]
    },
    {
        "icon": "cookie-bite",
        "label": "Cookie Bite",
        "search": [
            "baked good",
            "bitten",
            "chips",
            "chocolate",
            "eat",
            "snack",
            "sweet",
            "treat"
        ]
    },
    {
        "icon": "square-chevron-right",
        "label": "Square Chevron Right",
        "search": [
            "arrow",
            "forward",
            "next"
        ]
    },
    {
        "icon": "hand-point-ribbon",
        "label": "Hand Point Ribbon",
        "search": [
            "remember",
            "remind"
        ]
    },
    {
        "icon": "grid-2-plus",
        "label": "Grid 2 Plus",
        "search": [
            "add",
            "app",
            "collection",
            "filter",
            "grid",
            "sort"
        ]
    },
    {
        "icon": "screwdriver-wrench",
        "label": "Screwdriver Wrench",
        "search": [
            "admin",
            "configuration",
            "equipment",
            "fix",
            "maintenance",
            "modify",
            "repair",
            "screwdriver",
            "settings",
            "tools",
            "wrench"
        ]
    },
    {
        "icon": "keynote",
        "label": "Keynote",
        "search": [
            "lecture",
            "panel",
            "seminar",
            "speak",
            "speaker",
            "talk"
        ]
    },
    {
        "icon": "tickets-airline",
        "label": "Tickets Airline",
        "search": [
            "airplane",
            "arrival",
            "boarding pass",
            "departure",
            "ticket",
            "travel"
        ]
    },
    {
        "icon": "uncharted",
        "label": "Uncharted Software",
        "search": []
    },
    {
        "icon": "calendar-lines",
        "label": "Calendar Lines",
        "search": [
            "date",
            "day",
            "month",
            "reminder",
            "year"
        ]
    },
    {
        "icon": "indent",
        "label": "Indent",
        "search": [
            "align",
            "justify",
            "paragraph",
            "tab"
        ]
    },
    {
        "icon": "golf-club",
        "label": "Golf Club",
        "search": [
            "caddy",
            "eagle",
            "putt",
            "tee"
        ]
    },
    {
        "icon": "bars",
        "label": "Bars",
        "search": [
            "checklist",
            "drag",
            "hamburger",
            "list",
            "menu",
            "nav",
            "navigation",
            "ol",
            "reorder",
            "settings",
            "todo",
            "ul"
        ]
    },
    {
        "icon": "hands-praying",
        "label": "Hands Praying",
        "search": [
            "kneel",
            "preach",
            "religion",
            "worship"
        ]
    },
    {
        "icon": "temperature-snow",
        "label": "Temperature Snow",
        "search": [
            "cold",
            "mercury",
            "thermometer",
            "winter"
        ]
    },
    {
        "icon": "viruses",
        "label": "Viruses",
        "search": [
            "bugs",
            "coronavirus",
            "covid-19",
            "flu",
            "health",
            "infection",
            "multiply",
            "pandemic",
            "sick",
            "spread",
            "vaccine",
            "viral"
        ]
    },
    {
        "icon": "playstation",
        "label": "PlayStation",
        "search": []
    },
    {
        "icon": "dryer",
        "label": "Dryer",
        "search": [
            "clean",
            "clothes",
            "laundromat",
            "laundry",
            "washing machine"
        ]
    },
    {
        "icon": "school-flag",
        "label": "School Flag",
        "search": [
            "educate",
            "flag",
            "school",
            "schoolhouse"
        ]
    },
    {
        "icon": "circle-gf",
        "label": "Circle Gf",
        "search": [
            "celiac",
            "gluten",
            "gluten free",
            "restaurant"
        ]
    },
    {
        "icon": "trademark",
        "label": "Trademark",
        "search": [
            "copyright",
            "mark",
            "register",
            "symbol",
            "tm",
            "trade mark",
            "trademark"
        ]
    },
    {
        "icon": "stretcher",
        "label": "Stretcher",
        "search": [
            "ambulance",
            "bed",
            "emergency",
            "er",
            "patient"
        ]
    },
    {
        "icon": "fire-burner",
        "label": "Fire Burner",
        "search": [
            "cook",
            "fire",
            "flame",
            "kitchen",
            "stove"
        ]
    },
    {
        "icon": "integral",
        "label": "Integral",
        "search": [
            "calculus",
            "equation",
            "function",
            "math"
        ]
    },
    {
        "icon": "grip-dots-vertical",
        "label": "Grip Dots Vertical",
        "search": [
            "circles",
            "drag",
            "drop",
            "ellipsis",
            "grab",
            "grid",
            "handle",
            "move"
        ]
    },
    {
        "icon": "face-lying",
        "label": "Face Lying",
        "search": [
            "dishonesty",
            "face",
            "fake",
            "liar",
            "lie",
            "long nose",
            "lying face",
            "pinocchio"
        ]
    },
    {
        "icon": "folder-user",
        "label": "Folder User",
        "search": [
            "contacts",
            "cv",
            "employee",
            "file",
            "resume",
            "uer"
        ]
    },
    {
        "icon": "ski-boot-ski",
        "label": "Ski Boot Ski",
        "search": [
            "boot",
            "ski",
            "skis",
            "snow",
            "winter"
        ]
    },
    {
        "icon": "microblog",
        "label": "Micro.blog",
        "search": []
    },
    {
        "icon": "gitkraken",
        "label": "GitKraken",
        "search": []
    },
    {
        "icon": "face-smile-beam",
        "label": "Face Smile Beam",
        "search": [
            "blush",
            "emoticon",
            "eye",
            "face",
            "happy",
            "positive",
            "smile",
            "smiling face with smiling eyes"
        ]
    },
    {
        "icon": "telegram",
        "label": "Telegram",
        "search": []
    },
    {
        "icon": "battery-exclamation",
        "label": "Battery Exclamation",
        "search": [
            "charge",
            "empty",
            "failed",
            "power"
        ]
    },
    {
        "icon": "wreath-laurel",
        "label": "Wreath Laurel",
        "search": [
            "award",
            "branch",
            "chaplet",
            "evergreen",
            "garland",
            "greece",
            "greek",
            "hat",
            "leaf",
            "mythology",
            "ribbon",
            "rome",
            "triumph",
            "victory"
        ]
    },
    {
        "icon": "stars",
        "label": "Stars",
        "search": [
            "favorite",
            "galaxy",
            "magic",
            "night",
            "quality",
            "space"
        ]
    },
    {
        "icon": "tent-arrow-left-right",
        "label": "Tent Arrow Left Right",
        "search": [
            "bivouac",
            "campground",
            "campsite",
            "refugee",
            "refugee",
            "shelter",
            "shelter",
            "tent",
            "transition"
        ]
    },
    {
        "icon": "route",
        "label": "Route",
        "search": [
            "directions",
            "navigation",
            "travel"
        ]
    },
    {
        "icon": "angles-up",
        "label": "Angles Up",
        "search": [
            "arrows",
            "caret",
            "collapse",
            "upload"
        ]
    },
    {
        "icon": "bucket",
        "label": "Bucket",
        "search": [
            "bucket",
            "pail",
            "sandcastle"
        ]
    },
    {
        "icon": "less-than-equal",
        "label": "Less Than Equal",
        "search": [
            "arithmetic",
            "compare",
            "math"
        ]
    },
    {
        "icon": "flag-pennant",
        "label": "Flag Pennant",
        "search": [
            "banner",
            "flag",
            "post",
            "sign",
            "sports",
            "triangular flag",
            "win"
        ]
    },
    {
        "icon": "folder-closed",
        "label": "Folder Closed",
        "search": [
            "file"
        ]
    },
    {
        "icon": "chess-king-piece",
        "label": "Chess King Piece",
        "search": [
            "board",
            "checkmate",
            "game",
            "strategy"
        ]
    },
    {
        "icon": "bin-recycle",
        "label": "Bin Recycle",
        "search": [
            "collect",
            "jug",
            "plastics",
            "recycle"
        ]
    },
    {
        "icon": "send-backward",
        "label": "Send Backward",
        "search": [
            "arrange",
            "back",
            "layer",
            "order",
            "stack"
        ]
    },
    {
        "icon": "itunes-note",
        "label": "Itunes Note",
        "search": []
    },
    {
        "icon": "less",
        "label": "Less",
        "search": []
    },
    {
        "icon": "truck-ramp-couch",
        "label": "Truck Ramp Couch",
        "search": [
            "cargo",
            "delivery",
            "moving",
            "rental",
            "shipping",
            "vehicle"
        ]
    },
    {
        "icon": "person-through-window",
        "label": "Person Through Window",
        "search": [
            "door",
            "exit",
            "forced entry",
            "leave",
            "robbery",
            "steal",
            "uer",
            "window"
        ]
    },
    {
        "icon": "avocado",
        "label": "Avocado",
        "search": [
            "avocado",
            "food",
            "fruit",
            "green",
            "guacamole",
            "hass",
            "pit"
        ]
    },
    {
        "icon": "seal-exclamation",
        "label": "Seal Exclamation",
        "search": [
            "attention",
            "badge",
            "certificate",
            "confirm",
            "failed",
            "guarantee",
            "required"
        ]
    },
    {
        "icon": "wind-turbine",
        "label": "Wind Turbine",
        "search": [
            "electricity",
            "energy",
            "generator",
            "renewable",
            "wind power",
            "windmill"
        ]
    },
    {
        "icon": "firefox",
        "label": "Firefox",
        "search": [
            "browser"
        ]
    },
    {
        "icon": "school-lock",
        "label": "School Lock",
        "search": [
            "closed",
            "lockdown",
            "padlock",
            "privacy",
            "quarantine",
            "schoolhouse"
        ]
    },
    {
        "icon": "chart-scatter-3d",
        "label": "Chart Scatter 3d",
        "search": [
            "chart",
            "graph",
            "performance",
            "statistics",
            "track",
            "trend"
        ]
    },
    {
        "icon": "album-collection-circle-plus",
        "label": "Album Collection Circle Plus",
        "search": [
            "catalog",
            "collection",
            "library",
            "music",
            "record",
            "song",
            "vinyl"
        ]
    },
    {
        "icon": "person-burst",
        "label": "Person Burst",
        "search": [
            "abuse",
            "accident",
            "crash",
            "explode",
            "uer",
            "violence"
        ]
    },
    {
        "icon": "balloon",
        "label": "Balloon",
        "search": [
            "balloon",
            "birthday",
            "celebrate",
            "celebration",
            "helium",
            "party",
            "pop",
            "up"
        ]
    },
    {
        "icon": "left-long",
        "label": "Left Long",
        "search": [
            "back",
            "long-arrow-left",
            "previous"
        ]
    },
    {
        "icon": "kaggle",
        "label": "Kaggle",
        "search": []
    },
    {
        "icon": "location-crosshairs",
        "label": "Location Crosshairs",
        "search": [
            "address",
            "coordinate",
            "direction",
            "gps",
            "location",
            "map",
            "navigation",
            "place",
            "where"
        ]
    },
    {
        "icon": "person-dots-from-line",
        "label": "Person Dots From Line",
        "search": [
            "allergy",
            "diagnosis",
            "uer"
        ]
    },
    {
        "icon": "gauge-simple-high",
        "label": "Gauge Simple High",
        "search": [
            "dashboard",
            "fast",
            "odometer",
            "quick",
            "speed",
            "speedometer"
        ]
    },
    {
        "icon": "angles-left",
        "label": "Angles Left",
        "search": [
            "Left-Pointing Double Angle Quotation Mark",
            "arrows",
            "back",
            "caret",
            "laquo",
            "previous",
            "quote"
        ]
    },
    {
        "icon": "up-down",
        "label": "Up Down",
        "search": [
            "Up Down Black Arrow",
            "arrow",
            "arrows-v",
            "expand",
            "portrait",
            "resize",
            "tall",
            "up-down arrow",
            "vertical"
        ]
    },
    {
        "icon": "facebook-messenger",
        "label": "Facebook Messenger",
        "search": [
            "fabook",
            "fb"
        ]
    },
    {
        "icon": "audible",
        "label": "Audible",
        "search": []
    },
    {
        "icon": "battery-empty",
        "label": "Battery Empty",
        "search": [
            "charge",
            "dead",
            "power",
            "status"
        ]
    },
    {
        "icon": "chart-sine",
        "label": "Chart Sine",
        "search": [
            "chart",
            "graph",
            "sine",
            "wave"
        ]
    },
    {
        "icon": "arrows-retweet",
        "label": "Arrows Retweet",
        "search": [
            "refresh",
            "reload",
            "renew",
            "retry",
            "share",
            "swap"
        ]
    },
    {
        "icon": "keyboard",
        "label": "Keyboard",
        "search": [
            "accessory",
            "computer",
            "edit",
            "input",
            "keyboard",
            "text",
            "type",
            "write"
        ]
    },
    {
        "icon": "code-pull-request-closed",
        "label": "Code Pull Request Closed",
        "search": [
            "git",
            "github",
            "pr",
            "svn",
            "version"
        ]
    },
    {
        "icon": "patreon",
        "label": "Patreon",
        "search": []
    },
    {
        "icon": "right",
        "label": "Right",
        "search": [
            "Rightwards Black Arrow",
            "forward",
            "next"
        ]
    },
    {
        "icon": "pen-clip-slash",
        "label": "Pen Clip Slash",
        "search": [
            "disabled",
            "modify",
            "remove",
            "style"
        ]
    },
    {
        "icon": "sensor-on",
        "label": "Sensor On",
        "search": [
            "alarm",
            "alert",
            "carbon monoxide",
            "detector",
            "fire",
            "smoke"
        ]
    },
    {
        "icon": "chevrons-up",
        "label": "Chevrons Up",
        "search": [
            "arrow",
            "collapse",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "cookie",
        "label": "Cookie",
        "search": [
            "baked good",
            "chips",
            "chocolate",
            "cookie",
            "dessert",
            "eat",
            "snack",
            "sweet",
            "treat"
        ]
    },
    {
        "icon": "stopwatch",
        "label": "Stopwatch",
        "search": [
            "clock",
            "reminder",
            "stopwatch",
            "time",
            "waiting"
        ]
    },
    {
        "icon": "eject",
        "label": "Eject",
        "search": [
            "abort",
            "cancel",
            "cd",
            "discharge",
            "eject",
            "eject button"
        ]
    },
    {
        "icon": "vnv",
        "label": "VNV",
        "search": []
    },
    {
        "icon": "card-spade",
        "label": "Card Spade",
        "search": [
            "ace",
            "card",
            "gamble",
            "playing card",
            "poker",
            "suit"
        ]
    },
    {
        "icon": "satellite-dish",
        "label": "Satellite Dish",
        "search": [
            "SETI",
            "antenna",
            "communications",
            "dish",
            "hardware",
            "radar",
            "receiver",
            "satellite",
            "satellite antenna",
            "saucer",
            "signal",
            "space"
        ]
    },
    {
        "icon": "table-cells-unlock",
        "label": "Table Cells Unlock",
        "search": [
            "blocks",
            "boxes",
            "category",
            "column",
            "excel",
            "grid",
            "lock",
            "spreadsheet",
            "squares",
            "unlock"
        ]
    },
    {
        "icon": "pagelines",
        "label": "Pagelines",
        "search": [
            "eco",
            "flora",
            "leaf",
            "leaves",
            "nature",
            "plant",
            "tree"
        ]
    },
    {
        "icon": "hand-back-point-down",
        "label": "Hand Back Point Down",
        "search": [
            "backhand",
            "backhand index pointing down",
            "direction",
            "down",
            "finger",
            "hand",
            "point"
        ]
    },
    {
        "icon": "clock-six-thirty",
        "label": "Clock Six Thirty",
        "search": [
            "6",
            "6:30",
            "clock",
            "hour",
            "minute",
            "o'clock",
            "pending",
            "six",
            "six-thirty",
            "thirty",
            "ticking",
            "time"
        ]
    },
    {
        "icon": "face-rolling-eyes",
        "label": "Face Rolling Eyes",
        "search": [
            "emoticon",
            "eyeroll",
            "eyes",
            "face",
            "face with rolling eyes",
            "neutral",
            "rating",
            "rolling"
        ]
    },
    {
        "icon": "list-check",
        "label": "List Check",
        "search": [
            "bullet",
            "cheatsheet",
            "checklist",
            "downloading",
            "downloads",
            "enable",
            "loading",
            "progress",
            "project management",
            "settings",
            "summary",
            "to do",
            "validate",
            "working"
        ]
    },
    {
        "icon": "house-blank",
        "label": "House Blank",
        "search": [
            "abode",
            "building",
            "house",
            "main"
        ]
    },
    {
        "icon": "sack-xmark",
        "label": "Sack Xmark",
        "search": [
            "bag",
            "burlap",
            "coupon",
            "rations",
            "salary",
            "uncheck"
        ]
    },
    {
        "icon": "hashtag",
        "label": "Hashtag",
        "search": [
            "Number Sign",
            "Twitter",
            "instagram",
            "pound",
            "social media",
            "tag"
        ]
    },
    {
        "icon": "amazon",
        "label": "Amazon",
        "search": []
    },
    {
        "icon": "envira",
        "label": "Envira Gallery",
        "search": [
            "leaf"
        ]
    },
    {
        "icon": "file-heart",
        "label": "File Heart",
        "search": [
            "favorite",
            "love",
            "wishlist"
        ]
    },
    {
        "icon": "square-q",
        "label": "Square Q",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "castle",
        "label": "Castle",
        "search": [
            "Castle",
            "European",
            "castle",
            "dungeon",
            "fortress",
            "palace",
            "turret"
        ]
    },
    {
        "icon": "traffic-light-slow",
        "label": "Traffic Light Slow",
        "search": [
            "direction",
            "road",
            "signal",
            "slow",
            "travel",
            "yellow"
        ]
    },
    {
        "icon": "message-captions",
        "label": "Message Captions",
        "search": [
            "answer",
            "chat",
            "closed captions",
            "subtitle",
            "subtitling"
        ]
    },
    {
        "icon": "bird",
        "label": "Bird",
        "search": [
            "avian",
            "bird",
            "feather",
            "fowl",
            "tweet",
            "wing"
        ]
    },
    {
        "icon": "train",
        "label": "Train",
        "search": [
            "bullet",
            "commute",
            "locomotive",
            "railway",
            "subway",
            "train"
        ]
    },
    {
        "icon": "message-middle",
        "label": "Message Middle",
        "search": [
            "answer",
            "contact",
            "conversation",
            "sms"
        ]
    },
    {
        "icon": "gamepad",
        "label": "Gamepad",
        "search": [
            "arcade",
            "controller",
            "d-pad",
            "joystick",
            "playstore",
            "video",
            "video game"
        ]
    },
    {
        "icon": "broccoli",
        "label": "Broccoli",
        "search": [
            "bush",
            "cauliflower",
            "tree",
            "wild cabbage"
        ]
    },
    {
        "icon": "coffee-beans",
        "label": "Coffee Beans",
        "search": [
            "berry",
            "brew",
            "coffee",
            "espresso",
            "java"
        ]
    },
    {
        "icon": "square-chevron-up",
        "label": "Square Chevron Up",
        "search": [
            "arrow",
            "collapse",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "linode",
        "label": "Linode",
        "search": []
    },
    {
        "icon": "accusoft",
        "label": "Accusoft",
        "search": []
    },
    {
        "icon": "file-export",
        "label": "File Export",
        "search": [
            "download",
            "save"
        ]
    },
    {
        "icon": "cup-straw-swoosh",
        "label": "Cup Straw Swoosh",
        "search": [
            "caffeine",
            "fast food",
            "orange mocha frappuccino",
            "pop",
            "soda",
            "soft drink",
            "takeout"
        ]
    },
    {
        "icon": "mandolin",
        "label": "Mandolin",
        "search": [
            "Dungeons & Dragons",
            "bard",
            "d&d",
            "dnd",
            "fantasy",
            "guitar",
            "instrument",
            "lute",
            "music",
            "song",
            "strings"
        ]
    },
    {
        "icon": "merge",
        "label": "Merge",
        "search": [
            "code",
            "combine"
        ]
    },
    {
        "icon": "book-arrow-up",
        "label": "Book Arrow Up",
        "search": [
            "library",
            "research",
            "upgrade"
        ]
    },
    {
        "icon": "meter",
        "label": "Meter",
        "search": [
            "electricity",
            "transmission",
            "utilities"
        ]
    },
    {
        "icon": "square-small",
        "label": "Square Small",
        "search": [
            "black small square",
            "block",
            "geometric",
            "square",
            "stop",
            "white small square"
        ]
    },
    {
        "icon": "circle-z",
        "label": "Circle Z",
        "search": [
            "Circled Latin Capital Letter Z",
            "letter"
        ]
    },
    {
        "icon": "mistletoe",
        "label": "Mistletoe",
        "search": [
            "awkward",
            "christmas",
            "decoration",
            "flora",
            "holiday",
            "kiss",
            "plant",
            "tradition",
            "trap",
            "xmas"
        ]
    },
    {
        "icon": "up-from-dotted-line",
        "label": "Up From Dotted Line",
        "search": [
            "import",
            "transfer",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "face-head-bandage",
        "label": "Face Head Bandage",
        "search": [
            "bandage",
            "clumsy",
            "face",
            "face with head-bandage",
            "hurt",
            "ill",
            "injury"
        ]
    },
    {
        "icon": "slash-back",
        "label": "Slash Back",
        "search": [
            "Reverse Solidus",
            "cancel",
            "remove"
        ]
    },
    {
        "icon": "sim-cards",
        "label": "Sim Cards",
        "search": [
            "contacts",
            "memory",
            "storage"
        ]
    },
    {
        "icon": "vector-square",
        "label": "Vector Square",
        "search": [
            "anchors",
            "lines",
            "object",
            "render",
            "shape"
        ]
    },
    {
        "icon": "arrow-left-from-bracket",
        "label": "Arrow Left From Bracket",
        "search": [
            "exit",
            "leave",
            "logout",
            "send"
        ]
    },
    {
        "icon": "usb-drive",
        "label": "Usb Drive",
        "search": [
            "access codes",
            "device",
            "flashdrive",
            "goober",
            "ssd",
            "storage",
            "thumbdrive"
        ]
    },
    {
        "icon": "head-side-brain",
        "label": "Head Side Brain",
        "search": [
            "diagnosis",
            "face",
            "knowledge",
            "mental health",
            "profile",
            "psychiatric",
            "psychiatry",
            "scholar",
            "uer"
        ]
    },
    {
        "icon": "erlang",
        "label": "Erlang",
        "search": []
    },
    {
        "icon": "glass-half",
        "label": "Glass Half",
        "search": [
            "drink",
            "optimism",
            "pessimism",
            "water"
        ]
    },
    {
        "icon": "face-grimace",
        "label": "Face Grimace",
        "search": [
            "cringe",
            "emoticon",
            "face",
            "grimace",
            "grimacing face",
            "teeth"
        ]
    },
    {
        "icon": "train-subway",
        "label": "Train Subway",
        "search": [
            "machine",
            "railway",
            "train",
            "transportation",
            "vehicle"
        ]
    },
    {
        "icon": "face-glasses",
        "label": "Face Glasses",
        "search": [
            "face",
            "geek",
            "glasses",
            "nerd",
            "nerd face",
            "smile",
            "teeth"
        ]
    },
    {
        "icon": "cloud-drizzle",
        "label": "Cloud Drizzle",
        "search": [
            "precipitation",
            "rain",
            "sprinkle"
        ]
    },
    {
        "icon": "circle-dot",
        "label": "Circle Dot",
        "search": [
            "bullseye",
            "button",
            "geometric",
            "notification",
            "radio",
            "radio button",
            "target"
        ]
    },
    {
        "icon": "object-group",
        "label": "Object Group",
        "search": [
            "combine",
            "copy",
            "design",
            "merge",
            "select"
        ]
    },
    {
        "icon": "cc-discover",
        "label": "Discover Credit Card",
        "search": []
    },
    {
        "icon": "safari",
        "label": "Safari",
        "search": [
            "browser"
        ]
    },
    {
        "icon": "user-police",
        "label": "User Police",
        "search": [
            "cop",
            "five-o",
            "law enforcement",
            "officer",
            "patrol",
            "police",
            "police officer",
            "trooper",
            "uer"
        ]
    },
    {
        "icon": "space-awesome",
        "label": "Space Awesome",
        "search": [
            "adventure",
            "rocket",
            "ship",
            "shuttle"
        ]
    },
    {
        "icon": "ship",
        "label": "Ship",
        "search": [
            "boat",
            "passenger",
            "sea",
            "ship",
            "water"
        ]
    },
    {
        "icon": "c",
        "label": "C",
        "search": [
            "Latin Capital Letter C",
            "Latin Small Letter C",
            "letter"
        ]
    },
    {
        "icon": "square-phone",
        "label": "Square Phone",
        "search": [
            "call",
            "earphone",
            "number",
            "support",
            "telephone",
            "voice"
        ]
    },
    {
        "icon": "box-taped",
        "label": "Box Taped",
        "search": [
            "archive",
            "container",
            "package",
            "storage"
        ]
    },
    {
        "icon": "ruler-combined",
        "label": "Ruler Combined",
        "search": [
            "design",
            "draft",
            "length",
            "measure",
            "planning"
        ]
    },
    {
        "icon": "bracket-square-right",
        "label": "Bracket Square Right",
        "search": [
            "Right Square Bracket",
            "code",
            "crotchets"
        ]
    },
    {
        "icon": "leaf-maple",
        "label": "Leaf Maple",
        "search": [
            "eco",
            "fall",
            "falling",
            "flora",
            "leaf",
            "maple",
            "maple leaf",
            "nature",
            "plant",
            "seasonal"
        ]
    },
    {
        "icon": "arrows-rotate",
        "label": "Arrows Rotate",
        "search": [
            "Clockwise Right and Left Semicircle Arrows",
            "clockwise",
            "exchange",
            "modify",
            "refresh",
            "reload",
            "renew",
            "retry",
            "rotate",
            "swap"
        ]
    },
    {
        "icon": "bench-tree",
        "label": "Bench Tree",
        "search": [
            "bench",
            "outside",
            "park",
            "picnic",
            "tree"
        ]
    },
    {
        "icon": "square-root",
        "label": "Square Root",
        "search": [
            "Square Root",
            "arithmetic",
            "calculus",
            "division",
            "math"
        ]
    },
    {
        "icon": "arrow-down-triangle-square",
        "label": "Arrow Down Triangle Square",
        "search": [
            "arrange",
            "filter",
            "order",
            "shapes",
            "square",
            "triangle"
        ]
    },
    {
        "icon": "person-dress",
        "label": "Person Dress",
        "search": [
            "man",
            "skirt",
            "uer",
            "woman"
        ]
    },
    {
        "icon": "quotes",
        "label": "Quotes",
        "search": [
            "cite",
            "quotation",
            "quote"
        ]
    },
    {
        "icon": "book-open",
        "label": "Book Open",
        "search": [
            "Book",
            "book",
            "flyer",
            "knowledge",
            "library",
            "notebook",
            "open",
            "open book",
            "pamphlet",
            "reading",
            "research"
        ]
    },
    {
        "icon": "folder-tree",
        "label": "Folder Tree",
        "search": [
            "archive",
            "directory",
            "document",
            "file",
            "search",
            "structure"
        ]
    },
    {
        "icon": "object-union",
        "label": "Object Union",
        "search": [
            "boolean",
            "combine",
            "group",
            "join",
            "pathfinder"
        ]
    },
    {
        "icon": "file-binary",
        "label": "File Binary",
        "search": [
            "binary",
            "code",
            "computer"
        ]
    },
    {
        "icon": "box-archive",
        "label": "Box Archive",
        "search": [
            "box",
            "package",
            "save",
            "storage"
        ]
    },
    {
        "icon": "chopsticks",
        "label": "Chopsticks",
        "search": [
            "bamboo",
            "chopsticks",
            "utensils"
        ]
    },
    {
        "icon": "waveform-lines",
        "label": "Waveform Lines",
        "search": [
            "amplitude",
            "sound",
            "soundwave"
        ]
    },
    {
        "icon": "down",
        "label": "Down",
        "search": [
            "download",
            "insert"
        ]
    },
    {
        "icon": "message-arrow-up",
        "label": "Message Arrow Up",
        "search": [
            "answer",
            "chat",
            "contact",
            "discussion",
            "send",
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "node",
        "label": "Node.js",
        "search": []
    },
    {
        "icon": "circle-down-left",
        "label": "Circle Down Left",
        "search": [
            "diagonal",
            "southwest"
        ]
    },
    {
        "icon": "objects-align-right",
        "label": "Objects Align Right",
        "search": [
            "align",
            "distribute",
            "line",
            "rectangles"
        ]
    },
    {
        "icon": "hourglass-clock",
        "label": "Hourglass Clock",
        "search": [
            "countdown",
            "hour",
            "hourglass",
            "hourglass not done",
            "minute",
            "pending",
            "sand",
            "stopwatch",
            "time",
            "timer",
            "waiting"
        ]
    },
    {
        "icon": "shutters",
        "label": "Shutters",
        "search": [
            "damper",
            "fire",
            "shades",
            "window"
        ]
    },
    {
        "icon": "tent-arrow-down-to-line",
        "label": "Tent Arrow Down To Line",
        "search": [
            "bivouac",
            "campground",
            "campsite",
            "permanent",
            "refugee",
            "refugee",
            "shelter",
            "shelter",
            "tent"
        ]
    },
    {
        "icon": "qrcode",
        "label": "Qrcode",
        "search": [
            "barcode",
            "info",
            "information",
            "scan"
        ]
    },
    {
        "icon": "codepen",
        "label": "Codepen",
        "search": []
    },
    {
        "icon": "dragon",
        "label": "Dragon",
        "search": [
            "Dungeons & Dragons",
            "d&d",
            "dnd",
            "dragon",
            "fairy tale",
            "fantasy",
            "fire",
            "lizard",
            "serpent"
        ]
    },
    {
        "icon": "hourglass-end",
        "label": "Hourglass End",
        "search": [
            "hour",
            "hourglass done",
            "minute",
            "pending",
            "sand",
            "stopwatch",
            "time",
            "timer",
            "waiting"
        ]
    },
    {
        "icon": "grip",
        "label": "Grip",
        "search": [
            "affordance",
            "drag",
            "drop",
            "grab",
            "handle"
        ]
    },
    {
        "icon": "border-top-left",
        "label": "Border Top Left",
        "search": [
            "cell",
            "outline",
            "stroke",
            "table"
        ]
    },
    {
        "icon": "sign-post",
        "label": "Sign Post",
        "search": [
            "directions",
            "directory",
            "map",
            "signage",
            "wayfinding"
        ]
    },
    {
        "icon": "ravelry",
        "label": "Ravelry",
        "search": []
    },
    {
        "icon": "list-ul",
        "label": "List Ul",
        "search": [
            "bullet",
            "cheatsheet",
            "checklist",
            "completed",
            "done",
            "finished",
            "ol",
            "summary",
            "survey",
            "todo",
            "ul"
        ]
    },
    {
        "icon": "book-section",
        "label": "Book Section",
        "search": [
            "law",
            "legal",
            "library",
            "research",
            "silcrow"
        ]
    },
    {
        "icon": "people-robbery",
        "label": "People Robbery",
        "search": [
            "criminal",
            "hands up",
            "looting",
            "robbery",
            "steal",
            "uer"
        ]
    },
    {
        "icon": "shirt-tank-top",
        "label": "Shirt Tank Top",
        "search": [
            "tank top",
            "undershirt"
        ]
    },
    {
        "icon": "steering-wheel",
        "label": "Steering Wheel",
        "search": [
            "auto",
            "car",
            "direction",
            "driving",
            "navigation"
        ]
    },
    {
        "icon": "alipay",
        "label": "Alipay",
        "search": []
    },
    {
        "icon": "magnifying-glass-waveform",
        "label": "Magnifying Glass Waveform",
        "search": [
            "audio",
            "find",
            "glass",
            "inspection",
            "magnifier",
            "magnify",
            "magnifying",
            "magnifying glass tilted left",
            "preview",
            "search",
            "sound",
            "tool",
            "waveform",
            "zoom"
        ]
    },
    {
        "icon": "alarm-plus",
        "label": "Alarm Plus",
        "search": [
            "alert",
            "date",
            "late",
            "reminder",
            "sleep",
            "snooze",
            "timer",
            "timestamp",
            "watch"
        ]
    },
    {
        "icon": "wine-glass-crack",
        "label": "Wine Glass Crack",
        "search": [
            "break",
            "broken",
            "delicate",
            "glass"
        ]
    },
    {
        "icon": "transporter",
        "label": "Transporter",
        "search": [
            "move",
            "teleport",
            "transfer",
            "translocate",
            "travel"
        ]
    },
    {
        "icon": "mobile-button",
        "label": "Mobile Button",
        "search": [
            "apple",
            "call",
            "cell phone",
            "device",
            "iphone",
            "number",
            "screen",
            "telephone"
        ]
    },
    {
        "icon": "arrow-down-a-z",
        "label": "Arrow Down A Z",
        "search": [
            "alphabetical",
            "arrange",
            "filter",
            "order",
            "sort-alpha-asc"
        ]
    },
    {
        "icon": "glass-citrus",
        "label": "Glass Citrus",
        "search": [
            "cocktail",
            "drink",
            "lemonade",
            "refreshing",
            "water"
        ]
    },
    {
        "icon": "cc-amex",
        "label": "Cc Amex",
        "search": [
            "amex"
        ]
    },
    {
        "icon": "pool-8-ball",
        "label": "Pool 8 Ball",
        "search": [
            "8",
            "ball",
            "billiard",
            "billiards",
            "eight",
            "fortune",
            "game",
            "luck",
            "pool 8 ball"
        ]
    },
    {
        "icon": "arrow-down-square-triangle",
        "label": "Arrow Down Square Triangle",
        "search": [
            "arrange",
            "filter",
            "order",
            "shapes",
            "square",
            "triangle"
        ]
    },
    {
        "icon": "repeat-1",
        "label": "Repeat 1",
        "search": [
            "arrow",
            "clockwise",
            "flip",
            "once",
            "reload",
            "renew",
            "repeat single button",
            "retry",
            "rewind",
            "switch"
        ]
    },
    {
        "icon": "transporter-2",
        "label": "Transporter 2",
        "search": [
            "move",
            "teleport",
            "transfer",
            "translocate",
            "travel"
        ]
    },
    {
        "icon": "star-christmas",
        "label": "Star Christmas",
        "search": [
            "bethlehem",
            "christmas",
            "holiday",
            "north",
            "xmas"
        ]
    },
    {
        "icon": "claw-marks",
        "label": "Claw Marks",
        "search": [
            "attack",
            "damage",
            "halloween",
            "rip",
            "scratch",
            "snikt",
            "tear",
            "torn",
            "wolverine"
        ]
    },
    {
        "icon": "lightbulb-on",
        "label": "Lightbulb On",
        "search": [
            "energy",
            "idea",
            "inspiration",
            "light",
            "shine"
        ]
    },
    {
        "icon": "money-bill",
        "label": "Money Bill",
        "search": [
            "buy",
            "cash",
            "checkout",
            "coupon",
            "investment",
            "money",
            "payment",
            "premium",
            "price",
            "purchase",
            "revenue",
            "salary"
        ]
    },
    {
        "icon": "pied-piper-alt",
        "label": "Alternate Pied Piper Logo (Old)",
        "search": []
    },
    {
        "icon": "messages-dollar",
        "label": "Messages Dollar",
        "search": [
            "answer",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "feedback",
            "message",
            "money",
            "note",
            "notification",
            "pay",
            "salary",
            "sms",
            "speech",
            "spend",
            "texting",
            "transfer"
        ]
    },
    {
        "icon": "croissant",
        "label": "Croissant",
        "search": [
            "bakery",
            "bread",
            "breakfast",
            "brioche",
            "butter",
            "crescent",
            "croissant",
            "dough",
            "food",
            "french",
            "gluten",
            "pastry",
            "roll"
        ]
    },
    {
        "icon": "file-user",
        "label": "File User",
        "search": [
            "account",
            "cv",
            "document",
            "employee",
            "page",
            "personnel",
            "profile",
            "resume",
            "uer"
        ]
    },
    {
        "icon": "arrow-turn-right",
        "label": "Arrow Turn Right",
        "search": [
            "direction",
            "east",
            "forward",
            "next",
            "right",
            "turn"
        ]
    },
    {
        "icon": "border-top",
        "label": "Border Top",
        "search": [
            "cell",
            "grid",
            "outline",
            "stroke",
            "table"
        ]
    },
    {
        "icon": "circle-minus",
        "label": "Circle Minus",
        "search": [
            "delete",
            "hide",
            "negative",
            "remove",
            "shape",
            "trash"
        ]
    },
    {
        "icon": "letterboxd",
        "label": "Letterboxd",
        "search": []
    },
    {
        "icon": "arrow-pointer",
        "label": "Arrow Pointer",
        "search": [
            "arrow",
            "cursor",
            "select"
        ]
    },
    {
        "icon": "square-share-nodes",
        "label": "Square Share Nodes",
        "search": [
            "forward",
            "save",
            "send",
            "social"
        ]
    },
    {
        "icon": "border-outer",
        "label": "Border Outer",
        "search": [
            "cell",
            "grid",
            "outline",
            "stroke",
            "table"
        ]
    },
    {
        "icon": "opera",
        "label": "Opera",
        "search": []
    },
    {
        "icon": "arrow-down-right",
        "label": "Arrow Down Right",
        "search": [
            "diagonal",
            "southeast"
        ]
    },
    {
        "icon": "table-cells-large",
        "label": "Table Cells Large",
        "search": [
            "blocks",
            "boxes",
            "category",
            "excel",
            "grid",
            "spreadsheet",
            "squares"
        ]
    },
    {
        "icon": "cloud-plus",
        "label": "Cloud Plus",
        "search": [
            "add",
            "new",
            "upload"
        ]
    },
    {
        "icon": "cat",
        "label": "Cat",
        "search": [
            "cat",
            "feline",
            "halloween",
            "holiday",
            "kitten",
            "kitty",
            "meow",
            "pet"
        ]
    },
    {
        "icon": "calendar-week",
        "label": "Calendar Week",
        "search": [
            "date",
            "day",
            "detail",
            "event",
            "focus",
            "month",
            "schedule",
            "single week",
            "time",
            "today",
            "when",
            "year"
        ]
    },
    {
        "icon": "scanner-image",
        "label": "Scanner Image",
        "search": [
            "copy",
            "device",
            "digitize",
            "image",
            "img",
            "import"
        ]
    },
    {
        "icon": "t-rex",
        "label": "T Rex",
        "search": [
            "carnivore",
            "dino",
            "dinosaur",
            "jurassic",
            "king",
            "tyrannosaurus"
        ]
    },
    {
        "icon": "weibo",
        "label": "Weibo",
        "search": []
    },
    {
        "icon": "pipe",
        "label": "Pipe",
        "search": [
            "Vertical Line",
            "divider",
            "input",
            "line"
        ]
    },
    {
        "icon": "arrow-up-to-bracket",
        "label": "Arrow Up To Bracket",
        "search": [
            "enter",
            "share",
            "transfer",
            "upload"
        ]
    },
    {
        "icon": "sigma",
        "label": "Sigma",
        "search": [
            "N-Ary Summation",
            "alphabet",
            "greek",
            "math",
            "summation"
        ]
    },
    {
        "icon": "keyboard-down",
        "label": "Keyboard Down",
        "search": [
            "hide",
            "keyboard"
        ]
    },
    {
        "icon": "arrow-down-to-arc",
        "label": "Arrow Down To Arc",
        "search": [
            "download",
            "enter",
            "insert",
            "save",
            "share",
            "transfer"
        ]
    },
    {
        "icon": "code-compare",
        "label": "Code Compare",
        "search": [
            "compare",
            "git",
            "github",
            "svn",
            "version"
        ]
    },
    {
        "icon": "wand",
        "label": "Wand",
        "search": [
            "Dungeons & Dragons",
            "d&d",
            "dnd",
            "fantasy",
            "halloween",
            "holiday",
            "magic",
            "weapon"
        ]
    },
    {
        "icon": "meter-bolt",
        "label": "Meter Bolt",
        "search": [
            "electricity",
            "transmission",
            "utilities"
        ]
    },
    {
        "icon": "arrows-rotate-reverse",
        "label": "Arrows Rotate Reverse",
        "search": [
            "Clockwise Right and Left Semicircle Arrows",
            "anticlockwise",
            "arrow",
            "counterclockwise",
            "exchange",
            "exchange",
            "modify",
            "modify",
            "refresh",
            "refresh",
            "reload",
            "reload",
            "renew",
            "renew",
            "retry",
            "retry",
            "rotate",
            "rotate",
            "swap",
            "swap",
            "withershins"
        ]
    },
    {
        "icon": "scanner-keyboard",
        "label": "Scanner Keyboard",
        "search": [
            "barcode",
            "checkout",
            "gun",
            "inventory",
            "price",
            "upc",
            "warehouse"
        ]
    },
    {
        "icon": "chess-bishop-piece",
        "label": "Chess Bishop Piece",
        "search": [
            "board",
            "checkmate",
            "game",
            "strategy"
        ]
    },
    {
        "icon": "file-plus-minus",
        "label": "File Plus Minus",
        "search": [
            "add",
            "difference",
            "math",
            "subtract"
        ]
    },
    {
        "icon": "union",
        "label": "Union",
        "search": [
            "N-Ary Union",
            "calculus",
            "equation",
            "function",
            "math"
        ]
    },
    {
        "icon": "arrow-up-big-small",
        "label": "Arrow Up Big Small",
        "search": [
            "arrange",
            "filter",
            "order",
            "rectangle",
            "upgrade"
        ]
    },
    {
        "icon": "road-circle-xmark",
        "label": "Road Circle Xmark",
        "search": [
            "destroy",
            "freeway",
            "highway",
            "pavement",
            "road",
            "uncheck"
        ]
    },
    {
        "icon": "cowbell-circle-plus",
        "label": "Cowbell Circle Plus",
        "search": [
            "Blue Öyster Cult",
            "Christopher Walken",
            "SNL",
            "The Bruce Dickinson",
            "Will Ferrell",
            "follow",
            "music"
        ]
    },
    {
        "icon": "thought-bubble",
        "label": "Thought Bubble",
        "search": [
            "Right Thought Bubble",
            "balloon",
            "bubble",
            "comic",
            "dream",
            "idea",
            "imagination",
            "think",
            "thought",
            "thought balloon"
        ]
    },
    {
        "icon": "pallet",
        "label": "Pallet",
        "search": [
            "archive",
            "box",
            "inventory",
            "shipping",
            "warehouse"
        ]
    },
    {
        "icon": "circle-book-open",
        "label": "Circle Book Open",
        "search": [
            "library",
            "research"
        ]
    },
    {
        "icon": "podium-star",
        "label": "Podium Star",
        "search": [
            "debate",
            "election",
            "keynote",
            "lecture",
            "panel",
            "politics",
            "seminar",
            "speak",
            "speaker",
            "speech",
            "talk"
        ]
    },
    {
        "icon": "cake-candles",
        "label": "Cake Candles",
        "search": [
            "anniversary",
            "bakery",
            "birthday",
            "birthday cake",
            "cake",
            "candles",
            "celebration",
            "dessert",
            "frosting",
            "holiday",
            "party",
            "pastry",
            "sweet"
        ]
    },
    {
        "icon": "face-exhaling",
        "label": "Face Exhaling",
        "search": [
            "breath",
            "exhale",
            "exhaustion",
            "relief",
            "sigh"
        ]
    },
    {
        "icon": "bug-slash",
        "label": "Bug Slash",
        "search": [
            "beetle",
            "disabled",
            "fix",
            "glitch",
            "insect",
            "optimize",
            "repair",
            "report",
            "warning"
        ]
    },
    {
        "icon": "trash-can-plus",
        "label": "Trash Can Plus",
        "search": [
            "delete",
            "garbage",
            "hide",
            "remove"
        ]
    },
    {
        "icon": "tarp",
        "label": "Tarp",
        "search": [
            "protection",
            "tarp",
            "tent",
            "waterproof"
        ]
    },
    {
        "icon": "border-center-h",
        "label": "Border Center H",
        "search": [
            "cell",
            "grid",
            "outline",
            "stroke",
            "table"
        ]
    },
    {
        "icon": "tally",
        "label": "Tally",
        "search": [
            "count",
            "hash",
            "numbers"
        ]
    },
    {
        "icon": "diagram-predecessor",
        "label": "Diagram Predecessor",
        "search": [
            "cells",
            "chart",
            "gantt",
            "predecessor",
            "previous",
            "row",
            "subtask",
            "table"
        ]
    },
    {
        "icon": "face-flushed",
        "label": "Face Flushed",
        "search": [
            "dazed",
            "embarrassed",
            "emoticon",
            "face",
            "flushed",
            "flushed face"
        ]
    },
    {
        "icon": "readme",
        "label": "ReadMe",
        "search": []
    },
    {
        "icon": "diagram-next",
        "label": "Diagram Next",
        "search": [
            "cells",
            "chart",
            "gantt",
            "row",
            "subtask",
            "successor",
            "table"
        ]
    },
    {
        "icon": "circle-sort-down",
        "label": "Circle Sort Down",
        "search": [
            "down",
            "elevator",
            "lower",
            "raise",
            "temperature",
            "thermostat",
            "up"
        ]
    },
    {
        "icon": "anchor-circle-xmark",
        "label": "Anchor Circle Xmark",
        "search": [
            "destroy",
            "marina",
            "port",
            "uncheck"
        ]
    },
    {
        "icon": "circle-p",
        "label": "Circle P",
        "search": [
            "Circled Latin Capital Letter P",
            "letter"
        ]
    },
    {
        "icon": "person-circle-xmark",
        "label": "Person Circle Xmark",
        "search": [
            "dead",
            "removed",
            "uer",
            "uncheck"
        ]
    },
    {
        "icon": "burrito",
        "label": "Burrito",
        "search": [
            "beans",
            "breakfast",
            "burrito",
            "chimichanga",
            "mexican",
            "salsa",
            "taco",
            "tortilla",
            "wrap"
        ]
    },
    {
        "icon": "signal-bars-good",
        "label": "Signal Bars Good",
        "search": [
            "bars",
            "graph",
            "online",
            "reception",
            "status"
        ]
    },
    {
        "icon": "spa",
        "label": "Spa",
        "search": [
            "flora",
            "massage",
            "mindfulness",
            "plant",
            "wellness"
        ]
    },
    {
        "icon": "golang",
        "label": "Go",
        "search": []
    },
    {
        "icon": "chess-clock-flip",
        "label": "Chess Clock Flip",
        "search": [
            "board",
            "checkmate",
            "game",
            "strategy",
            "timer",
            "tournament"
        ]
    },
    {
        "icon": "bars-progress",
        "label": "Bars Progress",
        "search": [
            "checklist",
            "downloading",
            "downloads",
            "loading",
            "poll",
            "progress",
            "project management",
            "settings",
            "to do"
        ]
    },
    {
        "icon": "overline",
        "label": "Overline",
        "search": [
            "horizontal",
            "line",
            "overbar",
            "overscore",
            "vinculum"
        ]
    },
    {
        "icon": "circle-microphone",
        "label": "Circle Microphone",
        "search": [
            "listen",
            "podcast",
            "record",
            "talking"
        ]
    },
    {
        "icon": "heart-circle-check",
        "label": "Heart Circle Check",
        "search": [
            "enable",
            "favorite",
            "heart",
            "love",
            "not affected",
            "ok",
            "okay",
            "validate",
            "working"
        ]
    },
    {
        "icon": "mars-stroke-right",
        "label": "Mars Stroke Right",
        "search": [
            "Horizontal Male with Stroke Sign",
            "gender"
        ]
    },
    {
        "icon": "face-expressionless",
        "label": "Face Expressionless",
        "search": [
            "expressionless",
            "expressionless face",
            "face",
            "inexpressive",
            "meh",
            "unexpressive"
        ]
    },
    {
        "icon": "transporter-empty",
        "label": "Transporter Empty",
        "search": [
            "complete",
            "move",
            "teleport",
            "transfer",
            "translocate",
            "travel"
        ]
    },
    {
        "icon": "watch-fitness",
        "label": "Watch Fitness",
        "search": [
            "Fitbit",
            "alert",
            "apple watch",
            "clock",
            "pedometer",
            "time",
            "wristwatch"
        ]
    },
    {
        "icon": "moon-cloud",
        "label": "Moon Cloud",
        "search": [
            "crescent",
            "dark",
            "lunar",
            "night",
            "overcast"
        ]
    },
    {
        "icon": "sunrise",
        "label": "Sunrise",
        "search": [
            "dawn",
            "day",
            "daybreak",
            "daylight",
            "daytime",
            "morning",
            "sun",
            "sun up",
            "sunrise"
        ]
    },
    {
        "icon": "building-memo",
        "label": "Building Memo",
        "search": [
            "apartment",
            "building",
            "business",
            "city",
            "company",
            "licence",
            "license",
            "list",
            "office",
            "office building",
            "permit",
            "realtor",
            "realty",
            "urban",
            "work",
            "zoning"
        ]
    },
    {
        "icon": "cart-flatbed-empty",
        "label": "Cart Flatbed Empty",
        "search": [
            "carry",
            "inventory",
            "shipping",
            "transport"
        ]
    },
    {
        "icon": "face-disappointed",
        "label": "Face Disappointed",
        "search": [
            "disappointed",
            "disappointed face",
            "face",
            "sad",
            "sadface"
        ]
    },
    {
        "icon": "bowl-chopsticks",
        "label": "Bowl Chopsticks",
        "search": [
            "chopsticks",
            "noodles",
            "ramen",
            "steaming"
        ]
    },
    {
        "icon": "tower-observation",
        "label": "Tower Observation",
        "search": [
            "fire tower",
            "view"
        ]
    },
    {
        "icon": "stack-exchange",
        "label": "Stack Exchange",
        "search": []
    },
    {
        "icon": "binary-lock",
        "label": "Binary Lock",
        "search": [
            "binary",
            "data",
            "encrypt",
            "lock",
            "padlock",
            "privacy",
            "programming"
        ]
    },
    {
        "icon": "sterling-sign",
        "label": "Sterling Sign",
        "search": [
            "Pound Sign",
            "currency"
        ]
    },
    {
        "icon": "alicorn",
        "label": "Alicorn",
        "search": [
            "animal",
            "fantasy",
            "fauna",
            "horse",
            "mammal",
            "pegasus",
            "unicorn",
            "wing"
        ]
    },
    {
        "icon": "arrow-right-long-to-line",
        "label": "Arrow Right Long To Line",
        "search": [
            "forward",
            "insert",
            "right",
            "skip",
            "tab"
        ]
    },
    {
        "icon": "computer-speaker",
        "label": "Computer Speaker",
        "search": [
            "airplay",
            "bluetooth",
            "devices",
            "music",
            "output",
            "pair",
            "sound",
            "sync"
        ]
    },
    {
        "icon": "faucet-drip",
        "label": "Faucet Drip",
        "search": [
            "drinking",
            "drip",
            "house",
            "hygiene",
            "kitchen",
            "potable",
            "potable water",
            "sanitation",
            "sink",
            "water"
        ]
    },
    {
        "icon": "face-raised-eyebrow",
        "label": "Face Raised Eyebrow",
        "search": [
            "colbert",
            "disapproval",
            "disbelief",
            "distrust",
            "face with raised eyebrow",
            "mild surprise",
            "scepticism",
            "skeptic",
            "surprise",
            "the rock"
        ]
    },
    {
        "icon": "gulp",
        "label": "Gulp",
        "search": []
    },
    {
        "icon": "face-smiling-hands",
        "label": "Face Smiling Hands",
        "search": [
            "care",
            "face",
            "hug",
            "hugging",
            "hugging face",
            "jazz hands",
            "love",
            "support",
            "wave"
        ]
    },
    {
        "icon": "file-lock",
        "label": "File Lock",
        "search": [
            "contract",
            "encrypt",
            "lock",
            "padlock",
            "privacy",
            "private",
            "protect"
        ]
    },
    {
        "icon": "circle-info",
        "label": "Circle Info",
        "search": [
            "details",
            "help",
            "information",
            "more",
            "support"
        ]
    },
    {
        "icon": "bell-exclamation",
        "label": "Bell Exclamation",
        "search": [
            "alarm",
            "alert",
            "attention",
            "chime",
            "failed",
            "notification",
            "reminder",
            "request"
        ]
    },
    {
        "icon": "feather",
        "label": "Feather",
        "search": [
            "bird",
            "feather",
            "flight",
            "light",
            "plucked",
            "plumage",
            "quill",
            "write"
        ]
    },
    {
        "icon": "bowl-rice",
        "label": "Bowl Rice",
        "search": [
            "boiled",
            "cooked",
            "cooked rice",
            "rice",
            "steamed"
        ]
    },
    {
        "icon": "dial-med-low",
        "label": "Dial Med Low",
        "search": [
            "dial",
            "level"
        ]
    },
    {
        "icon": "star-half-stroke",
        "label": "Star Half Stroke",
        "search": [
            "achievement",
            "award",
            "rating",
            "score",
            "star-half-empty",
            "star-half-full"
        ]
    },
    {
        "icon": "planet-moon",
        "label": "Planet Moon",
        "search": [
            "earth",
            "natural satellite",
            "orbit",
            "solar system",
            "space",
            "universe"
        ]
    },
    {
        "icon": "temperature-arrow-down",
        "label": "Temperature Arrow Down",
        "search": [
            "air conditioner",
            "cold",
            "heater",
            "mercury",
            "thermometer",
            "winter"
        ]
    },
    {
        "icon": "mask-ventilator",
        "label": "Mask Ventilator",
        "search": [
            "breath",
            "gas",
            "mask",
            "oxygen",
            "respirator",
            "ventilator"
        ]
    },
    {
        "icon": "cannon",
        "label": "Cannon",
        "search": [
            "artillery",
            "cannonball",
            "gun powder",
            "munition",
            "ordnance",
            "projectile",
            "weapon"
        ]
    },
    {
        "icon": "chart-scatter",
        "label": "Chart Scatter",
        "search": [
            "analytics",
            "chart",
            "diagram",
            "graph",
            "performance",
            "plot",
            "statistics"
        ]
    },
    {
        "icon": "file-video",
        "label": "File Video",
        "search": [
            "document",
            "m4v",
            "movie",
            "mp4",
            "play"
        ]
    },
    {
        "icon": "square-o",
        "label": "Square O",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "arrow-trend-down",
        "label": "Arrow Trend Down",
        "search": [
            "line",
            "stocks",
            "trend"
        ]
    },
    {
        "icon": "citrus-slice",
        "label": "Citrus Slice",
        "search": [
            "grapefruit",
            "juice",
            "lemon",
            "lime",
            "mandarin",
            "orange",
            "tangerine",
            "wedge"
        ]
    },
    {
        "icon": "display-chart-up-circle-currency",
        "label": "Display Chart Up Circle Currency",
        "search": [
            "analytics",
            "chart",
            "computer",
            "currency",
            "display",
            "exchange",
            "graph",
            "investment",
            "measure",
            "money",
            "monitor",
            "roi",
            "tracking",
            "trading",
            "trend"
        ]
    },
    {
        "icon": "comment-middle-top",
        "label": "Comment Middle Top",
        "search": [
            "answer",
            "chat",
            "conversation"
        ]
    },
    {
        "icon": "down-to-dotted-line",
        "label": "Down To Dotted Line",
        "search": [
            "download",
            "export",
            "insert",
            "transfer"
        ]
    },
    {
        "icon": "phone-arrow-down-left",
        "label": "Phone Arrow Down Left",
        "search": [
            "answer",
            "incoming"
        ]
    },
    {
        "icon": "buoy-mooring",
        "label": "Buoy Mooring",
        "search": [
            "anchor",
            "float",
            "hazard",
            "mooring",
            "nautical",
            "navigation",
            "warning",
            "water"
        ]
    },
    {
        "icon": "oil-can",
        "label": "Oil Can",
        "search": [
            "auto",
            "crude",
            "gasoline",
            "grease",
            "lubricate",
            "petroleum"
        ]
    },
    {
        "icon": "memo-circle-info",
        "label": "Memo Circle Info",
        "search": [
            "cv",
            "details",
            "file",
            "idea",
            "information",
            "note",
            "notepad",
            "page",
            "paper"
        ]
    },
    {
        "icon": "yelp",
        "label": "Yelp",
        "search": []
    },
    {
        "icon": "gofore",
        "label": "Gofore",
        "search": []
    },
    {
        "icon": "cart-circle-arrow-up",
        "label": "Cart Circle Arrow Up",
        "search": [
            "cart",
            "grocery",
            "market",
            "shopping",
            "upgrade"
        ]
    },
    {
        "icon": "circle-parking",
        "label": "Circle Parking",
        "search": [
            "auto",
            "car",
            "garage",
            "meter"
        ]
    },
    {
        "icon": "cassette-betamax",
        "label": "Cassette Betamax",
        "search": [
            "cassette",
            "rental",
            "retro",
            "tape",
            "vhs",
            "video",
            "vintage"
        ]
    },
    {
        "icon": "people-carry-box",
        "label": "People Carry Box",
        "search": [
            "together",
            "uer",
            "users-people"
        ]
    },
    {
        "icon": "clock-eight",
        "label": "Clock Eight",
        "search": [
            "00",
            "8",
            "8:00",
            "clock",
            "eight",
            "eight o’clock",
            "hour",
            "minute",
            "o'clock",
            "o’clock",
            "pending",
            "ticking",
            "time"
        ]
    },
    {
        "icon": "chair",
        "label": "Chair",
        "search": [
            "chair",
            "furniture",
            "seat",
            "sit"
        ]
    },
    {
        "icon": "wind",
        "label": "Wind",
        "search": [
            "air",
            "blow",
            "breeze",
            "fall",
            "seasonal",
            "weather"
        ]
    },
    {
        "icon": "aviato",
        "label": "Aviato",
        "search": []
    },
    {
        "icon": "layer-group",
        "label": "Layer Group",
        "search": [
            "arrange",
            "category",
            "develop",
            "layers",
            "map",
            "platform",
            "stack"
        ]
    },
    {
        "icon": "lollipop",
        "label": "Lollipop",
        "search": [
            "candy",
            "lollypop",
            "sucker",
            "sugar",
            "sweet",
            "swirl"
        ]
    },
    {
        "icon": "notes",
        "label": "Notes",
        "search": [
            "memo",
            "sticky note"
        ]
    },
    {
        "icon": "hexagon-xmark",
        "label": "Hexagon Xmark",
        "search": [
            "close",
            "cross",
            "exit",
            "incorrect",
            "notice",
            "notification",
            "notify",
            "problem",
            "uncheck",
            "wrong",
            "x"
        ]
    },
    {
        "icon": "shish-kebab",
        "label": "Shish Kebab",
        "search": [
            "grill",
            "kabob",
            "kebob",
            "meat",
            "shawarma",
            "skewer",
            "souvlaki"
        ]
    },
    {
        "icon": "head-side-mask",
        "label": "Head Side Mask",
        "search": [
            "breath",
            "coronavirus",
            "covid-19",
            "filter",
            "flu",
            "infection",
            "pandemic",
            "respirator",
            "uer",
            "virus"
        ]
    },
    {
        "icon": "hands",
        "label": "Hands",
        "search": [
            "Translate",
            "asl",
            "deaf",
            "hands"
        ]
    },
    {
        "icon": "tablets",
        "label": "Tablets",
        "search": [
            "drugs",
            "medicine",
            "pills",
            "prescription"
        ]
    },
    {
        "icon": "weight-hanging",
        "label": "Weight Hanging",
        "search": [
            "anvil",
            "heavy",
            "measurement"
        ]
    },
    {
        "icon": "pinball",
        "label": "Pinball",
        "search": [
            "arcade",
            "fun",
            "game",
            "pinball"
        ]
    },
    {
        "icon": "dice",
        "label": "Dice",
        "search": [
            "chance",
            "dice",
            "die",
            "gambling",
            "game",
            "game die",
            "roll"
        ]
    },
    {
        "icon": "padlet",
        "label": "Padlet",
        "search": []
    },
    {
        "icon": "shop-slash",
        "label": "Shop Slash",
        "search": [
            "building",
            "buy",
            "closed",
            "covid-19",
            "disabled",
            "purchase",
            "shopping"
        ]
    },
    {
        "icon": "sort-down",
        "label": "Sort Down",
        "search": [
            "arrow",
            "descending",
            "filter",
            "insert",
            "order",
            "sort-desc"
        ]
    },
    {
        "icon": "comment-exclamation",
        "label": "Comment Exclamation",
        "search": [
            "alert",
            "answer",
            "attention",
            "bubble",
            "chat",
            "commenting",
            "conversation",
            "exclaim",
            "failed",
            "feedback",
            "important",
            "message",
            "note",
            "notification",
            "request",
            "sms",
            "speech",
            "surprise",
            "texting"
        ]
    },
    {
        "icon": "table-layout",
        "label": "Table Layout",
        "search": [
            "category",
            "cell",
            "column",
            "layout",
            "row",
            "spreadsheet"
        ]
    },
    {
        "icon": "edge-legacy",
        "label": "Edge Legacy Browser",
        "search": []
    },
    {
        "icon": "square-lastfm",
        "label": "Square Lastfm",
        "search": []
    },
    {
        "icon": "goodreads-g",
        "label": "Goodreads G",
        "search": []
    },
    {
        "icon": "cc-mastercard",
        "label": "MasterCard Credit Card",
        "search": []
    },
    {
        "icon": "discourse",
        "label": "Discourse",
        "search": []
    },
    {
        "icon": "peseta-sign",
        "label": "Peseta Sign",
        "search": [
            "Peseta Sign",
            "currency"
        ]
    },
    {
        "icon": "tablet-screen-button",
        "label": "Tablet Screen Button",
        "search": [
            "apple",
            "device",
            "ipad",
            "kindle",
            "screen"
        ]
    },
    {
        "icon": "hand-holding-dollar",
        "label": "Hand Holding Dollar",
        "search": [
            "$",
            "carry",
            "coupon",
            "dollar sign",
            "donate",
            "donation",
            "giving",
            "investment",
            "lift",
            "money",
            "premium",
            "price",
            "revenue",
            "salary"
        ]
    },
    {
        "icon": "horse-saddle",
        "label": "Horse Saddle",
        "search": [
            "cowboy",
            "equus",
            "fauna",
            "mammmal",
            "mare",
            "neigh",
            "pony",
            "rodeo",
            "western"
        ]
    },
    {
        "icon": "shield",
        "label": "Shield",
        "search": [
            "achievement",
            "armor",
            "award",
            "block",
            "cleric",
            "defend",
            "defense",
            "holy",
            "paladin",
            "protect",
            "safety",
            "security",
            "shield",
            "weapon",
            "winner"
        ]
    },
    {
        "icon": "peach",
        "label": "Peach",
        "search": [
            "butt",
            "fruit",
            "peach",
            "pit",
            "stone"
        ]
    },
    {
        "icon": "face-laugh",
        "label": "Face Laugh",
        "search": [
            "LOL",
            "emoticon",
            "face",
            "laugh",
            "smile"
        ]
    },
    {
        "icon": "bell-school-slash",
        "label": "Bell School Slash",
        "search": [
            "alert",
            "cancel",
            "class",
            "disabled",
            "notification",
            "off",
            "reminder"
        ]
    },
    {
        "icon": "align-slash",
        "label": "Align Slash",
        "search": [
            "cancel",
            "disabled",
            "format",
            "paragraph",
            "remove"
        ]
    },
    {
        "icon": "cloud-exclamation",
        "label": "Cloud Exclamation",
        "search": [
            "alert",
            "cloud",
            "connection",
            "error",
            "failed",
            "online",
            "warning",
            "wifi"
        ]
    },
    {
        "icon": "hands-holding",
        "label": "Hands Holding",
        "search": [
            "carry",
            "hold",
            "lift"
        ]
    },
    {
        "icon": "cart-shopping",
        "label": "Cart Shopping",
        "search": [
            "buy",
            "cart",
            "checkout",
            "grocery",
            "payment",
            "purchase",
            "shopping",
            "shopping cart",
            "trolley"
        ]
    },
    {
        "icon": "triangle-person-digging",
        "label": "Triangle Person Digging",
        "search": [
            "bury",
            "construction",
            "debris",
            "dig",
            "maintenance",
            "men at work",
            "warning"
        ]
    },
    {
        "icon": "subtitles-slash",
        "label": "Subtitles Slash",
        "search": [
            "caption",
            "closed captions",
            "description",
            "film",
            "language",
            "movie",
            "off",
            "text",
            "translation"
        ]
    },
    {
        "icon": "black-tie",
        "label": "Font Awesome Black Tie",
        "search": [
            "administrator"
        ]
    },
    {
        "icon": "square-d",
        "label": "Square D",
        "search": [
            "letter"
        ]
    },
    {
        "icon": "folder-medical",
        "label": "Folder Medical",
        "search": [
            "health",
            "patient",
            "record"
        ]
    },
    {
        "icon": "chart-scatter-bubble",
        "label": "Chart Scatter Bubble",
        "search": [
            "chart",
            "graph",
            "performance",
            "statistics",
            "track",
            "trend"
        ]
    },
    {
        "icon": "hat-witch",
        "label": "Hat Witch",
        "search": [
            "accessory",
            "clothing",
            "halloween",
            "head",
            "holiday",
            "mage",
            "magic",
            "sorceror"
        ]
    },
    {
        "icon": "square-facebook",
        "label": "Square Facebook",
        "search": [
            "fabook",
            "fb",
            "social network"
        ]
    },
    {
        "icon": "garage-car",
        "label": "Garage Car",
        "search": [
            "auto",
            "car",
            "door",
            "storage",
            "structure",
            "warehouse"
        ]
    },
    {
        "icon": "calendar-clock",
        "label": "Calendar Clock",
        "search": [
            "date",
            "day",
            "delay",
            "month",
            "remind",
            "waiting",
            "year"
        ]
    },
    {
        "icon": "octagon",
        "label": "Octagon",
        "search": [
            "octagonal",
            "shape",
            "sign",
            "stop",
            "stop sign"
        ]
    },
    {
        "icon": "battle-net",
        "label": "Battle.net",
        "search": []
    },
    {
        "icon": "hand-pointer",
        "label": "Hand Pointer",
        "search": [
            "arrow",
            "cursor",
            "select"
        ]
    },
    {
        "icon": "rabbit",
        "label": "Rabbit",
        "search": [
            "animal",
            "bunny",
            "fast",
            "fauna",
            "hare",
            "mammal",
            "pet",
            "rabbit",
            "speed",
            "wabbit"
        ]
    },
    {
        "icon": "bimobject",
        "label": "BIMobject",
        "search": []
    },
    {
        "icon": "sushi",
        "label": "Sushi",
        "search": [
            "fish",
            "nigiri",
            "nori",
            "raw",
            "rice",
            "salmon",
            "seafood",
            "tuna"
        ]
    },
    {
        "icon": "scanner-gun",
        "label": "Scanner Gun",
        "search": [
            "barcode",
            "checkout",
            "gun",
            "inventory",
            "price",
            "upc",
            "warehouse"
        ]
    },
    {
        "icon": "pencil-mechanical",
        "label": "Pencil Mechanical",
        "search": [
            "draw",
            "edit",
            "eraser",
            "graphite",
            "lead",
            "pencil",
            "stylus",
            "write"
        ]
    },
    {
        "icon": "hand-holding-seedling",
        "label": "Hand Holding Seedling",
        "search": [
            "carry",
            "grow",
            "lift",
            "plant"
        ]
    },
    {
        "icon": "location-question",
        "label": "Location Question",
        "search": [
            "agree",
            "coordinates",
            "destination",
            "help",
            "info",
            "location",
            "map",
            "navigation",
            "pin",
            "place",
            "support"
        ]
    },
    {
        "icon": "up",
        "label": "Up",
        "search": [
            "upgrade",
            "upload"
        ]
    },
    {
        "icon": "arrow-up-arrow-down",
        "label": "Arrow Up Arrow Down",
        "search": [
            "Upwards Arrow Leftwards of Downwards Arrow",
            "reverse",
            "swap",
            "switch",
            "transfer"
        ]
    },
    {
        "icon": "scarecrow",
        "label": "Scarecrow",
        "search": [
            "bird",
            "crow",
            "farm",
            "field",
            "halloween",
            "strawman"
        ]
    },
    {
        "icon": "location-crosshairs-slash",
        "label": "Location Crosshairs Slash",
        "search": [
            "address",
            "coordinate",
            "direction",
            "disabled",
            "gps",
            "map",
            "navigation",
            "place",
            "where"
        ]
    },
    {
        "icon": "registered",
        "label": "Registered",
        "search": [
            "copyright",
            "mark",
            "r",
            "registered",
            "trademark"
        ]
    },
    {
        "icon": "rectangle-pro",
        "label": "Rectangle Pro",
        "search": [
            "professional"
        ]
    },
    {
        "icon": "bread-slice-butter",
        "label": "Bread Slice Butter",
        "search": [
            "bread",
            "breakfast",
            "butter",
            "toast"
        ]
    },
    {
        "icon": "light-ceiling",
        "label": "Light Ceiling",
        "search": [
            "bright",
            "furniture",
            "light",
            "overhead"
        ]
    },
    {
        "icon": "user-hair-mullet",
        "label": "User Hair Mullet",
        "search": [
            "business",
            "mullet",
            "party",
            "uer"
        ]
    },
    {
        "icon": "square-parking-slash",
        "label": "Square Parking Slash",
        "search": [
            "auto",
            "car",
            "disabled",
            "garage",
            "meter"
        ]
    },
    {
        "icon": "link-simple-slash",
        "label": "Link Simple Slash",
        "search": [
            "attachment",
            "chain",
            "chain-broken",
            "disabled",
            "disconnect",
            "remove"
        ]
    },
    {
        "icon": "house-signal",
        "label": "House Signal",
        "search": [
            "abode",
            "building",
            "connect",
            "family",
            "home",
            "residence",
            "smart home",
            "wifi",
            "www"
        ]
    },
    {
        "icon": "lock-keyhole",
        "label": "Lock Keyhole",
        "search": [
            "admin",
            "lock",
            "open",
            "padlock",
            "password",
            "privacy",
            "private",
            "protect",
            "security"
        ]
    },
    {
        "icon": "tally-2",
        "label": "Tally 2",
        "search": [
            "calculate",
            "count",
            "hash",
            "number"
        ]
    },
    {
        "icon": "bangladeshi-taka-sign",
        "label": "Bangladeshi Taka Sign",
        "search": [
            "bdt",
            "currency",
            "tk"
        ]
    }
]
